webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$Q8DXfG009VhLIFQ.jVOUc.PQP9veEMmsqkthzMdi8xIFTCRkf2AEm';
        this.siteImage = "https://cityneeds.ng/cnpro.jpg";

        this.siteUrl = "https://forum.survey.cityneeds.ng/";

        this.siteShareUrl = "https://share.cityneeds.ng/";

        if (window.location.hostname == 'localhost') {
            this.siteActiveUrl = "http://localhost:8040/";
        } else {
            this.siteActiveUrl = "https://" + window.location.hostname + '/';
        }

        this.baseURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/';
        this.imageURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';
        this.imageCNproURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/server/x52rs6c/pr.im.sys.ti.ny.255/cnpro_categories/';
        this.imageBusinessURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/server/x52rs6c/pr.im.sys.ti.ny.255/business_categories/';

        this.pageIntv = 5;this.pageCnproIntv = 12;

        this.thisYear = new Date().getFullYear();

        this.paystack_public_test = '';
        this.paystack_secret_test = '';
        this.paystack_public_live = '';
        this.paystack_secret_live = '';
        this.ravepay_public_test = 'FLWPUBK-8b636e40e721ae65285c678950808ef5-X';
        this.ravepay_secret_test = '';
        this.ravepay_public_live_remita = 'FLWPUBK-7bfea41df783f28ad7c71d9925a1bc57-X';
        this.ravepay_secret_live_remita = 'FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X';
        this.ravepay_public_live_paga = 'FLWPUBK-9a2d236c853b6f2e2c7a5c0888456977-X';
        this.ravepay_secret_live_paga = 'FLWSECK-e548cb5dc39ca101d6eb143a7378cd17-X';

        this.service_purchase_failed = "Payment Failed";
        this.service_purchase_success = "Payment was Successful";
        this.service_payment_successful = "Payment was successful";
        this.service_payment_failed = "Payment was not processed. please try again or contact us";
        this.service_payment_circle_fully_successful = "Payment was Successful";
        this.service_payment_circle_not_fully_successful = "Payment Made, Update Failed";
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "getStates",
        value: function getStates(context) {
            return context.$http.get(this.baseURL + 'states');
        }
    }, {
        key: "getStateName",
        value: function getStateName(context, id) {
            return context.$http.get(this.baseURL + 'states/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCityName",
        value: function getCityName(context, id) {
            return context.$http.get(this.baseURL + 'cities/name/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCities",
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getUserID",
        value: function getUserID(context, id) {
            return context.$http.post(this.baseURL + 'auth/sessions/id', id);
        }
    }, {
        key: "getDataItem",
        value: function getDataItem(context, data, id) {
            return context.$http.post(this.baseURL + 'auth/data/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getNotifications",
        value: function getNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "uploadDataPhoto",
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + '/uploads', data, {
                headers: {
                    'Api-Token': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "regUser",
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "loginUser",
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "sessionGuard",
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "authTokenKey",
        value: function authTokenKey(context, id) {
            return context.$http.get(this.baseURL + 'auth/tokens/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "prepareCNuserGuestID",
        value: function prepareCNuserGuestID(context) {
            return context.$http.get(this.baseURL + 'users/guests', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "verifyEmail",
        value: function verifyEmail(context, data) {
            return context.$http.post(this.baseURL + 'auth/verify/email', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "verifyResetToken",
        value: function verifyResetToken(context, token) {
            return context.$http.post(this.baseURL + 'auth/verify/reset/token/' + token, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "forgotPassword",
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'auth/password/forgot', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "resetForgotPassword",
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'auth/password/forgot/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "resetPassword",
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'auth/password/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "resetEmail",
        value: function resetEmail(context, data) {
            return context.$http.post(this.baseURL + 'auth/email/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "activateEmail",
        value: function activateEmail(context, data) {
            return context.$http.post(this.baseURL + 'auth/verify/email', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getUser",
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "editProfile",
        value: function editProfile(context, data, id) {
            return context.$http.put(this.baseURL + 'users/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "setUserPaymentDetails",
        value: function setUserPaymentDetails(context, data) {
            return context.$http.post(this.baseURL + 'users/payments', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessCategories",
        value: function getBusinessCategories(context) {
            return context.$http.get(this.baseURL + 'businesscategories', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getAllBusinesses",
        value: function getAllBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getSearchBusinesses",
        value: function getSearchBusinesses(context, offset, items) {
            return context.$http.get(this.baseURL + 'businesses/pages/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinesses",
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getBusiness",
        value: function getBusiness(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessWorkingHours",
        value: function getBusinessWorkingHours(context, id) {
            return context.$http.get(this.baseURL + 'businesses/workinghours/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "addBusiness",
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "editBusiness",
        value: function editBusiness(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "setWorkingHours",
        value: function setWorkingHours(context, id, data) {
            var datab = [];
            datab = ['t', 'u', 'y'];
            return context.$http.put(this.baseURL + 'businesses/workinghours/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "deleteBusiness",
        value: function deleteBusiness(context, id) {
            return context.$http.delete(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "searchBusinesses",
        value: function searchBusinesses(context, data, offset, items) {
            return context.$http.post(this.baseURL + 'businesses/search/' + offset + '/' + items, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "searchBusiness",
        value: function searchBusiness(context, id) {
            return context.$http.get(this.baseURL + 'businesses/business/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "citisaveBusinesses",
        value: function citisaveBusinesses(context, data) {
            return context.$http.post(this.baseURL + 'businesses/citisave', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCnproParentCategories",
        value: function getCnproParentCategories(context) {
            return context.$http.get(this.baseURL + 'cnprocategories/parent', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCnproCategories",
        value: function getCnproCategories(context, id) {
            return context.$http.get(this.baseURL + 'cnprocategories/sub/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getAllCnpros",
        value: function getAllCnpros(context) {
            return context.$http.get(this.baseURL + 'cnpros', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getSearchCnpros",
        value: function getSearchCnpros(context, offset, items) {
            return context.$http.get(this.baseURL + 'cnpros/pages/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCnpros",
        value: function getCnpros(context, id) {
            return context.$http.get(this.baseURL + 'cnpros/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCnpro",
        value: function getCnpro(context, id) {
            return context.$http.get(this.baseURL + 'cnpros/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "searchCnpro",
        value: function searchCnpro(context, search) {
            return context.$http.get(this.baseURL + 'cnpros/cnpro/search/' + search, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "addCnpro",
        value: function addCnpro(context, data) {
            return context.$http.post(this.baseURL + 'cnpros', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "addCnproPhoto",
        value: function addCnproPhoto(context, data) {
            return context.$http.post(this.baseURL + 'cnpros/uploads', data, {
                headers: {
                    'Api-Token': this.apiToken,
                    'Content-Type': 'multipart/form-data'

                }
            });
        }
    }, {
        key: "editCnpro",
        value: function editCnpro(context, data, id) {
            return context.$http.put(this.baseURL + 'cnpros/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "deleteCnpro",
        value: function deleteCnpro(context, id) {
            return context.$http.delete(this.baseURL + 'cnpros/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "searchCnpros",
        value: function searchCnpros(context, data, offset, items) {
            return context.$http.post(this.baseURL + 'cnpros/search/' + offset + '/' + items, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "findCnpro",
        value: function findCnpro(context, data) {
            return context.$http.post(this.baseURL + 'cnpros/findrequests', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getSavedListings",
        value: function getSavedListings(context, id) {
            return context.$http.get(this.baseURL + 'citisaves/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getSavedListing",
        value: function getSavedListing(context, id) {
            return context.$http.get(this.baseURL + 'citisaves/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "saveListing",
        value: function saveListing(context, data) {
            return context.$http.post(this.baseURL + 'citisaves', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getServiceCharge",
        value: function getServiceCharge(context) {
            return context.$http.get(this.baseURL + 'contracts/services/charges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getUserContracts",
        value: function getUserContracts(context, id) {
            return context.$http.get(this.baseURL + 'contracts/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCnproContracts",
        value: function getCnproContracts(context, id) {
            return context.$http.get(this.baseURL + 'contracts/cnpro/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getContract",
        value: function getContract(context, id) {
            return context.$http.get(this.baseURL + 'contracts/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "checkCnproContractRequest",
        value: function checkCnproContractRequest(context, data) {
            return context.$http.post(this.baseURL + 'contracts/checks', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "requestQuote",
        value: function requestQuote(context, data) {
            return context.$http.post(this.baseURL + 'contracts', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "replyQuote",
        value: function replyQuote(context, id, data) {
            return context.$http.post(this.baseURL + 'contracts/reply', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "setQuote",
        value: function setQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/set/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "updateQuote",
        value: function updateQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/update/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "acceptQuote",
        value: function acceptQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/accept/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "rejectQuote",
        value: function rejectQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/reject/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "confirmContractCnpro",
        value: function confirmContractCnpro(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/confirm/cnpro/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "confirmContract",
        value: function confirmContract(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/confirm/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "closeContract",
        value: function closeContract(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/close/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNSettings",
        value: function getCNSettings(context, offset, items) {
            return context.$http.get(this.baseURL + 'cnsettings', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNdiscounts",
        value: function getCNdiscounts(context, offset, items) {
            return context.$http.get(this.baseURL + 'cndiscounts/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNdiscountsBusinessCategories",
        value: function getCNdiscountsBusinessCategories(context) {
            return context.$http.get(this.baseURL + 'cndiscounts/businessdata', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNdiscount",
        value: function getCNdiscount(context, id) {
            return context.$http.get(this.baseURL + 'cndiscounts/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "searchCNdiscount",
        value: function searchCNdiscount(context, data) {
            return context.$http.post(this.baseURL + 'cndiscounts/search', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "addNewCNdiscount",
        value: function addNewCNdiscount(context, data) {
            return context.$http.post(this.baseURL + 'cndiscounts', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCornerStoneCarCompanies",
        value: function getCornerStoneCarCompanies(context) {
            return context.$http.get(this.baseURL + 'cninsurance/cornerstone/motor/companies', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getVechicleManufacturerModels",
        value: function getVechicleManufacturerModels(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/cornerstone/motor/models/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNinsuranceListings",
        value: function getCNinsuranceListings(context, offset, items) {
            return context.$http.get(this.baseURL + 'cninsurance/listings', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNinsurance",
        value: function getCNinsurance(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNinsuranceUserAccounts",
        value: function getCNinsuranceUserAccounts(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/users/accounts/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNinsuranceAccountForms",
        value: function getCNinsuranceAccountForms(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/accounts/forms/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNinsuranceAccountClaims",
        value: function getCNinsuranceAccountClaims(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/claims/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNinsuranceAccountComplaints",
        value: function getCNinsuranceAccountComplaints(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/complaints/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "submitNewCNinsurance",
        value: function submitNewCNinsurance(context, data) {
            return context.$http.post(this.baseURL + 'cninsurance/forms', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "postCNinsuranceForm",
        value: function postCNinsuranceForm(context, data) {
            return context.$http.post(this.baseURL + 'cninsurance/forms/updates', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "postCNinsuranceFileClaimComplaintForm",
        value: function postCNinsuranceFileClaimComplaintForm(context, data) {
            return context.$http.post(this.baseURL + 'cninsurance/forms/file/claims/complaints', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "mailCNinsuranceFileClaimComplaintForm",
        value: function mailCNinsuranceFileClaimComplaintForm(context, data) {
            return context.$http.post(this.baseURL + 'cninsurance/forms/mail/claims/complaints', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "postCNpaymentDetails",
        value: function postCNpaymentDetails(context, data) {
            return context.$http.post(this.baseURL + 'cnpayments/general', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "updatePayment",
        value: function updatePayment(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getContractComplaints",
        value: function getContractComplaints(context, id) {
            return context.$http.get(this.baseURL + 'contracts/complaints/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "makeComplaint",
        value: function makeComplaint(context, id, data) {
            return context.$http.post(this.baseURL + 'contracts/complaints', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "resolveComplaint",
        value: function resolveComplaint(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/complaints/resolve/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getAllReviews",
        value: function getAllReviews(context) {
            return context.$http.get(this.baseURL + 'reviews', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "submitReview",
        value: function submitReview(context, data) {
            return context.$http.post(this.baseURL + 'reviews', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "submitRating",
        value: function submitRating(context, data) {
            return context.$http.post(this.baseURL + 'ratings', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getAllForums",
        value: function getAllForums(context) {
            return context.$http.get(this.baseURL + 'forums', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getForums",
        value: function getForums(context, category, offset, items) {
            return context.$http.get(this.baseURL + 'forums/' + category + '/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "searchForums",
        value: function searchForums(context, id) {
            return context.$http.get(this.baseURL + 'forums/search/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "postThread",
        value: function postThread(context, data) {
            return context.$http.post(this.baseURL + 'forums', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "editThread",
        value: function editThread(context, id, data) {
            return context.$http.put(this.baseURL + 'forums/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getUserThreads",
        value: function getUserThreads(context, id) {
            return context.$http.get(this.baseURL + 'forums/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getThread",
        value: function getThread(context, data) {
            return context.$http.post(this.baseURL + 'forums/url', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "forumComments",
        value: function forumComments(context, id) {
            return context.$http.get(this.baseURL + 'forums/comments/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "addThreadComment",
        value: function addThreadComment(context, data) {
            return context.$http.post(this.baseURL + 'forums/comments', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "editThreadComment",
        value: function editThreadComment(context, id, data) {
            return context.$http.put(this.baseURL + 'forums/comments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "canEditData",
        value: function canEditData(context, data) {
            return context.$http.post(this.baseURL + 'settings/ownership', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "survey",
        value: function survey(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "addSurveyQuestion",
        value: function addSurveyQuestion(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/questions', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "editSurvey",
        value: function editSurvey(context, data, id) {
            return context.$http.put(this.baseURL + 'cnsurveys/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "editSurveyQuestion",
        value: function editSurveyQuestion(context, data, id) {
            return context.$http.put(this.baseURL + 'cnsurveys/questions/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "userSurveys",
        value: function userSurveys(context, id) {
            return context.$http.get(this.baseURL + 'cnsurveys/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getUserSurveys",
        value: function getUserSurveys(context, id) {
            return context.$http.get(this.baseURL + 'cnsurveys/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "allSurveys",
        value: function allSurveys(context) {
            return context.$http.get(this.baseURL + 'cnsurveys', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getAllSurveys",
        value: function getAllSurveys(context, offset, items) {
            return context.$http.get(this.baseURL + 'cnsurveys/pages/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getSurvey",
        value: function getSurvey(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/url', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "surveyAns",
        value: function surveyAns(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/answers', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "deleteSurvey",
        value: function deleteSurvey(context, id) {
            return context.$http.delete(this.baseURL + 'cnsurveys/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "deleteSurveyQuestion",
        value: function deleteSurveyQuestion(context, id) {
            return context.$http.delete(this.baseURL + 'cnsurveys/questions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "updateCnsurveysPayments",
        value: function updateCnsurveysPayments(context, id, data) {
            return context.$http.put(this.baseURL + 'cnsurveys/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getPaymentPlans",
        value: function getPaymentPlans(context) {
            return context.$http.get(this.baseURL + 'plans', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "setPaymentPlansRequest",
        value: function setPaymentPlansRequest(context, data) {
            return context.$http.post(this.baseURL + 'plans/users/requests', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "setPaymentPlan",
        value: function setPaymentPlan(context, data) {
            return context.$http.post(this.baseURL + 'plans/users', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "updatePaymentPlan",
        value: function updatePaymentPlan(context, id, data) {
            return context.$http.put(this.baseURL + 'plans/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "setPaymentRequests",
        value: function setPaymentRequests(context, data) {
            return context.$http.post(this.baseURL + 'cnpayments/prepare/requests', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getMonies",
        value: function getMonies(context, id) {
            return context.$http.get(this.baseURL + 'monies/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getMoney",
        value: function getMoney(context, id) {
            return context.$http.get(this.baseURL + 'monies/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "updateMoniesPaid",
        value: function updateMoniesPaid(context, id, data) {
            return context.$http.put(this.baseURL + 'monies/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getBanking",
        value: function getBanking(context, id) {
            return context.$http.get(this.baseURL + 'monies/banks/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "setBanking",
        value: function setBanking(context, data) {
            return context.$http.post(this.baseURL + 'monies/banks', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "updateBankSetting",
        value: function updateBankSetting(context, id, data) {
            return context.$http.put(this.baseURL + 'monies/banks/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getWalletProcessingCharges",
        value: function getWalletProcessingCharges(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/charges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getWalletProcessingChargesRF",
        value: function getWalletProcessingChargesRF(context) {
            return context.$http.get(this.baseURL + 'cnwallet/charges/rf', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getWalletBalance",
        value: function getWalletBalance(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/balance/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getWalletTransactions",
        value: function getWalletTransactions(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/transactions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "postWalletTopup",
        value: function postWalletTopup(context, data) {
            return context.$http.post(this.baseURL + 'cnwallet/transactions/topup', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "postWalletPayout",
        value: function postWalletPayout(context, data) {
            return context.$http.post(this.baseURL + 'cnwallet/transactions/payout', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getCNpayTransactions",
        value: function getCNpayTransactions(context, id) {
            return context.$http.get(this.baseURL + 'cnpay/transactions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "getReferralTransactions",
        value: function getReferralTransactions(context, id) {
            return context.$http.get(this.baseURL + 'referrals/transactions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "subscribe",
        value: function subscribe(context, data) {
            return context.$http.post(this.baseURL + 'subscriptions/requests', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: "remitaRRRLookup",
        value: function remitaRRRLookup(context, req, data) {
            return context.$http.post('https://login.remita.net/remita/exapp/api/v1/send/api/echannelsvc/echannel/agents/collection/K0hJWTFORFVmcEZ1T2ZIY2hTWXdtVGpaVTNBaVVTZFh6bDFlSzNxS0d6UFBQRXoxdVBaREhkUHRnOWozZGhZYQ==/' + req.rrr_code + '/' + req.rrr_request_id + '/lookup?callback=?', data, {
                headers: {
                    Accept: "application/json"
                }
            });
        }
    }, {
        key: "remitaRRRPaymentNotification",
        value: function remitaRRRPaymentNotification(context, req, data) {
            return context.$http.post('https://login.remita.net/remita/exapp/api/v1/send/api/echannelsvc/echannel/agents/collection/K0hJWTFORFVmcEZ1T2ZIY2hTWXdtVGpaVTNBaVVTZFh6bDFlSzNxS0d6UFBQRXoxdVBaREhkUHRnOWozZGhZYQ==/' + req.rrr_code + '/' + req.rrr_request_id + '/lookup?callback=?', data, {
                headers: {
                    Accept: "application/json"
                }
            });
        }
    }, {
        key: "opaga",
        value: function opaga(context, data) {
            return context.$http.post('https://qa1.mypaga.com/paga-webservices/agent-rest/secured/purchaseAirtime', data, {
                headers: {
                    principal: '8B856153-7EA1-4A85-B26D-33D5EA201C0D',
                    Credentials: 'password1',
                    hash: this.SHA512('5618889345117897834344943344889' + '08059079689' + '100' + 'bc547750b92797f955b36112cc9bdd5cddf7d0862151d03a167ada8995aa24a9ad24610b36a68bc02da24141ee51670aea13ed6469099a4453f335cb239db5da'),
                    Accept: 'application/json'
                }
            });
        }
    }, {
        key: "verifyRavePayment",
        value: function verifyRavePayment(context, data) {
            return context.$http.post('https://api.ravepay.co/flwv3-pug/getpaidx/api/v2/verify', data, {
                headers: {
                    Accept: "application/json"
                }
            });
        }
    }, {
        key: "get_car_manufacturers",
        value: function get_car_manufacturers() {
            return ["Abarth", "Alfa Romeo", "Aston Martin", "Audi", "Bentley", "BMW", "Bugatti", "Cadillac", "Chevrolet", "Chrysler", "Citroën", "Dacia", "Daewoo", "Daihatsu", "Dodge", "Donkervoort", "DS", "Ferrari", "Fiat", "Fisker", "Ford", "Honda", "Hummer", "Hyundai", "Infiniti", "Iveco", "Jaguar", "Jeep", "Kia", "KTM", "Lada", "Lamborghini", "Lancia", "Land Rover", "Landwind", "Lexus", "Lotus", "Maserati", "Maybach", "Mazda", "McLaren", "Mercedes-Benz", "MG", "Mini", "Mitsubishi", "Morgan", "Nissan", "Opel", "Peugeot", "Porsche", "Renault", "Rolls-Royce", "Rover", "Saab", "Seat", "Skoda", "Smart", "SsangYong", "Subaru", "Suzuki", "Tesla", "Toyota", "Volkswagen", "Volvo"];
        }
    }, {
        key: "SHA512",
        value: function SHA512(str) {
            function int64(msint_32, lsint_32) {
                this.highOrder = msint_32;
                this.lowOrder = lsint_32;
            }

            var H = [new int64(0x6a09e667, 0xf3bcc908), new int64(0xbb67ae85, 0x84caa73b), new int64(0x3c6ef372, 0xfe94f82b), new int64(0xa54ff53a, 0x5f1d36f1), new int64(0x510e527f, 0xade682d1), new int64(0x9b05688c, 0x2b3e6c1f), new int64(0x1f83d9ab, 0xfb41bd6b), new int64(0x5be0cd19, 0x137e2179)];

            var K = [new int64(0x428a2f98, 0xd728ae22), new int64(0x71374491, 0x23ef65cd), new int64(0xb5c0fbcf, 0xec4d3b2f), new int64(0xe9b5dba5, 0x8189dbbc), new int64(0x3956c25b, 0xf348b538), new int64(0x59f111f1, 0xb605d019), new int64(0x923f82a4, 0xaf194f9b), new int64(0xab1c5ed5, 0xda6d8118), new int64(0xd807aa98, 0xa3030242), new int64(0x12835b01, 0x45706fbe), new int64(0x243185be, 0x4ee4b28c), new int64(0x550c7dc3, 0xd5ffb4e2), new int64(0x72be5d74, 0xf27b896f), new int64(0x80deb1fe, 0x3b1696b1), new int64(0x9bdc06a7, 0x25c71235), new int64(0xc19bf174, 0xcf692694), new int64(0xe49b69c1, 0x9ef14ad2), new int64(0xefbe4786, 0x384f25e3), new int64(0x0fc19dc6, 0x8b8cd5b5), new int64(0x240ca1cc, 0x77ac9c65), new int64(0x2de92c6f, 0x592b0275), new int64(0x4a7484aa, 0x6ea6e483), new int64(0x5cb0a9dc, 0xbd41fbd4), new int64(0x76f988da, 0x831153b5), new int64(0x983e5152, 0xee66dfab), new int64(0xa831c66d, 0x2db43210), new int64(0xb00327c8, 0x98fb213f), new int64(0xbf597fc7, 0xbeef0ee4), new int64(0xc6e00bf3, 0x3da88fc2), new int64(0xd5a79147, 0x930aa725), new int64(0x06ca6351, 0xe003826f), new int64(0x14292967, 0x0a0e6e70), new int64(0x27b70a85, 0x46d22ffc), new int64(0x2e1b2138, 0x5c26c926), new int64(0x4d2c6dfc, 0x5ac42aed), new int64(0x53380d13, 0x9d95b3df), new int64(0x650a7354, 0x8baf63de), new int64(0x766a0abb, 0x3c77b2a8), new int64(0x81c2c92e, 0x47edaee6), new int64(0x92722c85, 0x1482353b), new int64(0xa2bfe8a1, 0x4cf10364), new int64(0xa81a664b, 0xbc423001), new int64(0xc24b8b70, 0xd0f89791), new int64(0xc76c51a3, 0x0654be30), new int64(0xd192e819, 0xd6ef5218), new int64(0xd6990624, 0x5565a910), new int64(0xf40e3585, 0x5771202a), new int64(0x106aa070, 0x32bbd1b8), new int64(0x19a4c116, 0xb8d2d0c8), new int64(0x1e376c08, 0x5141ab53), new int64(0x2748774c, 0xdf8eeb99), new int64(0x34b0bcb5, 0xe19b48a8), new int64(0x391c0cb3, 0xc5c95a63), new int64(0x4ed8aa4a, 0xe3418acb), new int64(0x5b9cca4f, 0x7763e373), new int64(0x682e6ff3, 0xd6b2b8a3), new int64(0x748f82ee, 0x5defb2fc), new int64(0x78a5636f, 0x43172f60), new int64(0x84c87814, 0xa1f0ab72), new int64(0x8cc70208, 0x1a6439ec), new int64(0x90befffa, 0x23631e28), new int64(0xa4506ceb, 0xde82bde9), new int64(0xbef9a3f7, 0xb2c67915), new int64(0xc67178f2, 0xe372532b), new int64(0xca273ece, 0xea26619c), new int64(0xd186b8c7, 0x21c0c207), new int64(0xeada7dd6, 0xcde0eb1e), new int64(0xf57d4f7f, 0xee6ed178), new int64(0x06f067aa, 0x72176fba), new int64(0x0a637dc5, 0xa2c898a6), new int64(0x113f9804, 0xbef90dae), new int64(0x1b710b35, 0x131c471b), new int64(0x28db77f5, 0x23047d84), new int64(0x32caab7b, 0x40c72493), new int64(0x3c9ebe0a, 0x15c9bebc), new int64(0x431d67c4, 0x9c100d4c), new int64(0x4cc5d4be, 0xcb3e42b6), new int64(0x597f299c, 0xfc657e2a), new int64(0x5fcb6fab, 0x3ad6faec), new int64(0x6c44198c, 0x4a475817)];

            var W = new Array(64);
            var a, b, c, d, e, f, g, h, i, j;
            var T1, T2;
            var charsize = 8;

            function utf8_encode(str) {
                return unescape(encodeURIComponent(str));
            }

            function str2binb(str) {
                var bin = [];
                var mask = (1 << charsize) - 1;
                var len = str.length * charsize;

                for (var i = 0; i < len; i += charsize) {
                    bin[i >> 5] |= (str.charCodeAt(i / charsize) & mask) << 32 - charsize - i % 32;
                }

                return bin;
            }

            function binb2hex(binarray) {
                var hex_tab = '0123456789abcdef';
                var str = '';
                var length = binarray.length * 4;
                var srcByte;

                for (var i = 0; i < length; i += 1) {
                    srcByte = binarray[i >> 2] >> (3 - i % 4) * 8;
                    str += hex_tab.charAt(srcByte >> 4 & 0xF) + hex_tab.charAt(srcByte & 0xF);
                }

                return str;
            }

            function safe_add_2(x, y) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (x.lowOrder & 0xFFFF) + (y.lowOrder & 0xFFFF);
                msw = (x.lowOrder >>> 16) + (y.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (x.highOrder & 0xFFFF) + (y.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (x.highOrder >>> 16) + (y.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function safe_add_4(a, b, c, d) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF);
                msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function safe_add_5(a, b, c, d, e) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF) + (e.lowOrder & 0xFFFF);
                msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (e.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (e.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (e.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function maj(x, y, z) {
                return new int64(x.highOrder & y.highOrder ^ x.highOrder & z.highOrder ^ y.highOrder & z.highOrder, x.lowOrder & y.lowOrder ^ x.lowOrder & z.lowOrder ^ y.lowOrder & z.lowOrder);
            }

            function ch(x, y, z) {
                return new int64(x.highOrder & y.highOrder ^ ~x.highOrder & z.highOrder, x.lowOrder & y.lowOrder ^ ~x.lowOrder & z.lowOrder);
            }

            function rotr(x, n) {
                if (n <= 32) {
                    return new int64(x.highOrder >>> n | x.lowOrder << 32 - n, x.lowOrder >>> n | x.highOrder << 32 - n);
                } else {
                    return new int64(x.lowOrder >>> n | x.highOrder << 32 - n, x.highOrder >>> n | x.lowOrder << 32 - n);
                }
            }

            function sigma0(x) {
                var rotr28 = rotr(x, 28);
                var rotr34 = rotr(x, 34);
                var rotr39 = rotr(x, 39);

                return new int64(rotr28.highOrder ^ rotr34.highOrder ^ rotr39.highOrder, rotr28.lowOrder ^ rotr34.lowOrder ^ rotr39.lowOrder);
            }

            function sigma1(x) {
                var rotr14 = rotr(x, 14);
                var rotr18 = rotr(x, 18);
                var rotr41 = rotr(x, 41);

                return new int64(rotr14.highOrder ^ rotr18.highOrder ^ rotr41.highOrder, rotr14.lowOrder ^ rotr18.lowOrder ^ rotr41.lowOrder);
            }

            function gamma0(x) {
                var rotr1 = rotr(x, 1),
                    rotr8 = rotr(x, 8),
                    shr7 = shr(x, 7);

                return new int64(rotr1.highOrder ^ rotr8.highOrder ^ shr7.highOrder, rotr1.lowOrder ^ rotr8.lowOrder ^ shr7.lowOrder);
            }

            function gamma1(x) {
                var rotr19 = rotr(x, 19);
                var rotr61 = rotr(x, 61);
                var shr6 = shr(x, 6);

                return new int64(rotr19.highOrder ^ rotr61.highOrder ^ shr6.highOrder, rotr19.lowOrder ^ rotr61.lowOrder ^ shr6.lowOrder);
            }

            function shr(x, n) {
                if (n <= 32) {
                    return new int64(x.highOrder >>> n, x.lowOrder >>> n | x.highOrder << 32 - n);
                } else {
                    return new int64(0, x.highOrder << 32 - n);
                }
            }

            var str = utf8_encode(str);
            var strlen = str.length * charsize;
            var str = str2binb(str);

            str[strlen >> 5] |= 0x80 << 24 - strlen % 32;
            str[(strlen + 128 >> 10 << 5) + 31] = strlen;

            for (var i = 0; i < str.length; i += 32) {
                a = H[0];
                b = H[1];
                c = H[2];
                d = H[3];
                e = H[4];
                f = H[5];
                g = H[6];
                h = H[7];

                for (var j = 0; j < 80; j++) {
                    if (j < 16) {
                        W[j] = new int64(str[j * 2 + i], str[j * 2 + i + 1]);
                    } else {
                        W[j] = safe_add_4(gamma1(W[j - 2]), W[j - 7], gamma0(W[j - 15]), W[j - 16]);
                    }

                    T1 = safe_add_5(h, sigma1(e), ch(e, f, g), K[j], W[j]);
                    T2 = safe_add_2(sigma0(a), maj(a, b, c));
                    h = g;
                    g = f;
                    f = e;
                    e = safe_add_2(d, T1);
                    d = c;
                    c = b;
                    b = a;
                    a = safe_add_2(T1, T2);
                }

                H[0] = safe_add_2(a, H[0]);
                H[1] = safe_add_2(b, H[1]);
                H[2] = safe_add_2(c, H[2]);
                H[3] = safe_add_2(d, H[3]);
                H[4] = safe_add_2(e, H[4]);
                H[5] = safe_add_2(f, H[5]);
                H[6] = safe_add_2(g, H[6]);
                H[7] = safe_add_2(h, H[7]);
            }

            var binarray = [];
            for (var i = 0; i < H.length; i++) {
                binarray.push(H[i].highOrder);
                binarray.push(H[i].lowOrder);
            }
            return binb2hex(binarray);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(175)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  "data-v-3d0f547b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  "data-v-713e7952",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  "data-v-31e56fc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setts_js__ = __webpack_require__(19);





var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_2__services_validator__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Preset',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__setts_js__["a" /* default */]],
    data: function data() {
        return {
            is_logged_in: false,
            user: {},
            logdata: {},
            headerKey: 0
        };
    },


    methods: {
        set_url: function set_url(link) {
            if (link.includes('http') || link.includes('www')) {
                link = link.replace('www', 'https://www.');
                window.location.href = link;
            } else {
                window.location.href = "https://www." + link;
            }
        },
        set_auto_login: function set_auto_login() {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.logdata).length > 0) {
                localStorage.setItem("cityneeds_user", this.logdata.user_fullname);
                localStorage.setItem("cityneeds_token", this.logdata.user_session_key);
                localStorage.setItem("cityneeds_token_key", this.logdata.user_token_key);
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        _this.is_logged_in = true;
                        data.forEach(function (element) {
                            var _this2 = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this2.user = data.body.data;
                                    _this2.user.user_phone = "0" + _this2.user.user_phone;
                                    _this2.user.user_id = element.user_id;
                                    _this2.user.current_wallet_balance = 0;
                                    localStorage.setItem("cityneeds_user", _this2.user.user_fullname);

                                    _this2.getWalletBalance();

                                    _this2.getCNinsuranceAccounts();
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getWalletBalance: function getWalletBalance() {
            var _this3 = this;

            var set_user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletBalance(this, set_user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.user.current_wallet_balance = data.body.data_current_wallet_balance;

                    _this3.headerKey++;
                }
            }).catch(function (err) {
                if (err) {}
            });
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  "data-v-6827bbfe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  "data-v-6667e270",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  "data-v-7c8feb6f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }
    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setts_js__ = __webpack_require__(19);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PaymentsAndUpdates',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__setts_js__["a" /* default */]],
    data: function data() {
        return {
            is_logged_in: false,
            payment_set_amount: 500,
            payment_process_option: 0,
            payment_status: 0,
            callback_url: "",

            paymentModalComponentKey: 0,
            today: new Date()
        };
    },


    methods: {
        setPaymentOption: function setPaymentOption(option) {
            this.payment_process_option = option;
            if (this.payment_data.total_amount && this.payment_data.total_amount > 0) {
                if (this.payment_process_option == 1) {
                    this.processCNpaymentByGateway();
                } else if (this.payment_process_option == 2) {
                    this.processCNpaymentWithWallet();
                }
            }
            this.payment_process_option = 0;
        },
        processCNpaymentByGateway: function processCNpaymentByGateway() {
            var self = this;
            var gateway_pub_key = service.ravepay_public_live_paga;
            if (this.payment_data.payment_ravepay_pub_key != '') {
                gateway_pub_key = this.payment_data.payment_ravepay_pub_key;
            }

            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test,
                customer_email: this.payment_data.customerEmail,
                amount: this.payment_data.total_amount,
                customer_phone: this.payment_data.customerPhoneNumber,
                currency: "NGN",
                payment_method: "both",

                txref: this.payment_data.payment_ref,
                subaccounts: this.payment_data.payment_subaccounts,
                meta: this.payment_data.payment_meta,
                onclose: function onclose() {
                    setTimeout(function () {}, 20000);
                },
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.processing = true;
                        self.data_processing_message = "Payment made, Processing Data Update";

                        var txn_payload = {
                            "transaction_payment_ref": txref,
                            "transaction_module": self.payment_data.transaction_module,
                            "transaction_module_id": self.payment_data.transaction_module_id,
                            "transaction_type": self.payment_data.transaction_type,
                            "transaction_mode": 1,
                            "transaction_mode_transaction_ref": txref,
                            "transaction_amount_paid": tx_amount,
                            "payer_name": self.payment_data.customerName || "Nil",
                            "payer_email": self.payment_data.customerEmail,
                            "payer_phone": self.payment_data.customerPhoneNumber,
                            "payer_user": self.user.user_id || 0
                        };

                        self.postCNpaymentDetails(txn_payload);
                    } else {
                        self.payment_message = service.service_payment_failed;
                    }
                }
            });
        },
        processCNpaymentWithWallet: function processCNpaymentWithWallet() {
            var _this = this;

            var tx_amount = this.payment_data.total_amount;
            var tx_ref = this.payment_data.payment_ref;

            var payload = {
                pay: this.user.user_id,
                txn_amount: tx_amount,
                service: this.payment_data.transaction_service,
                service_ref: tx_ref
            };
            var test_mode = false;
            if (test_mode) {
                console.log("test_mode: chilling here");
            } else {
                var self = this;
                service.postWalletPayout(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        var txref = response.body.data_txn_ref;
                        var txn_payload = {
                            "transaction_payment_ref": self.payment_data.payment_ref,
                            "transaction_module": self.payment_data.transaction_module,
                            "transaction_module_id": self.payment_data.transaction_module_id,
                            "transaction_type": self.payment_data.transaction_type,
                            "transaction_mode": 2,
                            "transaction_mode_transaction_ref": txref,
                            "transaction_amount_paid": tx_amount,
                            "payer_name": self.payment_data.customerName || "Nil",
                            "payer_email": self.payment_data.customerEmail,
                            "payer_phone": self.payment_data.customerPhoneNumber,
                            "payer_user": self.user.user_id || 0
                        };

                        self.postCNpaymentDetails(txn_payload);
                    } else {
                        _this.payment_message = service.service_payment_failed;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        postCNpaymentDetails: function postCNpaymentDetails(txn_payload) {
            var self = this;
            service.postCNpaymentDetails(self, txn_payload).then(function (response) {
                var message = response.body.message;
                message = message.replace('{', '');
                self.payment_process_option = 0;
                if (response.body.status == 200) {
                    self.payment_status = 200;
                    self.data_processing_message = service.service_payment_circle_fully_successful;

                    localStorage.setItem("payment_modal_message", self.data_processing_message);
                } else if (response.body.status == 400) {
                    self.payment_status = 400;
                    self.data_processing_message = service.service_payment_circle_not_fully_successful + '\nIssue: ' + message;

                    localStorage.setItem("payment_modal_message", self.data_processing_message);
                    localStorage.setItem("reslove_issues", message);
                }
            }).catch(function (err) {});
        },
        afterPostPayment: function afterPostPayment(data) {
            if (data.data_callback_url && data.data_callback_url) {
                this.$router.push(this.callback_url);
            }
        },
        resetPaymentEvents: function resetPaymentEvents() {
            localStorage.removeItem("payment_modal_message");
            localStorage.removeItem("reslove_issues");
            localStorage.removeItem("reslove_issues_for");
        }
    },
    created: function created() {}
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Setts',
    data: function data() {
        return {
            is_logged_in: false,
            user: {},
            logdata: {},
            disable_btn: false,
            process_loading: false,
            current_page: 0
        };
    },


    methods: {
        jumpToView: function jumpToView(id) {
            document.getElementById(id).scrollIntoView();
        },
        toggleView: function toggleView(view) {
            var view_set = document.getElementById(view).style.display;
            if (view_set == "none") {
                document.getElementById(view).style.display = "block";
            } else if (view_set == "block") {
                document.getElementById(view).style.display = "none";
            }
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        },
        formatCurrency_2: function formatCurrency_2(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            currency = currency.replace(".00", "");
            return currency;
        },
        setProcessLoading: function setProcessLoading() {
            this.disable_btn = true;
            this.process_loading = true;
        },
        stopProcessLoading: function stopProcessLoading() {
            this.disable_btn = false;
            this.process_loading = false;
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_payments_and_updates_js__ = __webpack_require__(12);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsuranceFileComplaint',
    props: {
        payment_data: Object,
        payment_object: Object
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_payments_and_updates_js__["a" /* default */]],
    data: function data() {
        return {
            active_payment_processing: "false",
            data_processing_message: "",
            active_url: service.siteActiveUrl,
            call_src: 1 };
    },

    components: {},
    computed: {},
    methods: {
        resets: function resets() {
            this.payment_process_option = 0;
            this.data_processing_message = "";
        },
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");
            $('.modal-backdrop').remove();

            this.resets();
        },
        getModalMessage: function getModalMessage() {
            var msg = localStorage.getItem("payment_modal_message");
            localStorage.removeItem("payment_modal_message");
            return msg;
        },
        resolveIssues: function resolveIssues() {
            var resolve_url = localStorage.getItem("reslove_issues_for");
            if (resolve_url == '' || resolve_url == undefined) {
                location.replace('/account-cninsurance');
            } else {
                this.$router.push(resolve_url + '/resolve');
            }

            $('.modal-backdrop').remove();
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");

        var self = this;
        setTimeout(function () {
            var cs = localStorage.getItem("cityneeds_call_src");
            if (cs > 0) {
                self.call_src = cs;
            }
        }, 500);
    }
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-15c2eae6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(0);



var service = new __WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */]();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "getUserId",
        value: function getUserId() {
            var u = localStorage.getItem("cn_user");
            var user = JSON.parse(u);
            var uid = user.user_id;
            return uid;
        }
    }, {
        key: "getUserToken",
        value: function getUserToken() {
            var u = localStorage.getItem("cn_user");
            var user = JSON.parse(u);
            var token = user.user_token_key;
            return token;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Sidebar",
    data: function data() {
        return {
            forums: {},
            forum: {},
            search: {},
            survey: {},
            surveys: [],
            pageNotSurvey: true,
            siteUrl: service.siteUrl + "?title=",
            cnproParentCategories: {},
            sub_categories: {}
        };
    },

    components: {
        'prompts': __WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue___default.a
    },
    methods: {
        copyLink: function copyLink(survey) {
            this.$clipboard(this.siteUrl + survey.cnsurvey_title_url);
            var btn = $('.linky').tooltip({
                trigger: 'click',
                placement: 'bottom'
            });
            this.setTooltip(btn, 'Copied to Clipboard');
            this.hideTooltip(btn);
        },
        setTooltip: function setTooltip(btn, message) {
            btn.tooltip('hide').attr('data-original-title', message).tooltip('show');
        },
        hideTooltip: function hideTooltip(btn) {
            setTimeout(function () {
                btn.tooltip('hide');
            }, 1000);
        },
        setForum: function setForum(forum) {
            localStorage.setItem("cn_f", forum);
            this.$router.push("/forum");
        },
        getSurveys: function getSurveys() {
            var _this = this;

            service.getAllSurveys(this, 0, 1).then(function (res) {
                _this.surveys = res.body.data;
            });
        },
        getAllForums: function getAllForums() {
            var _this2 = this;

            service.getAllForums(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.forums = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        checkCurrentPage: function checkCurrentPage() {
            if (this.$route.path != '/cnsurveys') {
                this.pageNotSurvey = true;
            } else {
                this.pageNotSurvey = false;
            }
        },
        getCnproParentCategories: function getCnproParentCategories() {
            var _this3 = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this4 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this4.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this5 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            if (parent == "business-search") {
                this.search.type = 'business-search';
                this.getBusinessCategories();
            } else {
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent);
            }
        },
        prep_search: function prep_search(keywords) {
            this.search.keywords = keywords;
            this.search.city = 'Abuja';
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type + '?context=' + this.search.keywords + '&city=' + this.search.city);
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        this.getAllForums();
        this.getSurveys();
        this.checkCurrentPage();
        this.getCnproParentCategories();
    }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setts_js__ = __webpack_require__(19);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_2__services_validator__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DataServer',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__setts_js__["a" /* default */]],
    props: {
        payment_details_data: Object
    },
    description: 'For all integratable/sharable data calls eg: Businesses, CNpros....',
    data: function data() {
        return {
            businesses: {},
            business: {},
            cnsurveys: {},
            cnsurvey: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {},
            quote: {},
            businessCategories: {},

            cndiscounts: {},
            panelFlag: false,
            addFlag: false,
            editFlag: false,
            deleteFlag: false,
            cnsurveysPanel: false,
            img_url: service.imageURL,
            working_hours: [],
            business_working_hours: {},
            noBusinessSet: false,
            error_here: {},
            error_count: 0,

            terms_cn_agree: false,

            data_processing_message: "",

            set_payment_view: false,
            set_payment_details_data: {},
            set_payment_data: {},
            set_payment_object: {},
            set_payment_object_title: "",
            data_server_ready: true,
            files_info: [],
            imageForm: "",
            imagesFormArray: [],
            max_files_upload: 10,

            cndiscount_set_duration: 14 };
    },

    components: {},
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "add") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if (attr == "edit") {
                this.addFlag = false;
                this.deleteFlag = false;
                this.editFlag = true;
                this.business = attr2;
            }
            if (attr == "delete") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = true;
                this.business = attr2;
            }
            if (attr == "view-cnsurveys") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.cnsurveysPanel = true;
            }
        },
        resets: function resets() {
            this.set_payment_view = false;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(id) {
            var _this = this;

            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then(function (res) {
                _this.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this2 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.businessCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        addBusiness: function addBusiness() {
            this.error_count = 0;
            var credentials = {
                business_user: this.user.user_id,
                business_category: this.business.category,
                business_name: this.business.name,
                business_email: this.business.email,
                business_phone: this.business.phone,
                business_address: this.business.address || " ",
                business_state: 15,
                business_city: 1,
                business_description: this.business.description || " ",
                business_website: this.business.website || "nill",
                business_facebook: this.business.facebook || 'https://web.facebook.com/',
                business_twitter: this.business.twitter || 'https://twitter.com/',
                business_instagram: this.business.instagram || 'https://www.instagram.com/'
            };

            var navi = this.$router;
            if (credentials.business_user != null && credentials.business_name != null && credentials.business_category != null && credentials.business_email != null && credentials.business_city != null) {
                if (!valid.validateEmail(credentials.business_email)) {
                    this.error_here.email = "Invalid Email";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not valid', 'Warning!');
                }
                if (!valid.validateName(credentials.business_name)) {
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Business Name is not valid', 'Warning!');
                }
                if (!valid.validatePhoneNumber(credentials.business_phone)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }

                if (credentials.business_website != "nill" && !valid.validateWebsite(credentials.business_website)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Website is not valid', 'Warning!');
                } else if (this.error_count == 0) {
                    service.addBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Business Added!", "Success!");
                            location.reload(true);
                        } else {
                            toastr.error('Sorry, could not add Business', 'Warning!');
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    });
                } else {}
            } else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
        },
        getBusinesses: function getBusinesses() {
            var _this3 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getBusinesses(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.businesses = data.body.data;
                    var result = data.body.data;
                    var count = 0;
                    result.forEach(function (element) {
                        ++count;
                        if (count == 1) {
                            this.business = element;
                            this.getCities(this.business.business_state);
                        }
                    }, _this3);
                } else {
                    _this3.noBusinessSet = true;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusiness: function getBusiness(business) {
            var _this4 = this;

            this.panelFlag = false;
            this.cnsurveysPanel = false;
            service.getBusiness(this, business).then(function (data) {
                if (data.body.status == 200) {
                    _this4.business = data.body.data;
                    _this4.getCities(_this4.business.business_state);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        calcDaysBtwnDays: function calcDaysBtwnDays(date_1, date_2) {
            var date1 = new Date(date_1);
            var date2 = new Date(date_2);

            var difference_in_time = date2.getTime() - date1.getTime();

            var difference_in_days = difference_in_time / (1000 * 3600 * 24);

            return difference_in_days;
        },
        addNewDiscounts: function addNewDiscounts() {
            var _this5 = this;

            document.getElementById('dform_top').scrollIntoView();
            this.data_processing_message = "";
            var payload = {
                cndiscount_business_user: this.user.user_id,
                cndiscount_business_category: this.business.category || 0,
                cndiscount_business_name: this.business.name || "",
                cndiscount_business_address: this.business.address || "",
                cndiscount_business_location: this.business.location || "",
                cndiscount_business_map: this.business.map || "",
                cndiscount_business_map_lat: this.business.map_lat || "",
                cndiscount_business_map_lng: this.business.map_lng || "",

                cndiscount_business: this.business.business_id || 0,
                cndiscount_caption: this.cndiscount.cndiscount_caption,
                cndiscount_description: this.cndiscount.cndiscount_description,
                cndiscount_code: this.cndiscount.cndiscount_code,
                cndiscount_link: this.cndiscount.cndiscount_link || "#",
                cndiscount_start_date: this.cndiscount.cndiscount_start_date || "",
                cndiscount_expiry_date: this.cndiscount.cndiscount_expiry_date || "",
                cndiscount_normal_price: Number(this.cndiscount.cndiscount_normal_price) || 0,
                cndiscount_discount_price: Number(this.cndiscount.cndiscount_discount_price) || 0
            };

            var can_post = false;

            if (payload.cndiscount_business == 0 && payload.cndiscount_business_name == '') {
                this.data_processing_message = "Business details is not set";
            } else if (payload.cndiscount_business_category == 0 && payload.cndiscount_business_category == undefined) {
                this.data_processing_message = "Please select a business category";
            } else {
                if (payload.cndiscount_caption == '' || payload.cndiscount_code == '') {
                    this.data_processing_message = "Please fill in your discount details";
                } else {
                    if (payload.cndiscount_expiry_date == '' || payload.cndiscount_start_date == '') {
                        this.data_processing_message = "Please check dates";
                        can_post = false;
                    } else {
                        var get_calcDaysBtwnDays = this.calcDaysBtwnDays(payload.cndiscount_start_date, payload.cndiscount_expiry_date);
                        if (Number(get_calcDaysBtwnDays) > Number(this.cndiscount_set_duration)) {
                            this.data_processing_message = "Please check dates, duration should not be more than " + this.cndiscount_set_duration + " days";
                            can_post = false;
                        } else {
                            if (payload.cndiscount_normal_price == 0 && payload.cndiscount_discount_price == 0) {
                                this.data_processing_message = "Please check prices, discount price and normal price";
                                can_post = false;
                            } else {
                                if (payload.cndiscount_normal_price <= payload.cndiscount_discount_price) {
                                    this.data_processing_message = "Please check prices, discount price should be less than normal price";
                                    can_post = false;
                                } else {
                                    can_post = true;
                                }
                            }
                        }
                    }
                }
            }

            if (this.cndiscount.cndiscount_ref && this.cndiscount.cndiscount_ref != '') {
                payload.cndiscount_ref = this.cndiscount.cndiscount_ref;
            }

            if (can_post) {
                this.setProcessLoading();
                var set_upload_media = false;
                set_upload_media = true;
                service.addNewCNdiscount(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Submitted!", "Success!");

                        _this5.prepMakePayment(data.body.data.payment_data);
                    } else if (data.body.status == 202) {
                        toastr.success("Updated!", "Success!");

                        _this5.prepMakePayment(data.body.data.payment_data);
                    } else if (data.body.status == 200) {
                        toastr.success("Updated!", "Success!");
                        _this5.onFileChange(data.body.data_id);

                        location.reload("/business-listings");
                    } else {
                        toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                        _this5.data_processing_message = "Sorry, could not process, please check your entries and try again";
                    }
                    if (set_upload_media) {
                        if (_this5.files_info.length > 0) {
                            _this5.onFileChange(data.body.data_id);
                        }
                    }
                    _this5.stopProcessLoading();
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information, please check your entries', 'Warning!');
                        _this5.data_processing_message = "Sorry, could not process, please check your entries and try again";
                    }
                    _this5.stopProcessLoading();
                });
            }
        },
        prepSetCNdiscountPayment: function prepSetCNdiscountPayment(payment_data) {
            this.set_payment_object_title = "Make DiscountBazaar Setup Payment";
            this.set_payment_object_set_callback_url = "business-listings#discountbazaar";
            this.setPaymentDetails();

            this.setPaymentModeModal(payment_data);
        },
        prepMakePayment: function prepMakePayment(payment_data) {
            this.set_payment_details_data = payment_data;
            this.set_payment_view = true;
        },
        setPaymentModeModal: function setPaymentModeModal(payment_data) {
            this.data_processing_message = "Processing...";

            this.payment_status = 0;
            this.set_payment_data = payment_data;
            this.set_payment_data.callback_url = payment_data.callback_url;

            if (this.set_payment_data.total_amount && this.set_payment_data.total_amount > 0) {
                this.paymentModalComponentKey++;

                var self = this;
                setTimeout(function () {
                    $('#paywith').modal();
                    self.resets();
                }, 10);
            } else {
                this.data_processing_message = "Sorry could not fully submit form, please check your entry, or contact us";
            }
        },
        setPaymentDetails: function setPaymentDetails() {
            this.set_payment_object = {
                payment_detail_type: "general",
                payment_detail_name: this.set_payment_object_title,
                payment_detail_logo: "",
                payment_detail_set_callbackurl: this.set_payment_object_set_callback_url
            };
        },
        setPreps: function setPreps() {
            this.set_payment_details_data = this.payment_details_data;
        },
        setOnFileChange: function setOnFileChange(e, data) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var file = _step.value;

                        var set_name = this.cndiscount.cndiscount_caption.replace(/\s/g, '');
                        file = new File([file], set_name + "-cityneedsng-discounts.jpg");

                        var file_name = file.name;
                        var pos = file_name.lastIndexOf(".");
                        var set_file_name = file_name.substr(0, pos < 0 ? file_name.length : pos) + ".jpg";
                        set_file_name = set_file_name.replace(' ', '-');
                        var new_File = new File([file], set_file_name);
                        this.files_info.push(new_File);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        onFileChange: function onFileChange(data) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.files_info), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var file = _step2.value;

                    var formData = new FormData();
                    formData.append('photo', file);
                    formData.append('data_id', data);
                    formData.append('data_type', "cndiscount_media");
                    service.uploadDataPhoto(this, formData).then(function (response) {}).catch(function (err) {});
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        getCNSettings: function getCNSettings() {
            service.getCNSettings(this).then(function (data) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.body.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var setting = _step3.value;

                        if (setting.setting_id == 1) {
                            this.cndiscount_set_duration = setting.setting_value;
                            console.log(this.cndiscount_set_duration);
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            });
        }
    },
    mounted: function mounted() {},
    created: function created() {
        this.getCNSettings();
        this.setPreps();
        this.setPaymentDetails();
        this.getStates();
        this.getBusinessCategories();
        this.getBusinesses();
    }
});

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  "data-v-67f2fe40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-2c64a4a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(158)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  "data-v-09552e6b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(178)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  "data-v-3eb405ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  "data-v-557b28db",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_index_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ref_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ref_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Ref_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Register_index_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Register_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Register_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_index_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Login_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ResetPassword_index_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ResetPassword_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ResetPassword_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_index_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Dashboard_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Profile_index_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Profile_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Profile_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Cnpros_index_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Cnpros_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Cnpros_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Cnpro_index_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Cnpro_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Cnpro_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CnproSearch_index_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CnproSearch_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_CnproSearch_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Businesses_index_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Businesses_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Businesses_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Business_index_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Business_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Business_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_BusinessSearch_index_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_BusinessSearch_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_BusinessSearch_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CnproAccounts_index_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CnproAccounts_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_CnproAccounts_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_BusinessListings_index_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_BusinessListings_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_BusinessListings_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Contracts_index_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Contracts_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Contracts_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SavedListings_index_vue__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SavedListings_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_SavedListings_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Forums_index_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Forums_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Forums_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Forum_index_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Forum_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Forum_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Cnsurveys_index_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Cnsurveys_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Cnsurveys_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Cnsurvey_index_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Cnsurvey_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Cnsurvey_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_CnsurveyRequests_index_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_CnsurveyRequests_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_CnsurveyRequests_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Pricing_index_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Pricing_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Pricing_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Terms_index_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Terms_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Terms_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Policy_index_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Policy_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Policy_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_About_index_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_About_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_About_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_HowItWorks_index_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_HowItWorks_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_HowItWorks_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_MyMoney_index_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_MyMoney_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_MyMoney_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_FindCnpro_index_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_FindCnpro_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_FindCnpro_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_CNwallet_index_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_CNwallet_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_CNwallet_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_MyReferrals_index_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_MyReferrals_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_MyReferrals_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_CNpayTransactions_index_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_CNpayTransactions_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_CNpayTransactions_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_CNdiscountSystem_Template_index_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_CNdiscountSystem_Template_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_CNdiscountSystem_Template_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_CNdiscountSystem_CNdiscounts_index_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_CNdiscountSystem_CNdiscounts_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_CNdiscountSystem_CNdiscounts_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_CNdiscountSystem_CNdiscountPost_index_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_CNdiscountSystem_CNdiscountPost_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_CNdiscountSystem_CNdiscountPost_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_CNdiscountSetup_index_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_CNdiscountSetup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_CNdiscountSetup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_CNInsuranceSystem_Template_index_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_CNInsuranceSystem_Template_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_CNInsuranceSystem_Template_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_CNInsuranceSystem_CNInsurance_index_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_CNInsuranceSystem_CNInsurance_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_CNInsuranceSystem_CNInsurance_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_CNInsuranceSystem_CNInsuranceListing_index_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_CNInsuranceSystem_CNInsuranceListing_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_CNInsuranceSystem_CNInsuranceListing_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Account_Template_index_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Account_Template_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Account_Template_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Account_CNinsurance_index_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Account_CNinsurance_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Account_CNinsurance_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_PricingPayments_index_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_PricingPayments_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_PricingPayments_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_CNPayments_index_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_CNPayments_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_CNPayments_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_CNProcesses_index_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_CNProcesses_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_CNProcesses_index_vue__);

















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_2__components_Home_index_vue___default.a }, { path: '/register', name: 'Register', component: __WEBPACK_IMPORTED_MODULE_4__components_Register_index_vue___default.a }, { path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_5__components_Login_index_vue___default.a }, { path: '/reset', name: 'ResetPassword', component: __WEBPACK_IMPORTED_MODULE_6__components_ResetPassword_index_vue___default.a }, { path: '/dashboard', name: 'Dashboard', component: __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_index_vue___default.a }, {
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_41__components_Account_Template_index_vue___default.a,
    children: [{
      path: '/account-cninsurance',
      name: 'CNinsuranceAccount',
      component: __WEBPACK_IMPORTED_MODULE_42__components_Account_CNinsurance_index_vue___default.a
    }, {
      path: '/account-cninsurance/:ref',
      name: 'CNinsuranceAccountRef',
      component: __WEBPACK_IMPORTED_MODULE_42__components_Account_CNinsurance_index_vue___default.a
    }]
  }, { path: '/profile', name: 'Profile', component: __WEBPACK_IMPORTED_MODULE_8__components_Profile_index_vue___default.a }, { path: '/cnpros', name: 'Cnpros', component: __WEBPACK_IMPORTED_MODULE_9__components_Cnpros_index_vue___default.a, meta: { title: 'CNpros', metaTags: [{
        name: 'description',
        content: 'Find Pre-verified Freelance Service Professionals  (CNpros)'
      }, {
        property: 'og:description',
        content: 'Find Pre-verified Freelance Service Professionals  (CNpros)'
      }] } }, { path: '/cnpro-search', name: 'CnproSearch', component: __WEBPACK_IMPORTED_MODULE_11__components_CnproSearch_index_vue___default.a }, { path: '/cnpro', name: 'Cnpro', component: __WEBPACK_IMPORTED_MODULE_10__components_Cnpro_index_vue___default.a }, { path: '/businesses', name: 'Businesses', component: __WEBPACK_IMPORTED_MODULE_12__components_Businesses_index_vue___default.a, meta: { title: 'Businesses', metaTags: [{
        name: 'description',
        content: 'Find Pre-verified Businesses'
      }, {
        property: 'og:description',
        content: 'Find Pre-verified Businesses'
      }] } }, { path: '/business', name: 'Business', component: __WEBPACK_IMPORTED_MODULE_13__components_Business_index_vue___default.a }, { path: '/business-search', name: 'BusinessSearch', component: __WEBPACK_IMPORTED_MODULE_14__components_BusinessSearch_index_vue___default.a }, { path: '/cnpro-accounts', name: 'CnproAccounts', component: __WEBPACK_IMPORTED_MODULE_15__components_CnproAccounts_index_vue___default.a }, { path: '/business-listings', name: 'BusinessListings', component: __WEBPACK_IMPORTED_MODULE_16__components_BusinessListings_index_vue___default.a }, { path: '/contracts', name: 'Contracts', component: __WEBPACK_IMPORTED_MODULE_17__components_Contracts_index_vue___default.a }, { path: '/saved-listings', name: 'SavedListings', component: __WEBPACK_IMPORTED_MODULE_18__components_SavedListings_index_vue___default.a }, { path: '/forums', name: 'Forums', component: __WEBPACK_IMPORTED_MODULE_19__components_Forums_index_vue___default.a }, { path: '/forum', name: 'Forum', component: __WEBPACK_IMPORTED_MODULE_20__components_Forum_index_vue___default.a }, { path: '/cnsurveys', name: 'Cnsurveys', component: __WEBPACK_IMPORTED_MODULE_21__components_Cnsurveys_index_vue___default.a }, { path: '/cnsurvey', name: 'Cnsurvey', component: __WEBPACK_IMPORTED_MODULE_22__components_Cnsurvey_index_vue___default.a }, { path: '/survey-requests', name: 'CnsurveyRequests', component: __WEBPACK_IMPORTED_MODULE_23__components_CnsurveyRequests_index_vue___default.a }, { path: '/pricing', name: 'Pricing Page', component: __WEBPACK_IMPORTED_MODULE_24__components_Pricing_index_vue___default.a }, { path: '/pricingpayments', name: 'Pricing Payments', component: __WEBPACK_IMPORTED_MODULE_43__components_PricingPayments_index_vue___default.a }, { path: '/cnpayments', name: 'CNPayments', component: __WEBPACK_IMPORTED_MODULE_44__components_CNPayments_index_vue___default.a }, { path: '/cnprocesses', name: 'CNProcesses', component: __WEBPACK_IMPORTED_MODULE_45__components_CNProcesses_index_vue___default.a }, { path: '/terms', name: 'Terms', component: __WEBPACK_IMPORTED_MODULE_25__components_Terms_index_vue___default.a }, { path: '/policy', name: 'Policy', component: __WEBPACK_IMPORTED_MODULE_26__components_Policy_index_vue___default.a }, { path: '/about', name: 'About', component: __WEBPACK_IMPORTED_MODULE_27__components_About_index_vue___default.a }, { path: '/how-it-works', name: 'HowItWorks', component: __WEBPACK_IMPORTED_MODULE_28__components_HowItWorks_index_vue___default.a }, { path: '/mymoney', name: 'MyMoney', component: __WEBPACK_IMPORTED_MODULE_29__components_MyMoney_index_vue___default.a }, { path: '/help-me-find-a-cnpro', name: 'FindCnpro', component: __WEBPACK_IMPORTED_MODULE_30__components_FindCnpro_index_vue___default.a }, { path: '/cnwallet', name: 'CNwallet', component: __WEBPACK_IMPORTED_MODULE_31__components_CNwallet_index_vue___default.a }, { path: '/cnpaytransactions', name: 'CNpayTransactions', component: __WEBPACK_IMPORTED_MODULE_33__components_CNpayTransactions_index_vue___default.a }, { path: '/myreferrals', name: 'MyReferrals', component: __WEBPACK_IMPORTED_MODULE_32__components_MyReferrals_index_vue___default.a }, { path: '/cndiscountsetup', name: 'CNdiscountsetup', component: __WEBPACK_IMPORTED_MODULE_37__components_CNdiscountSetup_index_vue___default.a }, { path: '/discountbazaarsetup', name: 'DiscountBazaarsetup', component: __WEBPACK_IMPORTED_MODULE_37__components_CNdiscountSetup_index_vue___default.a }, {
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_34__components_CNdiscountSystem_Template_index_vue___default.a,
    children: [{
      path: '/cndiscounts',
      name: 'CNdiscounts',
      component: __WEBPACK_IMPORTED_MODULE_35__components_CNdiscountSystem_CNdiscounts_index_vue___default.a
    }, {
      path: '/cndiscount' + ':cndiscountref',
      name: 'CNdiscountPost',
      component: __WEBPACK_IMPORTED_MODULE_36__components_CNdiscountSystem_CNdiscountPost_index_vue___default.a
    }, {
      path: '/discountbazaar/',
      name: 'DiscountBazaar',
      component: __WEBPACK_IMPORTED_MODULE_35__components_CNdiscountSystem_CNdiscounts_index_vue___default.a
    }, {
      path: '/discountbazaar' + ':cndiscountref',
      name: 'DiscountBazaarPost',
      component: __WEBPACK_IMPORTED_MODULE_36__components_CNdiscountSystem_CNdiscountPost_index_vue___default.a
    }]
  }, {
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_38__components_CNInsuranceSystem_Template_index_vue___default.a,
    children: [{
      path: '/cninsurance',
      name: 'CNInsurance',
      component: __WEBPACK_IMPORTED_MODULE_39__components_CNInsuranceSystem_CNInsurance_index_vue___default.a
    }, {
      path: '/cninsurance' + ':cninsurancelisting',
      name: 'CNInsuranceListing',
      component: __WEBPACK_IMPORTED_MODULE_40__components_CNInsuranceSystem_CNInsuranceListing_index_vue___default.a
    }, {
      path: '/insuremoto',
      name: 'InsureMoto',
      component: __WEBPACK_IMPORTED_MODULE_39__components_CNInsuranceSystem_CNInsurance_index_vue___default.a
    }, {
      path: '/insuremoto' + ':cninsurancelisting',
      name: 'InsureMotoListing',
      component: __WEBPACK_IMPORTED_MODULE_40__components_CNInsuranceSystem_CNInsuranceListing_index_vue___default.a
    }, {
      path: '/:cninsurancelisting/:ref',
      name: 'CNInsuranceListingRef',
      component: __WEBPACK_IMPORTED_MODULE_40__components_CNInsuranceSystem_CNInsuranceListing_index_vue___default.a
    }]
  }, { path: '/:refno', component: __WEBPACK_IMPORTED_MODULE_3__components_Ref_vue___default.a,
    children: [{
      path: '',
      name: 'Ref',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Ref_vue___default.a
    }] }, { path: '/cnpro/', name: 'Cnpro', component: __WEBPACK_IMPORTED_MODULE_10__components_Cnpro_index_vue___default.a }, { path: '/businesses/', name: 'Businesses', component: __WEBPACK_IMPORTED_MODULE_12__components_Businesses_index_vue___default.a }, { path: '/discountbazaar/', name: 'DiscountBazaar', component: __WEBPACK_IMPORTED_MODULE_35__components_CNdiscountSystem_CNdiscounts_index_vue___default.a }]
}));

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var inBrowser = typeof window !== 'undefined';
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueProgress',
    serverCacheKey: function serverCacheKey() {
        return 'Progress';
    },
    computed: {
        style: function style() {
            var location = this.progress.options.location;
            var style = {
                'background-color': this.progress.options.canSuccess ? this.progress.options.color : this.progress.options.failedColor,
                'opacity': this.progress.options.show ? 1 : 0
            };
            if (location == 'top' || location == 'bottom') {
                location === 'top' ? style.top = '0px' : style.bottom = '0px';
                if (!this.progress.options.inverse) {
                    style.left = '0px';
                } else {
                    style.right = '0px';
                }
                style.width = this.progress.percent + '%';
                style.height = this.progress.options.thickness;
                style.transition = "width " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            } else if (location == 'left' || location == 'right') {
                location === 'left' ? style.left = '0px' : style.right = '0px';
                if (!this.progress.options.inverse) {
                    style.bottom = '0px';
                } else {
                    style.top = '0px';
                }
                style.height = this.progress.percent + '%';
                style.width = this.progress.options.thickness;
                style.transition = "height " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            }
            return style;
        },
        progress: function progress() {
            if (inBrowser) {
                return window.VueProgressBarEventBus.RADON_LOADING_BAR;
            } else {
                return {
                    percent: 0,
                    options: {
                        canSuccess: true,
                        show: false,
                        color: 'rgb(19, 91, 55)',
                        failedColor: 'red',
                        thickness: '2px',
                        transition: {
                            speed: '0.2s',
                            opacity: '0.6s',
                            termination: 300
                        },
                        location: 'top',
                        autoRevert: true,
                        inverse: false
                    }
                };
            }
        }
    }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utility__ = __webpack_require__(26);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var utility = new __WEBPACK_IMPORTED_MODULE_1__services_utility__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "CreateThread",
    data: function data() {
        return {
            user: {},
            thread: {},
            pro: [],
            businesses: [],
            imageForm: {},
            set_image: false,
            loggedIn: false
        };
    },

    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.loggedIn = true;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        createThreadXX: function createThreadXX() {
            localStorage.setItem("cn_prv_page", "forums");
            this.preset();
            var data = this.thread;
            data.forum_business = 0;
            data.forum_cnpro = 0;

            data.forum_created_by = this.user.user_id;
            service.postThread(this, data).then(function (response) {
                if (response.body.status = 201) {
                    toastr.success("Thread created", 'Ok buddy');
                    window.location.reload();
                } else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!');
                }
            });
        },
        createThread: function createThread() {
            var _this2 = this;

            localStorage.setItem("cn_prv_page", "forums");
            this.preset();
            var data = this.thread;
            data.forum_business = 0;
            data.forum_cnpro = 0;

            data.forum_created_by = this.user.user_id;
            service.postThread(this, data).then(function (response) {
                if (response.body.status = 201) {
                    _this2.thread = {};
                    toastr.success("Thread created", 'Ok buddy');

                    if (_this2.set_image) {
                        var forum_id = response.body.data;
                        _this2.imageForm.append("data_id", forum_id);
                        _this2.imageForm.append("data_type", "forum_attachment");
                        service.uploadDataPhoto(_this2, _this2.imageForm).then(function (data) {
                            location.reload();
                        }).catch(function (err) {
                            if (err) {}
                        });
                    } else {
                        location.reload();
                    }
                } else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!');
                }
            });
        },
        getUserCat: function getUserCat(choice) {
            var _this3 = this;

            var token = utility.getUserToken();

            if (choice == 1) {
                service.getUserPros(this, token).then(function (res) {
                    _this3.pro = res.body.data;
                });
            } else if (choice == 2) {
                service.getBusinesses(this, token).then(function (res) {
                    console.log(res.body.data);
                });
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
                this.set_image = true;
            }
        },
        setReg: function setReg() {
            localStorage.setItem("current_page", 'forums');
            location.replace('login');
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        }
    }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Sidebar",
    data: function data() {
        return {
            forums: {},
            forum: {},
            search: {},
            survey: {},
            surveys: [],
            pageNotSurvey: true,
            cnproParentCategories: {},
            sub_categories: {}
        };
    },


    methods: {
        setForum: function setForum(forum) {
            localStorage.setItem("cn_f", forum);
            this.$router.push("/forum");
        },
        getSurveys: function getSurveys() {
            var _this = this;

            service.allSurveys(this).then(function (res) {
                _this.surveys = res.body.data;
            });
        },
        getAllForums: function getAllForums() {
            var _this2 = this;

            service.getAllForums(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.forums = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        checkCurrentPage: function checkCurrentPage() {
            if (this.$route.path != '/cnsurveys') {
                this.pageNotSurvey = true;
            } else {
                this.pageNotSurvey = false;
            }
        },
        getCnproParentCategories: function getCnproParentCategories() {
            var _this3 = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this4 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this4.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this5 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            if (parent == "business-search") {
                this.search.type = 'business-search';
                this.getBusinessCategories();
            } else {
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent);
            }
        },
        prep_search: function prep_search(keywords) {
            this.search.keywords = keywords;
            this.search.city = 'Abuja';
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type + '?context=' + this.search.keywords + '&city=' + this.search.city);
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        this.getAllForums();
        this.getSurveys();
        this.checkCurrentPage();
        this.getCnproParentCategories();
    }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Ref",
    data: function data() {
        return {};
    },

    methods: {},
    created: function created() {
        if (this.$route.params.refno) {
            var arr_ref = this.$route.params.refno;
            var arr = arr_ref.split("ref");
            localStorage.setItem("cityneeds_ref", arr[1]);

            location.replace("/");
        }
    }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "SearchBar",
    data: function data() {
        return {
            search: {},
            cnproParentCategories: {},
            sub_categories: {}
        };
    },

    methods: {
        getCnproParentCategories: function getCnproParentCategories() {
            var _this = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this2 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this2.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this3 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            if (parent == "business-search") {
                this.search.type = 'business-search';
                this.getBusinessCategories();
            } else {
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent);
            }
        },
        prep_search: function prep_search(keywords) {
            this.search.keywords = keywords;
            this.search.city = 'Abuja';
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                location.replace(this.search.type + '?context=' + this.search.keywords + '&city=' + this.search.city);
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        this.getCnproParentCategories();
    }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'About',
    data: function data() {
        return {};
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },

    created: function created() {}
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Dashboard_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__templates_CNInsuranceForm_index_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__templates_CNInsuranceForm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__templates_CNInsuranceForm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__templates_CNinsuranceFileComplaint_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__templates_CNinsuranceFileComplaint_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__templates_CNinsuranceFileComplaint_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__templates_CNinsuranceFileClaim_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__templates_CNinsuranceFileClaim_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__templates_CNinsuranceFileClaim_index_vue__);


















var service = new __WEBPACK_IMPORTED_MODULE_5__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_6__services_validator__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNinsuranceAccounts',
    mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_preset_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            cninsurance_accounts: {},
            cninsurance_account: {},
            cninsurance_account_forms: {},
            cninsurance_partner: {},
            cninsurance_form: {},
            cninsurance_data: {},
            current_form_data: {},
            current_form_data_form_entries: {},
            cninsurance_account_claims: {},
            cninsurance_account_complaints: {},
            cninsurance_claim: {},
            cninsurance_complaint: {},
            cninsurance_account_unsubmitted_forms: 0,
            cninsurance_account_unpaid_forms: 0,
            viewAll: false,
            viewOne: true,
            set_component_view: {},
            set_main_view: {},

            set_renew_selected: false,
            set_renew_selected_form_data: {},
            set_renew_selected_form_data_form_entries: {},

            set_resubmit: false,
            set_submit_form_data: {},
            set_submit_form_data_form_entries: {},
            loading: true
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_7__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_8__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_9__Dashboard_Footer_index_vue___default.a,
        'cninsurance-post-form': __WEBPACK_IMPORTED_MODULE_11__templates_CNInsuranceForm_index_vue___default.a,
        'cninsurance-file-complaint': __WEBPACK_IMPORTED_MODULE_12__templates_CNinsuranceFileComplaint_index_vue___default.a,
        'cninsurance-file-claim': __WEBPACK_IMPORTED_MODULE_13__templates_CNinsuranceFileClaim_index_vue___default.a
    },
    methods: {
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");
            $('.modal-backdrop').remove();
            this.reset_views();
        },
        reset_views: function reset_views() {
            this.set_component_view = {};
        },
        setMainView: function setMainView(view, attr1, attr2) {
            this.set_main_view = {};
            this.set_main_view[view] = true;

            if (view == "renew_selected") {
                this.set_renew_selected = true;
                this.set_renew_selected_form_data = attr1;
                this.set_cninsurance_form_values(attr1.cninsurance_form_entries);
            }

            if (view == "resubmit") {
                this.set_resubmit = true;
                this.set_submit_form_data = attr1;
                this.set_cninsurance_form_values(attr1.cninsurance_form_entries);
            }
        },
        setComponentView: function setComponentView(view, attr1, attr2) {
            this.set_component_view = {};
            this.set_component_view[view] = true;
        },
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;

            if (attr == "add") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }

            if (attr == "edit") {
                this.addFlag = false;
                this.deleteFlag = false;
                this.editFlag = true;
                this.business = attr2;
            }

            if (attr == "delete") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = true;
                this.business = attr2;
            }

            if (attr == "view-cnsurveys") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.cnsurveysPanel = true;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(id) {
            var _this = this;

            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then(function (res) {
                _this.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this2 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.businessCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        setModalContentView: function setModalContentView(view, attr1, attr2) {
            $('.modal').modal('hide');

            if (view == 'show_form') {
                this.cninsurance_form = attr1;
                this.cninsurance_data.cninsurance_form = this.cninsurance_form.cninsurance_form_policy_id;
                $('#show_form').modal();
            } else if (view == 'show_claim') {
                this.cninsurance_claim = attr1;
                $('#show_claim').modal();
            }
        },
        set_cninsurance_form_values: function set_cninsurance_form_values(form) {
            var set_form = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(form), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var entry = _step.value;

                    if (entry.cninsurance_form_entry_type == 1) {
                        set_form.cninsurance_form_first_name = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 2) {
                        set_form.cninsurance_form_last_name = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 3) {
                        set_form.cninsurance_form_dob = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 4) {
                        set_form.cninsurance_form_gender = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 5) {
                        set_form.cninsurance_form_email = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 6) {
                        var set_no = entry.cninsurance_form_entry_value_f.split("_");
                        set_form.cninsurance_form_phone = set_no[1];
                    }

                    if (entry.cninsurance_form_entry_type == 7) {
                        set_form.cninsurance_form_address = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 8) {
                        set_form.cninsurance_form_vehicle_reg_no = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 9) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.cninsurance_partner.cninsurance_form_variables), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var va = _step2.value;

                                if (va.cninsurance_form_variable_type_id == 9) {
                                    var _iteratorNormalCompletion3 = true;
                                    var _didIteratorError3 = false;
                                    var _iteratorError3 = undefined;

                                    try {
                                        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(va.cninsurance_form_variable_type_values), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                            var vc = _step3.value;

                                            if (vc.cninsurance_form_variable_id == entry.cninsurance_form_entry_value_has_id) {
                                                set_form.cninsurance_form_vehicle_class = vc;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                _iterator3.return();
                                            }
                                        } finally {
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }

                    if (entry.cninsurance_form_entry_type == 10) {
                        set_form.cninsurance_form_vehicle_make = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 11) {
                        set_form.cninsurance_form_vehicle_model = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 12) {
                        set_form.cninsurance_form_vehicle_number_plate = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 13) {
                        set_form.cninsurance_form_vehicle_chassis_number = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 14) {
                        set_form.cninsurance_form_vehicle_engine_number = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 15) {
                        set_form.cninsurance_form_year_of_manufacture = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 16) {
                        set_form.cninsurance_form_year_of_purchase = entry.cninsurance_form_entry_value;
                    }

                    if (entry.cninsurance_form_entry_type == 17) {
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.cninsurance_partner.cninsurance_form_variables), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var _va = _step4.value;

                                if (_va.cninsurance_form_variable_type_id == 17) {
                                    var _iteratorNormalCompletion5 = true;
                                    var _didIteratorError5 = false;
                                    var _iteratorError5 = undefined;

                                    try {
                                        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_va.cninsurance_form_variable_type_values), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                            var ph = _step5.value;

                                            if (ph.cninsurance_form_variable_id == entry.cninsurance_form_entry_value_has_id) {
                                                set_form.cninsurance_form_policyholder_type = ph;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                _iterator5.return();
                                            }
                                        } finally {
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }

                    if (entry.cninsurance_form_entry_type == 18) {
                        set_form.cninsurance_form_company_name = entry.cninsurance_form_entry_value;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.set_renew_selected) {
                this.set_renew_selected_form_data_form_entries = set_form;
                this.set_renew_selected = false;
            } else if (this.set_resubmit) {
                set_form.cninsurance_form_ref = this.set_submit_form_data.cninsurance_form_ref;
                this.set_submit_form_data_form_entries = set_form;
                this.set_resubmit = false;
            } else {
                this.current_form_data_form_entries = set_form;
            }
        },
        getCNinsuranceAccounts: function getCNinsuranceAccounts() {
            var _this3 = this;

            service.getCNinsuranceUserAccounts(this, this.user.user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cninsurance_accounts = data.body.data;
                    _this3.cninsurance_account = _this3.cninsurance_accounts[_this3.cninsurance_accounts.length - 1];

                    _this3.cninsurance_partner = _this3.cninsurance_account.cninsurance_account_cninsurance_data;

                    _this3.getCNinsuranceUserAccountForms();
                }
            }).catch(function (err) {
                if (err) {
                    _this3.loading = false;
                }
            });
        },
        getCNinsuranceUserAccountForms: function getCNinsuranceUserAccountForms() {
            var _this4 = this;

            if (this.cninsurance_account.cninsurance_account_id > 0) {
                service.getCNinsuranceAccountForms(this, this.cninsurance_account.cninsurance_account_id).then(function (data) {
                    if (data.body.status == 200) {
                        _this4.cninsurance_account_forms = data.body.data;

                        _this4.current_form_data = data.body.data_current_form_data;
                        _this4.set_cninsurance_form_values(_this4.current_form_data.cninsurance_form_entries);
                        _this4.cninsurance_account_unpaid_forms = data.body.data_count_unpaid;
                        _this4.cninsurance_account_unsubmitted_forms = data.body.data_count_unsubmit;

                        var form_index = 0;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this4.cninsurance_account_forms), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var form = _step6.value;

                                _this4.cninsurance_account_forms[form_index].form_details = '';
                                var form_vechicle_make = '';var form_vechicle_model = '';
                                var _iteratorNormalCompletion7 = true;
                                var _didIteratorError7 = false;
                                var _iteratorError7 = undefined;

                                try {
                                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(form.cninsurance_form_entries), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        var entry = _step7.value;

                                        if (entry.cninsurance_form_entry_type == 10) {
                                            form_vechicle_make = entry.cninsurance_form_entry_value;
                                        }

                                        if (entry.cninsurance_form_entry_type == 11) {
                                            form_vechicle_model = entry.cninsurance_form_entry_value;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError7 = true;
                                    _iteratorError7 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                            _iterator7.return();
                                        }
                                    } finally {
                                        if (_didIteratorError7) {
                                            throw _iteratorError7;
                                        }
                                    }
                                }

                                _this4.cninsurance_account_forms[form_index].form_details = form_vechicle_make + " " + form_vechicle_model;
                                form_index++;
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }

                        _this4.getCNinsuranceUserAccountClaims();
                        _this4.getCNinsuranceUserAccountComplaints();

                        _this4.loading = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this4.loading = false;
                    }
                });
            }
        },
        getCNinsuranceUserAccountClaims: function getCNinsuranceUserAccountClaims() {
            var _this5 = this;

            service.getCNinsuranceAccountClaims(this, this.cninsurance_account.cninsurance_account_id).then(function (data) {
                if (data.body.status == 200) {
                    _this5.cninsurance_account_claims = data.body.data;
                }
            }).catch(function (err) {});
        },
        getCNinsuranceUserAccountComplaints: function getCNinsuranceUserAccountComplaints() {
            var _this6 = this;

            service.getCNinsuranceAccountComplaints(this, this.cninsurance_account.cninsurance_account_id).then(function (data) {
                if (data.body.status == 200) {
                    _this6.cninsurance_account_complaints = data.body.data;
                }
            }).catch(function (err) {});
        }
    },
    mounted: function mounted() {
        var self = this;
    },
    created: function created() {
        this.setMainView('forms');
    }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsuranceSystem',
    data: function data() {
        return {};
    },

    components: {},
    methods: {},

    created: function created() {}
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_CNdiscountForm_index_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_CNdiscountForm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__templates_CNdiscountForm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_setts_js__ = __webpack_require__(19);







var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_1__services_validator__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BusinessListings',
    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_setts_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            cnsurvey: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {},
            quote: {},
            businessCategories: {},
            cndiscount: {},
            cndiscounts: {},
            set_cndiscount: {},
            set_view_cndiscount: false,
            set_update_cndiscount: false,
            panelFlag: false,
            addFlag: false,
            editFlag: false,
            deleteFlag: false,
            cnsurveysPanel: false,
            img_url: service.imageURL,
            working_hours: [],
            business_working_hours: {},
            noBusinessSet: false,
            error_here: {},
            error_count: 0,

            component_view: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue___default.a,
        'cndiscount-form': __WEBPACK_IMPORTED_MODULE_5__templates_CNdiscountForm_index_vue___default.a
    },
    methods: {
        setComponentView: function setComponentView(view, attr1, attr2) {
            this.component_view = {};
            this.component_view[view] = true;

            document.getElementById('discountbazaar').scrollIntoView();
        },
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "add") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if (attr == "edit") {
                this.addFlag = false;
                this.deleteFlag = false;
                this.editFlag = true;
                this.business = attr2;
                this.initMap();
            }
            if (attr == "delete") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = true;
                this.business = attr2;
            }
            if (attr == "view-cnsurveys") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.cnsurveysPanel = true;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        set_url: function set_url(link) {
            if (link.includes('http') || link.includes('www')) {
                window.location.href = link;
            } else {
                window.location.href = "http://" + link;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getWorkingHours: function getWorkingHours() {
            this.working_hours = ['12:00 AM', '01:00 AM', '02:00 AM', '03:00 AM', '04:00 AM', '06:00 AM', '07:00 AM', '08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '06:00 PM', '07:00 PM', '08:00 PM', '09:00 PM', '10:00 PM', '11:00 PM'];
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(id) {
            var _this2 = this;

            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then(function (res) {
                _this2.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this3 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.businessCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        addBusiness: function addBusiness() {
            this.error_count = 0;
            var credentials = {
                business_user: this.user.user_id,
                business_category: this.business.category,
                business_name: this.business.name,
                business_email: this.business.email,
                business_phone: this.business.phone,
                business_address: this.business.address || " ",
                business_state: 15,
                business_city: 1,
                business_description: this.business.description || " ",
                business_website: this.business.website || "nill",
                business_facebook: this.business.facebook || 'https://web.facebook.com/',
                business_twitter: this.business.twitter || 'https://twitter.com/',
                business_instagram: this.business.instagram || 'https://www.instagram.com/'
            };

            var navi = this.$router;
            if (credentials.business_user != null && credentials.business_name != null && credentials.business_category != null && credentials.business_email != null && credentials.business_city != null) {
                if (!valid.validateEmail(credentials.business_email)) {
                    this.error_here.email = "Invalid Email";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not valid', 'Warning!');
                }
                if (!valid.validateName(credentials.business_name)) {
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Business Name is not valid', 'Warning!');
                }
                if (!valid.validatePhoneNumber(credentials.business_phone)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }

                if (credentials.business_website != "nill" && !valid.validateWebsite(credentials.business_website)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Website is not valid', 'Warning!');
                } else if (this.error_count == 0) {
                    service.addBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Business Added!", "Success!");
                            location.reload(true);
                        } else {
                            toastr.error('Sorry, could not add Business', 'Warning!');
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    });
                } else {}
            } else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
        },
        getBusinesses: function getBusinesses() {
            var _this4 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getBusinesses(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this4.businesses = data.body.data;
                    var result = data.body.data;
                    var count = 0;
                    result.forEach(function (element) {
                        ++count;
                        if (count == 1) {
                            this.business = element;
                            this.getCities(this.business.business_state);
                        }
                    }, _this4);
                } else {
                    _this4.noBusinessSet = true;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusiness: function getBusiness(business) {
            var _this5 = this;

            this.panelFlag = false;
            this.cnsurveysPanel = false;
            service.getBusiness(this, business).then(function (data) {
                if (data.body.status == 200) {
                    _this5.business = data.body.data;
                    _this5.getCities(_this5.business.business_state);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        editBusiness: function editBusiness() {
            this.error_count = 0;
            if (this.business.business_name != '' && this.business.business_category != '' && this.business.business_phone != '' && this.business.business_city != 0) {
                if (!valid.validateEmail(this.business.business_email)) {
                    this.error_here.email = "Invalid Email";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not valid', 'Warning!');
                }
                if (!valid.validateName(this.business.business_name)) {
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                }

                this.business.business_phone = this.business.business_phone.toString();
                if (this.business.business_phone.charAt(0) != "0") {
                    this.business.business_phone = "0" + this.business.business_phone;
                }

                if (!valid.validatePhoneNumber(this.business.business_phone)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }
                if (this.business.business_website != '' && this.business.business_website != null && !valid.validateWebsite(this.business.business_website)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Website is not valid', 'Warning!');
                }

                if (this.error_count == 0) {
                    service.editBusiness(this, this.business.business_id, this.business).then(function (data) {
                        if (data.body.status == 200) {
                            toastr.success("Listing Updated!", "Success!");
                            location.reload(true);
                        } else {
                            location.reload(true);
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    });
                } else {
                    toastr.error('Please check form for errors in entries', 'Warning!');
                }
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        setWorkingHours: function setWorkingHours() {
            service.setWorkingHours(this, this.business.business_id, this.business.working_hours).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Updated!", "Success!");
                    location.reload(true);
                } else {
                    toastr.error('Sorry, could not update Working Hours', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addNewDiscounts: function addNewDiscounts() {
            var payload = {
                cndiscount_business: this.business.business_id,
                cndiscount_caption: this.cndiscount.cndiscount_caption,
                cndiscount_description: this.cndiscount.cndiscount_description,
                cndiscount_code: this.cndiscount.cndiscount_code,
                cndiscount_start_date: this.cndiscount.cndiscount_start_date,
                cndiscount_expiry_date: this.cndiscount.cndiscount_expiry_date
            };
            if (payload.discount_code != '') {
                service.addNewCNdiscount(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Updated!", "Success!");
                    } else {
                        toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information, please check your entries', 'Warning!');
                    }
                });
            }
        },
        removeBusiness: function removeBusiness() {
            var _this6 = this;

            service.deleteBusiness(this, this.business.business_id).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Profile Updated!", "Success!");
                    _this6.business.business_delete_request = data.body.message;
                } else {
                    toastr.error('Sorry, could not update Profile', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        onFileChange: function onFileChange(e, data) {
            var _this7 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data);
                formData.append('data_type', "businesses");
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        _this7.business.business_image = data.body.data;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        initMap: function initMap() {
            var cn = { lat: 8.985714, lng: 7.4465517 };

            var map = new google.maps.Map(document.getElementById("map"), {
                zoom: 4,
                center: cn
            });

            var marker = new google.maps.Marker({
                position: cn,
                map: map
            });
        }
    },
    mounted: function mounted() {
        this.initMap();
    },

    created: function created() {
        this.preset();
        this.getStates();
        this.getBusinessCategories();
        this.getBusinesses();
        this.getWorkingHours();
    }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BusinessSearch',
    data: function data() {
        return {
            businesses: {},
            search: {},
            search_result: "",
            search_message: "",
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            current_page: 0
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default.a
    },

    methods: {
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        getSearchBusinesses: function getSearchBusinesses(offset, items) {
            var credentials = {
                search_type: 'businesses',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            };

            this.search_result = this.$route.query.context;
            service.searchBusinesses(this, credentials, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    this.businesses = data.body.data;
                    if (data.body.data_count % this.pag_intv) {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv) + 1;
                    } else {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv);
                    }
                    this.current_page = items;
                } else if (data.body.status == 400) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                } else {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        }
    },
    created: function created() {

        this.getSearchBusinesses(0, this.pag_intv);
    }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Businesses',
    data: function data() {
        return {
            user: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            img_bz_url: service.imageBusinessURL,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            backgroundSize: 'contain'
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setComponent: function setComponent(business) {
            this.business = business;
            this.panelFlag = true;

            var reviews = this.business.business_reviews;
            reviews.forEach(function (element) {
                if (this.user.user_id == element.review_user_id) {
                    this.has_reviewed = true;
                }
            }, this);
            var rating = this.business.business_ratings;
            rating.forEach(function (element) {
                if (this.user.user_id == element.rate_user_id) {
                    this.has_rated = true;
                }
            }, this);
        },
        saveComponent: function saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2,
                save_business: this.business.business_id,
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            };
            service.saveListing(this, credentials).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success('Business Saved!!', 'Success!');
                } else if (data.body.status == 400) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                } else if (data.body.status == 500) {
                    toastr.error(data.body.message, 'Warning!');
                } else {
                    toastr.error('Please Log In to Save', 'Warning!');
                }
            });
        },
        getSearchBusiness: function getSearchBusiness() {
            if (this.$route.query.context != null) {
                var credentials = {
                    search_keywords: this.$route.query.context
                };
                service.searchBusiness(this, this.$route.query.context).then(function (data) {
                    if (data.body.status == 200) {
                        this.business = data.body.data;
                    } else if (data.body.status == 400) {
                        this.search_message = "Sorry Could not get the Information of entry yet";
                    } else {
                        this.search_message = "Sorry Could not get the Information of entry yet";
                    }
                });
            } else {
                this.$router.push("businesses");
            }
        },

        trackevent: function trackevent(event) {
            if (event.isTrusted) {
                localStorage.setItem("cn_prv_page", "businesses");
                this.preset();
            }
        },

        submitReview: function submitReview() {
            var credentials = {
                review_category: 2,
                review_review: this.review.review,
                review_cnpro: 0,
                review_business: this.business.business_id,
                review_user: this.user.user_id

            };
            var navi = this.$router;
            if (credentials.review_user != null || credentials.review_review != null) {
                service.submitReview(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Review Submitted!", "Success!");
                        location.reload();
                    } else {
                        toastr.error('Sorry, could not submit Review', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        rateBusiness: function rateBusiness() {
            var credentials = {
                rating_category: 1,
                rating_rate: this.rate,
                rating_cnpro: 0,
                rating_business: this.business.business_id,
                rating_user: this.user.user_id

            };
            var navi = this.$router;
            if (credentials.rating_user != null || credentials.rating_rate != null) {
                service.submitRating(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Rated!", "Success!");
                    } else {
                        toastr.error('Sorry, could not Rate', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "business");
        }
        this.getSearchBusiness();
    }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Businesses',
    data: function data() {
        return {
            user: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        saveDiv: function saveDiv(divId, title) {
            var d_divId = document.getElementById(divId);
            var d_position = d_divId.getBoundingClientRect();
            var HTML_Width = d_position.width;
            var HTML_Height = d_position.height;

            var element = document.getElementById(divId);
            var opt = {
                margin: 1,
                filename: title + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },

                jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }

            };

            html2pdf().set(opt).from(element).save();
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        setComponent: function setComponent(business) {
            this.business = business;
            this.panelFlag = true;

            var reviews = this.business.business_reviews;
            reviews.forEach(function (element) {
                if (this.user.user_id == element.review_user_id) {
                    this.has_reviewed = true;
                    console.log(999 + element.review_user_id);
                }
            }, this);
            var rating = this.business.business_ratings;
            rating.forEach(function (element) {
                if (this.user.user_id == element.rate_user_id) {
                    this.has_rated = true;
                }
            }, this);
        },
        saveComponent: function saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2,
                save_business: this.business.business_id,
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            };
            service.saveListing(this, credentials).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success('Business Saved!!', 'Success!');
                } else if (data.body.status == 400) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                } else if (data.body.status == 500) {
                    toastr.error(data.body.message, 'Warning!');
                } else {
                    toastr.error('Please Log In to Save', 'Warning!');
                }
            });
        },
        setBusiness: function setBusiness() {
            var credentials = {
                data_item: localStorage.getItem("cityneeds_search_business")
            };
            localStorage.removeItem("cityneeds_search_business");
            localStorage.removeItem("cityneeds_search_city");
            localStorage.removeItem("cityneeds_search_keywords");
            localStorage.removeItem("cityneeds_search_type");
            service.getDataItem(this, credentials, 2).then(function (data) {
                var _this2 = this;

                if (data.body.status == 200) {
                    service.getBusiness(this, data.body.data).then(function (data2) {
                        if (data2.body.status == 200) {
                            _this2.business = data2.body.data;
                            _this2.panelFlag = true;
                        }
                    }).catch(function (err) {
                        if (err) {}
                    });
                } else if (data.body.status == 400) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        getAllBusinessesX: function getAllBusinessesX() {
            var _this3 = this;

            service.getAllBusinesses(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.businesses = data.body.data;
                    localStorage.setItem("cityneeds_cnsearch", data.body.data);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getAllBusinesses: function getAllBusinesses(offset, items) {
            var _this4 = this;

            service.getSearchBusinesses(this, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    _this4.businesses = data.body.data;
                    if (data.body.data_count % _this4.pag_intv) {
                        _this4.businesses.count_range = Math.floor(data.body.data_count / _this4.pag_intv) + 1;
                    } else {
                        _this4.businesses.count_range = Math.floor(data.body.data_count / _this4.pag_intv);
                    }
                    _this4.current_page = items;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getSearchBusinesses: function getSearchBusinesses(offset, items) {
            var credentials = {
                search_type: 'businesses',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            };

            this.search_result = this.$route.query.context;
            service.searchBusinesses(this, credentials, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    this.businesses = data.body.data;
                    if (data.body.data_count % this.pag_intv) {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv) + 1;
                    } else {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv);
                    }
                    this.current_page = items;
                } else if (data.body.status == 400) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                } else {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        getBusiness: function getBusiness(business) {
            var _this5 = this;

            service.getBusiness(this, business).then(function (data) {
                if (data.body.status == 200) {
                    _this5.business = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                if (credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                } else if (credentials.search_type == "cnpros") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                }
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "businesses");
        }

        this.getAllBusinesses(0, this.pag_intv);
    }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_CNInsuranceForm_index_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_CNInsuranceForm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__templates_CNInsuranceForm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__templates_CNinsuranceFileClaim_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__templates_CNinsuranceFileClaim_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__templates_CNinsuranceFileClaim_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates_CNinsuranceFileComplaint_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates_CNinsuranceFileComplaint_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__templates_CNinsuranceFileComplaint_index_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsurance',
    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_preset_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            cninsurance_listing: {},
            cninsurance: {},
            cninsurance_form_entry: {},
            set_flie_claim: false,
            set_flie_complaint: false,
            set_component_view: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default.a,
        'cninsurance-post-form': __WEBPACK_IMPORTED_MODULE_6__templates_CNInsuranceForm_index_vue___default.a,
        'cninsurance-file-claim': __WEBPACK_IMPORTED_MODULE_7__templates_CNinsuranceFileClaim_index_vue___default.a,
        'cninsurance-file-complaint': __WEBPACK_IMPORTED_MODULE_8__templates_CNinsuranceFileComplaint_index_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        presetXX: function presetXX() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setViewComponent: function setViewComponent(view, attr1, attr2) {
            this.set_component_view = {};
            this.set_component_view[view] = true;
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        setComponent: function setComponent(business) {
            this.business = business;
            this.panelFlag = true;

            var reviews = this.business.business_reviews;
            reviews.forEach(function (element) {
                if (this.user.user_id == element.review_user_id) {
                    this.has_reviewed = true;
                    console.log(element.review_user_id);
                }
            }, this);
            var rating = this.business.business_ratings;
            rating.forEach(function (element) {
                if (this.user.user_id == element.rate_user_id) {
                    this.has_rated = true;
                }
            }, this);
        },
        getCNInsurance: function getCNInsurance() {
            var _this2 = this;

            if (this.$route.params.cninsurancelisting) {
                var str_rs = this.$route.params.cninsurancelisting;
                var res = str_rs.split("-");
                var listing = res[1];
                var navi = this.$router;
                service.getCNinsurance(this, listing).then(function (data) {
                    if (data.body.status == 200) {
                        _this2.cninsurance_listing = data.body.data;

                        _this2.cninsurance_form_resolve_issues_redirect_url = listing;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "businesses");
        }
        this.getCNInsurance();
    }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsurance',
    data: function data() {
        return {
            user: {},
            cninsurance_listings: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        setComponent: function setComponent(business) {
            this.business = business;
            this.panelFlag = true;

            var reviews = this.business.business_reviews;
            reviews.forEach(function (element) {
                if (this.user.user_id == element.review_user_id) {
                    this.has_reviewed = true;
                    console.log(999 + element.review_user_id);
                }
            }, this);
            var rating = this.business.business_ratings;
            rating.forEach(function (element) {
                if (this.user.user_id == element.rate_user_id) {
                    this.has_rated = true;
                }
            }, this);
        },
        saveComponent: function saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2,
                save_business: this.business.business_id,
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            };
            service.saveListing(this, credentials).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success('Business Saved!!', 'Success!');
                } else if (data.body.status == 400) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                } else if (data.body.status == 500) {
                    toastr.error(data.body.message, 'Warning!');
                } else {
                    toastr.error('Please Log In to Save', 'Warning!');
                }
            });
        },
        setBusiness: function setBusiness() {
            var credentials = {
                data_item: localStorage.getItem("cityneeds_search_business")
            };
            localStorage.removeItem("cityneeds_search_business");
            localStorage.removeItem("cityneeds_search_city");
            localStorage.removeItem("cityneeds_search_keywords");
            localStorage.removeItem("cityneeds_search_type");
            service.getDataItem(this, credentials, 2).then(function (data) {
                var _this2 = this;

                if (data.body.status == 200) {
                    service.getBusiness(this, data.body.data).then(function (data2) {
                        if (data2.body.status == 200) {
                            _this2.business = data2.body.data;
                            _this2.panelFlag = true;
                        }
                    }).catch(function (err) {
                        if (err) {}
                    });
                } else if (data.body.status == 400) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        getAllCNInsurance: function getAllCNInsurance(offset, items) {
            var _this3 = this;

            var navi = this.$router;
            service.getCNinsuranceListings(this, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cninsurance_listings = data.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.cninsurance_listings).length === 1) {
                        window.location.replace("/insuremoto-" + _this3.cninsurance_listings[0].cninsurance_url_name);
                    }
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getSearchBusinesses: function getSearchBusinesses(offset, items) {
            var credentials = {
                search_type: 'businesses',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            };

            this.search_result = this.$route.query.context;
            service.searchBusinesses(this, credentials, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    this.businesses = data.body.data;
                    if (data.body.data_count % this.pag_intv) {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv) + 1;
                    } else {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv);
                    }
                    this.current_page = items;
                } else if (data.body.status == 400) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                } else {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        getBusiness: function getBusiness(business) {
            var _this4 = this;

            service.getBusiness(this, business).then(function (data) {
                if (data.body.status == 200) {
                    _this4.business = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                if (credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                } else if (credentials.search_type == "cnpros") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                }
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "businesses");
        }

        this.getAllCNInsurance(0, 1);
    }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsuranceSystem',
    data: function data() {
        return {};
    },

    components: {},
    methods: {},

    created: function created() {}
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_payments_and_updates_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_CNpaymentModal_script_js__ = __webpack_require__(20);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNPayments',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_preset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__templates_CNpaymentModal_script_js__["default"]], data: function data() {
        return {
            user: {},
            payment: {},
            set_payment_data: {},
            set_payment_object: {},
            payment_details_data: {},
            component_view: {},
            amount_topay: 0,

            disable_btn: false,
            current_wallet_balance: 0,
            loggedIn: false,

            payment_message: '',
            service_payment_ref: '',
            token_key: 0,
            data_plan_payment_data: {},
            show_done: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a,
        "cnpayment-modal": __WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue___default.a
    },
    computed: {},
    methods: {
        setComponentView: function setComponentView(view, attr1, attr2) {
            this.component_view = {};
            this.component_view[view] = true;
            this.jumpToView('topp02');
        },
        getIncomingRequest: function getIncomingRequest() {
            if (this.$route.query.pay && this.$route.query.pay > 0) {
                this.pay_type = this.$route.query.pay;
            }
            if (this.$route.query.re && this.$route.query.re != '') {
                this.service_payment_ref = this.$route.query.re;
            }

            this.setPayment();
        },
        setPayment: function setPayment() {
            var _this = this;

            if (this.pay_type > 0) {
                var payload = {
                    pay_service_type: 3,
                    pay_service_ref: this.service_payment_ref,
                    pay_service_user_token: this.token_key
                };
                service.setPaymentRequests(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        if (data.body.data_pay_status == 1) {
                            _this.payment_details_data = data.body.data_payment_data;
                            _this.setComponentView('paymentDetails', '', '');
                        } else {
                            console.log(data.body.data_pay_status);
                        }
                    } else {
                        _this.payment_message = "Sorry, could not find payment details.";
                    }
                }).catch(function (err) {});
            }
        },
        setPaymentModeModal: function setPaymentModeModal(payment_data) {
            this.set_payment_data = payment_data;
            this.set_payment_data.callback_url = "account";
            if (this.set_payment_data.total_amount && this.set_payment_data.total_amount > 0) {
                this.paymentModalComponentKey++;
                setTimeout(function () {
                    $('#paywith').modal();
                }, 10);
            } else {
                this.data_processing_message = "Sorry could not fully submit form, please check your entry, or contact us";
            }
        },
        setPaymentDetails: function setPaymentDetails() {
            this.set_payment_object = {
                payment_detail_type: 'insuremoto',
                payment_detail_name: "Insuremoto Payments",
                payment_detail_logo: "",
                payment_detail_set_callbackurl: 'insuremoto' };
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this2 = this;

            var user_id = this.token_key;
            service.getWalletTransactions(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this2.current_wallet_balance = data.body.data_current_wallet_balance;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        },
        setPreset: function setPreset() {
            var _this3 = this;

            service.authTokenKey(this, this.token_key).then(function (data) {
                if (data.body.status == 200) {
                    var self = _this3;
                    localStorage.setItem("cityneeds_token", data.body.data_key);
                    localStorage.setItem("cityneeds_token_key", _this3.token_key);
                    setTimeout(function () {
                        self.preset();
                        setTimeout(function () {
                            self.xreset();
                        }, 10);
                    }, 10);
                } else {
                    _this3.payment_message = "Sorry, could not find payment details.";
                }
            }).catch(function (err) {});
        }
    },

    created: function created() {
        this.getIncomingRequest();
        this.setPaymentDetails();
        this.getWalletTransactions();

        this.payment.title = "Insuremoto Payments";
    }

});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_payments_and_updates_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_CNpaymentModal_script_js__ = __webpack_require__(20);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNPayments',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_preset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__templates_CNpaymentModal_script_js__["default"]], data: function data() {
        return {
            user: {},
            payment: {},
            set_payment_data: {},
            set_payment_object: {},
            payment_details_data: {},
            component_view: {},
            amount_topay: 0,

            disable_btn: false,
            current_wallet_balance: 0,
            loggedIn: false,

            payment_message: '',
            service_payment_ref: '',
            token_key: 0,
            data_plan_payment_data: {},
            show_done: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a,
        "cnpayment-modal": __WEBPACK_IMPORTED_MODULE_5__templates_CNpaymentModal_index_vue___default.a
    },
    computed: {},
    methods: {
        setComponentView: function setComponentView(view, attr1, attr2) {
            this.component_view = {};
            this.component_view[view] = true;
            this.jumpToView('topp02');
        },
        getIncomingRequest: function getIncomingRequest() {
            if (this.$route.query.pay && this.$route.query.pay > 0) {
                this.pay_type = this.$route.query.pay;
            }
            if (this.$route.query.re && this.$route.query.re != '') {
                this.service_payment_ref = this.$route.query.re;
            }
            if (this.$route.query.no && this.$route.query.no != '') {
                this.token_key = this.$route.query.no;
                localStorage.setItem("cityneeds_call_src", 2);
                this.setPreset();
            }
        },
        setPreset: function setPreset() {
            var _this = this;

            service.authTokenKey(this, this.token_key).then(function (data) {
                if (data.body.status == 200) {
                    var self = _this;
                    localStorage.setItem("cityneeds_token", data.body.data_key);
                    localStorage.setItem("cityneeds_token_key", _this.token_key);
                    setTimeout(function () {
                        self.preset();
                        setTimeout(function () {
                            self.xreset();
                        }, 10);
                    }, 10);
                } else {
                    _this.payment_message = "Sorry, could not find payment details.";
                }
            }).catch(function (err) {});
        },
        xreset: function xreset() {
            this.$router.push('cnpayments?pay=3&re=' + this.service_payment_ref + '&no=' + this.token_key);
        }
    },

    created: function created() {
        this.getIncomingRequest();
    }

});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SearchBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_dataserver_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates_CNdiscountForm_index_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates_CNdiscountForm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__templates_CNdiscountForm_index_vue__);










var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNdiscounts',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_dataserver_js__["a" /* default */]],
    data: function data() {
        return {
            can_set_discount: false,
            set_new_business: false,

            cndiscounts: {},
            cndiscount: {},
            cndiscount_payment_data: {},
            preview_form: false,
            view_info: false,

            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            disable_btn: false,
            process_loading: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default.a,
        'horizontal-widget': __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue___default.a,
        'cndiscount-form': __WEBPACK_IMPORTED_MODULE_8__templates_CNdiscountForm_index_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        toggleComponent: function toggleComponent(id) {
            var stl = document.getElementById(id).style.display;
            if (stl == "block") {
                document.getElementById(id).style = "display:none";
            } else {
                document.getElementById(id).style = "display:block";
            }
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        setReload: function setReload() {
            location.reload();
        },
        setPreps: function setPreps() {
            this.set_payment_object_title = "Make CNdiscount Payment";
        },
        setReg: function setReg() {
            localStorage.setItem("current_page", 'cndiscountsetup');
            location.replace('register');
        },
        setAddNewBusiness: function setAddNewBusiness() {
            this.business = {};
            this.set_new_business = true;
        }
    },
    mounted: function mounted() {
        this.setPreps();
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "businesses");
        }
    }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SearchBar_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNdiscounts',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            cndiscounts: {},
            cndiscount: {},
            cndiscount_prev: {},
            cndiscount_next: {},
            downloading: false,
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            siteUrl: service.siteShareUrl,
            data_share_link: '',
            loading: true
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default.a,
        'horizontal-widget': __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_4__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl + this.data_share_link);
            var btn = $('.linky').tooltip({
                trigger: 'click',
                placement: 'bottom'
            });
            this.setTooltip(btn, 'Copied to Clipboard');
            this.hideTooltip(btn);
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");$('#paywith').modal();
        },
        openModal: function openModal(modal) {
            $('#moda').modal();
        },
        setCNdiscount: function setCNdiscount(cndiscount, index) {
            this.cndiscount = cndiscount;

            this.cndiscount_prev = this.cndiscounts[index - 1];
            this.cndiscount_next = this.cndiscounts[index + 1];
            if (index == 0) {
                this.cndiscount_prev = {};
            } else {
                this.cndiscount_prev = this.cndiscounts[index - 1];
            }
            if (index + 1 == this.cndiscounts.length) {
                this.cndiscount_next = {};
            } else {
                this.cndiscount_next = this.cndiscounts[index + 1];
            }
        },
        getCNdiscount: function getCNdiscount() {
            var _this = this;

            if (this.$route.params.cndiscountref) {
                var str_rs = this.$route.params.cndiscountref;
                var res = str_rs.split("-");
                var listing = res[1];
                this.data_share_link = '?cndiscount=' + listing;
                var navi = this.$router;
                service.getCNdiscount(this, listing).then(function (data) {
                    if (data.body.status == 200) {
                        _this.cndiscount = data.body.data[0];
                        _this.loading = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        set_cndiscount_image: function set_cndiscount_image(cnd) {
            var image = '/static/assets/img/cndiscount00.jpg';
            if (cnd.cndiscount_media && cnd.cndiscount_media != '' && cnd.cndiscount_media != 'business-default.jpg') {
                image = this.img_url + cnd.cndiscount_media;
            }
            return image;
        },
        saveDiv: function saveDiv(divId, title) {
            this.downloading = true;
            console.log(this.downloading);
            var d_divId = document.getElementById(divId);
            var d_position = d_divId.getBoundingClientRect();
            var HTML_Width = d_position.width;
            var HTML_Height = d_position.height;

            var element = document.getElementById(divId);
            var opt = {
                margin: 1,
                filename: title + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },

                jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }

            };

            html2pdf().set(opt).from(element).save();

            var self = this;
            setTimeout(function () {
                self.downloading = false;
            }, 10000);
        },
        printDiv: function printDiv(divId, title) {

            var mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

            mywindow.document.write('<html><head><title>' + title + '</title>');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById(divId).innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();

            mywindow.print();
            mywindow.close();

            return true;
        }
    },
    mounted: function mounted() {
        document.getElementById('topp03').scrollIntoView();
    },
    created: function created() {
        this.getCNdiscount();
    }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SearchBar_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNdiscounts',
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_preset_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            cndiscounts: {},
            cndiscounts_business_categories: {},
            cndiscounts_business_locations: {},
            cndiscount: {},
            cndiscount_prev: {},
            cndiscount_next: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            page_set: []
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_3__Second_Header_index_vue___default.a,
        'horizontal-widget': __WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_5__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_6__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_7__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        setCNdiscount: function setCNdiscount(cndiscount, index) {
            this.cndiscount = cndiscount;

            this.cndiscount_prev = this.cndiscounts[index - 1];
            this.cndiscount_next = this.cndiscounts[index + 1];
            if (index == 0) {
                this.cndiscount_prev = {};
            } else {
                this.cndiscount_prev = this.cndiscounts[index - 1];
            }
            if (index + 1 == this.cndiscounts.length) {
                this.cndiscount_next = {};
            } else {
                this.cndiscount_next = this.cndiscounts[index + 1];
            }
        },
        setComponent: function setComponent(business) {
            this.business = business;
            this.panelFlag = true;

            var reviews = this.business.business_reviews;
            reviews.forEach(function (element) {
                if (this.user.user_id == element.review_user_id) {
                    this.has_reviewed = true;
                    console.log(999 + element.review_user_id);
                }
            }, this);
            var rating = this.business.business_ratings;
            rating.forEach(function (element) {
                if (this.user.user_id == element.rate_user_id) {
                    this.has_rated = true;
                }
            }, this);
        },
        saveComponent: function saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2,
                save_business: this.business.business_id,
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            };
            service.saveListing(this, credentials).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success('Business Saved!!', 'Success!');
                } else if (data.body.status == 400) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                } else if (data.body.status == 500) {
                    toastr.error(data.body.message, 'Warning!');
                } else {
                    toastr.error('Please Log In to Save', 'Warning!');
                }
            });
        },
        setBusiness: function setBusiness() {
            var credentials = {
                data_item: localStorage.getItem("cityneeds_search_business")
            };
            localStorage.removeItem("cityneeds_search_business");
            localStorage.removeItem("cityneeds_search_city");
            localStorage.removeItem("cityneeds_search_keywords");
            localStorage.removeItem("cityneeds_search_type");
            service.getDataItem(this, credentials, 2).then(function (data) {
                var _this = this;

                if (data.body.status == 200) {
                    service.getBusiness(this, data.body.data).then(function (data2) {
                        if (data2.body.status == 200) {
                            _this.business = data2.body.data;
                            _this.panelFlag = true;
                        }
                    }).catch(function (err) {
                        if (err) {}
                    });
                } else if (data.body.status == 400) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        getAllBusinessesX: function getAllBusinessesX() {
            var _this2 = this;

            service.getAllBusinesses(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.businesses = data.body.data;
                    localStorage.setItem("cityneeds_cnsearch", data.body.data);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getAllBusinesses: function getAllBusinesses(offset, items) {
            var _this3 = this;

            service.getSearchBusinesses(this, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    _this3.businesses = data.body.data;
                    if (data.body.data_count % _this3.pag_intv) {
                        _this3.businesses.count_range = Math.floor(data.body.data_count / _this3.pag_intv) + 1;
                    } else {
                        _this3.businesses.count_range = Math.floor(data.body.data_count / _this3.pag_intv);
                    }
                    _this3.current_page = items;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getSearchBusinesses: function getSearchBusinesses(offset, items) {
            var credentials = {
                search_type: 'businesses',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            };

            this.search_result = this.$route.query.context;
            service.searchBusinesses(this, credentials, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    this.businesses = data.body.data;
                    if (data.body.data_count % this.pag_intv) {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv) + 1;
                    } else {
                        this.businesses.count_range = Math.floor(data.body.data_count / this.pag_intv);
                    }
                    this.current_page = items;
                } else if (data.body.status == 400) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                } else {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        getBusiness: function getBusiness(business) {
            var _this4 = this;

            service.getBusiness(this, business).then(function (data) {
                if (data.body.status == 200) {
                    _this4.business = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCNdiscounts: function getCNdiscounts(page, offset, items) {
            var _this5 = this;

            service.getCNdiscounts(this, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    _this5.cndiscounts = data.body.data;
                    _this5.page_set = data.body.page_sets;

                    _this5.current_page = page;
                    _this5.isActive(page);

                    _this5.setDiscountTimers();
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        setDiscountTimers: function setDiscountTimers() {
            var self = this;

            setInterval(function () {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.cndiscounts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var discount = _step.value;

                        if (discount.cndiscount_countdown_days > 0 || discount.cndiscount_countdown_hours > 0 || discount.cndiscount_countdown_minutes > 0) {
                            var cntd = discount.cndiscount_countdown_seconds--;
                            if (cntd == 1 || cntd == 0) {
                                discount.cndiscount_countdown_seconds = 60;

                                if (discount.cndiscount_countdown_minutes == 1 || discount.cndiscount_countdown_minutes == 0) {
                                    if (discount.cndiscount_countdown_minutes == 1) {
                                        discount.cndiscount_countdown_hours--;
                                    }
                                    discount.cndiscount_countdown_minutes = 60;
                                } else {
                                    if (discount.cndiscount_countdown_minutes > 1) {
                                        discount.cndiscount_countdown_minutes--;
                                    }
                                }
                            } else {
                                if (cntd > 1) {
                                    discount.cndiscount_countdown_seconds--;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }, 1000);

            setInterval(function () {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.cndiscounts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var discount = _step2.value;

                        if (discount.cndiscount_countdown_hours > 1) {
                            discount.cndiscount_countdown_hours--;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }, 3600000);
        },
        getCNdiscountsBusinessData: function getCNdiscountsBusinessData() {
            var _this6 = this;

            service.getCNdiscountsBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this6.cndiscounts_business_categories = data.body.data_categories;
                    _this6.cndiscounts_business_locations = data.body.data_locations;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        doSearch: function doSearch() {
            var _this7 = this;

            var search_category = {};
            if (this.search.category) {
                search_category = this.search.category.cndiscounts_business_category_id;
            } else {
                search_category = 0;
            }
            var payload = {
                search_category: search_category || 0,
                search_location: this.search.location || ''
            };

            var navi = this.$router;
            if (payload.search_category > 0 || payload.search_location != '') {
                this.search_result = "Searching ";
                if (payload.search_category > 0) {
                    this.search_result = "Searching " + "for " + this.search.category.cndiscounts_business_category_name;
                }
                if (payload.search_location != '') {
                    this.search_result += " in " + payload.search_location;
                }
                service.searchCNdiscount(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this7.cndiscounts = data.body.data;
                        _this7.page_set = data.body.page_sets;

                        _this7.current_page = page;
                        _this7.isActive(page);
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        set_cndiscount_image: function set_cndiscount_image(cnd) {
            var image = '/static/assets/img/cndiscount00.jpg';
            if (cnd.cndiscount_media && cnd.cndiscount_media != '' && cnd.cndiscount_media != 'business-default.jpg') {
                image = this.img_url + cnd.cndiscount_media;
            }
            return image;
        },
        setNavii: function setNavii(url) {
            this.$router.push(url);
        }
    },
    mounted: function mounted() {
        document.getElementById('topp04').scrollIntoView();
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "businesses");
        }

        this.getAllBusinesses(0, this.pag_intv);
        this.getCNdiscounts(1, 0, 25);
        this.getCNdiscountsBusinessData();
    }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsuranceSystem',
    data: function data() {
        return {};
    },

    components: {},
    methods: {},

    created: function created() {}
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNpay',
    data: function data() {
        return {
            user: {},
            payment_details: {},
            cnpay_transactions: {},
            cnpay_transaction: {},
            cnpay_transaction_type: 1,
            loading: true,
            disable_btn: false,
            show_payment_receipt: true,
            downloading: false,
            img_url: service.imageURL
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel() {
            this.panelFlag = true;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        },
        setFormattedVoucher: function setFormattedVoucher(voucher) {
            if (voucher != '' || voucher != undefined) {
                var s_voucher = String(voucher).replace('--', '');
                return String(s_voucher).match(/.{1,4}/g).join('-');
            }
        },
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");

            this.wallet_transaction = {};
            this.wallet_payment_calculated = false;
            this.wallet_payment_message = '';
            this.wallet_payment_error_message = '';
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getCNpayTransactions: function getCNpayTransactions() {
            var _this2 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getCNpayTransactions(this, user_id).then(function (data) {
                _this2.cnpay_transactions = data.body.data;
                _this2.loading = false;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        setTransaction: function setTransaction(txn, type) {
            this.show_payment_receipt = false;
            this.cnpay_transaction = txn.cnpay_txn_details;
            this.cnpay_transaction_type = type;
        },
        printDiv: function printDiv(divId, title) {

            var mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');


            mywindow.document.write('<html><head><title>' + title + '</title>');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById(divId).innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();

            mywindow.print();
            mywindow.close();

            return true;
        },
        saveDiv: function saveDiv(divId, title) {
            this.downloading = true;
            var d_divId = document.getElementById(divId);
            var d_position = d_divId.getBoundingClientRect();
            var HTML_Width = d_position.width;
            var HTML_Height = d_position.height;

            var element = document.getElementById(divId);
            var opt = {
                margin: 1,
                filename: title + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { allowTaint: true, useCORS: true, scale: 2 },

                jsPDF: { unit: 'mm', format: [312, 592], orientation: 'portrait' }
            };

            var self = this;
            html2pdf().set(opt).from(element).save().then(function () {
                setTimeout(function () {
                    self.downloading = false;
                }, 2500);
            });
        }
    },
    created: function created() {
        this.preset();
        this.getCNpayTransactions();
    }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNwallet',
    data: function data() {
        return {
            user: {},
            payment_details: {},
            wallet_charges: {},
            wallet_transaction: {},
            wallet_transactions: {},
            current_wallet_balance: 0,
            bank: {},
            to_pay_out: 0,
            amount_paid: '',
            wallet_payment_message: '',
            wallet_payment_error_message: '',
            min_wallet_topup_amount: 100,
            max_wallet_topup_amount: 10000,
            wallet_payment_calculated: false,
            loading: true,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel() {
            this.panelFlag = true;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        },
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");

            this.wallet_transaction = {};
            this.wallet_payment_calculated = false;
            this.wallet_payment_message = '';
            this.wallet_payment_error_message = '';
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setWalletTransaction: function setWalletTransaction(txn) {
            this.wallet_transaction = txn;
        },
        getWalletProcessingCharges: function getWalletProcessingCharges() {
            var _this2 = this;

            service.getWalletProcessingChargesRF(this).then(function (data) {
                _this2.wallet_charges = data.body.data;
                _this2.min_wallet_topup_amount = data.body.data_min_wallet_topup_amount;
                _this2.max_wallet_topup_amount = data.body.data_max_wallet_topup_amount;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this3 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletTransactions(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.current_wallet_balance = data.body.data_current_wallet_balance;
                }
                _this3.wallet_transactions = data.body.data;
                _this3.loading = false;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        prepareWalletPayment: function prepareWalletPayment() {
            if (this.wallet_transaction.topay_amt == null) {
                toastr.error('Amount is empty', 'Warning!');
            } else {
                this.wallet_transaction.topay_amt = parseFloat(this.wallet_transaction.topay_amt);

                if (this.wallet_transaction.topay_amt > this.max_wallet_topup_amount) {
                    this.wallet_payment_error_message = 'Maximum Topup amount exceeded';
                    toastr.error('Maximum Topup amount exceeded', 'Warning!');
                } else if (this.wallet_transaction.topay_amt < this.min_wallet_topup_amount) {
                    this.wallet_payment_error_message = 'Minimum Topup amount is 100NGN';
                    toastr.error('Minimum Topup amount is 100', 'Warning!');
                } else {
                    this.wallet_charges.forEach(function (element) {
                        if (this.wallet_transaction.topay_amt >= element.wallet_charge_min && this.wallet_transaction.topay_amt <= element.wallet_charge_max) {
                            this.wallet_transaction.processing_fee = element.wallet_charge_charge;
                        }
                    }, this);
                    this.wallet_payment_calculated = true;
                }
            }
        },
        makePayment: function makePayment() {
            var _this4 = this;

            this.disable_btn = true;
            var user_id = localStorage.getItem("cityneeds_token_key");
            var payload = {
                "user": user_id,
                "service": 2 };
            service.setUserPaymentDetails(this, payload).then(function (data) {
                _this4.payment_details = data.body.data;

                _this4.processPayment();
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        processPaymentXX: function processPaymentXX() {
            var self = this;
            var txref = self.payment_details.payer_txn_ref;
            var tx_amount = self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee;
            var txn_payload = {
                "txn_ref": txref,
                "pay": self.user.user_id,
                "txn_amount": self.wallet_transaction.topay_amt,
                "processing_fee": self.wallet_transaction.processing_fee,
                "topup_by_admin": 0,
                "total_amount": tx_amount
            };

            service.postWalletTopup(self, txn_payload).then(function (response) {
                self.disable_btn = false;
                self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                self.loading = true;
                setTimeout(function () {

                    self.closeModal('#topup');
                }, 4000);

                self.getWalletTransactions();
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            var self = this;
            var x = getpaidSetup({
                PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X",
                customer_email: self.payment_details.payer_email,
                amount: self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee,
                customer_phone: self.payment_details.payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: "CNwallet-" + self.payment_details.payer_txn_ref,
                meta: [{
                    metaname: "CNwallet",
                    metavalue: self.payment_details.payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.processing = true;

                        var txn_payload = {
                            "txn_ref": txref,
                            "pay": self.user.user_id,
                            "txn_amount": self.wallet_transaction.topay_amt,
                            "processing_fee": self.wallet_transaction.processing_fee,
                            "topup_by_admin": 0,
                            "total_amount": tx_amount
                        };

                        service.postWalletTopup(self, txn_payload).then(function (response) {
                            self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                            self.loading = true;
                            self.disable_btn = false;
                            setTimeout(function () {

                                self.closeModal('#topup');
                            }, 4000);

                            self.getWalletTransactions();
                        }).catch(function (err) {});
                    } else {
                        self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us";
                    }

                    x.close();
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getWalletProcessingCharges();
        this.getWalletTransactions();
    }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_1__services_validator__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CnproAccounts',
    data: function data() {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            contracts: {},
            contract: {},
            contract_threads: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {},
            quote: {},
            cnproParentCategories: {},
            cnproCategories: {},
            panelFlag: false,
            viewFlag: false,
            addFlag: false,
            editFlag: false,
            deleteFlag: false,
            quotePanel: false,
            viewQuotePanel: false,
            viewQuoteFlag: false,
            viewComplaints: false,
            contractsPanel: false,
            editQuoteFlag: false,
            photo: "",
            img_url: service.imageURL,
            noCnproSet: false,
            noContractSet: false,
            loading: false,
            serviceCharge: 0,
            serviceChargeInPercentage: 0,
            totalAfterServiceCharge: 0,
            uploadWorkPicture: false,
            error_here: {},
            error_count: 0
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__Dashboard_Footer_index_vue___default.a
    },
    computed: {
        serviceChargeTotal: {
            get: function get() {
                return this.totalAfterServiceCharge;
            },
            set: function set(newVal) {
                this.quote.labour_cost = newVal;
            }
        }
    },
    methods: {
        toggleMenuActions: function toggleMenuActions() {
            $('.toggle-menu-actions').toggle();
        },
        back: function back() {
            this.panelFlag = false;
            this.viewComplaints = false;
            this.deleteFlag = false;
            this.viewFlag = false;
            this.editFlag = false;
            this.viewQuoteFlag = false;
            this.viewQuotePanel = false;
            this.contractsPanel = false;
            this.viewComplaints = false;
        },
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "add") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if (attr == "view") {
                this.addFlag = false;
                this.deleteFlag = false;
                this.viewFlag = true;
                this.editFlag = false;
                this.viewQuoteFlag = false;
                this.viewQuotePanel = false;
                this.contractsPanel = false;
                this.viewComplaints = false;
            }
            if (attr == "edit") {
                this.addFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.editFlag = true;
                this.cnpro = attr2;
            }
            if (attr == "delete") {
                this.addFlag = false;
                this.editFlag = false;
                this.viewFlag = false;
                this.deleteFlag = true;
                this.cnpro = attr2;
            }
            if (attr == "viewQuotePanel") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.contractsPanel = false;
                this.viewQuotePanel = true;
                this.contract_threads = attr2;
                this.viewComplaints = false;
            }
            if (attr == "view-contracts") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.viewQuoteFlag = false;
                this.viewQuotePanel = false;
                this.contractsPanel = true;
                this.viewComplaints = false;
            }
            if (attr == "viewQuoteFlag") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.contractsPanel = false;
                this.viewQuotePanel = false;
                this.viewQuoteFlag = true;
                this.viewComplaints = false;
            }
            if (attr == "view-compliants") {
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.contractsPanel = false;
                this.viewQuotePanel = false;
                this.viewQuoteFlag = false;
                this.viewComplaints = true;
            }
        },
        setQuotePanel: function setQuotePanel() {
            this.panelFlag = true;
            this.quotePanel = true;
            this.addFlag = false;
            this.editFlag = false;
            this.deleteFlag = false;
            this.viewFlag = false;
            this.viewQuotePanel = false;
        },
        setEditQuote: function setEditQuote() {
            this.editQuoteFlag = true;
            this.totalAfterServiceCharge = this.contract.contract_labour_cost - this.contract.contract_labour_cost * this.serviceCharge;
        },
        setContractThreadPanel: function setContractThreadPanel(contract, thread) {
            this.panelFlag = true;
            this.addFlag = false;
            this.editFlag = false;
            this.deleteFlag = false;
            this.viewFlag = false;
            this.quotePanel = false;
            this.contractsPanel = false;
            this.viewQuotePanel = true;
            this.contract = contract;
            this.contract_threads = thread;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(id) {
            var _this2 = this;

            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then(function (res) {
                _this2.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            });
        },
        setServiceCharge: function setServiceCharge() {
            var _this3 = this;

            service.getServiceCharge(this).then(function (data) {
                if (data.status == 200) {
                    _this3.serviceCharge = data.body.data / 100;
                    _this3.serviceChargeInPercentage = data.body.data;
                }
            }).catch(function (err) {});
        },
        getCnproParentCategories: function getCnproParentCategories() {
            var _this4 = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this4.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproCategories: function getCnproCategories(parent) {
            var _this5 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this5.cnproCategories = data.body.data;
                    document.getElementById("loader").style.visibility = "hidden";
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnpros: function getCnpros() {
            var _this6 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getCnpros(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this6.cnpros = data.body.data;
                    var result = data.body.data;
                    var count = 0;
                    result.forEach(function (element) {
                        ++count;
                        if (count == 1) {
                            this.cnpro = element;

                            this.getCnproCategories(this.cnpro.cnpro_parent_category);
                            this.getCities(this.cnpro.cnpro_state);
                        }
                    }, _this6);
                } else {
                    _this6.noCnproSet = true;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnpro: function getCnpro(cnpro) {
            var _this7 = this;

            this.viewFlag = true;
            this.panelFlag = true;
            this.contractsPanel = false;
            this.addFlag = false;
            service.getCnpro(this, cnpro).then(function (data) {
                if (data.body.status == 200) {
                    _this7.cnpro = data.body.data;


                    _this7.getCnproCategories(_this7.cnpro.cnpro_parent_category);
                    _this7.getCities(_this7.cnpro.cnpro_state);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        addCnpro: function addCnpro() {
            this.error_count = 0;
            var credentials = {
                cnpro_user: this.user.user_id,
                cnpro_category: this.cnpro.category,
                cnpro_name: this.cnpro.name,
                cnpro_email: this.cnpro.email,
                cnpro_phone: this.cnpro.phone,
                cnpro_address: this.cnpro.address,
                cnpro_state: 15,
                cnpro_city: 1,
                cnpro_description: this.cnpro.description,
                cnpro_facebook: this.cnpro.facebook || 'https://web.facebook.com/',
                cnpro_twitter: this.cnpro.twitter || 'https://twitter.com/',
                cnpro_instagram: this.cnpro.instagram || 'https://www.instagram.com/'
            };

            var navi = this.$router;
            if (credentials.cnpro_user != null && credentials.cnpro_name != null && credentials.cnpro_category != null && credentials.cnpro_city != null && credentials.cnpro_phone != null && credentials.cnpro_email != null && credentials.cnpro_address != null) {
                if (!valid.validateEmail(credentials.cnpro_email)) {
                    this.error_here.email = "Invalid Email";

                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not Valid', 'Warning!');
                }
                if (!valid.validateName(credentials.cnpro_name)) {
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Name is not valid', 'Warning!');
                }
                if (!valid.validatePhoneNumber(credentials.cnpro_phone)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                } else if (this.error_count == 0) {
                    service.addCnpro(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("CNpro Added!", "Success!");
                            location.reload(true);
                        } else {
                            toastr.error('Sorry, could not add Cnpro', 'Warning!');
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    });
                } else {}
            } else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
        },
        editCnpro: function editCnpro() {
            this.error_count = 0;
            if (this.cnpro.cnpro_name != '' && this.cnpro.cnpro_phone != '' && this.cnpro.cnpro_email != '' && this.cnpro.cnpro_city != 0) {
                if (!valid.validateEmail(this.cnpro.cnpro_email)) {
                    this.error_here.email = "Invalid Email";

                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not Valid', 'Warning!');
                }
                if (!valid.validateName(this.cnpro.cnpro_name)) {
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Name is not valid', 'Warning!');
                }
                if (!valid.validatePhoneNumber(this.cnpro.cnpro_phone)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                } else if (this.error_count == 0) {
                    service.editCnpro(this, this.cnpro, this.cnpro.cnpro_id).then(function (data) {
                        if (data.body.status == 200) {
                            toastr.success("Profile Updated!", "Success!");
                            location.reload(true);
                        } else {
                            location.reload(true);
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    });
                } else {
                    toastr.error(' process information', 'Warning!');
                }
            } else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
        },
        removeCnpro: function removeCnpro() {
            var _this8 = this;

            service.deleteCnpro(this, this.cnpro.cnpro_id).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Profile Updated!", "Success!");
                    _this8.cnpro.cnpro_delete_request = data.body.data;
                } else {
                    toastr.error('Sorry, could not update Profile', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        onFileChange: function onFileChange(e, data, type) {
            var _this9 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data);
                formData.append('data_type', type);
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == 'cnpros') {
                            _this9.cnpro.cnpro_image = data.body.data;
                        }
                        if (type == 'cnpros_id_card') {
                            _this9.cnpro.cnpro_id_card = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        workPicturesUpload: function workPicturesUpload(e, data, type) {
            var _this10 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data);
                formData.append('data_type', type);
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == 'contract_work_image_1') {
                            _this10.contract.contract_work_image_1 = data.body.data;
                        }
                        if (type == 'contract_work_image_2') {
                            _this10.contract.contract_work_image_2 = data.body.data;
                        }
                        if (type == 'contract_work_image_3') {
                            _this10.contract.contract_work_image_3 = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getCnproContracts: function getCnproContracts(cnpro) {
            var _this11 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getCnproContracts(this, cnpro).then(function (data) {
                if (data.body.status == 200) {
                    _this11.contracts = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        setQuote: function setQuote(contract, cnpro) {
            var credentials = {
                contract_cnpro: cnpro,
                contract_quote: this.quote.details || 'nill',
                contract_material_details: this.quote.materials || 'nill',

                contract_labour_cost: this.quote.labour_cost || 0,
                contract_work_duration: this.quote.duration || 0
            };
            var navi = this.$router;
            if (credentials.contract_quote != null || credentials.contract_cnpro != null) {
                service.setQuote(this, contract, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Quote Set!", "Success!");

                        location.reload(true);
                    } else {
                        toastr.error('Sorry, could not set Quote', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        editQuote: function editQuote(contract, cnpro) {
            var _this12 = this;

            var credentials = {
                contract_cnpro: cnpro,
                contract_quote: this.contract.contract_quote_description || 'nill',
                contract_material_details: this.contract.contract_material_details || 'nill',

                contract_labour_cost: this.contract.contract_labour_cost || 0,
                contract_work_duration: this.contract.contract_work_duration || 0
            };
            var navi = this.$router;
            if (credentials.contract_quote != null || credentials.contract_cnpro != null) {
                service.updateQuote(this, contract, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Quote Edited!", "Success!");
                        _this12.editQuoteFlag = false;
                    } else {
                        toastr.error('Sorry, could not edit Quote', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        replyQuote: function replyQuote(contract, cnpro) {
            var _this13 = this;

            var credentials = {
                contract_contract: contract,
                contract_category: 1,
                contract_user: cnpro,
                contract_reply: this.quote.message
            };

            var navi = this.$router;
            if (credentials.contract_reply != null || credentials.contract_user != null || credentials.contract_user != null) {
                service.replyQuote(this, contract, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Sent!", "Success!");
                        _this13.contract_threads = data.body.data;
                        _this13.quote.message = '';
                    } else {
                        toastr.error('Sorry, could not send', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        markWorkDone: function markWorkDone(contract, cnpro) {
            var _this14 = this;

            var credentials = {
                contract_contract: contract,
                contract_cnpro: cnpro
            };
            var navi = this.$router;
            if (credentials.contract_cnpro != null) {
                service.confirmContractCnpro(this, contract, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Job Confirmed!", "Success!");
                        _this14.contract.contract_status_id = 8;
                        _this14.contract.contract_status = 'Confirmed by CNpro';
                        _this14.uploadWorkPictures = true;
                    } else {
                        toastr.error('Sorry, could not confirm', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        this.preset();
        this.getStates();
        this.getCnproParentCategories();
        this.getCnpros();
        this.setServiceCharge();
    }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CnproSearch',
    data: function data() {
        return {
            cnpros: [],
            search: {},
            search_result: "",
            search_message: "",
            img_url: service.imageURL,
            img_cp_url: service.imageCNproURL,
            backgroundSize: 'contain',
            pag_intv: service.pageIntv,
            current_page: 0,
            other_cnpros_current_page: 0,
            cnprosKey: 0,
            cnpros_store: {},
            other_cnpros: [],
            other_cnpros_store: {}
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default.a,
        'horizontal-widget': __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        isActive: function isActive(page, view) {
            if (view == 'cnpros' && page == this.current_page) {
                return true;
            }
            if (view == 'othercnpros' && page == this.other_cnpros_current_page) {
                return true;
            }
        },
        scrollToTop: function scrollToTop(where) {
            var top = document.getElementById(where).offsetTop;
            window.scrollTo(0, top);
        },
        sortCnpros: function sortCnpros(offset, page_view) {
            this.current_page = page_view;
            var limit = 5;

            this.cnpros = [];
            var count_offset = offset;
            var count_limit = 0;
            if (count_offset <= offset) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.cnpros_store), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var row = _step.value;

                        if (count_limit < limit) {
                            if (this.cnpros_store[count_offset] != undefined) {
                                this.cnpros.push(this.cnpros_store[count_offset]);
                            }
                        }
                        count_limit++;count_offset++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            this.current_page = offset;
            this.scrollToTop("topwrap");
        },
        sortOtherCnpros: function sortOtherCnpros(offset, page_view) {
            this.other_cnpros_current_page = page_view;
            var limit = 5;

            this.other_cnpros = [];
            var count_offset = offset;
            var count_limit = 0;
            if (count_offset <= offset) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.other_cnpros_store), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var row = _step2.value;

                        if (count_limit < limit) {
                            if (this.other_cnpros_store[count_offset] != undefined) {
                                this.other_cnpros.push(this.other_cnpros_store[count_offset]);
                            }
                        }
                        count_limit++;count_offset++;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            this.scrollToTop("otherwrap");
        },
        prepCnprosPagination: function prepCnprosPagination(data_count) {
            if (data_count % this.pag_intv) {
                this.cnpros_store.count_range = Math.floor(data_count / this.pag_intv);
            } else {
                this.cnpros_store.count_range = Math.floor(data_count / this.pag_intv);
            }

            this.current_page = 1;
        },
        prepOtherCnprosPagination: function prepOtherCnprosPagination(data_count) {
            if (data_count % this.pag_intv) {
                this.other_cnpros_store.count_range = Math.floor(data_count / this.pag_intv);
            } else {
                this.other_cnpros_store.count_range = Math.floor(data_count / this.pag_intv);
            }
            this.other_cnpros_current_page = 1;
        },
        getSearchCnpros: function getSearchCnpros(offset, items) {
            var _this = this;

            var credentials = {
                search_type: 'cnpros',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            };

            this.search_result = this.$route.query.context;
            service.searchCnpros(this, credentials, offset, this.pag_intv).then(function (data) {
                if (data.body.status == 200) {
                    this.scrollToTop("topwrap");

                    this.cnpros_store = data.body.data;
                    this.other_cnpros_store = data.body.data_2;

                    this.sortCnpros(0, 5);
                    this.prepCnprosPagination(data.body.data_count);

                    this.sortOtherCnpros(0, 5);
                    this.prepOtherCnprosPagination(data.body.data_2_count);
                } else if (data.body.status == 400 || data.body.status == 404) {
                    this.search_message = "Sorry Could not get the Information of entry yet";

                    this.other_cnpros_store = data.body.data_2;

                    this.sortOtherCnpros(0, 5);
                    this.prepOtherCnprosPagination(data.body.data_2_count);
                }
            }).catch(function (err) {
                if (_this.cnpros.length == 0) {
                    _this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        getSearchCnprosXX: function getSearchCnprosXX(offset, items) {
            var _this2 = this;

            var credentials = {
                search_type: 'cnpros',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            };

            this.search_result = this.$route.query.context;
            service.searchCnpros(this, credentials, offset, this.pag_intv).then(function (data) {
                if (data.body.status == 200) {
                    this.cnpros = data.body.data;
                    if (data.body.data_count % this.pag_intv) {
                        this.cnpros.count_range = Math.floor(data.body.data_count / this.pag_intv) + 1;
                    } else {
                        this.cnpros.count_range = Math.floor(data.body.data_count / this.pag_intv);
                    }
                    this.current_page = items;
                } else if (data.body.status == 400 || data.body.status == 404) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            }).catch(function (err) {
                if (err) {
                    _this2.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        }
    },
    created: function created() {
        this.getSearchCnpros(0, this.pag_intv);
    }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnpro',
    data: function data() {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            cnsurveys: {},
            request: {},
            activeRequest: false,
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            reviews: {},
            review: {},
            rate: ""
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            this.user.user_id = element.user_id;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.user = data.body.data;
                                    _this.getSearchCnpro();
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this2);
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setComponent: function setComponent(cnpro) {},
        saveComponent: function saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 1,
                save_business: 0,
                save_cnpro: this.cnpro.cnpro_id,
                save_user: this.user.user_id || 'nill'
            };
            service.saveListing(this, credentials).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success('CNpro Saved!!', 'Success!');
                } else if (data.body.status == 400) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                } else if (data.body.status == 500) {
                    toastr.error(data.body.message, 'Warning!');
                } else {
                    toastr.error('Please Log In to Save', 'Warning!');
                }
            });
        },
        setCnpro: function setCnpro() {},
        moveToPlans: function moveToPlans() {
            localStorage.setItem("cityneeds_request_plans", "cnpro");
            this.$router.push('pricing');
        },
        getSearchCnpro: function getSearchCnpro() {
            var _this3 = this;

            var check_cnpro = this.$route.query.context;
            if (check_cnpro != null) {

                service.searchCnpro(this, this.$route.query.context).then(function (data2) {
                    if (data2.body.status == 200) {
                        _this3.cnpro = data2.body.data;
                        _this3.panelFlag = true;
                        _this3.checkActiveRequest();
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {
                this.$router.push("cnpros");
            }
        },
        getCnpro: function getCnpro(cnpro) {
            var _this4 = this;

            service.getCnpro(this, cnpro).then(function (data) {
                if (data.body.status == 200) {
                    _this4.cnpro = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        requestQuote: function requestQuote() {
            var _this5 = this;

            var credentials = {
                contract_contractor: this.user.user_id,
                contract_cnpro: this.cnpro.cnpro_id,
                contract_request_details: this.request.details || ""
            };
            var navi = this.$router;
            if (credentials.contract_contractor != null || credentials.contract_cnpro != null) {
                service.requestQuote(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Message Sent!", "Success!");
                        _this5.activeRequest = true;
                    } else {
                        toastr.error('Sorry, could not request Quote', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        checkActiveRequest: function checkActiveRequest() {
            var _this6 = this;

            var credentials = {
                contract_contractor: this.user.user_id,
                contract_cnpro: this.cnpro.cnpro_id
            };
            service.checkCnproContractRequest(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    _this6.activeRequest = true;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        submitReview: function submitReview() {
            var credentials = {
                review_category: 1,
                review_review: this.review.review,
                review_cnpro: this.cnpro.cnpro_id,
                review_business: 0,
                review_user: this.user.user_id

            };
            var navi = this.$router;
            if (credentials.review_user != null || credentials.review_review != null) {
                service.submitReview(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Review Submitted!", "Success!");
                    } else {
                        toastr.error('Sorry, could not submit Review', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        rateCnpro: function rateCnpro() {
            var credentials = {
                rating_category: 1,
                rating_rate: this.rate,
                rating_cnpro: this.cnpro.cnpro_id,
                rating_business: 0,
                rating_user: this.user.user_id

            };
            var navi = this.$router;
            if (credentials.rating_user != null || credentials.rating_rate != null) {
                service.submitRating(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Rated!", "Success!");
                    } else {
                        toastr.error('Sorry, could not Rate', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        localStorage.setItem("cn_prv_page", "cnpro");
        this.preset();
    }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnpros',
    data: function data() {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            cnsurveys: {},
            request: {},
            activeRequest: false,
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            img_cp_url: service.imageCNproURL,
            pag_cnpro_intv: service.pageCnproIntv,
            current_page: 0,
            reviews: {},
            review: {},
            rate: "",
            backgroundSize: 'contain',
            search_mode: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default.a,
        'horizontal-widget': __WEBPACK_IMPORTED_MODULE_3__HorizontalWidget_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        saveComponent: function saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 1,
                save_business: 0,
                save_cnpro: this.cnpro.cnpro_id,
                save_user: this.user.user_id || 'nill'
            };
            service.saveListing(this, credentials).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success('CNpro Saved!!', 'Success!');
                } else if (data.body.status == 400) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                } else if (data.body.status == 500) {
                    toastr.error(data.body.message, 'Warning!');
                } else {
                    toastr.error('Please Log In to Save', 'Warning!');
                }
            });
        },
        viewCnpro: function viewCnpro(cnpro) {
            if (cnpro) {
                localStorage.setItem("cityneeds_search_cnpro", cnpro.cnpro_data_item);
                this.$router.push("cnpro");
            }
        },
        getAllCnprosX: function getAllCnprosX() {
            var _this2 = this;

            service.getAllCnpros(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cnpros = data.body.data;
                    localStorage.setItem("cityneeds_cnsearch", data.body.data);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getAllCnpros: function getAllCnpros(offset, items) {
            var _this3 = this;

            service.getSearchCnpros(this, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cnpros = data.body.data;
                    if (data.body.data_count % _this3.pag_intv) {
                        _this3.cnpros.count_range = Math.floor(data.body.data_count / _this3.pag_intv) + 1;
                    } else if (data.body.data_count > _this3.pag_intv) {
                        _this3.cnpros.count_range = Math.floor(data.body.data_count / _this3.pag_intv);
                    }
                    _this3.current_page = items;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getSearchCnpros: function getSearchCnpros(offset, items) {
            var credentials = {
                search_type: 'cnpros',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            };

            this.search_result = this.$route.query.context;
            service.searchCnpros(this, credentials, offset, this.pag_intv).then(function (data) {
                if (data.body.status == 200) {
                    this.cnpros = data.body.data;
                    if (data.body.data_count % this.pag_intv) {
                        this.cnpros.count_range = Math.floor(data.body.data_count / this.pag_intv) + 1;
                    } else {
                        thiscnpros.count_range = Math.floor(data.body.data_count / this.pag_intv);
                    }
                    this.current_page = items;
                } else if (data.body.status == 400 || data.body.status == 404) {
                    this.search_message = "Sorry Could not get the Information of entry yet";
                }
            });
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                if (credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                } else if (credentials.search_type == "cnpros") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                }
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        }

        this.getAllCnpros(0, this.pag_intv);
    }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utility__ = __webpack_require__(26);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var utility = new __WEBPACK_IMPORTED_MODULE_4__services_utility__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CnsurveyRequests',
    data: function data() {
        return {
            user: {},
            businesses: [],
            businessCategories: {},
            states: [],
            surveys: {},
            survey: {},
            options: [],
            survey_questions: {},
            cities: {},
            panelFlag: false,
            addFlag: false,
            addQuestionFlag: false,
            editQuestionFlag: false,
            editFlag: false,
            deleteFlag: false,
            activateFlag: false,
            loadSurveyData: "",
            amount_paid: "",
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "activate-survey") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = false;
                this.activateFlag = true;

                this.survey = attr2;
            }
            if (attr == "add") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if (attr == "edit") {
                this.editFlag = true;
                this.deleteFlag = false;
                this.addFlag = false;

                this.survey = attr2;
            }
            if (attr == "add-question") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = false;
                this.addQuestionFlag = true;
            }
            if (attr == "edit-question") {
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = false;
                this.editQuestionFlag = true;

                this.survey_questions = attr2;
            }
            if (attr == "delete") {

                this.panelFlag = false;
                this.survey = attr2;
                this.survey.deleteFlag = true;
            }
            if (attr == "delete-question") {
                this.survey_questions = attr2;
                this.survey_questions.deleteFlag = true;
                this.deleteFlag = true;
            }
            if (attr == "back") {
                location.reload(true);
            }
        },
        getBusiness: function getBusiness() {
            var _this2 = this;

            var uid = localStorage.getItem("cityneeds_token_key");
            service.getBusinesses(this, uid).then(function (res) {
                _this2.businesses = res.body.data;
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this3 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.businessCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnsurveys: function getCnsurveys() {
            var _this4 = this;

            var id = localStorage.getItem("cityneeds_token_key");
            service.getUserSurveys(this, id).then(function (res) {
                _this4.surveys = res.body.data;
            });
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(id) {
            var _this5 = this;

            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then(function (res) {
                _this5.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            });
        },
        setSurveyCategory: function setSurveyCategory(category) {
            if (category == 4) {
                this.loadSurveyData = "business";
                this.survey.cnsurvey_business_category = 0;
            } else {
                this.loadSurveyData = "business_categories";
                this.survey.cnsurvey_business = 0;
            }
        },
        next: function next(sv, i) {
            if (this.surveys[sv].cnsurveys_questions[i + 1] == undefined) {
                this.surveys[sv].cnsurvey_question_index = 0;
            } else {
                this.surveys[sv].cnsurvey_question_index++;
            }
        },
        createSurvey: function createSurvey() {
            var _this6 = this;

            var survey = this.survey;
            var options = this.options;
            survey.cnsurvey_user = this.user.user_id;
            survey.state = 15;
            survey.cnsurvey_city = 1;
            if (survey.cnsurvey_title != '' && survey.cnsurvey_category) {
                if (survey.cnsurvey_business && survey.cnsurvey_business != '' || survey.cnsurvey_business_category && survey.cnsurvey_business_category != '') {
                    service.survey(this, survey).then(function (res) {
                        if (res.status == 201) {
                            toastr.success("Survey submitted!", "Success!");
                            _this6.survey.cnsurvey_id = res.body.cnsurvey_status;

                            _this6.survey.cnsurveys_questions = [];
                            _this6.addQuestionFlag = true;
                            _this6.addFlag = false;
                        } else {
                            toastr.error("Couldn't complete request, kindly try again", "Warning!");
                        }
                    });
                } else {
                    toastr.error("Complete all fields with *", "Warning!");
                }
            } else {
                toastr.error("Complete all fields with *", "Warning!");
            }
        },
        addSurveyQuestion: function addSurveyQuestion(attr) {
            var _this7 = this;

            var survey = this.survey;
            var options = this.options;
            survey.cnsurvey_options = [options.one, options.two, options.three, options.four, options.five];
            if (options.one != null) {
                service.addSurveyQuestion(this, survey).then(function (res) {
                    if (res.status == 201) {
                        _this7.survey.cnsurveys_questions.length++;
                        toastr.success("Survey Question Added!", "Success!");

                        _this7.survey.cnsurvey_question = "";
                        _this7.options = [];
                        if (attr == "finish") {
                            location.reload(true);
                        }
                    } else {
                        toastr.error("Couldn't complete request, kindly try again", "Warning!");
                    }
                });
            }

            if (survey.cnsurveys_questions.length == 4) {
                location.reload(true);
            }
        },
        get_option_answer: function get_option_answer(option, survey_answers) {
            var option_count = 0;
            if (survey_answers != null) {
                survey_answers.forEach(function (element) {
                    if (option == element.cnsurvey_answer_option) {
                        option_count++;
                    }
                }, this);
                return option_count;
            } else {
                return 0;
            }
        },
        editSurvey: function editSurvey() {
            if (this.survey.cnsurvey_title != '' && this.survey.cnsurvey_category) {
                if (this.survey.cnsurvey_business && this.survey.cnsurvey_business != '' || this.survey.cnsurvey_business_category && this.survey.cnsurvey_business_category != '') {

                    service.editSurvey(this, this.survey, this.survey.cnsurvey_id).then(function (res) {
                        if (res.body.status == 200) {
                            toastr.success("Survey edited!", "Success!");
                            location.reload(true);
                        } else {
                            toastr.error("Couldn't complete request, kindly try again", "Warning!");
                        }
                    });
                } else {
                    toastr.error("Complete all fields with *", "Warning!");
                }
            } else {
                toastr.error("Complete all fields with *", "Warning!");
            }
        },
        editSurveyQuestion: function editSurveyQuestion() {
            service.editSurveyQuestion(this, this.survey_questions, this.survey_questions.cnsurvey_question_id).then(function (res) {
                if (res.body.status == 200) {
                    toastr.success("Survey Question edited!", "Success!");
                    location.reload(true);
                } else {
                    toastr.error("Couldn't complete request, kindly try again", "Warning!");
                }
            });
        },
        deleteSurvey: function deleteSurvey() {
            service.deleteSurvey(this, this.survey.cnsurvey_id).then(function (res) {
                if (res.body.status == 200) {
                    toastr.success("Survey deleted!", "Success!");
                    location.reload(true);
                } else {
                    toastr.error("Couldn't complete request, kindly try again", "Warning!");
                }
            });
        },
        deleteSurveyQuestion: function deleteSurveyQuestion() {
            service.deleteSurveyQuestion(this, this.survey_questions.cnsurvey_question_id).then(function (res) {
                if (res.body.status == 200) {
                    toastr.success("Survey Question deleted!", "Success!");
                    location.reload(true);
                } else {
                    toastr.error("Couldn't complete request, kindly try again", "Warning!");
                }
            });
        },
        processPayment: function processPayment(data) {

            this.disable_btn = true;

            var obj = this;
            this.amount_paid = data.payment_amount;
            var handler = PaystackPop.setup({
                key: 'pk_live_1e88da135e1bd1205b610cac36fc6d9a27a2fbd8',
                Name: data.payment_user,

                email: "webworks@webnigeria.ng",
                amount: data.payment_amount * 100,
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.payment_user
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this8 = this;

            var credentials = {
                amount_paid: this.amount_paid,
                payment_ref: payment_ref
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updateCnsurveysPayments(this, payment_ref, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");
                        _this8.$router.go('/mymoney');
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        this.preset();
        this.getBusiness();
        this.getBusinessCategories();
        this.getStates();
        this.getCnsurveys();
    }

});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnsurvey',
    data: function data() {
        return {
            user: {},
            survey: {},
            surveys: [],
            answer: [],
            pag_intv: service.pageIntv,
            current_page: 0,
            siteUrl: service.siteUrl + "?title="
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default.a
    },
    methods: {
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl + this.survey.cnsurvey_title_url);
            var btn = $('.linky').tooltip({
                trigger: 'click',
                placement: 'bottom'
            });
            this.setTooltip(btn, 'Copied to Clipboard');
            this.hideTooltip(btn);
        },
        setTooltip: function setTooltip(btn, message) {
            btn.tooltip('hide').attr('data-original-title', message).tooltip('show');
        },
        hideTooltip: function hideTooltip(btn) {
            setTimeout(function () {
                btn.tooltip('hide');
            }, 1000);
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        preset2: function preset2() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getSurvey();
                        }, _this2);
                    } else {
                        if (localStorage.getItem("cgt") == null) {
                            _this2.prepareCNuserGuestID();
                        } else {
                            _this2.user.user_id = localStorage.getItem("cgt");
                            _this2.getSurvey();
                        }
                    }
                }).catch(function (err) {
                    if (localStorage.getItem("cgt") == null) {
                        _this2.prepareCNuserGuestID();
                    } else {
                        _this2.user.user_id = localStorage.getItem("cgt");
                        _this2.getSurvey();
                    }
                });
            } else {
                if (localStorage.getItem("cgt") == null) {
                    this.prepareCNuserGuestID();
                } else {
                    this.user.user_id = localStorage.getItem("cgt");
                    this.getSurvey();
                }
            }
        },
        prepareCNuserGuestID: function prepareCNuserGuestID() {
            var _this3 = this;

            service.prepareCNuserGuestID(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.user.user_id = response.body.data;
                    localStorage.setItem("cgt", _this3.user.user_id);
                    _this3.getSurvey(0, _this3.pag_intv);
                }
            }).catch(function (err) {});
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        getSurvey: function getSurvey() {
            var _this4 = this;

            if (this.$route.query.title != null) {
                var data = {
                    cnsurvey_url: this.$route.query.title
                };
                service.getSurvey(this, data).then(function (res) {
                    _this4.survey = res.body.data;
                });
            } else {}
        },
        next: function next(sv, i) {
            if (this.survey.cnsurveys_questions[i + 1] == undefined) {
                this.survey.cnsurvey_question_index = 0;

                this.survey.cnsurveys_questions = this.survey.cnsurveys_questions;
                this.survey.survey_finished_poll = true;
            } else {
                this.survey.cnsurvey_question_index++;
            }
        },
        check_if_user_has_polled: function check_if_user_has_polled(survey_answers) {
            var loop_count = 0;
            if (survey_answers != null) {
                survey_answers.forEach(function (element) {
                    if (this.user.user_id == element.cnsurvey_answer_user) {
                        loop_count = 1;
                    }
                }, this);
                if (loop_count == 1) {
                    return true;
                }
            } else {
                return false;
            }
        },
        get_option_answer: function get_option_answer(option, survey_answers) {
            var option_count = 0;
            if (survey_answers != null) {
                survey_answers.forEach(function (element) {
                    if (option == element.cnsurvey_answer_option) {
                        option_count++;
                    }
                }, this);
                return option_count;
            } else {
                return 0;
            }
        },
        fillSurvey: function fillSurvey(survey, survey_question, survey_question_index, option) {
            var _this5 = this;

            this.survey = survey;
            this.survey.disable = true;
            var data = {
                cnsurvey_answer_survey_question: survey_question.cnsurvey_question_id,
                cnsurvey_answer_user: this.user.user_id || 0,
                cnsurvey_answer_option: option
            };
            service.surveyAns(this, data).then(function (res) {
                if (res.status == 201) {
                    toastr.success("You've Polled", "Thumbs Up!");
                    _this5.survey.disable = false;
                    _this5.survey.cnsurveys_questions[survey_question_index].cnsurveys_answers = res.body.cnsurvey_answers;

                    _this5.survey.cnsurveys_questions[survey_question_index].polled = true;

                    if (_this5.survey.cnsurveys_questions[survey_question_index + 1] == undefined) {
                        _this5.survey.cnsurveys_questions = _this5.survey.cnsurveys_questions;
                        _this5.survey.survey_finished_poll = true;

                        if (localStorage.getItem("cityneeds_token") == null) {
                            $('#guest-poll').modal('show');
                        }
                    } else {
                        _this5.survey.cnsurveys_questions[survey_question_index].next = true;
                    }
                } else {
                    toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                }
            });
        }
    },
    created: function created() {
        localStorage.setItem("cn_prv_page", "cnsurveys");
        this.preset2();
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CreateThread_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SearchBar_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnsurveys',
    data: function data() {
        return {
            user: {},
            survey: {},
            surveys: [],
            answer: [],
            pag_intv: service.pageIntv,
            current_page: 0,
            siteUrl: service.siteUrl + "?title="
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a,
        'create-thread': __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_5__SearchBar_vue___default.a
    },
    methods: {
        copyLink: function copyLink(survey) {
            this.$clipboard(this.siteUrl + survey.cnsurvey_title_url);
            var btn = $('.linky').tooltip({
                trigger: 'click',
                placement: 'bottom'
            });
            this.setTooltip(btn, 'Copied to Clipboard');
            this.hideTooltip(btn);
        },
        setTooltip: function setTooltip(btn, message) {
            btn.tooltip('hide').attr('data-original-title', message).tooltip('show');
        },
        hideTooltip: function hideTooltip(btn) {
            setTimeout(function () {
                btn.tooltip('hide');
            }, 1000);
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getSurveys(0, this.pag_intv);
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        preset2: function preset2() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getSurveys(0, this.pag_intv);
                        }, _this2);
                    } else {
                        if (localStorage.getItem("cgt") == null) {
                            _this2.prepareCNuserGuestID();
                        } else {
                            _this2.user.user_id = localStorage.getItem("cgt");
                            _this2.getSurveys(0, _this2.pag_intv);
                        }
                    }
                }).catch(function (err) {
                    if (localStorage.getItem("cgt") == null) {
                        _this2.prepareCNuserGuestID();
                    } else {
                        _this2.user.user_id = localStorage.getItem("cgt");
                        _this2.getSurveys(0, _this2.pag_intv);
                    }
                });
            } else {
                if (localStorage.getItem("cgt") == null) {
                    this.prepareCNuserGuestID();
                } else {
                    this.user.user_id = localStorage.getItem("cgt");
                    this.getSurveys(0, this.pag_intv);
                }
            }
        },
        prepareCNuserGuestID: function prepareCNuserGuestID() {
            var _this3 = this;

            service.prepareCNuserGuestID(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.user.user_id = response.body.data;
                    localStorage.setItem("cgt", _this3.user.user_id);
                    _this3.getSurveys(0, _this3.pag_intv);
                }
            }).catch(function (err) {});
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        getSurveys: function getSurveys(offset, items) {
            var _this4 = this;

            service.getAllSurveys(this, offset, items).then(function (res) {
                _this4.surveys = res.body.data;
                if (res.body.data_count % _this4.pag_intv) {
                    _this4.surveys.count_range = Math.floor(res.body.data_count / _this4.pag_intv) + 1;
                } else {
                    _this4.surveys.count_range = Math.floor(res.body.data_count / _this4.pag_intv);
                }

                if (offset == 0) {
                    _this4.current_page = 1;
                } else {
                    _this4.current_page = items;
                }
            });
        },
        next: function next(sv, i) {
            if (this.surveys[sv].cnsurveys_questions[i + 1] == undefined) {
                this.surveys[sv].cnsurvey_question_index = 0;

                if (localStorage.getItem("cityneeds_token") == null) {
                    $('#guest-poll').modal('show');
                }
            } else {
                this.surveys[sv].cnsurvey_question_index++;
            }
        },
        check_if_user_has_polled: function check_if_user_has_polled(survey_answers) {
            var loop_count = 0;
            if (survey_answers != null) {
                survey_answers.forEach(function (element) {
                    if (this.user.user_id == element.cnsurvey_answer_user) {
                        loop_count = 1;
                    }
                }, this);
                if (loop_count == 1) {
                    return true;
                }
            } else {
                return false;
            }
        },
        get_option_answer: function get_option_answer(option, survey_answers) {
            var option_count = 0;
            if (survey_answers != null) {
                survey_answers.forEach(function (element) {
                    if (option == element.cnsurvey_answer_option) {
                        option_count++;
                    }
                }, this);
                return option_count;
            } else {
                return 0;
            }
        },
        fillSurvey: function fillSurvey(survey, survey_question, survey_question_index, option) {
            var _this5 = this;

            this.survey = survey;

            var data = {
                cnsurvey_answer_survey_question: survey_question.cnsurvey_question_id,
                cnsurvey_answer_user: this.user.user_id || 0,
                cnsurvey_answer_option: option
            };
            service.surveyAns(this, data).then(function (res) {
                if (res.status == 201) {
                    toastr.success("You've Polled", "Thumbs Up!");

                    _this5.survey.cnsurveys_questions[survey_question_index].cnsurveys_answers = res.body.cnsurvey_answers;

                    _this5.survey.cnsurveys_questions[survey_question_index].polled = true;
                } else {
                    toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                }
            });
        }
    },
    created: function created() {
        localStorage.setItem("cn_prv_page", "cnsurveys");
        this.preset2();
    }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_payments_and_updates_js__ = __webpack_require__(12);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Contracts',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_payments_and_updates_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            cnpro_id: "",
            contracts: {},
            contract: {},
            contract_threads: {},
            panelFlag: false,
            addFlag: false,
            viewContractPanel: false,
            viewContractThread: false,
            viewQuote: false,
            contract_payment_ref: "",
            reviews: {},
            review: {},
            rate: "",
            canRate: true,
            img_url: service.imageURL,
            selected_contract: '',
            current_wallet_balance: 0,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal, cnpro) {
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        back: function back() {
            this.panelFlag = false;
        },
        toggleMenuActions: function toggleMenuActions() {
            $('.toggle-menu-actions').toggle();
        },
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == 'view') {
                this.viewQuote = false;
                this.viewContractPanel = true;
                this.viewContractThread = false;
            }
            if (attr == 'viewContract') {
                this.viewQuote = false;
                this.viewContractPanel = true;
                this.viewContractThread = false;
                this.getContract(attr2);
            }
            if (attr == 'view-thread') {
                this.viewQuote = false;
                this.viewContractThread = true;
                this.viewContractPanel = false;
            }
        },
        setViewQuote: function setViewQuote(cnpro) {
            this.viewQuote = true;
            this.viewContractPanel = false;
            this.viewContractThread = false;
        },
        setContractThreadPanel: function setContractThreadPanel(contract, thread) {
            this.panelFlag = true;
            this.addFlag = false;
            this.viewContractPanel = true;
            this.contract.contract_id = contract;
            this.contract_threads = thread;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getUserContracts: function getUserContracts() {
            var _this2 = this;

            this.viewQuote = false;
            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getUserContracts(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this2.contracts = data.body.data;
                    var result = data.body.data;
                    var count = 0;
                    result.forEach(function (element) {
                        ++count;
                        if (count == 1) {
                            this.contract = element;
                            this.cnpro_id = this.contract.contract_cnpro_id;
                        }
                    }, _this2);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getContract: function getContract(contract) {
            var _this3 = this;

            service.getContract(this, contract).then(function (data) {
                if (data.body.status == 200) {
                    _this3.contract = data.body.data;
                    _this3.cnpro_id = _this3.contract.contract_cnpro_id;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        replyContract: function replyContract(contract, user) {
            var _this4 = this;

            var credentials = {
                contract_contract: contract,
                contract_user: user,
                contract_category: 3,
                contract_reply: this.contract.message
            };

            var navi = this.$router;
            if (credentials.contract_reply != null || credentials.contract_user != null || credentials.contract_user != null) {
                service.replyQuote(this, contract, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Sent!", "Success!");
                        _this4.getContract(contract);
                    } else {
                        toastr.error('Sorry, could not send', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        preAcceptQuote: function preAcceptQuote(contract) {
            this.selected_contract = contract;

            $('#paywith').modal();
        },
        acceptQuote: function acceptQuote(pay_with_option) {
            var _this5 = this;

            var contract = this.selected_contract;
            this.disable_btn = true;
            var credentials = {
                contract_contractor: this.user.user_id
            };
            var navi = this.$router;
            if (credentials.contract_contractor != null) {
                service.acceptQuote(this, contract.contract_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Quote Accepted!", "Success!");

                        if (pay_with_option == "gateway") {
                            _this5.processPayment(data.body.data);
                        } else {
                            _this5.processPaymentWithWallet(data.body.data);
                        }
                    } else {
                        toastr.error('Sorry, could not accept Quote', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        rejectQuote: function rejectQuote(contract) {
            var credentials = {
                contract_contractor: this.user.user_id
            };
            var navi = this.$router;
            if (credentials.contract_contractor != null) {
                service.rejectQuote(this, contract, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Quote Rejected!", "Success!");
                        location.reload();
                    } else {
                        toastr.error('Sorry, could not reject Quote', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        closeModal: function closeModal() {
            location.reload();
        },
        confirmQuote: function confirmQuote(contract) {
            var credentials = {
                contract_contractor: this.user.user_id
            };
            var navi = this.$router;
            if (credentials.contract_contractor != null) {
                service.confirmContract(this, contract, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Job Confirmed!", "Success!");

                        $('#reviewModal').modal('show');
                    } else {
                        toastr.error('Sorry, could not confirm Quote', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        closeContract: function closeContract() {
            var navi = this.$router;
            service.closeContract(this, this.contract.contract_id, this.contract).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Contract Closed!", "Success!");
                    location.reload();
                } else {
                    toastr.error('Sorry, could not confirm Quote', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        processPayment: function processPayment(data) {
            var obj = this;
            var handler = PaystackPop.setup({
                key: 'pk_live_1e88da135e1bd1205b610cac36fc6d9a27a2fbd8',
                Name: data.contract_contractor,
                email: data.contract_contractor_email || "admin@cityneeds.ng",

                amount: data.contract_labour_cost * 100,
                ref: data.contract_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.contract_contractor
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.contract_request
                    }]
                },

                callback: function callback(response) {
                    var txn_payload = {
                        "transaction_payment_ref": data.contract_ref,
                        "transaction_module": 4,
                        "transaction_module_id": obj.selected_contract.contract_id,
                        "transaction_type": 1,
                        "transaction_mode": 1,
                        "transaction_mode_transaction_ref": ref,
                        "transaction_amount_paid": data.contract_labour_cost,
                        "payer_name": data.contract_contractor || "",
                        "payer_email": data.contract_contractor_email || "",
                        "payer_phone": obj.user.user_phone || 0,
                        "payer_user": obj.user.user_id || 0
                    };
                    obj.postCNpaymentDetails(txn_payload);

                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        processPaymentWithWallet: function processPaymentWithWallet(data) {
            var _this6 = this;

            this.amount_paid = data.plan_amount;
            var payload = {
                pay: this.user.user_id,
                txn_amount: data.contract_labour_cost,
                service: 3,
                service_ref: data.contract_ref
            };
            service.postWalletPayout(this, payload).then(function (response) {
                if (response.body.status == 201) {
                    var txref = response.body.data_txn_ref;

                    var txn_payload = {
                        "transaction_payment_ref": data.contract_ref,
                        "transaction_module": 4,
                        "transaction_module_id": _this6.selected_contract.contract_id,
                        "transaction_type": 1,
                        "transaction_mode": 2,
                        "transaction_mode_transaction_ref": txref,
                        "transaction_amount_paid": data.contract_labour_cost,
                        "payer_name": _this6.user.user_fullname || "",
                        "payer_email": _this6.user.user_email || "",
                        "payer_phone": _this6.user.user_phone || 0,
                        "payer_user": _this6.user.user_id || 0
                    };
                    _this6.postCNpaymentDetails(txn_payload);

                    _this6.updatePayment(response.body.data);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        updatePayment: function updatePayment(payment_ref) {
            var credentials = {
                contract_contractor: this.user.user_id
            };
            if (payment_ref != "") {
                service.updatePayment(this, payment_ref, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");
                        location.reload();
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        },
        makeComplaint: function makeComplaint(contract, user) {
            var _this7 = this;

            var credentials = {
                contract_contract: contract,
                contract_user: user,
                contract_complaint: this.contract.complaint
            };

            var navi = this.$router;
            if (credentials.contract_complaint != null || credentials.contract_user != null || credentials.contract_contract != null) {
                service.makeComplaint(this, contract, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Sent!", "Success!");
                        _this7.getContract(contract);
                    } else {
                        toastr.error('Sorry, could not send', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        resolveComplaint: function resolveComplaint(complaint, complaint_id) {
            var _this8 = this;

            this.complaint = complaint;
            var navi = this.$router;
            service.resolveComplaint(this, complaint_id, complaint).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Resolved!", "Success!");
                    _this8.complaint.contract_complaint_status = 15;
                } else {
                    toastr.error('Sorry, could not send', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        submitReview: function submitReview(cnpro) {
            var _this9 = this;

            var credentials = {
                review_category: 1,
                review_review: this.review.review,
                review_cnpro: cnpro,
                review_business: 0,
                review_user: this.user.user_id,
                check_rate: this.rate

            };
            var navi = this.$router;
            if (credentials.review_user != null && credentials.review_review != undefined) {
                if (credentials.check_rate != '') {
                    service.submitReview(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Review Submitted!", "Awesome!");
                            _this9.canRate = false;
                            location.reload();
                        } else {
                            toastr.error('Sorry, could not submit Review', 'Warning!');
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    });
                } else {
                    toastr.error('Kindly Rate cnpro', 'Warning!');
                }
            } else {
                toastr.error('Kindly enter review', 'Warning!');
            }
        },
        rateCnpro: function rateCnpro() {
            var _this10 = this;

            var credentials = {
                rating_category: 1,
                rating_rate: this.rate,
                rating_cnpro: this.cnpro_id,
                rating_business: 0,
                rating_user: this.user.user_id
            };
            var navi = this.$router;
            if (credentials.rating_user != null || credentials.rating_rate != null) {
                service.submitRating(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Rated!", "Success!");
                        _this10.canRate = false;
                    } else {
                        toastr.error('Sorry, could not Rate', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        getWalletBalance: function getWalletBalance() {
            var _this11 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletBalance(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this11.current_wallet_balance = data.body.data_current_wallet_balance;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        }
    },
    created: function created() {
        this.preset();
        this.getUserContracts();
        this.getWalletBalance();
    }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DashboardFooter',
    data: function data() {
        return {
            this_year: service.thisYear
        };
    },

    created: function created() {}
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DashboardHeader',
    data: function data() {
        return {
            user: {},
            img_url: service.imageURL,
            site_url: "",
            referral_text: "",
            copy_succ: false,
            site_set_url: "https://share.cityneeds.ng/?ref="
        };
    },

    methods: {
        copyLink: function copyLink() {
            this.copy_succ = true;
            this.$clipboard(this.referral_text);
        },
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.user = data.body.data;
                                }
                                _this.referral_text = 'Hey,\nCityneeds is a fast, simple and secure webapp that i go to whenever i need skilled-workers like plumbers, and tilers, etc. It also doubles as a payment platform for real-time settlement of AEDC, Dstv, Remita, MTN, amongst others bills. The sweetest part of it is that I get CASH-BACK REWARD on most payments I make!\n                                \nClick to signup now : ' + _this.site_set_url + _this.user.user_referral_code + '\nIt is absolutely free! ';
                            }).catch(function (err) {
                                if (err) {
                                    toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            });
                        }, _this2);
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        }
    },
    created: function created() {
        this.preset();
        setTimeout(function () {
            if (localStorage.getItem("cityneeds_prompt") == 0) {
                $('#prompt').modal();
                localStorage.setItem("cityneeds_prompt", 1);
            }
        }, 4000);
    }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DashboardSidebar',
    data: function data() {
        return {
            user: {},
            notifications_contracts: 0,
            notifications_cnpros: 0,
            notifications_cnsurveys: 0,
            show: true
        };
    },

    methods: {
        isActive: function isActive(page) {
            if (page == localStorage.getItem("cn_current_page")) {
                return true;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.getNotifications();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getNotifications: function getNotifications() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this2 = this;

                            this.user.user_id = element.user_id;

                            service.getNotifications(this, this.user.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this2.notifications_contracts = data.body.notifications_contracts;
                                    _this2.notifications_cnpros = data.body.notifications_cnpros;
                                    _this2.notifications_cnsurveys = data.body.notifications_cnsurveys;
                                }
                            }).catch(function (err) {
                                if (err) {
                                    toastr.error('Sorry, could not process information!', 'Warning!');
                                }
                            });
                        }, _this3);
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        }
    },
    created: function created() {
        this.getNotifications();
        localStorage.setItem("cn_current_page", this.$route.path);
    }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Dashboard',
    data: function data() {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            businesses: {},
            business: {},
            contracts: {},
            contract: {},
            cnsurveys: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        resetPassword: function resetPassword() {
            var _this2 = this;

            var credentials = {
                email: this.user.email,
                password: this.user.password
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.password == null || credentials.password == undefined || credentials.password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.resetPassword(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            localStorage.setItem("cityneeds_user", element.fullname);
                        }, _this2);
                        _this2.$router.push('dashboard');
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                    }
                });
            }
        },
        resetEmail: function resetEmail() {
            var _this3 = this;

            var credentials = {
                email: this.user.email,
                password: this.user.password
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.password == null || credentials.password == undefined || credentials.password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.resetEmail(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            localStorage.setItem("cityneeds_user", element.fullname);
                        }, _this3);
                        _this3.$router.push('dashboard');
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                    }
                });
            }
        },
        editProfile: function editProfile() {
            var credentials = {
                user_fullname: this.user.name,
                user_phone: this.user.phone,
                user_address: this.user.address,
                user_state: this.user.state,
                user_city: this.user.city
            };

            var navi = this.$router;
            if (credentials.user_fullname != null || credentials.user_phone != null || credentials.user_city != null) {
                service.editProfile(this, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Profile Updated!", "Success!");
                        location.reload(true);
                    } else {
                        toastr.error('Sorry, could not update Profile', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        getBusinesses: function getBusinesses() {
            var _this4 = this;

            var user_id = this.user.user_id;

            service.getBusinesses(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this4.businesses = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addBusiness: function addBusiness() {
            var credentials = {
                business_user: this.user.user_id,
                business_category: this.business.category,
                business_name: this.business.name,
                business_email: this.business.email,
                business_phone: this.business.phone,
                business_address: this.business.address,
                business_state: this.business.state,
                business_city: this.business.city,
                business_description: this.business.description
            };

            var navi = this.$router;
            if (credentials.business_user != null || credentials.business_name != null || credentials.business_category != null) {
                service.addBusiness(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Business Added!", "Success!");
                        location.reload(true);
                    } else {
                        toastr.error('Sorry, could not add Business', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        getCnpros: function getCnpros() {
            var _this5 = this;

            var user_id = this.user.user_id;

            service.getBusinesses(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this5.cnpros = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addCnpro: function addCnpro() {
            var credentials = {
                cnpro_user: this.user.user_id,
                cnpro_category: this.cnpro.category,
                cnpro_name: this.cnpro.name,
                cnpro_email: this.cnpro.email,
                cnpro_phone: this.cnpro.phone,
                cnpro_address: this.cnpro.address,
                cnpro_state: this.cnpro.state,
                cnpro_city: this.cnpro.city,
                cnpro_description: this.cnpro.description
            };

            var navi = this.$router;
            if (credentials.cnpro_user != null || credentials.cnpro_name != null || credentials.cnpro_category != null) {
                service.addCnpro(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Cnpro Added!", "Success!");
                        location.reload(true);
                    } else {
                        toastr.error('Sorry, could not add Cnpro', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        copyLink: function copyLink() {}
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SearchBar_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_1__services_validator__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FindCnpro',
    data: function data() {
        return {
            user: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            backgroundSize: 'contain',
            search_mode: false,
            cnproParentCategories: {},
            sub_categories: {},
            disable_btn: false,
            error_count: 0,
            request_sent: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_5__Main_Footer_index_vue___default.a,
        'horizontal-widget': __WEBPACK_IMPORTED_MODULE_4__HorizontalWidget_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_6__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.checkPremuimMember();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        checkPremuimMember: function checkPremuimMember() {
            var _this2 = this;

            service.getUser(this, this.user.user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this2.user = data.body.data;
                    if (_this2.user.user_premuim_plan_id == 1) {
                        _this2.$router.push("pricing");
                    } else {
                        _this2.getCnproParentCategories();
                    }
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproParentCategories: function getCnproParentCategories() {
            var _this3 = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this4 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this4.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            this.search.type = 'cnpro-search';
            this.getCnproSubCategories(parent);
        },
        processForm: function processForm() {
            var _this5 = this;

            this.disable_btn = true;
            this.error_count = 0;
            var credentials = {
                request_area: this.search.area,
                request_user: this.user.user_id,
                request_phone: this.search.phone,
                request_work_address: this.search.work_address,
                request_work_date: this.search.work_date,
                request_details: this.search.details
            };

            var navi = this.$router;

            if (credentials.request_phone) {
                if (!valid.validatePhoneNumber(credentials.request_phone)) {
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }
            } else {
                toastr.warning("Kindly fill in Phone Number", 'Missing Fields');
                this.disable_btn = false;
            }
            if (this.error_count == 0) {
                if (this.search.details != null && this.search.area != null && this.search.phone != null) {
                    service.findCnpro(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Request Sent", 'We will get back to you!');
                            this.search = {};
                            this.request_sent = true;
                        }
                    }).catch(function (err) {
                        _this5.disable_btn = false;_this5.search = {};
                    });
                } else {
                    toastr.warning("Kindly fill in fields with *", 'Missing Fields');
                    this.disable_btn = false;
                }
            }
        },
        makeAnotherRequest: function makeAnotherRequest() {
            this.request_sent = false;
        }
    },
    created: function created() {
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "help-me-find-a-cnpro");
            this.preset();
        }
    }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CreateThread_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utility__ = __webpack_require__(26);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var utility = new __WEBPACK_IMPORTED_MODULE_5__services_utility__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Forum',
    data: function data() {
        var _ref;

        return _ref = {
            user: {},
            thr_data: {},
            comments: {},
            comment: {},
            forum: {}
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'user', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'imageForm', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'forum_can_edit', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'edit_image_set', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'img_url', service.imageURL), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'siteUrl', service.siteUrl + "?topic="), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'siteImage', service.siteImage), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loggedIn', false), _ref;
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a,
        'create-thread': __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue___default.a
    },

    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "forum_comment") {
                this.comment = attr2;
            }
        },
        metaPrep: function metaPrep(attr) {
            var prep = this.$route.query.topic + " Forums - Cityneeds(cityneeds.ng)";
            if (attr == "title") {
                return this.forum.forum_topic + " Forums - Cityneeds(cityneeds.ng)";
            }
            if (attr == "image") {
                return this.forum.forum_attachment;
            }
        },
        copyLink: function copyLink() {
            this.$clipboard(this.forum.forum_url);
            var btn = $('.linky').tooltip({
                trigger: 'click',
                placement: 'bottom'
            });
            this.setTooltip(btn, 'Copied');
            this.hideTooltip(btn);
        },
        setTooltip: function setTooltip(btn, message) {
            btn.tooltip('hide').attr('data-original-title', message).tooltip('show');
        },
        hideTooltip: function hideTooltip(btn) {
            setTimeout(function () {
                btn.tooltip('hide');
            }, 1000);
        },
        setForumDsc: function setForumDsc(text) {
            var p_fmttd = "";

            var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
            var text1 = text.replace(exp, "<a href='$1'>$1</a>");
            var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

            p_fmttd = text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');

            return p_fmttd;
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        preset2: function preset2() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this2);
                    } else {
                        if (localStorage.getItem("cgt") == null) {
                            _this2.prepareCNuserGuestID();
                        } else {
                            _this2.user.user_id = localStorage.getItem("cgt");
                        }
                    }
                }).catch(function (err) {
                    if (localStorage.getItem("cgt") == null) {
                        _this2.prepareCNuserGuestID();
                    } else {
                        _this2.user.user_id = localStorage.getItem("cgt");
                    }
                });
            } else {
                if (localStorage.getItem("cgt") == null) {
                    this.prepareCNuserGuestID();
                } else {
                    this.user.user_id = localStorage.getItem("cgt");
                }
            }
        },

        trackevent: function trackevent(event) {
            if (event.isTrusted) {
                localStorage.setItem("cn_prv_page", "forums");
                this.preset2();
            }
        },
        can_edit: function can_edit() {
            var _this3 = this;

            var data = {};
            data.data_id = this.forum.forum_id;
            data.data_owner = this.user.user_id;
            data.data_type = "forums";
            service.canEditData(this, data).then(function (res) {
                if (res.status == 200) {
                    _this3.forum_can_edit = true;
                } else {}
            });
        },
        can_edit_comment: function can_edit_comment(forum) {
            if (forum == this.user.user_id) {
                return true;
            }
        },
        thread: function thread() {
            var _this4 = this;

            var id = this.$route.params;
            var uid = id.id;
            service.getThread(this, uid).then(function (res) {
                _this4.thr_data = res.body.data;
            });
        },
        addCommentXX: function addCommentXX() {
            if (this.user.user_id != undefined) {
                var tid = this.$route.params.id;
                var data = this.comment;

                data.forum_comment_forum = localStorage.getItem("cn_f");
                data.forum_comment_user = this.user.user_id;
                service.addThreadComment(this, data).then(function (res) {
                    if (res.status == 201) {
                        toastr.success("Comment successfully posted", "Success!");
                        location.reload();
                    } else {
                        toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                    }
                });
            }
        },
        addComment: function addComment() {
            var _this5 = this;

            if (this.user.user_id != undefined) {
                var tid = this.$route.params.id;
                var data = this.comment;

                data.forum_comment_forum = this.forum.forum_id;
                data.forum_comment_user = this.user.user_id;
                service.addThreadComment(this, data).then(function (res) {
                    if (res.status == 201) {
                        _this5.comment = {};
                        if (_this5.edit_image_set) {
                            var forum_comment_id = res.body.data;
                            _this5.imageForm.append("data_id", forum_comment_id);
                            _this5.imageForm.append("data_type", "forum_comment_attachment");
                            service.uploadDataPhoto(_this5, _this5.imageForm).then(function (data) {
                                if (localStorage.getItem("cityneeds_token") == null) {
                                    $('#guest-poll').modal('show');
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }
                        toastr.success("Comment successfully posted", "Success!");
                    } else {
                        toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                    }
                });
            }
        },
        getComments: function getComments() {
            var _this6 = this;

            var id = this.$route.params.id;
            service.forumComments(this, id).then(function (res) {
                _this6.comments = res.body.data;
            });
        },
        getForumXXX: function getForumXXX() {
            var _this7 = this;

            var forum_id = localStorage.getItem("cn_f");
            service.getThread(this, forum_id).then(function (res) {
                _this7.forum = res.body.data;
            });
        },
        getForum: function getForum() {
            var _this8 = this;

            if (localStorage.getItem("cityneeds_token") != null) {
                this.preset();
            }
            var data = {
                forum_url: this.$route.query.topic
            };
            service.getThread(this, data).then(function (res) {
                _this8.forum = res.body.data;
                _this8.forum.forum_url = _this8.siteUrl + _this8.forum.forum_topic_url;
                _this8.forum.forum_url_picture = _this8.forum.forum_attachment || _this8.siteImage;
                _this8.can_edit();
            });
        },
        editForum: function editForum() {
            var _this9 = this;

            var forum_url = "";
            service.editThread(this, this.forum.forum_id, this.forum).then(function (response) {
                if (response.body.status = 200) {
                    toastr.success("Thread edited", 'Ok buddy');
                    forum_url = response.body.data;

                    if (_this9.edit_image_set) {
                        _this9.imageForm.append("data_id", _this9.forum.forum_id);
                        _this9.imageForm.append("data_type", "forum_attachment");
                        service.uploadDataPhoto(_this9, _this9.imageForm).then(function (data) {}).catch(function (err) {
                            if (err) {}
                        });
                    }
                } else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!');
                }
                if (forum_url != null) {
                    location.replace("/forum?topic=" + forum_url);
                }
            });
        },
        editComment: function editComment(comment) {
            var _this10 = this;

            if (this.user.user_id != undefined) {
                service.editThreadComment(this, comment.forum_comment_id, comment).then(function (res) {
                    if (res.status == 200) {
                        if (_this10.edit_image_set) {
                            _this10.imageForm.append("data_id", comment.forum_comment_id);
                            _this10.imageForm.append("data_type", "forum_comment_attachment");
                            service.uploadDataPhoto(_this10, _this10.imageForm).then(function (data) {}).catch(function (err) {
                                if (err) {}
                            });
                        }
                        location.reload();
                    } else {
                        toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                        location.reload();
                    }
                });
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
                this.edit_image_set = true;
            }
        },
        setReg: function setReg() {
            var set_url = 'forum?topic=' + this.forum.forum_topic_url;
            localStorage.setItem("current_page", set_url);
            localStorage.setItem("cn_prv_page", set_url);
            localStorage.setItem("cn_current_page", set_url);
            location.replace('login');
        },
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("cityneeds_token")) {
                this.loggedIn = true;
            }
        }
    },

    mounted: function mounted() {
        this.checkLoggedIn();
        this.getForum();
    }

});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CreateThread_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Forums',
    data: function data() {
        return {
            forums: {},
            forum: {},
            panelFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            search_forum: 0,
            current_page: 0,
            loggedIn: false
        };
    },
    metaInfo: function metaInfo() {
        return {
            title: "Discussions on cityneeds forum",
            titleTemplate: '',
            meta: [{ 'property': 'og:description', 'content': 'Discussions on cityneeds forum, my opinion counts, cityneeds, abuja, nigeria africa', 'vmid': 'og:description' }]
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a,
        'create-thread': __WEBPACK_IMPORTED_MODULE_4__CreateThread_vue___default.a
    },
    methods: {
        setComponent: function setComponent(component) {
            this.forum = component;
            this.panelFlag = true;
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        setForumDsc: function setForumDsc(text) {
            var p_fmttd = "";

            var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
            var text1 = text.replace(exp, "<a href='$1'>$1</a>");
            var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

            p_fmttd = text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');

            return p_fmttd;
        },
        setForum: function setForum(forum) {
            localStorage.setItem("cn_f", forum);
            this.$router.push("/forum");
        },
        getAllForums: function getAllForums(offset, items) {
            var _this = this;

            service.getForums(this, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    _this.forums = data.body.data;

                    if (data.body.data_count % _this.pag_intv) {
                        _this.forums.count_range = Math.floor(data.body.data_count / _this.pag_intv) + 1;
                    } else {
                        _this.forums.count_range = Math.floor(data.body.data_count / _this.pag_intv);
                    }
                    _this.current_page = items;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getForums: function getForums(offset, items) {
            var _this2 = this;

            service.getForums(this, this.search_forum, offset, items).then(function (data) {
                if (data.body.status == 200) {
                    _this2.forums = data.body.data;

                    if (data.body.data_count % _this2.pag_intv) {
                        _this2.forums.count_range = Math.floor(data.body.data_count / _this2.pag_intv) + 1;
                    } else {
                        _this2.forums.count_range = Math.floor(data.body.data_count / _this2.pag_intv);
                    }

                    if (offset == 0) {
                        _this2.current_page = 1;
                    } else {
                        _this2.current_page = items;
                    }
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        searchForums: function searchForums() {
            var _this3 = this;

            if (this.search_forum != 0) {
                service.searchForums(this, this.search_forum).then(function (data) {
                    if (data.body.status == 200) {
                        _this3.forums = data.body.data;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {
                this.getAllForums(0, this.pag_intv);
            }
        },
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("cityneeds_token")) {
                this.loggedIn = true;
            }
        }
    },
    created: function created() {
        this.getForums(0, this.pag_intv);

        this.checkLoggedIn();
    }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    props: ['request', 'context_pg'],
    data: function data() {
        return {
            searches: {},
            search: {},
            cnpros: {},
            cnpro: {},
            businesses: [],
            cnsurveys: {},
            forums: {},
            reviews: {},
            img_url: service.imageURL,
            cnproParentCategories: {},
            sub_categories: {},
            user: "",
            subscription: {},
            process_message: ""
        };
    },

    components: {
        'main-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        getCnproParentCategories: function getCnproParentCategories() {
            var _this = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this2 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this2.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this3 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            if (parent == "business-search") {
                this.search.type = 'business-search';
                this.getBusinessCategories();
            } else {
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent);
            }
        },
        prep_search: function prep_search(keywords) {
            this.search.keywords = keywords;
            this.search.city = 'Abuja';
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type + '?context=' + this.search.keywords + '&city=' + this.search.city);
                if (credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                } else if (credentials.search_type == "cnpros") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                }
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        doSearch2: function doSearch2(category) {
            var navi = this.$router;
            localStorage.setItem("cityneeds_search_type", 'cnpros');
            localStorage.setItem("cityneeds_search_keywords", category);
            localStorage.setItem("cityneeds_search_city", 'Abuja');
            navi.push("cnpro-search");
        },
        viewCnpro: function viewCnpro(cnpro) {
            if (cnpro) {
                localStorage.setItem("cityneeds_search_cnpro", cnpro.cnpro_data_item);
                this.$router.push("cnpro");
            }
        },
        getCnpros: function getCnpros() {
            var _this4 = this;

            service.getAllCnpros(this).then(function (data) {
                if (data.body.status == 200) {
                    _this4.cnpros = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        viewBusiness: function viewBusiness(business) {
            if (business) {
                localStorage.setItem("cityneeds_search_business", business.business_data_item);
                this.$router.push("businesses");
            }
        },
        getBusinesses: function getBusinesses() {
            var _this5 = this;

            service.getAllBusinesses(this).then(function (data) {
                if (data.body.status == 200) {
                    var length = 0;
                    var datan = data.body.data;
                    datan.forEach(function (element) {
                        if (length <= 5) {
                            this.businesses.push(element);
                        }
                        length++;
                    }, _this5);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getForums: function getForums() {
            var _this6 = this;

            service.getAllForums(this).then(function (data) {
                if (data.body.status == 200) {
                    _this6.forums = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getReviews: function getReviews() {
            var _this7 = this;

            service.getAllReviews(this).then(function (data) {
                if (data.body.status == 200) {
                    _this7.reviews = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getSurveys: function getSurveys() {
            var _this8 = this;

            var offset = 0;var items = 1;
            service.getAllSurveys(this, offset, items).then(function (res) {
                _this8.cnsurveys = res.body.data;
            });
        },
        subscribe: function subscribe() {
            var _this9 = this;

            if (this.subscription.email == '' || this.subscription.email == undefined) {
                this.process_message = "Please provide your email";
            } else {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var email_test = re.test(String(this.subscription.email).toLowerCase());
                if (email_test == false) {
                    this.process_message = "Please provide a valid email";
                } else {
                    var payload = {
                        subscription_email: this.subscription.email
                    };
                    service.subscribe(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            _this9.process_message = "Your subscription was successful";
                            _this9.subscription.email = '';
                            var self = _this9;
                            setTimeout(function () {
                                self.process_message = "";
                            }, 1000);
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this9.process_message = "Sorry, could not process information";
                        }
                    });
                }
            }
        }
    },
    created: function created() {

        if (this.$route.params.ref) {
            localStorage.setItem("cityneeds_ref", this.$route.params.ref);
            this.$router.push("/");
        }
        var u = localStorage.getItem("cityneeds_user");
        if (u != null) {
            this.user = u;
        }
        setTimeout(function () {
            $('#prompt').modal();
        }, 4000);

        this.getSurveys();
        this.getCnpros();
        this.getBusinesses();
        this.getForums();
        this.getReviews();
        this.getCnproParentCategories();

        localStorage.removeItem("cityneeds_call_src");
    }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'HowItWprks',
    data: function data() {
        return {};
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },

    created: function created() {}
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Login',
    data: function data() {
        return {
            user: {},
            disable_btn: false,
            forgot_processed: false,
            activation_error_message: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            var _this = this;

            localStorage.removeItem("cityneeds_user");
            localStorage.removeItem("cityneeds_token");
            localStorage.removeItem("cityneeds_token_key");

            localStorage.removeItem("cityneeds_prompt");


            if (this.$route.query.activation) {
                var credentials = { "user_auth": this.$route.query.activation };
                service.activateEmail(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        toastr.success("Email Activation Successfull", 'Kudos!');
                    }
                }).catch(function (err) {
                    _this.activation_error_message = true;
                    toastr.warning("Email Activation Failed", 'Warning!');
                });
            }
        },
        activateSignal: function activateSignal() {},
        login: function login() {
            var _this2 = this;

            this.disable_btn = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };
            var navi = this.$router;
            if (credentials.user_email == null || credentials.user_email == undefined || credentials.user_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.user_password == null || credentials.user_password == undefined || credentials.user_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            localStorage.setItem("cityneeds_user", element.user_fullname);
                            localStorage.setItem("cityneeds_token", element.user_session_key);
                            localStorage.setItem("cityneeds_token_key", element.user_token_key);
                        }, _this2);

                        localStorage.setItem("cityneeds_prompt", 0);

                        if (localStorage.getItem("cn_prv_page")) {
                            navi.push(localStorage.getItem("cn_prv_page"));
                        } else {
                            navi.push('dashboard');
                        }
                    } else {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this2.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this2.disable_btn = false;
                    } else {
                        toastr.warning("Please Re-try Once More", 'Warning!');

                        _this2.disable_btn = false;
                    }
                });
            }
        },
        forgotPassword: function forgotPassword() {
            var _this3 = this;

            var credentials = {
                email: this.user.email
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else {
                service.forgotPassword(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        _this3.forgot_processed = true;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("Email not valid", 'Warning!');
                    }
                });
            }
        },
        resetForgot: function resetForgot() {
            this.forgot_processed = false;
        },
        verifyEmail: function verifyEmail() {
            var _this4 = this;

            var credentials = {
                email: this.user.email,
                auth: this.user.auth
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Validation Failed", 'Warning!');
            } else if (credentials.auth == null || credentials.auth == undefined || credentials.auth == '') {
                toastr.warning("Validation Failed", 'Warning!');
            } else {
                service.verifyEmail(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        var data = response.body.data;

                        _this4.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                        _this4.$router.push('login');
                    }
                });
            }
        }
    },
    created: function created() {
        this.reset();
    }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {},
            this_year: service.thisYear
        };
    }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    data: function data() {
        return {
            user: '',
            user_slug: {}
        };
    },

    components: {
        'prompts': __WEBPACK_IMPORTED_MODULE_1__YPrompts_index_vue___default.a
    },
    methods: {
        getUser: function getUser() {
            var u = localStorage.getItem("cityneeds_user");
            if (u != null) {
                this.user = u;
                this.user_slug = u.replace(" ", "_");
            }
        }
    },
    created: function created() {
        this.getUser();
    }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MyMoney',
    data: function data() {
        return {
            user: {},
            money: {},
            monies: {},
            bank: {},
            to_pay_out: 0,
            amount_paid: '',
            editBankFlag: false,
            bank_set: false,
            payment_request: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel() {
            this.panelFlag = true;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getMonies: function getMonies() {
            var _this2 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getMonies(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this2.monies = data.body.data;
                    var result = data.body.data;
                    var total = 0;
                    result.forEach(function (element) {
                        this.to_pay_out += element.contract_money_pay_out;
                    }, _this2);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getMoney: function getMoney(id) {
            var _this3 = this;

            service.getMoney(this, id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.money = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getBanking: function getBanking() {
            var _this4 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getBanking(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this4.bank = data.body.data;
                    _this4.bank_set = true;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        setBanking: function setBanking() {
            var _this5 = this;

            if (this.bank.bank_name == null || this.bank.account_name == null || this.bank.account_number == null) {
                toastr.error('Kindly enter all fields', 'Warning!');
            } else {
                this.bank.bank_user = this.user.user_id;
                service.setBanking(this, this.bank).then(function (response) {
                    if (response.status == 201) {
                        _this5.bank_set = true;
                    }
                }).catch(function (err) {
                    if (err.status == 500) {
                        toastr.warning("Something went wrong", 'Warning!');
                    }
                });
            }
        },
        editBank: function editBank() {
            this.editBankFlag = true;
            this.bank_set = false;
        },
        updateBankSetting: function updateBankSetting() {
            var _this6 = this;

            if (this.bank.bank_name == null || this.bank.account_name == null || this.bank.account_number == null) {
                toastr.error('Kindly enter all fields', 'Warning!');
            } else {
                service.updateBankSetting(this, this.bank.bank_id, this.bank).then(function (response) {
                    if (response.status == 200) {
                        _this6.bank_set = true;
                    }
                }).catch(function (err) {
                    if (err.status == 500) {
                        toastr.warning("Something went wrong", 'Warning!');
                    }
                });
            }
        },
        setPayment: function setPayment(money) {
            this.money = money;
            this.payment_request = true;
        },
        processPayment: function processPayment() {
            var _this7 = this;

            service.updateMoniesPaid(this, this.money.contract_money_id, this.money).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Payment Request Sent", "Ok!");
                    _this7.$router.go('/mymoney');
                } else {
                    toastr.error('Sorry, could not update payment', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getMonies();
        this.getBanking();
    }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNwallet',
    data: function data() {
        return {
            user: {},
            referrals: {},
            referral_code: "",
            loading: true,
            disable_btn: false,
            site_url: "",
            referral_text: "",
            copy_succ: false,
            site_set_url: "https://share.cityneeds.ng/?ref="
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        copyLink: function copyLink() {
            document.getElementById("copiied").style.color = "#ffff00";
            this.copy_succ = true;
            this.$clipboard(this.referral_text);
        },
        fbShare: function fbShare(url, title, descr, image, winWidth, winHeight) {
            var winTop = screen.height / 2 - winHeight / 2;
            var winLeft = screen.width / 2 - winWidth / 2;
            window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
        },
        setPanel: function setPanel() {
            this.panelFlag = true;
        },
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            this.user.user_id = element.user_id;
                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.user = data.body.data;
                                    _this.referral_code = _this.user.user_referral_code;
                                    _this.site_url = _this.site_set_url + _this.referral_code;
                                    _this.getReferralTransactions();
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this2);
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getReferralTransactions: function getReferralTransactions() {
            var _this3 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getReferralTransactions(this, user_id).then(function (data) {
                _this3.referrals = data.body.data;

                _this3.site_url = _this3.site_set_url + _this3.referral_code;
                _this3.referral_text = 'Hi Dear,\nCityneeds is a convenient and easy-to-use platform where i find skillful and vetted artisans, get contact information of businesses, pay my utility bills, and buy airtime, all from the comfort of my phone, or tablet. Just so you know, I get cashback rewards for most payments I make.\n                 \nYou too can start using it now! Click to signup for free: ' + _this3.site_set_url + _this3.referral_code;
                _this3.loading = false;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Policy',
    data: function data() {
        return {};
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },

    created: function created() {}
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_payments_and_updates_js__ = __webpack_require__(12);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Pricing',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_payments_and_updates_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            plans: {},
            plan: {},
            amount_topay: '',
            amount_paid: '',
            premium_message: '',
            request_page: '',
            plan_type: false,
            disable_btn: false,
            selected_plan: false,
            current_wallet_balance: 0,
            loggedIn: false,

            payment_message: '',
            service_payment_ref: '',
            token_key: 0,
            data_plan_payment_data: {},
            show_done: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.loggedIn = true;
                                    _this.user = data.body.data;
                                    _this.plan_type = true;
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this2);
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        check_free_plan: function check_free_plan(plan) {
            if (plan.plan_id == 1) {
                return 'none';
            }
        },
        getPaymentPlans: function getPaymentPlans() {
            var _this3 = this;

            service.getPaymentPlans(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.plans = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getIncomingRequest: function getIncomingRequest() {
            if (this.$route.query.pay && this.$route.query.pay > 0) {
                this.pay_type = this.$route.query.pay;
            }
            if (this.$route.query.re && this.$route.query.re != '') {
                this.service_payment_ref = this.$route.query.re;
            }
            if (this.$route.query.no && this.$route.query.no != '') {
                this.token_key = this.$route.query.no;
            }

            this.setPayment();
        },
        setPayment: function setPayment() {
            var _this4 = this;

            if (this.pay_type == 1) {
                var payload = {
                    plan_ref: this.service_payment_ref,
                    plan_user_token: this.token_key
                };
                service.setPaymentPlansRequest(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        _this4.data_plan_payment_data = data;
                        _this4.amount_topay = data.plan_amount;
                        _this4.user.user_id = data.plan_user_id;
                        if (response.body.data_logged_in == 1) {
                            _this4.loggedIn = true;
                        }
                    } else {
                        _this4.payment_message = "Sorry, could not find payment details.";
                        _this4.show_done = true;
                    }
                }).catch(function (err) {});
            }
        },
        presetPaymentPlan: function presetPaymentPlan(plan) {
            this.selected_plan = plan;

            $('#paywith').modal();
        },
        setPaymentPlan: function setPaymentPlan(pay_with_option) {
            var payment_data = {
                pay_ref: this.data_plan_payment_data.plan_ref,
                pay_user: this.data_plan_payment_data.plan_user,
                pay_email: this.data_plan_payment_data.plan_user_email,
                pay_phone: this.data_plan_payment_data.plan_user_phone,
                pay_amount: this.data_plan_payment_data.plan_amount,
                pay_service: this.data_plan_payment_data.plan_plan,
                pay_service_module: 9,
                pay_service_module_id: this.data_plan_payment_data.plan_plan,
                pay_user_id: this.data_plan_payment_data.plan_user_id
            };
            if (pay_with_option == "gateway") {
                this.processPayment(payment_data);
            } else {
                this.processPaymentWithWallet(payment_data);
            }
        },
        processPayment: function processPayment(data) {
            var obj = this;
            this.amount_paid = data.pay_amount;
            var handler = PaystackPop.setup({
                key: 'pk_test_5e386f2b137cecdea7db6839c293614a8a115742',

                Name: data.pay_user,
                email: data.pay_email || "admin@cityneeds.ng",

                amount: Math.round(data.pay_amount * 100),
                ref: data.pay_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.pay_user
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.pay_service
                    }]
                },

                callback: function callback(response) {
                    var txn_payload = {
                        "transaction_payment_ref": data.pay_ref,
                        "transaction_module": 9,
                        "transaction_module_id": data.pay_service_module_id,
                        "transaction_type": 2,
                        "transaction_mode": 1,
                        "transaction_mode_transaction_ref": data.pay_ref,
                        "transaction_amount_paid": data.pay_amount,
                        "payer_name": data.pay_user || "",
                        "payer_email": data.pay_email || "",
                        "payer_phone": data.pay_phone || 0,
                        "payer_user": data.pay_user_id || 0
                    };
                    obj.postCNpaymentDetails(txn_payload);

                    obj.updatePlanPayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        processPaymentWithWallet: function processPaymentWithWallet(data) {
            var _this5 = this;

            this.amount_paid = data.pay_amount;
            var payload = {
                pay: this.user.user_id,
                txn_amount: data.pay_amount,
                service: 1,
                service_ref: data.pay_ref
            };
            service.postWalletPayout(this, payload).then(function (response) {
                if (response.body.status == 201) {
                    var txref = response.body.data_txn_ref;

                    var txn_payload = {
                        "transaction_payment_ref": data.pay_ref,
                        "transaction_module": 9,
                        "transaction_module_id": data.pay_service_module_id,
                        "transaction_type": 2,
                        "transaction_mode": 2,
                        "transaction_mode_transaction_ref": txref,
                        "transaction_amount_paid": data.pay_amount,
                        "payer_name": data.pay_user || "",
                        "payer_email": data.pay_email || "",
                        "payer_phone": data.pay_phone || 0,
                        "payer_user": data.pay_user_id || 0
                    };
                    _this5.postCNpaymentDetails(txn_payload);

                    _this5.updatePlanPayment(response.body.data);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        updatePlanPayment: function updatePlanPayment(payment_ref) {
            var _this6 = this;

            var credentials = {
                amount_paid: this.amount_paid,
                plan_user_id: this.user.user_id,
                record_transaction: 0
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePaymentPlan(this, payment_ref, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");
                        _this6.payment_message = "Payment was successful";
                        _this6.show_done = true;
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this7 = this;

            var user_id = this.token_key;
            service.getWalletTransactions(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this7.current_wallet_balance = data.body.data_current_wallet_balance;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        }
    },

    created: function created() {
        localStorage.clear();

        this.getIncomingRequest();
        this.getWalletTransactions();

        if (localStorage.getItem("cityneeds_user") != null) {}
    }

});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_payments_and_updates_js__ = __webpack_require__(12);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Pricing',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_payments_and_updates_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            plans: {},
            plan: {},
            amount_paid: '',
            premium_message: '',
            request_page: '',
            plan_type: false,
            disable_btn: false,
            selected_plan: false,
            current_wallet_balance: 0,
            loggedIn: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.loggedIn = true;
                                    _this.user = data.body.data;
                                    _this.plan_type = true;
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this2);
                    } else {
                        _this2.$router.push('/login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('/login');
                    }
                });
            } else {
                this.$router.push('/login');
            }
        },
        check_free_plan: function check_free_plan(plan) {
            if (plan.plan_id == 1) {
                return 'none';
            }
        },
        getPaymentPlans: function getPaymentPlans() {
            var _this3 = this;

            service.getPaymentPlans(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.plans = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getIncomingRequest: function getIncomingRequest() {
            if (localStorage.getItem("cityneeds_request_plans") == 'cnpro') {
                this.premium_message = true;
                this.request_page = 'cnpro';
                localStorage.removeItem("cityneeds_request_plans");
            }
            if (localStorage.getItem("cityneeds_request_plans") == 'profile') {
                this.request_page = 'profile';
            }
            localStorage.removeItem("cityneeds_request_plans");
        },
        presetPaymentPlan: function presetPaymentPlan(plan) {
            this.selected_plan = plan;

            $('#paywith').modal();
        },
        setPaymentPlan: function setPaymentPlan(pay_with_option) {
            var _this5 = this;

            var plan = this.selected_plan;
            this.disable_btn = true;

            localStorage.setItem("cn_prv_page", "pricing");
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this4 = this;

                            this.user.user_id = element.user_id;

                            if (this.user.user_id != null) {
                                var credentials = {
                                    plan_user_id: this.user.user_id,
                                    plan_plan: plan.plan_id,
                                    plan_amount: plan.plan_amount
                                };
                                if (credentials.plan_plan != null) {
                                    service.setPaymentPlan(this, credentials).then(function (data) {
                                        if (data.body.status == 201) {

                                            if (pay_with_option == "gateway") {
                                                _this4.processPayment(data.body.data);
                                            } else {
                                                _this4.processPaymentWithWallet(data.body.data);
                                            }
                                            localStorage.removeItem('cn_plan');
                                        } else {
                                            toastr.error('Sorry, could not set plan', 'Warning!');
                                            _this4.disable_btn = false;
                                        }
                                    }).catch(function (err) {
                                        if (err) {
                                            console.log(err);

                                            _this4.disable_btn = false;
                                        }
                                    });
                                } else {}
                                localStorage.removeItem('cn_plan');
                            }
                        }, _this5);
                    } else {
                        _this5.$router.push('/login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this5.$router.push('/login');
                    }
                });
            } else {
                this.$router.push('/login');
            }
        },
        processPayment: function processPayment(data) {
            var obj = this;
            this.amount_paid = data.plan_amount;
            var handler = PaystackPop.setup({
                key: 'pk_live_1e88da135e1bd1205b610cac36fc6d9a27a2fbd8',
                Name: data.plan_user,
                email: data.plan_user_email || "admin@cityneeds.ng",

                amount: Math.round(data.plan_amount * 100),
                ref: data.plan_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.plan_user
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.plan_user_name
                    }]
                },

                callback: function callback(response) {
                    var txn_payload = {
                        "transaction_payment_ref": ref,
                        "transaction_module": 9,
                        "transaction_module_id": obj.selected_plan.plan_id,
                        "transaction_type": 2,
                        "transaction_mode": 1,
                        "transaction_mode_transaction_ref": ref,
                        "transaction_amount_paid": data.plan_amount,
                        "payer_name": obj.user.user_fullname || "",
                        "payer_email": obj.user.user_email || "",
                        "payer_phone": obj.user.user_phone || 0,
                        "payer_user": obj.user.user_id || 0
                    };
                    obj.postCNpaymentDetails(txn_payload);

                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        processPaymentWithWallet: function processPaymentWithWallet(data) {
            var _this6 = this;

            this.amount_paid = data.plan_amount;
            var payload = {
                pay: this.user.user_id,
                txn_amount: data.plan_amount,
                service: 1,
                service_ref: data.plan_ref
            };
            service.postWalletPayout(this, payload).then(function (response) {
                if (response.body.status == 201) {
                    var txref = response.body.data_txn_ref;

                    var txn_payload = {
                        "transaction_payment_ref": data.plan_ref,
                        "transaction_module": 9,
                        "transaction_module_id": _this6.selected_plan.plan_id,
                        "transaction_type": 2,
                        "transaction_mode": 2,
                        "transaction_mode_transaction_ref": txref,
                        "transaction_amount_paid": data.plan_amount,
                        "payer_name": _this6.user.user_fullname || "",
                        "payer_email": _this6.user.user_email || "",
                        "payer_phone": _this6.user.user_phone || 0,
                        "payer_user": _this6.user.user_id || 0
                    };
                    _this6.postCNpaymentDetails(txn_payload);


                    _this6.updatePayment(response.body.data);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this7 = this;

            var credentials = {
                amount_paid: this.amount_paid,
                plan_user_id: this.user.user_id,
                record_transaction: 0
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePaymentPlan(this, payment_ref, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");

                        if (_this7.request_page != '') {
                            _this7.$router.push(_this7.request_page);
                        } else {
                            _this7.$router.go('/');
                        }
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this8 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletTransactions(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this8.current_wallet_balance = data.body.data_current_wallet_balance;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        }
    },

    created: function created() {
        this.getPaymentPlans();
        this.getIncomingRequest();
        this.getWalletTransactions();
        if (localStorage.getItem("cityneeds_user") != null) {
            this.preset();
        }
    }

});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Profile',
    data: function data() {
        return {
            user: {},
            activeLink: "edit-profile",
            img_url: service.imageURL,
            states: {},
            cities: {},
            setPanel: '',
            errorFlag: ''
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        isActive: function isActive(link) {
            if (link == this.activeLink) {
                return true;
            }
        },
        setComponent: function setComponent(attr, component) {
            this.activeLink = attr;
            if (attr == 'set-password') {
                this.setPanel = "set-password";
            }
        },
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.user = data.body.data;
                                    _this.user.user_phone = "0" + _this.user.user_phone;
                                    _this.getCities(_this.user.user_state);
                                }
                            }).catch(function (err) {
                                if (err) {
                                    toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            });
                        }, _this2);
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        logout: function logout() {
            this.$router.push('/login');
        },
        resetPassword: function resetPassword() {
            var _this3 = this;

            var credentials = {
                user_current_password: this.user.user_current_password,
                user_new_password: this.user.user_new_password,
                user: this.user.user_id
            };
            var navi = this.$router;
            if (credentials.user_current_password == '' || credentials.user_new_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else if (credentials.user_current_password == null || credentials.user_new_password == null) {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.resetPassword(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        navi.push('/login');
                    } else {
                        _this3.errorFlag = response.body.message;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                    }
                });
            }
        },
        resetEmail: function resetEmail() {
            var _this4 = this;

            var credentials = {
                email: this.user.email,
                password: this.user.password
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.password == null || credentials.password == undefined || credentials.password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.resetEmail(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            localStorage.setItem("cityneeds_user", element.fullname);
                        }, _this4);
                        _this4.$router.push('dashboard');
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                    }
                });
            }
        },
        editProfile: function editProfile() {
            if (this.user.user_fullname != '' && this.user.user_phone != '' && this.user.user_city != 0) {
                service.editProfile(this, this.user, this.user.user_id).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Profile Updated!", "Success!");
                        location.reload(true);
                    } else {
                        toastr.error('Sorry, could not update Profile', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        onFileChange: function onFileChange(e, user) {
            var _this5 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', user);
                formData.append('data_type', "users");
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        _this5.user.user_image = data.body.data;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            var _this6 = this;

            service.getCities(this, state).then(function (data) {
                _this6.cities = data.body.data;
            });
        },
        moveToPlans: function moveToPlans() {
            localStorage.setItem("cityneeds_request_plans", "profile");
            this.$router.go('pricing');
        }
    },
    created: function created() {
        this.preset();
        this.getStates();
    }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_1__services_validator__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        return {
            user: [],
            states: {},
            cities: {},
            disable_btn: false,
            error_here: {},
            error_count: 0,
            password_error_match: "",
            ref_code: "",
            terms_agree: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_2__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("cityneeds_user");
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        reg: function reg() {
            var _this = this;

            this.disable_btn = true;
            this.error_count = 0;
            this.error_here.email = "";
            this.error_here.phone = "";
            var credentials = {
                user_fullname: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address,
                user_state: this.user.state,
                user_city: 1,
                user_password: this.user.password,
                referral_code: this.user.ref_code || localStorage.getItem("cityneeds_ref")
            };

            var navi = this.$router;

            if (this.user.password != this.user.cpassword) {
                this.password_error_match = "Passwords do not match";
                this.disable_btn = false;
            } else {
                if (credentials.user_fullname != undefined && credentials.user_address != undefined && credentials.user_password != null) {
                    if (credentials.user_phone || credentials.user_email) {
                        if (this.terms_agree) {
                            if (credentials.user_email) {
                                if (!valid.validateEmail(credentials.user_email)) {
                                    this.error_here.email = "Invalid Email";

                                    this.error_count += 1;
                                    this.disable_btn = false;
                                    toastr.error('Email is not valid', 'Warning!');
                                }
                            }

                            if (credentials.user_phone) {
                                if (!valid.validatePhoneNumber(credentials.user_phone)) {
                                    this.error_count += 1;
                                    this.disable_btn = false;
                                    this.error_here.phone = "Invalid Phone";
                                    toastr.error('Phone Number is not valid', 'Warning!');
                                }
                            }

                            if (!valid.validateName(credentials.user_fullname)) {
                                this.error_here.name = "Name is not valid";
                                this.error_count += 1;
                                this.disable_btn = false;
                            }

                            if (this.error_count == 0) {
                                service.regUser(this, credentials).then(function (data) {
                                    if (data.body.status == 201) {
                                        toastr.success("Registration Successfull", 'Success!');

                                        var logdata = data.body.data;
                                        logdata.forEach(function (element) {
                                            localStorage.setItem("cityneeds_user", element.user_fullname);
                                            localStorage.setItem("cityneeds_token", element.user_session_key);
                                            localStorage.setItem("cityneeds_token_key", element.user_token_key);
                                        }, this);

                                        var reg_track = localStorage.getItem("current_page");
                                        if (this.reg_track == '') {
                                            navi.push('/');
                                        } else {
                                            navi.push(reg_track);
                                        }
                                    } else if (data.body.status == 409) {
                                        toastr.warning(data.body.message, 'Warning!');
                                        this.disable_btn = false;
                                    }
                                }).catch(function (err) {
                                    console.log(err);
                                    toastr.warning("Please Re-try Once More", 'Warning!');
                                    _this.disable_btn = false;
                                });
                            }
                        } else {
                            toastr.error('Please agree to Terms', 'Warning!');
                            this.disable_btn = false;
                        }
                    } else {
                        toastr.error('Requires Phone Number Or Email', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields marked *', 'Warning!');
                    this.disable_btn = false;
                }
            }
        }
    },
    created: function created() {
        this.reset();
        if (localStorage.getItem("cityneeds_ref") != 'undefined' && localStorage.getItem("cityneeds_ref") != undefined) {
            this.ref_code = localStorage.getItem("cityneeds_ref");
        }
    }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ResetPassword',
    data: function data() {
        return {
            user: {},
            disable_btn: false,
            forgot_processed: false,
            can_reset: false,
            can_login: false,
            is_not_valid: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            var _this = this;

            localStorage.removeItem("cityneeds_user");
            localStorage.removeItem("cityneeds_token");
            localStorage.removeItem("cityneeds_token_key");

            var navi = this.$router;
            if (this.$route.query.resetPassword) {
                service.verifyResetToken(this, this.$route.query.resetPassword).then(function (response) {
                    if (response.status == 200) {
                        _this.can_reset = true;
                        _this.user.user_id = response.body.data;
                    }
                }).catch(function (err) {
                    toastr.warning("Authentication Failed", 'Warning!');
                    if (err.status == 400) {
                        _this.is_not_valid = true;
                    } else {
                        navi.push('login');
                    }
                });
            } else {
                navi.push('login');
            }
        },
        resetPassword: function resetPassword() {
            var _this2 = this;

            var credentials = {
                new_password: this.user.new_password,
                confirm_password: this.user.confirm_password,
                user: this.user.user_id
            };
            var navi = this.$router;
            if (credentials.new_password == '' || credentials.confirm_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else if (credentials.new_password != credentials.confirm_password) {
                toastr.warning("Passwords does not match", 'Warning!');
            } else {
                service.resetForgotPassword(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.can_reset = false;
                        _this2.can_login = true;
                        toastr.success("Password has been Reset", 'Changed!');
                        navi.push('login');
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                    }
                });
            }
        }
    },
    created: function created() {
        this.reset();
    }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SavedListings',
    data: function data() {
        return {
            user: {},
            listings: {},
            listing: {},
            img_url: service.imageURL
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Dashboard_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Dashboard_Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Dashboard_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel() {
            this.panelFlag = true;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSavedListings: function getSavedListings() {
            var _this2 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getSavedListings(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this2.listings = data.body.data;
                    var result = data.body.data;
                    var count = 0;
                    result.forEach(function (element) {
                        ++count;
                        if (count == 1) {
                            this.listing = element;
                        }
                    }, _this2);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getSavedListing: function getSavedListing(id) {
            var _this3 = this;

            service.getSavedListing(this, id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.listing = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        viewCnpro: function viewCnpro(cnpro) {
            if (cnpro) {
                localStorage.setItem("cityneeds_search_cnpro", cnpro);
                this.$router.push("cnpro");
            }
        },
        viewBusiness: function viewBusiness(business) {
            if (business) {
                localStorage.setItem("cityneeds_search_business", business);
                this.$router.push("businesses");
            }
        }
    },
    created: function created() {
        this.preset();
        this.getSavedListings();
    }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__ = __webpack_require__(5);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({

  name: "SecondHeader",
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__["a" /* default */]],
  data: function data() {
    return {
      user_slug: {}
    };
  },

  methods: {},
  created: function created() {}
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Terms',
    data: function data() {
        return {};
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },

    created: function created() {}
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar_script_js__ = __webpack_require__(39);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Sidebar_script_js__["default"]],
    data: function data() {
        return {
            user: '',
            user_slug: {}
        };
    },

    methods: {
        getPrompts: function getPrompts() {
            var prompt = "cn_fo_prompt";
            var prompter = "#prompt-forum";
            var promt_value = 0;
            var prompt_timer = 0;

            if (localStorage.getItem(prompt)) {
                var timer = localStorage.getItem(prompt);
                if (timer == 0 || timer == 1) {
                    promt_value = 2;
                    prompt_timer = 0;
                } else if (timer == 2) {
                    promt_value = 3;
                    prompt_timer = 8000;
                } else if (timer == 3) {
                    promt_value = 4;
                    prompt_timer = 32000;
                } else if (timer == 4) {
                    promt_value = 1;
                    prompt_timer = 82000;
                }
            } else {
                promt_value = 2;
                prompt_timer = 0;
            }

            if (this.checkCanSetPrompt(prompt)) {
                console.log('888');
                this.setPrompts(prompt, promt_value, prompter, prompt_timer);
            }
        },
        checkCanSetPrompt: function checkCanSetPrompt(prompt) {
            var can_set = false;
            if (prompt == 'forum') {}

            return true;
        },
        setPrompts: function setPrompts(prompt, value, prompter, timer) {
            if (value > 0) {
                localStorage.setItem(prompt, value);
            }

            if (timer > 0) {
                setTimeout(function () {
                    $(prompter).modal();
                }, timer);
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_progressbar__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_meta__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_clipboard__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(57);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_v_clipboard___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_progressbar___default.a, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '5px'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '\n    <div id="app">\n      <vue-progress-bar></vue-progress-bar>\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_validator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CNpaymentModal_index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CNpaymentModal_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CNpaymentModal_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CNpaymentModal_script_js__ = __webpack_require__(20);








var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_3__services_validator__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsuranceForm',
    props: {
        cninsurance_listing: Object,
        cninsurance: Object
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_preset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__CNpaymentModal_script_js__["default"]], data: function data() {
        return {
            user: {},

            set_payment_data: {},
            set_payment_object: {},
            payment_details_data: {},
            component_view: {},
            form_vechicle_classes: {},
            form_policyholder_types: {},

            car_manufacturers: {},
            car_models: {},
            data_processing_message: "",
            terms_cn_agree: false
        };
    },

    components: {
        "cnpayment-modal": __WEBPACK_IMPORTED_MODULE_5__CNpaymentModal_index_vue___default.a
    },
    computed: {},
    methods: {
        setComponentView: function setComponentView(view, attr1, attr2) {
            this.component_view = {};
            this.component_view[view] = true;
            this.jumpToView('topp02');
        },
        getCornerStoneCarCompanies: function getCornerStoneCarCompanies() {
            var _this = this;

            service.getCornerStoneCarCompanies(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.car_manufacturers = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getVechicleManufacturerModels: function getVechicleManufacturerModels(make) {
            var _this2 = this;

            console.log(98122);
            service.getVechicleManufacturerModels(this, make).then(function (data) {
                if (data.body.status == 200) {
                    _this2.car_models = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        setFormParams: function setFormParams() {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.cninsurance_listing).length !== 0) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.cninsurance_listing.cninsurance_form_variables), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var vc = _step.value;

                        if (vc.cninsurance_form_variable_type_id == 9) {
                            this.form_vechicle_classes = vc.cninsurance_form_variable_type_values;
                        }

                        if (vc.cninsurance_form_variable_type_id == 17) {
                            this.form_policyholder_types = vc.cninsurance_form_variable_type_values;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        submitCNInsuranceForm: function submitCNInsuranceForm() {
            var _this3 = this;

            this.data_processing_message = "";
            var error_count = 0;
            if (this.cninsurance.cninsurance_form_first_name == '' || this.cninsurance.cninsurance_form_last_name == '' || this.cninsurance.cninsurance_form_gender == '' || this.cninsurance.cninsurance_form_dob == '' || this.cninsurance.cninsurance_form_email == '' || this.cninsurance.cninsurance_form_phone == '' || this.cninsurance.cninsurance_form_address == '' || this.cninsurance.cninsurance_form_vehicle_reg_no == '' || this.cninsurance.cninsurance_form_vehicle_class == '' || this.cninsurance.cninsurance_form_vehicle_make == '' || this.cninsurance.cninsurance_form_vehicle_model == '' || this.cninsurance.cninsurance_form_vehicle_number_plate == '' || this.cninsurance.cninsurance_form_vehicle_chassis_number == '' || this.cninsurance.cninsurance_form_vehicle_engine_number == '' || this.cninsurance.cninsurance_form_year_of_manufacture == '' || this.cninsurance.cninsurance_form_year_of_purchase == '' || this.cninsurance.cninsurance_form_policyholder_type == '') {
                error_count++;
                this.data_processing_message = "Please enter all details with *";
            } else {
                if (!valid.validateEmail(this.cninsurance.cninsurance_form_email)) {
                    error_count++;
                    this.data_processing_message = "Invalid Email";
                }

                if (!valid.validatePhoneNumber(this.cninsurance.cninsurance_form_phone)) {
                    error_count++;
                    this.data_processing_message += ", Invalid Phone";
                }

                if (this.cninsurance.cninsurance_form_vehicle_class == '' || this.cninsurance.cninsurance_form_vehicle_class == undefined) {
                    error_count++;
                    this.data_processing_message += ", Please select a Vechicle Class";
                }

                if (this.cninsurance.cninsurance_form_policyholder_type == '' || this.cninsurance.cninsurance_form_policyholder_type == undefined) {
                    error_count++;
                    this.data_processing_message += ", Please select a Policy Holder Type";
                }

                if (this.cninsurance.cninsurance_form_year_of_manufacture < 1900 || this.cninsurance.cninsurance_form_year_of_manufacture > 2099) {
                    error_count++;
                    if (this.data_processing_message != "") {
                        this.data_processing_message += ", Year of Manufacture is out of range";
                    } else {
                        this.data_processing_message = "Year of Manufacture is out of range";
                    }
                }

                if (this.cninsurance.cninsurance_form_year_of_purchase < 1900 || this.cninsurance.cninsurance_form_year_of_purchase > 2099) {
                    error_count++;
                    if (this.data_processing_message != "") {
                        this.data_processing_message += ", Year of Purchase is out of range";
                    } else {
                        this.data_processing_message = "Year of Purchase is out of range";
                    }
                }
            }

            if (error_count == 0) {
                var cnform_array = [];

                if (this.cninsurance.cninsurance_form_first_name) {
                    var fomr_arr = {
                        form_label: 1,
                        form_label_value: this.cninsurance.cninsurance_form_first_name
                    };
                    cnform_array.push(fomr_arr);
                }

                if (this.cninsurance.cninsurance_form_last_name) {
                    var _fomr_arr = {
                        form_label: 2,
                        form_label_value: this.cninsurance.cninsurance_form_last_name
                    };
                    cnform_array.push(_fomr_arr);
                }

                if (this.cninsurance.cninsurance_form_dob) {
                    var _fomr_arr2 = {
                        form_label: 3,
                        form_label_value: this.cninsurance.cninsurance_form_dob
                    };
                    cnform_array.push(_fomr_arr2);
                }

                if (this.cninsurance.cninsurance_form_gender) {
                    var _fomr_arr3 = {
                        form_label: 4,
                        form_label_value: this.cninsurance.cninsurance_form_gender
                    };
                    cnform_array.push(_fomr_arr3);
                }

                if (this.cninsurance.cninsurance_form_email) {
                    var _fomr_arr4 = {
                        form_label: 5,
                        form_label_value: this.cninsurance.cninsurance_form_email
                    };
                    cnform_array.push(_fomr_arr4);
                }

                if (this.cninsurance.cninsurance_form_phone) {
                    var _fomr_arr5 = {
                        form_label: 6,
                        form_label_value: this.cninsurance.cninsurance_form_phone
                    };
                    cnform_array.push(_fomr_arr5);
                }

                if (this.cninsurance.cninsurance_form_address) {
                    var _fomr_arr6 = {
                        form_label: 7,
                        form_label_value: this.cninsurance.cninsurance_form_address
                    };
                    cnform_array.push(_fomr_arr6);
                }

                if (this.cninsurance.cninsurance_form_vehicle_reg_no) {
                    var _fomr_arr7 = {
                        form_label: 8,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_reg_no
                    };
                    cnform_array.push(_fomr_arr7);
                }

                if (this.cninsurance.cninsurance_form_vehicle_class) {
                    var _fomr_arr8 = {
                        form_label: 9,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_class.cninsurance_form_variable_name,
                        form_label_has_variable_id: this.cninsurance.cninsurance_form_vehicle_class.cninsurance_form_variable_id
                    };
                    cnform_array.push(_fomr_arr8);
                }

                if (this.cninsurance.cninsurance_form_vehicle_make) {
                    var _fomr_arr9 = {
                        form_label: 10,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_make
                    };
                    cnform_array.push(_fomr_arr9);
                }

                if (this.cninsurance.cninsurance_form_vehicle_model) {
                    var _fomr_arr10 = {
                        form_label: 11,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_model
                    };
                    cnform_array.push(_fomr_arr10);
                }

                if (this.cninsurance.cninsurance_form_vehicle_number_plate) {
                    var _fomr_arr11 = {
                        form_label: 12,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_number_plate
                    };
                    cnform_array.push(_fomr_arr11);
                }

                if (this.cninsurance.cninsurance_form_vehicle_chassis_number) {
                    var _fomr_arr12 = {
                        form_label: 13,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_chassis_number
                    };
                    cnform_array.push(_fomr_arr12);
                }

                if (this.cninsurance.cninsurance_form_vehicle_engine_number) {
                    var _fomr_arr13 = {
                        form_label: 14,
                        form_label_value: this.cninsurance.cninsurance_form_vehicle_engine_number
                    };
                    cnform_array.push(_fomr_arr13);
                }

                if (this.cninsurance.cninsurance_form_year_of_manufacture) {
                    var _fomr_arr14 = {
                        form_label: 15,
                        form_label_value: this.cninsurance.cninsurance_form_year_of_manufacture
                    };
                    cnform_array.push(_fomr_arr14);
                }

                if (this.cninsurance.cninsurance_form_year_of_purchase) {
                    var _fomr_arr15 = {
                        form_label: 16,
                        form_label_value: this.cninsurance.cninsurance_form_year_of_purchase
                    };
                    cnform_array.push(_fomr_arr15);
                }

                if (this.cninsurance.cninsurance_form_policyholder_type) {
                    var _fomr_arr16 = {
                        form_label: 17,

                        form_label_value: this.cninsurance.cninsurance_form_policyholder_type.cninsurance_form_variable_name,
                        form_label_has_variable_id: this.cninsurance.cninsurance_form_policyholder_type.cninsurance_form_variable_id
                    };
                    cnform_array.push(_fomr_arr16);
                }

                if (this.cninsurance.cninsurance_form_company_name) {
                    var _fomr_arr17 = {
                        form_label: 18,
                        form_label_value: this.cninsurance.cninsurance_form_company_name
                    };
                    cnform_array.push(_fomr_arr17);
                }

                var payload = {
                    cninsurance_company: 1,
                    cninsurance_user: this.user.user_id || 0,
                    cninsurance_form: cnform_array,
                    cninsurance_discount: this.cninsurance.cninsurance_discount_code || ''
                };
                if (payload.cninsurance_company > 0 && payload.cninsurance_form.length > 0) {
                    if (this.cninsurance.cninsurance_form_ref && this.cninsurance.cninsurance_form_ref != '') {
                        payload.cninsurance_form_ref = this.cninsurance.cninsurance_form_ref;
                        service.postCNinsuranceForm(this, payload).then(function (data) {
                            if (data.body.status == 200) {
                                if (data.body.data_pay_status == 1) {
                                    _this3.setPaymentMode(data.body.data_payment_data);
                                } else if (data.body.data_pay_status == 0) {
                                    _this3.data_processing_message = "Insurance Form has been submitted successfully";

                                    localStorage.setItem("payment_modal_message", "Insurance Form has been submitted successfully");
                                    toastr.success('Insurance Form has been submitted successfully', 'Success!');
                                    _this3.paymentModalComponentKey++;
                                    var self = _this3;
                                    setTimeout(function () {
                                        $('#formupdate').modal();
                                        self.paymentModalComponentKey++;
                                    }, 500);
                                }
                            } else {
                                toastr.error('Sorry, could not process, please check your entries - ' + data.body.message, 'Warning!');
                                _this3.data_processing_message = data.body.message;
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.error('Sorry, could not process information, please check entries', 'Warning!');
                            }
                        });
                    } else {
                        service.submitNewCNinsurance(this, payload).then(function (data) {
                            if (data.body.status == 201) {
                                _this3.cninsurance.cninsurance_form_ref = data.body.data_cninsurance_form_order_ref;

                                if (data.body.data_user_details) {
                                    _this3.logdata = data.body.data_user_details;
                                    _this3.set_auto_login();
                                }

                                _this3.setPaymentMode(data.body.data_payment_data);
                            } else {
                                toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                                _this3.data_processing_message = data.body.message;
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.error('Sorry, could not process information, please check entries', 'Warning!');
                            }
                        });
                    }
                } else {
                    toastr.error('please check your entries', 'Warning!');
                }
            }
        },
        setPaymentMode: function setPaymentMode(payment_data) {
            this.payment_details_data = payment_data;
            this.setComponentView('paymentDetails', '', '');
        },
        setPaymentModeModal: function setPaymentModeModal(payment_data) {
            this.set_payment_data = payment_data;
            this.set_payment_data.callback_url = "account-cninsurance";

            if (this.set_payment_data.total_amount && this.set_payment_data.total_amount > 0) {
                this.paymentModalComponentKey++;

                setTimeout(function () {
                    $('#paywith').modal();
                }, 10);
            } else {
                this.data_processing_message = "Sorry could not fully submit form, please check your entry, or contact us";
            }

            this.setComponentView('previewForm', '', '');
        },
        setPaymentDetails: function setPaymentDetails() {
            this.set_payment_object = {
                payment_detail_type: 'cninsurance',
                payment_detail_name: this.cninsurance_listing.cninsurance_name,
                payment_detail_logo: this.cninsurance_listing.cninsurance_logo,
                payment_detail_set_callbackurl: 'account-cninsurance' };
        },
        wn_catch: function wn_catch() {
            var issues = localStorage.getItem("reslove_issues");
            this.data_processing_message = issues;
            var r_route = this.$route.params.listing;

            localStorage.removeItem("reslove_issues");
            localStorage.removeItem("reslove_issues_for");

            var cur_rl = this.$router.currentRoute;
            var new_rl = cur_rl.path.replace('/resolve', '');
            this.$router.push(new_rl);
        }
    },
    mounted: function mounted() {
        this.setFormParams();
        this.setPaymentDetails();
        this.getCornerStoneCarCompanies();
    },

    created: function created() {
        this.setComponentView("fillForm", "", "");

        var resolve_url = "cninsurance";
        if (this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url && this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url != '' && this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url != undefined) {

            resolve_url = this.cninsurance_listing.cninsurance_form_resolve_issues_redirect_url;
        }
        localStorage.setItem("reslove_issues_for", resolve_url);
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_dataserver_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_CNpaymentModal_index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_CNpaymentModal_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__templates_CNpaymentModal_index_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNdiscounts',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_preset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_dataserver_js__["a" /* default */]],
    props: {
        cndiscount: Object,
        cndiscount_set_view: ""
    },
    data: function data() {
        return {
            can_set_discount: false,
            set_new_business: false,

            cndiscounts: {},

            preview_form: false,
            view_info: false,

            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            disable_btn: false,
            process_loading: false,

            map: '',
            marker: false,
            mapComponentKey: 0
        };
    },

    components: {
        'cnpayment-modal': __WEBPACK_IMPORTED_MODULE_3__templates_CNpaymentModal_index_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                if (this.user.user_id != null) {
                    this.rate = newVal;
                    this.rateBusiness();
                } else {
                    localStorage.setItem("cn_prv_page", "businesses");
                    this.preset();
                }
            }
        }
    },
    methods: {
        toggleComponent: function toggleComponent(id) {
            var stl = document.getElementById(id).style.display;
            if (stl == "block") {
                document.getElementById(id).style = "display:none";
            } else {
                document.getElementById(id).style = "display:block";
            }
        },
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        setReload: function setReload() {
            location.reload();
        },
        setPreps: function setPreps() {
            this.set_payment_details_data = this.payment_details_data;

            this.set_payment_object_title = "Make DiscountBazaar Payment";
            if (this.cndiscount_set_view == 'payment_view') {
                this.set_payment_view = true;
            }
        },
        setReg: function setReg() {
            localStorage.setItem("current_page", 'cndiscountsetup');
            location.replace('register');
        },
        setAddNewBusiness: function setAddNewBusiness() {
            this.business = {};
            this.set_new_business = true;
        },
        initMap: function initMap() {
            var cn = { lat: 8.985714, lng: 7.4465517 };

            this.map = new google.maps.Map(document.getElementById("map00"), {
                zoom: 18,
                center: cn
            });

            this.marker = new google.maps.Marker({
                position: cn,
                map: this.map
            });

            var self = this;

            google.maps.event.addListener(self.map, 'click', function (event) {
                console.log(903);

                var clickedLocation = event.latLng;console.log(self.map);

                if (self.marker === false) {
                    console.log(9038);

                    self.marker = new google.maps.Marker({
                        position: clickedLocation,
                        map: self.map,
                        draggable: true });

                    google.maps.event.addListener(self.marker, 'dragend', function (event) {
                        self.markerLocation();
                    });
                } else {
                    console.log(9203);

                    self.marker.setPosition(clickedLocation);
                }

                self.markerLocation();
            });
        },
        markerLocation: function markerLocation() {
            var currentLocation = this.marker.getPosition();
            console.log('lat: ' + currentLocation.lat());
            console.log('lng: ' + currentLocation.lng());

            this.business.map_lat = currentLocation.lat();
            this.business.map_lng = currentLocation.lng();

            this.mapComponentKey++;
        }
    },
    mounted: function mounted() {
        var self = this;
        setTimeout(function () {
            self.initMap('map00');
        }, 3000);

        this.setPreps();
    },
    created: function created() {
        this.initMap();
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "businesses");
        }
    }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_preset_js__ = __webpack_require__(5);



var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsuranceFileComplaint',
    props: {
        cninsurance_listing: Object,
        cninsurance: Object
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_preset_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},

            cninsurance_data: {},
            files_info: [],
            imageForm: "",
            imagesFormArray: [],
            max_files_upload: 10,
            remove_files: false,
            data_processing_message: "",
            process_request_sent: false
        };
    },

    components: {},
    computed: {},
    methods: {
        reset: function reset() {
            this.process_request_sent = false;
            this.data_processing_message = '';
            this.cninsurance_data = {};
        },
        prep_sets: function prep_sets() {
            this.cninsurance_data.cninsurance_form = this.cninsurance.cninsurance_form;
        },
        submitCNInsuranceForm: function submitCNInsuranceForm() {
            var _this = this;

            var payload = {
                form_data_id: this.cninsurance_data.cninsurance_form,
                form_data_title: this.cninsurance_data.cninsurance_complaint_title || "",
                form_data_details: this.cninsurance_data.cninsurance_complaint,
                form_data_type: "cninsurance_file_claim"
            };
            if (payload.form_data_id != '' && payload.form_data_title != '' && payload.form_data_details != '') {
                service.postCNinsuranceFileClaimComplaintForm(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        if (data.body.data_id > 0) {
                            if (_this.files_info.length > 0) {
                                _this.onFileChange(data.body.data_id);
                            } else {
                                _this.mailCNinsuranceForm(data.body.data_id);
                            }
                            toastr.success("Processing!", "Success!");
                        } else {
                            _this.data_processing_message = data.body.message;
                            toastr.error("Form not valid", "Warning!");
                        }
                    } else if (data.body.status == 404) {
                        _this.data_processing_message = data.body.message;
                        toastr.error("Form not valid", "Warning!");
                    } else {
                        toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information, please check your entries', 'Warning!');
                    }
                });
            } else {
                toastr.error('please check your entries', 'Warning!');
            }
        },
        mailCNinsuranceForm: function mailCNinsuranceForm(complaint_form_id) {
            var _this2 = this;

            var payload = {
                form_data_id: complaint_form_id,
                form_request_type: 2 };
            if (payload.cninsurance_form != '' && payload.cninsurance_complaint != '') {
                service.mailCNinsuranceFileClaimComplaintForm(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this2.data_processing_message = "Complaint has been sent";
                        _this2.process_request_sent = true;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setOnFileChange: function setOnFileChange(e, data) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var file = _step.value;

                        if (this.files_info.length < this.max_files_upload) {
                            this.files_info.push(file);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        onFileChange: function onFileChange(data) {
            var _this3 = this;

            var ups_count = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.files_info), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var file = _step2.value;

                    var formData = new FormData();
                    formData.append('photo', file);
                    formData.append('data_id', data);
                    formData.append('data_type', "cninsurance_file_claim");
                    service.uploadDataPhoto(this, formData).then(function (response) {
                        ups_count++;
                        if (ups_count == _this3.files_info.length) {
                            _this3.mailCNinsuranceForm(data);
                        }
                    }).catch(function (err) {});
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        unsetRemoveFiles: function unsetRemoveFiles() {
            this.remove_files = false;

            document.getElementById("fileList").style = "display:block";
            document.getElementById("stackFiles").style = "display:none";

            this.handleFiles();
        },
        setRemoveFiles: function setRemoveFiles() {
            this.remove_files = true;
            for (var i = 0; i < this.files_info.length; i++) {
                var li = document.createElement("li");


                var img = document.createElement("img");
                img.src = URL.createObjectURL(this.files_info[i]);
                img.height = 40;img.width = 60;
                img.onload = function () {
                    URL.revokeObjectURL(this.src);
                };
                li.appendChild(img);
                var file_ko = document.getElementById("filsdaw" + i);
                file_ko.innerHTML = "";
                file_ko.appendChild(img);

                document.getElementById("fileList").style = "display:none";
                document.getElementById("stackFiles").style = "display:block";
            }
        },
        handleFiles: function handleFiles() {
            if (!this.files_info.length) {
                fileList.innerHTML = "<p>No files selected!</p>";
            } else {
                fileList.innerHTML = "";
                var list = document.createElement("ul");
                fileList.appendChild(list);
                list.style.margin = "0";list.style.padding = "0";

                for (var i = 0; i < this.files_info.length; i++) {
                    var li = document.createElement("li");
                    list.appendChild(li);
                    li.style.listStyle = "none";
                    li.style.display = "inline";
                    li.style.padding = "5px";
                    li.style.marginLeft = "0";

                    var img = document.createElement("img");
                    img.src = URL.createObjectURL(this.files_info[i]);
                    img.height = 60;
                    img.onload = function () {
                        URL.revokeObjectURL(this.src);
                    };
                    li.appendChild(img);
                    var info = document.createElement("span");
                    info.innerHTML = this.files_info[i].name + ": " + this.files_info[i].size + " bytes";

                    var col = document.createElement("span");
                    col.innerHTML = '<div>Text</div>';
                }

                document.getElementById("fileList").style = "display:block";
                document.getElementById("stackFiles").style = "display:none";
                this.remove_files = false;
            }
        },
        removeFileUploadXX: function removeFileUploadXX(file_index) {
            this.files_info.splice(file_index, 1);
            this.setRemoveFiles();
        },
        removeFileUpload: function removeFileUpload(file) {
            var files_info = this.files_info;
            this.files_info = [];
            var index = files_info.indexOf(file);
            while (index > -1) {
                files_info.splice(index, 1);
                index = files_info.indexOf(file);
            }
            this.files_info = files_info;
            this.setRemoveFiles();
        }
    },
    mounted: function mounted() {

        var fileSelect = document.getElementById("fileSelect");
        var fileElem = document.getElementById("fileElem");
        var fileList = document.getElementById("fileList");

        fileSelect.addEventListener("click", function (e) {
            if (fileElem) {
                fileElem.click();
            }
            e.preventDefault();
        }, false);

        fileElem.addEventListener("change", this.handleFiles, false);
    },
    created: function created() {
        this.prep_sets();
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {} else {
            localStorage.setItem("cn_prv_page", "cninsurance");
        }
    }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_preset_js__ = __webpack_require__(5);



var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNInsuranceFileComplaint',
    props: {
        cninsurance_listing: Object,
        cninsurance: Object
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_preset_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},

            cninsurance_data: {},
            files_info: [],
            imageForm: "",
            imagesFormArray: [],
            max_files_upload: 10,
            remove_files: false,
            data_processing_message: "",
            process_request_sent: false
        };
    },

    components: {},
    computed: {},
    methods: {
        reset: function reset() {
            this.process_request_sent = false;
            this.data_processing_message = '';
            this.cninsurance_data = {};
        },
        prep_sets: function prep_sets() {
            this.cninsurance_data.cninsurance_form = this.cninsurance.cninsurance_form;
        },
        submitCNInsuranceForm: function submitCNInsuranceForm() {
            var _this = this;

            var payload = {
                form_data_id: this.cninsurance_data.cninsurance_form,
                form_data_title: this.cninsurance_data.cninsurance_complaint_title || "",
                form_data_details: this.cninsurance_data.cninsurance_complaint,
                form_data_type: "cninsurance_file_complaint"
            };
            if (payload.form_data_id != '' && payload.form_data_title != '' && payload.form_data_details != '') {
                service.postCNinsuranceFileClaimComplaintForm(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        if (data.body.data_id > 0) {
                            if (_this.files_info.length > 0) {
                                _this.onFileChange(data.body.data_id);
                            } else {
                                _this.mailCNinsuranceForm(data.body.data_id);
                            }
                            toastr.success("Processing!", "Success!");
                        } else {
                            _this.data_processing_message = data.body.message;
                            toastr.error("Form not valid", "Warning!");
                        }
                    } else if (data.body.status == 404) {
                        _this.data_processing_message = data.body.message;
                        toastr.error("Form not valid", "Warning!");
                    } else {
                        toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information, please check your entries', 'Warning!');
                    }
                });
            } else {
                toastr.error('please check your entries', 'Warning!');
            }
        },
        mailCNinsuranceForm: function mailCNinsuranceForm(complaint_form_id) {
            var _this2 = this;

            var payload = {
                form_data_id: complaint_form_id,
                form_request_type: 2 };
            if (payload.cninsurance_form != '' && payload.cninsurance_complaint != '') {
                service.mailCNinsuranceFileClaimComplaintForm(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this2.data_processing_message = "Complaint has been sent";
                        _this2.process_request_sent = true;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setOnFileChange: function setOnFileChange(e, data) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var file = _step.value;

                        if (this.files_info.length < this.max_files_upload) {
                            this.files_info.push(file);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        onFileChange: function onFileChange(data) {
            var _this3 = this;

            var ups_count = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.files_info), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var file = _step2.value;

                    var formData = new FormData();
                    formData.append('photo', file);
                    formData.append('data_id', data);
                    formData.append('data_type', "cninsurance_file_complaint");
                    service.uploadDataPhoto(this, formData).then(function (response) {
                        ups_count++;
                        if (ups_count == _this3.files_info.length) {
                            _this3.mailCNinsuranceForm(data);
                        }
                    }).catch(function (err) {});
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        unsetRemoveFiles: function unsetRemoveFiles() {
            this.remove_files = false;

            document.getElementById("fileList02").style = "display:block";
            document.getElementById("stackFiles02").style = "display:none";

            this.handleFiles();
        },
        setRemoveFiles: function setRemoveFiles() {
            this.remove_files = true;
            for (var i = 0; i < this.files_info.length; i++) {
                var li = document.createElement("li");


                var img = document.createElement("img");
                img.src = URL.createObjectURL(this.files_info[i]);
                img.height = 40;img.width = 60;
                img.onload = function () {
                    URL.revokeObjectURL(this.src);
                };
                li.appendChild(img);
                var file_ko = document.getElementById("filsdaw" + i);
                file_ko.innerHTML = "";
                file_ko.appendChild(img);

                document.getElementById("fileList02").style = "display:none";
                document.getElementById("stackFiles02").style = "display:block";
            }
        },
        handleFiles: function handleFiles() {
            if (!this.files_info.length) {
                fileList02.innerHTML = "<p>No files selected!</p>";
            } else {
                fileList02.innerHTML = "";
                var list = document.createElement("ul");
                fileList02.appendChild(list);
                list.style.margin = "0";list.style.padding = "0";

                for (var i = 0; i < this.files_info.length; i++) {
                    var li = document.createElement("li");
                    list.appendChild(li);
                    li.style.listStyle = "none";
                    li.style.display = "inline";
                    li.style.padding = "5px";
                    li.style.marginLeft = "0";

                    var img = document.createElement("img");
                    img.src = URL.createObjectURL(this.files_info[i]);
                    img.height = 60;
                    img.onload = function () {
                        URL.revokeObjectURL(this.src);
                    };
                    li.appendChild(img);
                    var info = document.createElement("span");
                    info.innerHTML = this.files_info[i].name + ": " + this.files_info[i].size + " bytes";

                    var col = document.createElement("span");
                    col.innerHTML = '<div>Text</div>';
                }

                document.getElementById("fileList02").style = "display:block";
                document.getElementById("stackFiles02").style = "display:none";
                this.remove_files = false;
            }
        },
        removeFileUploadXX: function removeFileUploadXX(file_index) {
            this.files_info.splice(file_index, 1);
            this.setRemoveFiles();
        },
        removeFileUpload: function removeFileUpload(file) {
            var files_info = this.files_info;
            this.files_info = [];
            var index = files_info.indexOf(file);
            while (index > -1) {
                files_info.splice(index, 1);
                index = files_info.indexOf(file);
            }
            this.files_info = files_info;
            this.setRemoveFiles();
        }
    },
    mounted: function mounted() {

        var fileSelect = document.getElementById("fileSelect");
        var fileElem02 = document.getElementById("fileElem02");
        var fileList02 = document.getElementById("fileList02");

        fileSelect.addEventListener("click", function (e) {
            if (fileElem02) {
                fileElem02.click();
            }
            e.preventDefault();
        }, false);

        fileElem02.addEventListener("change", this.handleFiles, false);
    },
    created: function created() {
        this.prep_sets();
        var u_t = localStorage.getItem("cityneeds_token");
        if (u_t != null) {
            this.preset();
        } else {
            localStorage.setItem("cn_prv_page", "cninsurance");
        }
    }
});

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loader.16e6437.gif";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  "data-v-70de9ef9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-19fbb8ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(318),
  /* scopeId */
  "data-v-c6d57db4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(321),
  /* scopeId */
  "data-v-e453550e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(159)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  "data-v-099b1132",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  "data-v-6f45feac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(179)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  "data-v-3f8f6418",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  "data-v-7668e990",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  "data-v-8b02a9ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(156)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-04270715",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  "data-v-5dd3dfc2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(320),
  /* scopeId */
  "data-v-e1624884",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(319),
  /* scopeId */
  "data-v-db155f06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(185)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  "data-v-59717a8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(173)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  "data-v-3997a2bd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  "data-v-2144b7fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  "data-v-7d2253c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(171)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  "data-v-34fd1024",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(166)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  "data-v-20c3ad14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(180)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-4b3455d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  "data-v-ac1d00e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(316),
  /* scopeId */
  "data-v-bf20ac8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(160)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-0ea52dda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(155)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  "data-v-033af3a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  "data-v-4bc1118c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(317),
  /* scopeId */
  "data-v-c1c358e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  "data-v-78384e80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(157)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  "data-v-06404815",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  "data-v-63b31f8d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(164)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-1ee2099c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(176)
__webpack_require__(177)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  "data-v-3d0fda89",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(165)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-1ffa01de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  "data-v-77c747d5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(174)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  "data-v-3b4f7aed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(322),
  /* scopeId */
  "data-v-f3b19640",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(315),
  /* scopeId */
  "data-v-bd0b52d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  "data-v-b4ad3148",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(170)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  "data-v-33f4f7bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)
__webpack_require__(203)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  "data-v-a145f09c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(172)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  "data-v-36ee31d5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(162)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(183)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  "data-v-53252066",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  "data-v-7317df36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(182)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  "data-v-514b157c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  "data-v-8a4fd71a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8 "
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-poll"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('b', [_vm._v(_vm._s(_vm.survey.cnsurvey_title))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.survey.cnsurveys_questions), function(svq, index2) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index2 === _vm.survey.cnsurvey_question_index),
        expression: "index2 === survey.cnsurvey_question_index"
      }]
    }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt) {
      return _c('div', {
        staticClass: "options"
      }, [(_vm.check_if_user_has_polled(svq.cnsurveys_answers) || svq.polled) ? _c('div', [_c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))]), _vm._v(" "), _c('p', {
        staticClass: "pull-right",
        staticStyle: {
          "margin-top": "-0.7em"
        }
      }, [_vm._v("  " + _vm._s(_vm.get_option_answer(opt.cnsurvey_option_id, svq.cnsurveys_answers)))]), _vm._v(" "), _c('div', {
        staticClass: "progress",
        staticStyle: {
          "height": "0.2em"
        }
      }, [_c('div', {
        staticClass: "progress-bar progress-bar-info",
        style: ({
          width: _vm.get_option_answer(opt.cnsurvey_option_id, svq.cnsurveys_answers) + '%'
        }),
        attrs: {
          "role": "progressbar",
          "aria-valuenow": "60",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      })])]) : _c('div', [_c('div', {
        staticClass: "radio",
        on: {
          "click": function($event) {
            _vm.fillSurvey(_vm.survey, svq, index2, opt.cnsurvey_option_id)
          }
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.answer),
          expression: "answer"
        }],
        attrs: {
          "disabled": _vm.survey.disable,
          "id": "op",
          "type": "radio"
        },
        domProps: {
          "value": opt.cnsurvey_option_id,
          "checked": _vm._q(_vm.answer, opt.cnsurvey_option_id)
        },
        on: {
          "__c": function($event) {
            _vm.answer = opt.cnsurvey_option_id
          }
        }
      }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
    }), _vm._v(" "), _c('span', {
      staticClass: "pull-left"
    }, [_c('ul', {
      staticClass: "social-links nav nav-pills"
    }, [_c('li', [_c('a', {
      attrs: {
        "href": 'https://twitter.com/share?url=' + _vm.siteUrl + _vm.survey.cnsurvey_title_url + '&text=' + _vm.survey.cnsurvey_title + '&hashtags=cityneeds,cnsurveys',
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-twitter"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": 'http://www.facebook.com/sharer.php?u=' + _vm.siteUrl + _vm.survey.cnsurvey_title_url,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-facebook"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      staticClass: "linky",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.copyLink()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-link"
    }), _vm._v("Copy Link")])])])]), _vm._v(" "), (_vm.survey.cnsurveys_questions.length != 1) ? _c('span', [(_vm.check_if_user_has_polled(svq.cnsurveys_answers) || _vm.survey.survey_finished_poll) ? _c('span', [((index2 + 1) != _vm.survey.cnsurveys_questions.length) ? _c('span', [(_vm.check_if_user_has_polled(svq.cnsurveys_answers) || svq.polled) ? _c('button', {
      staticClass: "btn btn-xs btn-default pull-right",
      on: {
        "click": function($event) {
          _vm.next(0, index2)
        }
      }
    }, [_vm._v("View next Poll")]) : _vm._e()]) : _c('span', [(_vm.check_if_user_has_polled(svq.cnsurveys_answers) || svq.polled) ? _c('button', {
      staticClass: "btn btn-xs btn-default pull-right",
      on: {
        "click": function($event) {
          _vm.next(0, index2)
        }
      }
    }, [_vm._v("Done")]) : _vm._e()])]) : _c('span', [((index2 + 1) != _vm.survey.cnsurveys_questions.length) ? _c('span', [(_vm.check_if_user_has_polled(svq.cnsurveys_answers) || svq.polled) ? _c('button', {
      staticClass: "btn btn-xs btn-default pull-right",
      on: {
        "click": function($event) {
          _vm.next(0, index2)
        }
      }
    }, [_vm._v("Next")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('br'), _c('br'), (_vm.survey.cnsurvey_business != 0) ? _c('p', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v("Survey by: " + _vm._s(_vm.survey.cnsurvey_business_name))]) : _vm._e()])], 2)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.surveys.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSurveys(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])])]), _vm._v(" "), _c('sidebar')], 1)])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "guest-poll",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-offset-2 modal-content",
    staticStyle: {
      "top": "10em",
      "border-radius": "0px",
      "padding": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Thank you for making your opinion count! If you would like to partake in future CNsurveys, \r\n                or create your own CNsurvey, and stand the chance of earning random rewards , register now!\r\n                ")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/register",
      "type": "button"
    }
  }, [_vm._v("Sign Up")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "/cnsurveys"
    }
  }, [_vm._v("Back to CNsurveys")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-image": "url('https://cityneeds.ng/cnpro.jpg')",
      "height": "8em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-title"
  }, [_c('form', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      key: cc.cnpro_parent_category_id,
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.cnnpro_category_name,
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.cnnpro_category_name,
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "create-thread",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "0px"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.loggedIn) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "padding": "2em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#9c0909",
      "font-size": "18px",
      "line-height": "1.6"
    }
  }, [_vm._v("It will only take just few minutes, Log in / Create your cityneeds account to start a discussion")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReg
    }
  }, [_vm._v("\n                    Log In / Create "), _c('br'), _vm._v(" your cityneeds account\n                ")])])]) : _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discussion Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thread.forum_topic),
      expression: "thread.forum_topic"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Discussion Title"
    },
    domProps: {
      "value": (_vm.thread.forum_topic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thread.forum_topic = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thread.forum_category),
      expression: "thread.forum_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.thread.forum_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Community")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Short Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thread.forum_description),
      expression: "thread.forum_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "What would you want to discuss?"
    },
    domProps: {
      "value": (_vm.thread.forum_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thread.forum_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Add a Photo?")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })])])]), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.createThread
    }
  }, [_vm._v("Submit")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("START A DISCUSSION")])])
}]}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-sm-offset-2"
  }, [(_vm.user.user_premuim_plan_id) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "background-white"
  }, [(_vm.request_sent) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding": "1em"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\r\n                                        Your request has been sent successfully, we would contact you.\r\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.makeAnotherRequest
    }
  }, [_vm._v("Make another Request")])]), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "detail-enquire-form background-white p20"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Complete This Form: CNpro is a Click Away ")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What work do you want done?"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these areas suites best"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  }), _vm._v(" "), (_vm.sub_categories.length == 0) ? _c('option', [_c('i', [_vm._v("loading...")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.details),
      expression: "search.details"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.search.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.phone),
      expression: "search.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.search.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.work_address),
      expression: "search.work_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.work_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.work_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.work_date),
      expression: "search.work_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.search.work_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.work_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Dear " + _vm._s(_vm.user.user_fullname) + ", we would send you a mail at "), _c('b', [_vm._v(_vm._s(_vm.user.user_email))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.processForm
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" Make Request\r\n                                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('p', [_vm._v("Loading ......")])])]), _vm._v(" "), _c('horizontal-widget')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Help Me Find A CNpro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "cnpros",
      "type": "button"
    }
  }, [_vm._v("See more CNpros")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNpro Work Specification"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(": ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Briefly Describe Proposed Work"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Phone:"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address Of Where Work Is To Be Done:"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("When Do You want This Work Done?:"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dform_top"
    }
  }, [_c('div', {}, [(_vm.set_payment_view) ? _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em",
      "cursor": "pointer",
      "text-align": "center",
      "text-decoration": "underline",
      "color": "#22baae"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_view = false;
        _vm.preview_form == true;
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.set_payment_details_data).length !== 0)) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "3em 0.2em"
    }
  }, [_c('h4', [_vm._v("Payment Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h6', [_c('b', [_vm._v("Name")]), _c('br'), _c('br'), _vm._v("\r\n                                    " + _vm._s(_vm.set_payment_details_data.customerName) + "\r\n                                ")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "line-height": "1.8"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.cndiscount_form_amount))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.cndiscount_form_commission))])]), _vm._v(" "), (Number(_vm.set_payment_details_data.cndiscount_form_stamp_duty) > 0) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.cndiscount_form_stamp_duty))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.total_amount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepSetCNdiscountPayment(_vm.set_payment_details_data)
      }
    }
  }, [_vm._v("Proceed")])])])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-align": "center",
      "text-decoration": "underline",
      "color": "#22baae"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_view = false;
        _vm.preview_form == true;
      }
    }
  }, [_vm._v("Back to Form")])])]) : _c('div', {}, [(_vm.cndiscount_set_view == '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('b', [_vm._v("Duration: ")]), _vm._v("2 weeks")]) : _vm._e(), _vm._v(" "), (_vm.preview_form) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em",
      "cursor": "pointer",
      "text-decoration": "underline",
      "color": "#22baae"
    },
    on: {
      "click": function($event) {
        _vm.preview_form = false;
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Caption")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_caption) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Code")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_code) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Description")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_description) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Claim Link")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_link) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Start Date")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_start_date) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Expiry Date")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_expiry_date) + "\r\n                            ")])])])])]) : _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(!_vm.is_logged_in) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReg
    }
  }, [_vm._v("\r\n                       Create your cityneeds account\r\n                    ")])]) : _c('div', {
    staticClass: "row"
  }, [((Object.keys(_vm.businesses).length > 1)) ? _c('div', [_c('h3', [_vm._v("Set up DiscountBazaar for "), _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#22baae",
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('label', [_vm._v("or change business")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business),
      expression: "business"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _vm._l((_vm.businesses), function(bz) {
    return _c('option', {
      domProps: {
        "value": bz
      }
    }, [_vm._v(_vm._s(bz.business_name))])
  })], 2)])]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.businesses).length == 1)) ? _c('div', {
    staticClass: "p20"
  }, [_c('h3', [_vm._v("Set up DiscountBazaar for "), _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#22baae",
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('div', [(!_vm.set_new_business) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setAddNewBusiness
    }
  }, [_vm._v("Or add another business")]) : _c('button', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReload
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.businesses).length == 0) || _vm.set_new_business)) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "p20 mb10"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Business Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.category),
      expression: "business.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Business Category")]), _vm._v(" "), _vm._l((_vm.businessCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_id
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.name),
      expression: "business.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.business.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.location),
      expression: "business.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Wuse"
    },
    domProps: {
      "value": (_vm.business.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.location = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.address),
      expression: "business.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.business.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "map00"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.map),
      expression: "business.map"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Map"
    },
    domProps: {
      "value": (_vm.business.map)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.map = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.view_info = true;
        _vm.toggleComponent('gmap01');
      }
    }
  }, [_vm._v("\r\n                                        How to get my Google Map Code "), _c('i', {
    staticClass: "fa fa-angle-up",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]), _vm._v(" "), _vm._m(12)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Set up DiscountBazaar")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_caption),
      expression: "cndiscount.cndiscount_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter the Caption or Title of Discount"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_code),
      expression: "cndiscount.cndiscount_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Unique Discount Code"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_description),
      expression: "cndiscount.cndiscount_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Describe your offer",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Claim Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_link),
      expression: "cndiscount.cndiscount_link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter the website or social media link that would be used to claim the discount in this format, e.g.  https://quickstew.com"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_link = $event.target.value
      }
    }
  })]), _vm._v(" "), (((_vm.cndiscount.cndiscount_payment_status != undefined))) ? _c('div', [(_vm.cndiscount.cndiscount_payment_status == 0) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_start_date),
      expression: "cndiscount.cndiscount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_expiry_date),
      expression: "cndiscount.cndiscount_expiry_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_expiry_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_expiry_date = $event.target.value
      }
    }
  })])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_start_date),
      expression: "cndiscount.cndiscount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_expiry_date),
      expression: "cndiscount.cndiscount_expiry_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_expiry_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_expiry_date = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Normal Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_normal_price),
      expression: "cndiscount.cndiscount_normal_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_normal_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_normal_price = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_discount_price),
      expression: "cndiscount.cndiscount_discount_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_discount_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_discount_price = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', [_vm._v(" Add Media")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "file",
      "id": "fileElem04",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.setOnFileChange($event, _vm.cndiscount)
      }
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), (((_vm.business.business_id > 0) && (_vm.business.business_location == ''))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.location),
      expression: "business.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg: Wuse"
    },
    domProps: {
      "value": (_vm.business.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.location = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (((_vm.business.business_id > 0) && (_vm.business.business_map == ''))) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), ((_vm.business.map_lat && (_vm.business.map_lat != ''))) ? _c('div', {
    key: _vm.mapComponentKey
  }, [_c('p', [_vm._v("Map Set to: Points LT-"), _c('span', [_vm._v(_vm._s(_vm.business.map_lat))]), _vm._v("-LN-"), _c('span', [_vm._v(_vm._s(_vm.business.map_lng))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "map00"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.map),
      expression: "business.map"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Map Code"
    },
    domProps: {
      "value": (_vm.business.map)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.map = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleComponent('gmap01');
      }
    }
  }, [_vm._v("\r\n                                            How to get my Google Map Code "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]), _vm._v(" "), _vm._m(23)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 wn-pd0"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms_cn_agree),
      expression: "terms_cn_agree"
    }],
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "-3em",
      "float": "left"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms_cn_agree) ? _vm._i(_vm.terms_cn_agree, null) > -1 : (_vm.terms_cn_agree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms_cn_agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms_cn_agree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms_cn_agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms_cn_agree = $$c
        }
      }
    }
  }), _vm._m(24)])]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.process_loading) ? _c('div', {
    staticClass: "cx-loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addNewDiscounts
    }
  }, [_vm._v("Set up DiscountBazaar")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (((_vm.set_payment_data.total_amount) && (_vm.set_payment_data.total_amount > 0))) ? _c('div', [_c('cnpayment-modal', {
    attrs: {
      "payment_data": _vm.set_payment_data,
      "payment_object": _vm.set_payment_object
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("DiscountBazaar Post Fee:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Processing Fee: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Above Threshold Limit Charge (ATLC):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total Amount: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Google Map\r\n                                    "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("(please use the Google map to set the coordinates of your Business address)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "gmap01"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae dashed"
    }
  }, [_c('ol', [_c('li', [_vm._v("Click the button below "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "href": "https://google-map-generator.com/"
    }
  })]), _vm._v(" "), _c('li', [_vm._v("Enter your addres in the "), _c('span', [_vm._v("Enter your Address")]), _vm._v(" box")]), _vm._v(" "), _c('li', [_vm._v("Click on the "), _c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-weight": "bolder"
    }
  }, [_vm._v("Get HTML-Code")])]), _vm._v(" "), _c('li', [_vm._v("Copy the Code that appears and paste inside the box above")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Caption"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Discount Code"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe this Offer"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Start Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Expiry Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Start Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Expiry Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Map Location"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("(please use the Google map to set the coordinates of your Business address)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "gmap01"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae dashed",
      "margin-bottom": "2em"
    }
  }, [_c('ol', [_c('li', [_vm._v("Click the button below "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "href": "https://google-map-generator.com/",
      "target": "_blank"
    }
  }, [_vm._v("Get My Google Map Code")])]), _vm._v(" "), _c('li', [_vm._v("Enter your addres in the "), _c('span', [_vm._v("Enter your Address")]), _vm._v(" box")]), _vm._v(" "), _c('li', [_vm._v("Click on the "), _c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-weight": "bolder"
    }
  }, [_vm._v("Get HTML-Code")])]), _vm._v(" "), _c('li', [_vm._v("Copy the Code that appears and paste inside the box above")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-top": "-0.4em",
      "margin-left": "-1.4em",
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("Please accept "), _c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms")]), _vm._v(" to submit")])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-lg-8"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.search_result))]), _vm._v(" in Abuja")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.search_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.search_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cards-row"
  }, [_vm._l((_vm.businesses), function(business) {
    return [_c('div', {
      staticClass: "card-row"
    }, [_c('a', {
      staticStyle: {
        "color": "inherit"
      },
      attrs: {
        "href": 'business?context=' + business.business_url_name
      }
    }, [_c('div', {
      staticClass: "card-row-inner"
    }, [_c('div', {
      staticClass: "card-row-image"
    }, [_c('img', {
      staticClass: "full-image img-responsive",
      attrs: {
        "src": _vm.img_url + business.business_image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-row-label"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent(business)
        }
      }
    }, [_vm._v(_vm._s(business.business_category_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-body"
    }, [_c('h2', {
      staticClass: "card-row-title"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent(business)
        }
      }
    }, [_vm._v(_vm._s(business.business_name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-content"
    }, [_c('p', [_vm._v("\r\n                                                        " + _vm._s(business.business_category_name) + "\r\n                                                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-properties points"
    }, [_c('dl', [_c('dd', [_vm._v("Review(s)")]), _c('dt', [_vm._v(_vm._s(business.business_reviews_total_count))]), _vm._v(" "), _c('dd', [_vm._v("Category")]), _c('dt', [_vm._v(_vm._s(business.business_category_name))]), _vm._v(" "), _c('dd', [_vm._v("Location")]), _c('dt', [_vm._v(_vm._s(business.business_address))]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('dd', [_vm._v("Rating")]), _c('dt', [_vm._v(_vm._s(business.business_rating_average_rate) + " "), _c('i', {
      staticClass: "fa fa-star"
    })])])])])])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.businesses.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSearchBusinesses(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])])]), _vm._v(" "), _c('sidebar')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [(_vm.panelFlag) ? _c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [(_vm.addFlag) ? _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("About Survey")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_title),
      expression: "survey.cnsurvey_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.survey.cnsurvey_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.survey.cnsurvey_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_category),
      expression: "survey.cnsurvey_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.survey.cnsurvey_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setSurveyCategory(_vm.survey.cnsurvey_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("An Existing Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Not An Existing Business")])])]), _vm._v(" "), (_vm.loadSurveyData == 'business') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_business),
      expression: "survey.cnsurvey_business"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.survey.cnsurvey_business = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.businesses), function(business) {
    return _c('option', {
      domProps: {
        "value": business.business_id
      }
    }, [_vm._v(_vm._s(business.business_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.loadSurveyData == 'business_categories') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_business_category),
      expression: "survey.cnsurvey_business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.survey.cnsurvey_business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.businessCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_id
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.createSurvey
    }
  }, [_vm._v("Submit")])])])]) : _vm._e(), _vm._v(" "), (_vm.addQuestionFlag) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Create Survey")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('back', '')
      }
    }
  }, [_vm._v("Back to Surveys")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), (_vm.survey.cnsurveys_questions.length < 5) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-2"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Survey Question")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Add a question to survey")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Survey Title: ")]), _vm._v(_vm._s(_vm.survey.cnsurvey_title))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Question")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_question),
      expression: "survey.cnsurvey_question"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.survey.cnsurvey_question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.survey.cnsurvey_question = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Survey Options")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option A")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.one),
      expression: "options.one"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.one)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options.one = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option B")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.two),
      expression: "options.two"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.two)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options.two = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option C")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.three),
      expression: "options.three"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.three)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options.three = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option D")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.four),
      expression: "options.four"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.four)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options.four = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option E")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.five),
      expression: "options.five"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.five)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options.five = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.survey.cnsurveys_questions.length < 5) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.addSurveyQuestion('add')
      }
    }
  }, [_vm._v("Add Another Question")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        _vm.addSurveyQuestion('finish')
      }
    }
  }, [_vm._v("Finish")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editFlag) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Edit Survey")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('back', '')
      }
    }
  }, [_vm._v("Back to Surveys")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), (_vm.survey.cnsurvey_can_edit == 1) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Sorry, You cannot edit this Survey, Please contact Admin")])]) : _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("About Survey")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_title),
      expression: "survey.cnsurvey_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.survey.cnsurvey_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.survey.cnsurvey_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('b', [_vm._v("Survey Type: " + _vm._s(_vm.survey.cnsurvey_category_name))])])]), _vm._v(" "), (_vm.survey.cnsurvey_category == 4) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_business),
      expression: "survey.cnsurvey_business"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.survey.cnsurvey_business = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.businesses), function(business) {
    return _c('option', {
      domProps: {
        "value": business.business_id
      }
    }, [_vm._v(_vm._s(business.business_name))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.survey.cnsurvey_category == 5) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey.cnsurvey_business_category),
      expression: "survey.cnsurvey_business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.survey.cnsurvey_business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.businessCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_id
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.editSurvey
    }
  }, [_vm._v("Save")])]), _vm._v(" "), (_vm.deleteFlag) ? _c('div', {
    staticClass: "col-md-12 col-sm-12"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Survey Questions\r\n                                                "), (_vm.survey.cnsurveys_questions.length < 5) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('add-question', '')
      }
    }
  }, [_vm._v("Add a Question")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.survey.cnsurveys_questions), function(svq, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-12"
    }, [_c('div', {
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit Survey Question"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('edit-question', svq)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v("  \r\n                                                                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Delete Survey Question"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('delete-question', svq)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [(svq.deleteFlag) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Do you really want to delete this survey?!")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": _vm.deleteSurveyQuestion
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "href": "survey-requests"
      }
    }, [_vm._v("NO")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((svq.cnsurveys_option), function(opt) {
      return _c('div', {
        staticClass: "options"
      }, [_c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])
    })), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "3em"
      }
    })])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editQuestionFlag) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Edit Survey")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('back', '')
      }
    }
  }, [_vm._v("Back to Surveys")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-2"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Edit Survey Question")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Survey Title: ")]), _vm._v(_vm._s(_vm.survey.cnsurvey_title))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Question")]), _vm._v(_vm._s(_vm.survey_questions.cnsurvey_question_id) + "\r\n                                                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey_questions.cnsurvey_question),
      expression: "survey_questions.cnsurvey_question"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.survey_questions.cnsurvey_question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.survey_questions.cnsurvey_question = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Survey Options")]), _vm._v(" "), _vm._l((_vm.survey_questions.cnsurveys_option), function(opt) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (opt.cnsurvey_option_option),
        expression: "opt.cnsurvey_option_option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (opt.cnsurvey_option_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          opt.cnsurvey_option_option = $event.target.value
        }
      }
    })])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.editSurveyQuestion
    }
  }, [_vm._v("Save")])])]) : _vm._e()]), _vm._v(" "), (_vm.activateFlag) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Activate Survey")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('back', '')
      }
    }
  }, [_vm._v("Back to Surveys")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-2"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.survey.cnsurvey_title))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Activate survey")]), _vm._v(" "), _c('p', [_vm._v("Your survey has been approved, you just have to activate it to go Live")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Activation Fee: ")]), _vm._v(_vm._s(_vm.survey.cnsurvey_activation_fee))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Duration: ")]), _vm._v(_vm._s(_vm.survey.cnsurvey_set_date) + " - " + _vm._s(_vm.survey.cnsurvey_end_date))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.processPayment(_vm.survey)
      }
    }
  }, [_vm._v("Proceed to Pay")])])])]) : _vm._e()]) : _c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('a', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setPanel('add', '')
      }
    }
  }, [_vm._v("Create Survey")]), _vm._v(" "), _c('h1', [_vm._v("Your Surveys")])]), _vm._v(" "), _vm._l((_vm.surveys), function(sv, index2) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-6"
    }, [_c('div', {
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_vm._v(_vm._s(sv.cnsurvey_title))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit Survey"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('edit', sv)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v("  \r\n                                                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Delete Survey"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('delete', sv)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [(sv.deleteFlag) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Do you really want to delete this survey?!")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": _vm.deleteSurvey
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "href": "survey-requests"
      }
    }, [_vm._v("NO")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((sv.cnsurveys_questions), function(svq, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index === sv.cnsurvey_question_index),
          expression: "index === sv.cnsurvey_question_index"
        }]
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt) {
        return _c('div', {
          staticClass: "options"
        }, [_c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))]), _vm._v(" "), _c('p', {
          staticClass: "pull-right",
          staticStyle: {
            "margin-top": "-0.7em"
          }
        }, [_vm._v("  " + _vm._s(_vm.get_option_answer(opt.cnsurvey_option_id, svq.cnsurveys_answers)))]), _vm._v(" "), _c('div', {
          staticClass: "progress",
          staticStyle: {
            "height": "0.2em"
          }
        }, [_c('div', {
          staticClass: "progress-bar progress-bar-info",
          style: ({
            width: _vm.get_option_answer(opt.cnsurvey_option_id, sv.cnsurveys_answers) + '%'
          }),
          attrs: {
            "role": "progressbar",
            "aria-valuenow": "60",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])])
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-default pull-right",
        on: {
          "click": function($event) {
            _vm.next(index2, index)
          }
        }
      }, [_vm._v("Next")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-default pull-left"
      }, [_vm._v(_vm._s(sv.cnsurvey_status_name))])], 2)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "3em"
      }
    })], 2)])])
  })], 2)])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Create Survey")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": "survey-requests"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back to CNsurveys")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Survey Title"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Survey Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Survey Business"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Survey Business Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Survey Title"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Survey Business"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Survey Business Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "80% !important",
      "text-align": "left !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [(_vm.payment_object.payment_detail_type == 'cninsurance') ? _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "2em",
      "margin-left": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "2em",
      "margin-left": "1em"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word",
      "text-align": "left!important"
    }
  }, [_c('div', {
    key: _vm.paymentModalComponentKey,
    staticClass: "container"
  }, [(_vm.payment_object.payment_detail_type != 'general') ? _c('div', {
    staticStyle: {
      "margin-left": "-1.3em",
      "word-wrap": "break-word",
      "text-align": "left !important"
    }
  }, [_c('img', {
    staticClass: "wn-profile-img",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.payment_object.payment_detail_logo
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.payment_object.payment_detail_name))])]) : _c('div', {
    staticStyle: {
      "margin-top": "-2em",
      "margin-left": "-1.3em"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.payment_object.payment_detail_name))])]), _vm._v(" "), (_vm.payment_status > 0) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "word-wrap": "break-word",
      "text-align": "left !important"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "word-wrap": "break-word !important"
    }
  }, [_vm._v(_vm._s(_vm.getModalMessage()))]), _vm._v(" "), (_vm.call_src == 2) ? _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/cnprocesses?type=3"
    }
  }, [_vm._v("Continue")])]) : _c('div', [(_vm.payment_status == 200) ? _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.active_url + _vm.payment_object.payment_detail_set_callbackurl
    }
  }, [_vm._v("Continue")])]) : _vm._e(), _vm._v(" "), (_vm.payment_status == 400) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resolveIssues
    }
  }, [_vm._v("Correct Issues")])]) : _vm._e()])])]) : _c('div', {
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word",
      "text-align": "left !important"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.formatCurrency(_vm.payment_data.total_amount)))])])]), _vm._v(" "), _c('div', {
    key: _vm.headerKey,
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), ((_vm.user.current_wallet_balance && (_vm.user.current_wallet_balance > _vm.payment_data.total_amount))) ? _c('div', [_c('p', [_c('b', [_vm._v("Current Wallet Balance: ₦" + _vm._s(_vm.formatCurrency_2(_vm.user.current_wallet_balance)))])]), _vm._v(" "), (_vm.payment_process_option == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.payment_process_option == 2,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentOption(2)
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You do not have sufficient funds in your wallet")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process payment from your Bank Account")]), _vm._v(" "), (_vm.payment_process_option == 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.payment_process_option == 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentOption(1)
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "formupdate",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    key: _vm.paymentModalComponentKey,
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "wn-profile-img",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.payment_object.payment_detail_logo
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.payment_object.payment_detail_name))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.getModalMessage()))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.active_url + 'account-cninsurance'
    }
  }, [_vm._v("Continue")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("Insure")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("moto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("buy insurance with a click 👌")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("city")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("needs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("convenience for living 👌")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "2em",
      "margin-left": "1em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("Insure")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("moto")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("buy insurance with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin fld"
  }, [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "cx-loading-md"
  })]) : _c('div', {
    staticClass: "wn-pad"
  }, [_c('div', {
    staticClass: "row fld",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.viewOne) ? _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-12"
  }, [(Object.keys(_vm.cninsurance_account_forms).length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My InsureMoto")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('renew', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Renew Insurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('forms', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Submitted Forms")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('claims', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Filed Claims")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('complaints', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Filed Complaints")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((_vm.cninsurance_account.cninsurance_account_cninsurance_data && _vm.cninsurance_account.cninsurance_account_cninsurance_data.cninsurance_name != '')) ? _c('div', [_c('h3', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.cninsurance_account.cninsurance_account_cninsurance_data.cninsurance_name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30 wn-pad0"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.set_main_view.complaints) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "background-color": "#ffffff"
    }
  }, [_c('h4', [_vm._v("View Complaints")]), _vm._v(" "), ((Object.keys(_vm.cninsurance_account_complaints).length !== 0)) ? _c('div', _vm._l((_vm.cninsurance_account_complaints), function(ccomp, ccondex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(_vm.cclaim.cninsurance_complaint_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(ccomp.cninsurance_complaint_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_complaint', _vm.cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Complaints")])]) : _vm._e(), _vm._v(" "), (_vm.set_main_view.claims) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "background-color": "#ffffff"
    }
  }, [_c('h4', [_vm._v("View Claims")]), _vm._v(" "), ((Object.keys(_vm.cninsurance_account_claims).length !== 0)) ? _c('div', _vm._l((_vm.cninsurance_account_claims), function(cclaim, cclndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(cclaim.cninsurance_claim_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(cclaim.cninsurance_claim_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_claim', cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Claims")])]) : _vm._e(), _vm._v(" "), (_vm.set_main_view.forms) ? _c('div', [_c('h4', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Forms (" + _vm._s((Object.keys(_vm.cninsurance_account_forms).length)) + ")")]), _vm._v(" "), (_vm.cninsurance_account_unsubmitted_forms > 0) ? _c('h4', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Not Submitted (" + _vm._s(_vm.cninsurance_account_unsubmitted_forms) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cninsurance_account_unpaid_forms > 0) ? _c('h4', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Not yet Paid for (" + _vm._s(_vm.cninsurance_account_unpaid_forms) + ")")]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.cninsurance_account_forms).length !== 0)) ? _c('div', _vm._l((_vm.cninsurance_account_forms), function(form, fndex) {
    return _c('div', [_c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-card-block",
      staticStyle: {
        "border": "1px solid #22baae",
        "margin-bottom": "1em",
        "padding": "0.2em",
        "border-radius": "2px"
      }
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('p', {
      staticStyle: {
        "color": "#22baae"
      }
    }, [_vm._v(_vm._s(form.form_details))])]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      staticStyle: {
        "border-bottom": "#22baae solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_form', form, '')
        }
      }
    }, [_vm._v("Check Status")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10",
      staticStyle: {
        "padding-left": "1.5em",
        "padding-top": "1em"
      }
    }, [(form.cninsurance_form_policy_id == 'nil') ? _c('p', [_c('b', [_vm._v("Form Policy Id:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Not assigned")])]) : _c('p', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('b', [_vm._v("Form Policy Id:")]), _vm._v(" " + _vm._s(form.cninsurance_form_policy_id))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "1.4"
      }
    }, [_c('b', [_vm._v("InsureMoto Id:")]), _vm._v(" " + _vm._s(form.cninsurance_form_ref))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "1.4"
      }
    }, [_c('b', [_vm._v("Date Submitted:")]), _vm._v(" " + _vm._s(form.cninsurance_form_reg_date))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "1.4"
      }
    }, [_c('b', [_vm._v("Form Status:")]), _vm._v(" " + _vm._s(form.cninsurance_form_sent_status_name))]), _vm._v(" "), (form.cninsurance_form_pay_status == 1) ? _c('p', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('b', [_vm._v("Payment Status:")]), _vm._v(" Paid")]) : _c('p', [_c('b', [_vm._v("Payment Status:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Not Paid")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "1em"
      }
    }, [(((form.cninsurance_form_pay_status == 0) || (form.cninsurance_form_sent_status != 200))) ? _c('button', {
      staticClass: "col-xs-4 btn btn-default",
      staticStyle: {
        "color": "#ff0000",
        "border-bottom": "#fdcfcf solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setMainView('resubmit', form)
        }
      }
    }, [_vm._v("process form")]) : _vm._e(), _vm._v(" "), (((form.cninsurance_form_pay_status == 1) && (form.cninsurance_form_sent_status == 200))) ? _c('button', {
      staticClass: "col-xs-4 btn btn-default",
      staticStyle: {
        "border-bottom": "#e7c619 solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setMainView('renew_selected', form)
        }
      }
    }, [_vm._v("Renew")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "col-xs-4 pull-right btn btn-default",
      staticStyle: {
        "border-bottom": "#22baae solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_form', form, '')
        }
      }
    }, [_vm._v("view")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-left": "1em"
    }
  }, [_vm._v("No Form")])]) : _vm._e(), _vm._v(" "), (_vm.set_main_view.renew && (Object.keys(_vm.cninsurance_partner).length !== 0)) ? _c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_partner,
      "cninsurance": _vm.current_form_data_form_entries
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.set_main_view.renew_selected && (Object.keys(_vm.cninsurance_partner).length !== 0)) ? _c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_partner,
      "cninsurance": _vm.set_renew_selected_form_data_form_entries
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.set_main_view.resubmit && (Object.keys(_vm.cninsurance_partner).length !== 0)) ? _c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_partner,
      "cninsurance": _vm.set_submit_form_data_form_entries
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "show_form",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('show_form')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Form Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_id))])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Number: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_number))])])]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_certificate_url != 'nil') ? _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "href": _vm.cninsurance_form.cninsurance_form_certificate_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Certificate")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wn-mobi-on"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.toggleView('menu_1')
      }
    }
  }, [_vm._v("Settings "), _c('i', {
    staticClass: "fa fa-gear",
    staticStyle: {
      "font-size": "1.6em",
      "color": "#22baae",
      "font-weight": "bolder"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "menu_1"
    }
  }, [(_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_claims', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Claims")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_complaints', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Complaints")]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_claim', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Claim")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_complaint', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Complaint")]), _vm._v(" "), ((Object.keys(_vm.set_component_view).length) > 0) ? _c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_component_view = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Back to Form")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right wn-mobi-off"
  }, [(_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_claims', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Claims")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_complaints', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Complaints")]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_claim', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Claim")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_complaint', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Complaint")]), _vm._v(" "), ((Object.keys(_vm.set_component_view).length) > 0) ? _c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_component_view = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Back to Form")]) : _vm._e()]), _vm._v(" "), (_vm.set_component_view.set_flie_complaint) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE COMPLAINT")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('cninsurance-file-complaint', {
    attrs: {
      "cninsurance": _vm.cninsurance_data
    }
  })], 1)]) : (_vm.set_component_view.set_flie_claim) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE CLAIM")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('cninsurance-file-claim', {
    attrs: {
      "cninsurance": _vm.cninsurance_data
    }
  })], 1)]) : (_vm.set_component_view.set_view_flie_claims) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("CLAIMS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_claims), function(cclaim, cclndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(cclaim.cninsurance_claim_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(cclaim.cninsurance_claim_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_claim', cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]) : (_vm.set_component_view.set_view_flie_complaints) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("COMPLAINTS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_complaints), function(ccomp, ccondex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(_vm.cclaim.cninsurance_complaint_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(ccomp.cninsurance_complaint_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_complaint', _vm.cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, _vm._l((_vm.cninsurance_form.cninsurance_form_entries), function(cform, cfndex) {
    return _c('div', {
      staticClass: "row"
    }, [((cform.cninsurance_form_entry_type % 2) != 0) ? _c('div', {
      staticClass: "wn-fleft wn-h-list"
    }, [_c('h6', [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(cform.cninsurance_form_entry_value) + "\r\n                                                                                ")])]) : _vm._e(), _vm._v(" "), ((cform.cninsurance_form_entry_type % 2) == 0) ? _c('div', {
      staticClass: "wn-fright wn-h-list"
    }, [_c('h6', [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(cform.cninsurance_form_entry_value) + "\r\n                                                                                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "show_claim",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('show_form')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Claim Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_claim.cninsurance_claim_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Claim Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_title) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_details) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_reg_date) + "\r\n                                                                                ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "show_complaint",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('show_form')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Complaint Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_complaint.cninsurance_complaint_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Complaint Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_title) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_details) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_reg_date) + "\r\n                                                                                ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])])]), _vm._v(" "), (Object.keys(_vm.cninsurance_partner).length !== 0) ? _c('div') : _vm._e()])]) : _c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No forms yet")]), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), (_vm.viewAll) ? _c('div', {
    staticClass: "row"
  }) : _vm._e()]), _vm._v(" "), _c('component-footer')], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 col-xs-12 col-lg-3 fld"
  }, [_c('div', {
    staticClass: "sidebar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-table",
    staticStyle: {
      "font-size": "4em",
      "color": "#22baae",
      "font-weight": "bold"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My InsureMoto")]), _vm._v(">\r\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/insuremoto"
    }
  }, [_vm._v("Start Insurance")])])
}]}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7 col-lg-8 pb30 background-white mn78"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid mt50"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8",
    staticStyle: {
      "margin-bottom": "1.3em",
      "z-index": "10"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_forum),
      expression: "search_forum"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search_forum = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getForums(0, _vm.pag_intv)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Search...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Community")])])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.forums), function(forum) {
    return _c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-body p30",
      attrs: {
        "id": "thread-card"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "pull-right text-center"
    }, [(forum.forum_comments.length) ? _c('h4', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(forum.forum_comments.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Replies")])]), _vm._v(" "), _c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "media-object img-circle",
      attrs: {
        "src": _vm.img_url + forum.forum_created_by_image,
        "alt": "User Profile Image",
        "width": "35",
        "height": "35"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_c('a', {
      attrs: {
        "href": 'forum?topic=' + forum.forum_topic_url
      }
    }, [_vm._v(_vm._s(forum.forum_topic))])]), _vm._v(" "), _c('p', {
      staticClass: "mb15"
    }, [_vm._v("By " + _vm._s(forum.forum_created_by) + " | " + _vm._s(forum.forum_reg_date) + " | "), _c('span', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('b', [_vm._v(_vm._s(forum.forum_category))])])]), _vm._v(" "), _c('p'), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.setForumDsc(forum.forum_description))
      }
    }), _vm._v(" "), (forum.forum_attachment) ? _c('span', [_c('img', {
      staticClass: "fc-img",
      attrs: {
        "src": _vm.img_url + forum.forum_attachment
      }
    })]) : _vm._e(), _vm._v(" "), _c('p')])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.forums.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getForums(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])])]), _vm._v(" "), _c('sidebar')], 1)])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('create-thread')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#create-thread"
    }
  }, [_vm._v("Start A Discussion")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Trending Discussions")])])])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "background": "#fff",
      "padding": "2em",
      "border-radius": "5px",
      "border": "1px solid #666"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-lg-12 ccol-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "500",
      "color": "#22baae"
    }
  }, [_vm._v("How You Can Find And Contract A CNpro ")])]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "premuim"
    }
  }, [_c('h3', [_vm._v("OPTION 1")]), _vm._v(" "), _c('h4', [_vm._v("HELP ME FIND A CNpro.")]), _vm._v(" "), _c('p', [_vm._v("Click \"Help Me Find A CNpro\" at the top, a form will drop down.\r\n\t\t\t\t\t\t\t\t\t\tFill the form, send, and we will help you find the ideal CNpro (pro skilled-worker).\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("OPTION 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('h4', [_vm._v("MAKE A CHOICE")]), _vm._v(" "), _c('p', [_vm._v("Search for your proposed job category.")]), _vm._v(" "), _c('p', [_vm._v("Choose from a pool of listed Service Professionals (CNpros) that match the job")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Step 2.")]), _vm._v(" "), _c('h4', [_vm._v("CHOOSE A PLAN")]), _vm._v(" "), _c('p', [_vm._v("Subscribe to any of the "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "how-it-works"
    }
  }, [_c('b', [_vm._v("Plans")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Step 3.")]), _vm._v(" "), _c('h4', [_vm._v("GETTING THE JOB DONE")]), _vm._v(" "), _c('p', [_vm._v("Start chatting with your chosen CNpro, or call the CNpro's listed phone number, and describe your proposed job.")]), _vm._v(" "), _c('p', [_vm._v("CNpro meets with You and evaluates the job.")]), _vm._v(" "), _c('p', [_vm._v("CNpro sends You a Job Quote, and CNpro's Fees (Labour Charge) for the proposed job.")]), _vm._v(" "), _c('p', [_vm._v("You purchase/provide the work materials for the proposed job.")]), _vm._v(" "), _c('p', [_vm._v("Your payment card is securely "), _c('b', [_vm._v("( 256-bit SSL encryption)")]), _vm._v(" debited for CNpro's Fees (Labour Charge) upfront, and payment is kept in escrow.")]), _vm._v(" "), _c('p', [_vm._v("On satisfactory completion of job by CNpro, You sign-off and notify Cityneeds")]), _vm._v(" "), _c('p', [_vm._v("After a Job-Quality-Monitoring period of 48 hours (2 days), if no complaint is received from You, CNpro's Fees (Labour Charge) is released and paid to the CNpro.")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')])])])])])])])
}]}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.panelFlag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [(_vm.addFlag) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Add a CNpro Account")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back to CNpros")])]), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Service Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.parent_category),
      expression: "cnpro.parent_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.parent_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCnproCategories(_vm.cnpro.parent_category)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Parent Category")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cnproCategories.length > 0),
      expression: "cnproCategories.length > 0"
    }],
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cnproCategories.length > 0),
      expression: "cnproCategories.length > 0"
    }],
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.category),
      expression: "cnpro.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Sub Category")]), _vm._v(" "), _vm._l((_vm.cnproCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.name),
      expression: "cnpro.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Service Name"
    },
    domProps: {
      "value": (_vm.cnpro.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.description),
      expression: "cnpro.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Your Service Description",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.cnpro.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Contact Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.address),
      expression: "cnpro.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address "
    },
    domProps: {
      "value": (_vm.cnpro.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.phone),
      expression: "cnpro.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone "
    },
    domProps: {
      "value": (_vm.cnpro.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.email),
      expression: "cnpro.email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "E-mail",
      "data-vv-rules": "required|email"
    },
    domProps: {
      "value": (_vm.cnpro.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')) + " " + _vm._s(_vm.error_here.email))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Social Media Handles")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.facebook),
      expression: "cnpro.facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://web.facebook.com/MyName/"
    },
    domProps: {
      "value": (_vm.cnpro.facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.twitter),
      expression: "cnpro.twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://twitter.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.instagram),
      expression: "cnpro.instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://www.instagram.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.instagram = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCnpro
    }
  }, [_vm._v("Submit Listing")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xs-12 fld-left"
  }, [(_vm.viewFlag) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active fld",
    attrs: {
      "role": "tabpanel",
      "id": "one"
    }
  }, [_c('div', [_c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                                    Service: " + _vm._s(_vm.cnpro.cnpro_category_name) + "\r\n                                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back to CNpros")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toggleMenuActions
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("View Actions")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu-actions"
  }, [_c('a', {
    staticClass: " btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setPanel('edit', _vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Edit")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts', _vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View Quotes/Contracts")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', [_vm._v("Name: " + _vm._s(_vm.cnpro.cnpro_name))]), _vm._v(" "), _c('p', [_vm._v("City: " + _vm._s(_vm.cnpro.cnpro_city_name))]), _vm._v(" "), _c('p', [_vm._v("State: " + _vm._s(_vm.cnpro.cnpro_state_name))]), _vm._v(" "), _c('p', [_vm._v("Address: " + _vm._s(_vm.cnpro.cnpro_address))]), _vm._v(" "), _c('p', [_vm._v("Email: " + _vm._s(_vm.cnpro.cnpro_email))]), _vm._v(" "), _c('p', [_vm._v("Phone: " + _vm._s(_vm.cnpro.cnpro_phone))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.cnpro.cnpro_description))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Social Media")]), _vm._v(" "), _c('p', [_vm._v("Facebook: " + _vm._s(_vm.cnpro.cnpro_facebook))]), _vm._v(" "), _c('p', [_vm._v("Twitter: " + _vm._s(_vm.cnpro.cnpro_twitter))]), _vm._v(" "), _c('p', [_vm._v("Instagram: " + _vm._s(_vm.cnpro.cnpro_instagram))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_image,
      "width": "150",
      "height": "150"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros')
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_id_card
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('label', [_vm._v("Change/Upload ID Card")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros_id_card')
      }
    }
  })])])])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('hr', {
    staticStyle: {
      "border-top": "dashed 1px #999"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: " btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setPanel('delete', _vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Remove CNpro")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "two"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "three"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "four"
    }
  }, [_vm._v("...")])])]) : _vm._e(), _vm._v(" "), (_vm.editFlag) ? _c('div', {
    staticClass: "content fld-lft-adjust"
  }, [_c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Edit CNpro Account\r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Service Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_parent_category),
      expression: "cnpro.cnpro_parent_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.cnpro_parent_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCnproCategories(_vm.cnpro.cnpro_parent_category)
      }]
    }
  }, _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_category),
      expression: "cnpro.cnpro_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.cnpro_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cnproCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_name),
      expression: "cnpro.cnpro_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Service Name"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_description),
      expression: "cnpro.cnpro_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Your Service Description",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Contact Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_address),
      expression: "cnpro.cnpro_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_phone),
      expression: "cnpro.cnpro_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_email),
      expression: "cnpro.cnpro_email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "E-mail",
      "data-vv-rules": "required|email"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')) + " " + _vm._s(_vm.error_here.email))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Social Media Handles")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(30), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_facebook),
      expression: "cnpro.cnpro_facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://web.facebook.com/MyName/"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(31), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_twitter),
      expression: "cnpro.cnpro_twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://twitter.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(32), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_instagram),
      expression: "cnpro.cnpro_instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://www.instagram.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_instagram = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCnpro
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.deleteFlag) ? _c('div', {
    staticClass: "content fld-lft-adjust"
  }, [_c('form', [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Delete CNpro Account\r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), _vm._m(33), (_vm.cnpro.cnpro_delete_request != '') ? _c('p', [_c('b', [_vm._v("Remove Account Status: ")]), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.cnpro.cnpro_delete_request))])]) : _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you wish to Continue?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.cnpro.cnpro_delete_request == '') ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeCnpro
    }
  }, [_vm._v("Yes Continue")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.viewQuotePanel) ? _c('div', {
    staticClass: "fld-lft-adjust p20 m30"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff",
      "padding-top": "2em"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_c('u', [_vm._v("Contract Status")]), _vm._v(": "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    },
    style: ({
      background: _vm.contract.contract_status_color_code,
      color: '#fff',
      padding: '0.2em'
    })
  }, [_vm._v(_vm._s(_vm.contract.contract_status))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-xs pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts')
      }
    }
  }, [_vm._v("Back to Contracts")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    on: {
      "click": _vm.toggleMenuActions
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v("View Actions")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu-actions"
  }, [(_vm.contract.contract_quote == 'SET') ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewQuoteFlag', '')
      }
    }
  }, [_vm._v("View Quote")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_quote != 'SET') ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-compliants')
      }
    }
  }, [_vm._v("View Complaints")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_status_id != 8 && _vm.contract.contract_status_id != 5 && _vm.contract.contract_status_id != 6 && _vm.contract.contract_status_id != 7 && _vm.contract.contract_status_id != 3) ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.markWorkDone(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Mark Job As Complete")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_status_id == 8 || _vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#contract_pictures"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload/View Work Pictures")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 8) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "border": "2px solid #22baae"
    }
  }, [(_vm.contract.contract_status_id == 5 && _vm.contract.contract_complaint_status != 16) ? _c('p', [_c('b', [_vm._v("CNuser confirmed Job as Completed...")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Notice: ")]), _vm._v("Your Job is on a 48hrs time frame review ending on "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.contract.contract_expiry_date))])]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_complaint_status == 16) ? _c('p', [_vm._m(34), _vm._v(" Please resolve complaints with the CNuser")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You've Marked this Job as Completed")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Discussion Thread")]), _vm._v(" "), _vm._l((_vm.contract_threads), function(thread) {
    return _c('p', [_c('b', [_vm._v(_vm._s(thread.contract_thread_user_name) + ":")]), _vm._v(" " + _vm._s(thread.contract_thread_thread))])
  }), _vm._v(" "), _c('form', [_c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.contract.contract_status_id != 5) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.message),
      expression: "quote.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "placeholder": "Message",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.message = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {}, [(_vm.contract.contract_status_id != 5) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.replyQuote(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Send")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 3) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setQuotePanel
    }
  }, [_vm._v("Give a Quote")]) : _vm._e()])])])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fld-lft-adjust"
  }, [(_vm.viewQuoteFlag) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                Quote Details "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), (_vm.contract.contract_quote == 'SET') ? _c('div', {}, [(_vm.editQuoteFlag) ? _c('div', [_c('form', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(35), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_quote_description),
      expression: "contract.contract_quote_description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_quote_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_quote_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(36), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_material_details),
      expression: "contract.contract_material_details"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_material_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_material_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(37), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_labour_cost),
      expression: "contract.contract_labour_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_labour_cost)
    },
    on: {
      "change": function($event) {
        _vm.totalAfterServiceCharge = (_vm.contract.contract_labour_cost - (_vm.contract.contract_labour_cost * _vm.serviceCharge))
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_labour_cost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Your Pay Out: ₦" + _vm._s(_vm.totalAfterServiceCharge) + " , (@" + _vm._s(_vm.serviceChargeInPercentage) + "% Service Charge(incl. of VAT))")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(38), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_work_duration),
      expression: "contract.contract_work_duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_work_duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_work_duration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editQuote(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('br')]) : _c('div', [_c('p', [_c('b', [_vm._v("Quote Status:")]), _vm._v(" " + _vm._s(_vm.contract.contract_status))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Proposed Job Description:")]), _vm._v(" " + _vm._s(_vm.contract.contract_quote_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("List of Materials:")]), _vm._v(" " + _vm._s(_vm.contract.contract_material_details))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Labour Cost:")]), _vm._v(" ₦" + _vm._s(_vm.contract.contract_labour_cost))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Work Duration:")]), _vm._v(" " + _vm._s(_vm.contract.contract_work_duration) + " Days")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.contract_edit_status == '1') ? _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setEditQuote
    }
  }, [_vm._v("Edit Quote")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fld-lft-adjust"
  }, [(_vm.quotePanel) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('form', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(39), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.details),
      expression: "quote.details"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(40), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.materials),
      expression: "quote.materials"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.materials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.materials = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(41), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.labour_cost),
      expression: "quote.labour_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.labour_cost)
    },
    on: {
      "change": function($event) {
        _vm.totalAfterServiceCharge = (_vm.quote.labour_cost - (_vm.quote.labour_cost * _vm.serviceCharge))
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.labour_cost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Your Pay Out: ₦" + _vm._s(_vm.totalAfterServiceCharge) + " , (@" + _vm._s(_vm.serviceChargeInPercentage) + "% Service Charge)")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(42), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.duration),
      expression: "quote.duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.duration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setQuote(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Submit Quote")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fld-lft-adjust"
  }, [(_vm.viewComplaints) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                Complaints on the Job \r\n                                                "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), (_vm.contract.contract_contract_complaints && _vm.contract.contract_contract_complaints.length != 0) ? _c('div', _vm._l((_vm.contract.contract_contract_complaints), function(complaint, index) {
    return _c('div', [_c('p', [_vm._v(" " + _vm._s(++index) + ") " + _vm._s(complaint.contract_complaint) + " \r\n                                                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(complaint.contract_complaint_date) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), (complaint.contract_complaint_status == 15) ? _c('span', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v("RESOLVED")]) : _vm._e()])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No Complaints made yet")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content fld-lft-adjust"
  }, [(_vm.contractsPanel) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                    Contract Requests \r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), (_vm.cnpro.cnpro_contracts && _vm.cnpro.cnpro_contracts.length == 0) ? _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Contracts Request Yet")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getCnpro(_vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Back to Profile")])]) : _c('div', _vm._l((_vm.cnpro.cnpro_contracts), function(co, index) {
    return _c('div', [_c('div', {
      staticClass: "background-white p20 mb30"
    }, [_c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setContractThreadPanel(co, co.contract_contract_threads)
        }
      }
    }, [_c('h4', [_vm._v(_vm._s(++index) + ".   "), _c('i', {
      staticClass: "fa fa-file",
      staticStyle: {
        "padding": "0.1em",
        "font-size": "1.2em"
      }
    }), _vm._v(_vm._s(co.contract_ref))]), _vm._v(" "), _c('p', {
      staticClass: "pull-left"
    }, [_vm._v(" " + _vm._s(co.contract_contractor) + " - " + _vm._s(co.contract_request) + " - "), _c('span', {
      staticClass: "status-flag",
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        background: co.contract_status_color_code,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(co.contract_status))]), _vm._v(" "), (co.contract_status_id == 12) ? _c('span', [_vm._v(" - " + _vm._s(co.contract_job_status))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "pull-left status-flag",
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        background: co.contract_complaint_status_color_code,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(co.contract_complaint_status_name))])])])])])])
  }))]) : _vm._e()])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-md-offset-3",
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.noCnproSet) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_vm._m(44), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('add', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a CNpro Account")])]), _vm._v(" "), _c('p')])]) : _c('div', {
    staticClass: "content col-md-12 col-sm-12 col-xs-12"
  }, [_vm._l((_vm.cnpros), function(cp, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-12 col-xs-12",
      staticStyle: {
        "padding": "1em",
        "border-bottom": "solid 1px rgb(230, 225, 225)"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCnpro(cp.cnpro_id)
        }
      }
    }, [_c('div', {
      staticClass: "col-md-2 col-lg-2 col-xs-2 col-sm-2 fld-cir-img"
    }, [_c('img', {
      staticStyle: {
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.img_url + cp.cnpro_image,
        "width": "100",
        "height": "100"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10 col-lg-10 col-xs-10 col-sm-10 fld-img-lft"
    }, [_c('h2', {
      staticStyle: {
        "padding": "0.5em"
      }
    }, [_vm._v(_vm._s(cp.cnpro_name))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.cnpros.length < 2) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('add', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a CNpro Account")]) : _vm._e()])], 2)])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "contract_pictures",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(46), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "506px",
      "max-height": "268px"
    },
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_1
    }
  }), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.workPicturesUpload($event, _vm.contract.contract_id, 'contract_work_image_1')
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(47), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "506px",
      "max-height": "268px"
    },
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_2
    }
  }), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.workPicturesUpload($event, _vm.contract.contract_id, 'contract_work_image_2')
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(48), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "506px",
      "max-height": "268px"
    },
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_3
    }
  }), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.workPicturesUpload($event, _vm.contract.contract_id, 'contract_work_image_3')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(49)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _c('img', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "loader",
      "src": __webpack_require__(215),
      "height": "15px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Sub Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe your Service"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Phone"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "page-title",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_vm._v("\r\n                                                                Profile Image And Identity Card\r\n                                                                "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Sub Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe your Service"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Phone"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(" You have requested to remove this CNpro Account,\r\n                                                    This account would be checked for any pending or unresovled Information,\r\n                                                    the process would take a minimum of 48hrs.\r\n                                                    "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Notice: ")]), _vm._v("You have some pending complaints on this job")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Proposed Job Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("List Of Materials "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Labour Cost "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Work Duration (in days)"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Proposed Job Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("List of Materials"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Labour Cost "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Work Duration (in days)"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My CNpro Accounts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not added any CNpro account "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Upload/View Work Pictures "), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(" Maximum of 3 Images")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 1 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 2 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 3 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget",
    attrs: {
      "id": "topp02"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 fld"
  }, [(_vm.component_view.paymentDetails) ? _c('div', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm', '', '')
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.payment_details_data).length !== 0)) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "3em"
    }
  }, [_c('h4', [_vm._v("Payment Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h6', [_c('b', [_vm._v("Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.payment_details_data.customerName) + "\r\n                                        ")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "line-height": "1.8"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), (_vm.payment_details_data.cninsurance_form_policy_amount_with_discount > 0) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('del', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" \r\n                                                    "), _c('span', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount_with_discount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("(" + _vm._s(_vm.payment_details_data.cninsurance_form_policy_discount) + "% off)")])]) : _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_commission))])]), _vm._v(" "), (Number(_vm.payment_details_data.cninsurance_form_policy_stamp_duty) > 0) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_stamp_duty))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦ ")]), _vm._v(_vm._s(_vm.payment_details_data.total_amount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentModeModal(_vm.payment_details_data)
      }
    }
  }, [_vm._v("Proceed")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Back to Form")])]) : _vm._e(), _vm._v(" "), (_vm.component_view.previewForm) ? _c('div', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('fillForm', '', '')
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.cninsurance).length !== 0)) ? _c('div', [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("First Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_first_name) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Last Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_last_name) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Date Of Birth")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_dob) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Gender")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_gender) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Email Address")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_email) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Phone Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_phone) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Address")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_address) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Registration Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_reg_no) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.cninsurance.cninsurance_form_vehicle_class) ? _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Class")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_class.cninsurance_form_variable_name) + "\r\n                                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Number Plate")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_number_plate) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Make (Manufacturer)")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_make) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Model")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_model) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Chassis Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_chassis_number) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Engine Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_engine_number) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Year of Manufacture")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_year_of_manufacture) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Year of Purchase")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_year_of_purchase) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Policy Holder Type")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_policyholder_type.cninsurance_form_variable_name) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Company / Organisation Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_company_name) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitCNInsuranceForm
    }
  }, [_vm._v("Submit")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('fillForm')
      }
    }
  }, [_vm._v("Back to Form")])]) : _vm._e(), _vm._v(" "), (_vm.component_view.fillForm) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "background-white xp20 mb30"
  }, [_c('h4', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.cninsurance_listing.cninsurance_name) + " Form")]), _vm._v(" "), _c('div', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-md-6 wn-pd0"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_first_name),
      expression: "cninsurance.cninsurance_form_first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your First Name"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_last_name),
      expression: "cninsurance.cninsurance_form_last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Last Name"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_dob),
      expression: "cninsurance.cninsurance_form_dob"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Enter Date of Birth"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_dob = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_gender),
      expression: "cninsurance.cninsurance_form_gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _c('option', [_vm._v("Male")]), _vm._v(" "), _c('option', [_vm._v("Female")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_email),
      expression: "cninsurance.cninsurance_form_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Email Address"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_phone),
      expression: "cninsurance.cninsurance_form_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter Phone Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_address),
      expression: "cninsurance.cninsurance_form_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Address"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_reg_no),
      expression: "cninsurance.cninsurance_form_vehicle_reg_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Registration Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_reg_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_reg_no = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(13), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_class),
      expression: "cninsurance.cninsurance_form_vehicle_class"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_vehicle_class = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.form_vechicle_classes), function(vechicle_class) {
    return _c('option', {
      domProps: {
        "value": vechicle_class
      }
    }, [_vm._v(_vm._s(vechicle_class.cninsurance_form_variable_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_number_plate),
      expression: "cninsurance.cninsurance_form_vehicle_number_plate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Number Plate"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_number_plate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_number_plate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(15), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_make),
      expression: "cninsurance.cninsurance_form_vehicle_make"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_vehicle_make = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getVechicleManufacturerModels(_vm.cninsurance.cninsurance_form_vehicle_make)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.car_manufacturers), function(vechicle_make) {
    return _c('option', {
      domProps: {
        "value": vechicle_make
      }
    }, [_vm._v(_vm._s(vechicle_make))])
  })], 2)]), _vm._v(" "), ((_vm.cninsurance.cninsurance_form_vehicle_model != '')) ? _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(16), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_model),
      expression: "cninsurance.cninsurance_form_vehicle_model"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_vehicle_model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.car_models), function(vechicle_model) {
    return _c('option', {
      domProps: {
        "value": vechicle_model
      }
    }, [_vm._v(_vm._s(vechicle_model))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_chassis_number),
      expression: "cninsurance.cninsurance_form_vehicle_chassis_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Chassis Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_chassis_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_chassis_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_engine_number),
      expression: "cninsurance.cninsurance_form_vehicle_engine_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Engine Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_engine_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_engine_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_year_of_manufacture),
      expression: "cninsurance.cninsurance_form_year_of_manufacture"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1900",
      "max": "2099",
      "step": "1",
      "placeholder": "Enter the Year of Manufacture"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_year_of_manufacture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_year_of_manufacture = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_year_of_purchase),
      expression: "cninsurance.cninsurance_form_year_of_purchase"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1900",
      "max": "2099",
      "step": "1",
      "placeholder": "Enter the Year of Purchase"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_year_of_purchase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_year_of_purchase = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(21), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_policyholder_type),
      expression: "cninsurance.cninsurance_form_policyholder_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_policyholder_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.form_policyholder_types), function(policyholder_type) {
    return _c('option', {
      domProps: {
        "value": policyholder_type
      }
    }, [_vm._v(_vm._s(policyholder_type.cninsurance_form_variable_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_c('label', [_vm._v("Company / Organisation Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_company_name),
      expression: "cninsurance.cninsurance_form_company_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Company / Organisation Name"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_company_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_company_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-5 col-xs-12 wn-pd0"
  }, [_c('label', [_vm._v("Discount Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_discount_code),
      expression: "cninsurance.cninsurance_discount_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Discount Code, if you have"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_discount_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_discount_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 col-xs-12 wn-pd0"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms_cn_agree),
      expression: "terms_cn_agree"
    }],
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "-2em",
      "float": "left"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms_cn_agree) ? _vm._i(_vm.terms_cn_agree, null) > -1 : (_vm.terms_cn_agree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms_cn_agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms_cn_agree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms_cn_agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms_cn_agree = $$c
        }
      }
    }
  }), _vm._m(22)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(this.$route.params.ref == 'resolve') ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.wn_catch()))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), (((_vm.cninsurance.cninsurance_form_order_ref) && (_vm.cninsurance.cninsurance_form_order_ref != ''))) ? _c('div', {
    staticClass: "center"
  }, [(_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Preview and Submit")]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.cninsurance).length !== 0)) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Preview")]) : _vm._e()]) : _c('div', {
    staticClass: "center"
  }, [(_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Preview and Submit")]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), _c('cnpayment-modal', {
    attrs: {
      "payment_data": _vm.set_payment_data,
      "payment_object": _vm.set_payment_object
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Policy Cost:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Processing Fee: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Above Threshold Limit Charge (ATLC):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total Amount: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("First Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Last Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Date Of Birth"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Gender"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Phone Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Registration Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Class"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Number Plate"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Make (Manufacturer) "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Model"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Chassis Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Engine Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Year of Manufacture"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Year of Purchase"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Policy Holder Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": "-2em",
      "float": "left"
    }
  }, [_vm._v("Please accept "), _c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms")])])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-lg-4"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Forum")]), _vm._v(" "), _c('div', _vm._l((_vm.forums), function(forum, index) {
    return _c('ul', {
      staticClass: "list-group"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 6),
        expression: "(index) < 6"
      }],
      attrs: {
        "href": 'forum?topic=' + forum.forum_topic_url
      }
    }, [_c('li', {
      staticClass: "list-group-item"
    }, [(forum.forum_comments.length) ? _c('span', {
      staticClass: "badge",
      staticStyle: {
        "background-color": "#22baae"
      }
    }, [_vm._v(_vm._s(forum.forum_comments.length))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#333"
      }
    }, [_vm._v(_vm._s(forum.forum_topic))])])])])
  }))]), _vm._v(" "), (_vm.pageNotSurvey) ? _c('div', {
    staticClass: "widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Live Poll")]), _vm._v(" "), _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 1),
        expression: "(index) < 1"
      }],
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_c('a', {
      attrs: {
        "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
      }
    }, [_vm._v(_vm._s(survey.cnsurvey_title))])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }]
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _c('a', {
        attrs: {
          "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
        }
      }, _vm._l((svq.cnsurveys_option), function(opt) {
        return _c('div', {
          staticClass: "options"
        }, [_c('div', [_c('div', {
          staticClass: "radio"
        }, [_c('input', {
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      })), _vm._v(" "), _c('span', {
        staticClass: "pull-left"
      }, [_c('ul', {
        staticClass: "social-links nav nav-pills"
      }, [_c('li', [_c('a', {
        attrs: {
          "href": 'https://twitter.com/share?url=' + _vm.siteUrl + survey.cnsurvey_title_url + '&text=' + survey.cnsurvey_title + '&hashtags=cityneeds,cnsurveys',
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-twitter"
      })])]), _vm._v(" "), _c('li', [_c('a', {
        attrs: {
          "href": 'http://www.facebook.com/sharer.php?u=' + _vm.siteUrl + survey.cnsurvey_title_url,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-facebook"
      })])]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "linky",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.copyLink(survey)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-link"
      }), _vm._v("Copy Link")])])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])])
    }))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "widget hidden-xs"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Search Listings")]), _vm._v(" "), _c('div', {
    staticClass: "detail-enquire-form background-white p20"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these areas suites best")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these areas suites best")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\r\n                                            ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (_vm.show_done) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "https://prep.cityneeds.ng/pricing"
    }
  }, [_vm._v("Go Back")])]) : _c('div', {
    staticClass: "container"
  }, [(_vm.amount_topay > 0) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.amount_topay))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance > _vm.amount_topay) ? _c('div', [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _vm._e()]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process Payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h1', [_vm._v("CNpro Plans & Pricing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Make Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [_c('p', [_c('b', [_vm._v("WHY YOU HAVE TO SUBSCRIBE BEFORE YOU CAN CONTACT CNpros:")])]), _vm._v(" "), _c('p', [_vm._v("Finding diligent workers is HARD. Ensuring that workers keep transactions within the loop is EVEN HARDER. "), _c('br'), _vm._v("\r\n                             Subscription fees guarantees that insurance is in place, and keeps conflict mediation mechanism active.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  })])])])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "col-sm-4 col-md-offset-4 wallet-background p20 mb30"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_vm._v("Available Balance")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#f2f2f2"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.wallet_transactions.length != 0) ? _c('div', {
    attrs: {
      "id": "wallet-transactions"
    }
  }, [_c('div', {
    staticClass: " p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20 col-md-8 col-md-offset-2",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have any CNpay Transactions yet")])])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "12em"
    },
    attrs: {
      "id": "topup",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#topup')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.wallet_payment_message != '') ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.wallet_payment_message))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("..reloading wallet")])]) : _c('div', [(_vm.wallet_payment_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.wallet_payment_error_message))]) : _vm._e(), _vm._v(" "), (_vm.wallet_payment_calculated) ? _c('div', [_c('h5', [_vm._v("Amount: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt)))]), _vm._v(" "), _c('h5', [_vm._v("Processing Fee: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.processing_fee)))]), _vm._v(" "), _c('h6', [_vm._v("Total: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt + _vm.wallet_transaction.processing_fee)))]), _vm._v(" "), (_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._v("Proceed")])]) : _c('div', [_c('h4', [_vm._v("How much would you like to top-up with?")]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "font-size": "13px",
      "border": "thin #22baae 1px",
      "text-align": "left",
      "border-radius": "2px",
      "background": "rgba(238, 229, 106, 0.473)",
      "line-height": "1.8"
    }
  }, [_vm._v("\r\n                            CNpay is a Closed Wallet. Top-up into CNpay CANNOT BE TRANSFERRED NOR WITHDRAWN AS CASH; funds in CNpay can only be spent within Cityneeds' platform for the purchase of Cityneeds' products and services.\r\n                        ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "11px"
    }
  }, [_vm._v("Top-up from ₦" + _vm._s(_vm.min_wallet_topup_amount) + " to ₦" + _vm._s(_vm.max_wallet_topup_amount))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wallet_transaction.topay_amt),
      expression: "wallet_transaction.topay_amt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": "Enter Amount"
    },
    domProps: {
      "value": (_vm.wallet_transaction.topay_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wallet_transaction.topay_amt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prepareWalletPayment
    }
  }, [_vm._v("Enter")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewWalletTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewWalletTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('h5', [_vm._v("Transaction Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
    staticStyle: {
      "padding": "5px",
      "color": "#ffffff"
    },
    style: ({
      backgroundColor: _vm.wallet_transaction.wallet_transaction_type_color
    })
  }, [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_current_balance)))]), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_ref != '') ? _c('div', [(_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_name))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_transaction_token != '') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_token))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Service REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_ref))])]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_action_by_admin == 1) ? _c('div', [_vm._m(6), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_action_by_admin_descr))])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Rewards")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-5 col-sm-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    staticStyle: {
      "margin-top": "-1em",
      "cursor": "pointer",
      "background": "#e7c619",
      "color": "#ffffff"
    },
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#topup"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Top-up CNpay Wallet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Current Balance(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Topup By Admin: ")]), _vm._v("Yes")])
}]}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-lg-3"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "user-photo"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.img_url + _vm.user.user_image,
      "alt": "User Photo"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "user-photo-action"
  }, [_vm._v("Click here to reupload\r\n                                                        "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.user.user_id)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "widget"
  }, [_c('ul', {
    staticClass: "menu-advanced"
  }, [_c('li', {
    class: {
      active: _vm.isActive('edit-profile')
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-profile', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Edit Profile")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('set-password')
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-password', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Password")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Logout")])])])]), _vm._v(" "), (_vm.user.user_premuim_plan_id == 1) ? _c('div', {
    staticClass: "widget"
  }, [_c('h4', [_vm._v(" Your Current Plan")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.user.user_premuim_plan))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "href": "pricing"
    },
    on: {
      "click": _vm.moveToPlans
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Upgrade to premuim")])]) : _c('div', {
    staticClass: "widget"
  }, [_c('h4', [_vm._v(" Your Current Plan")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.user.user_premuim_plan))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.user_premuim_plan_reg_date) + " - "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.user.user_premuim_plan_expiry_date))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-lg-9"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (_vm.setPanel == 'set-password') ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.errorFlag))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Enter Current Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_current_password),
      expression: "user.user_current_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.user_current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_current_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Enter New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_new_password),
      expression: "user.user_new_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.user_new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_new_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Change")])])]) : _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_fullname),
      expression: "user.user_fullname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_fullname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Gender")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_gender),
      expression: "user.user_gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.user_gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.user.user_gender
    }
  }, [_vm._v(_vm._s(_vm.user.user_gender))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Male"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Age")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_age),
      expression: "user.user_age"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "7",
      "max": "100"
    },
    domProps: {
      "value": (_vm.user.user_age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_age = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_address),
      expression: "user.user_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_state),
      expression: "user.user_state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.user_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.user.user_state)
      }]
    }
  }, _vm._l((_vm.states), function(st) {
    return _c('option', {
      domProps: {
        "value": st.state_id
      }
    }, [_vm._v(_vm._s(st.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_city),
      expression: "user.user_city"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.user_city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProfile
    }
  }, [_vm._v("Save")])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Edit Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                    Reset Password\r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary btn-xs pull-right",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Save")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                    Contact Information\r\n\r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary btn-xs pull-right",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Save")])])
}]}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main",
    attrs: {
      "id": "topp04"
    }
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [((Object.keys(_vm.cndiscount).length > 0)) ? _c('button', {
    staticClass: "btn btn-primary btn-xm",
    staticStyle: {
      "color": "#ffffff",
      "border-radius": "3px",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cndiscount = {}
      }
    }
  }, [_vm._v("View DiscountBazaar")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-xm",
    staticStyle: {
      "background-color": "#e7c619",
      "color": "#000000",
      "border-radius": "3px",
      "margin-bottom": "1em"
    },
    attrs: {
      "href": "/cndiscountsetup",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cndiscount = {}
      }
    }
  }, [_vm._v("Set up DiscountBazaar")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', [_c('form', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.category),
      expression: "search.category"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Types"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Search DiscountBazaar from these Business Types")]), _vm._v(" "), _vm._l((_vm.cndiscounts_business_categories), function(cc) {
    return _c('option', {
      key: cc.cndiscounts_business_category_id,
      domProps: {
        "value": cc
      }
    }, [_vm._v(_vm._s(cc.cndiscounts_business_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.location),
      expression: "search.location"
    }],
    staticClass: "search-select form-control",
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "title": "Location"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Pick a location")]), _vm._v(" "), _vm._l((_vm.cndiscounts_business_locations), function(cc) {
    return _c('option', {
      key: cc,
      domProps: {
        "value": cc
      }
    }, [_vm._v(_vm._s(cc))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.search_result))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.search_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.search_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "none !important"
    }
  }, [((Object.keys(_vm.cndiscounts).length == 0)) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v("No discounts ongoing now, be sure to check back soon.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cndiscounts), function(cnd, cndex) {
    return _c('div', {
      staticClass: "col-sm-12 col-lg-3"
    }, [_c('div', {
      staticClass: "card-row",
      staticStyle: {
        "padding": "0",
        "margin-bottom": "1.6em",
        "border": "#f8f7f7 solid",
        "background-color": "#ffffff !important",
        "min-height": "460px !important",
        "max-height": "460px !important",
        "clear": "both"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setNavii('/discountbazaar-' + cnd.cndiscount_ref)
        }
      }
    }, [_c('div', {
      staticClass: "card-row-inner"
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('div', {
      staticStyle: {
        "min-height": "250px",
        "max-height": "250px",
        "width": "100%",
        "background-size": "cover"
      },
      style: ({
        backgroundImage: 'url(' + _vm.set_cndiscount_image(cnd) + ')'
      })
    }), _vm._v(" "), (cnd.cndiscount_percentage_discount > 0) ? _c('div', {
      staticStyle: {
        "position": "absolute",
        "margin-left": "13vw",
        "margin-top": "-35vh"
      }
    }, [_c('p', {
      staticStyle: {
        "padding": "0.8em 0.4em",
        "border-radius": "50%",
        "width": "55px",
        "background-color": "#ff0000",
        "color": "#ffffff",
        "font-size": "14px",
        "font-weight": "bolder"
      }
    }, [_vm._v("-" + _vm._s(cnd.cndiscount_percentage_discount) + "%")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-12",
      staticStyle: {
        "text-align": "center",
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "card-row-content",
      staticStyle: {
        "text-align": "center !important"
      }
    }, [_c('p', {
      staticClass: "wn-caption"
    }, [_vm._v(_vm._s(cnd.cndiscount_caption))]), _vm._v(" "), _c('h6', {
      staticClass: "card-row-title",
      staticStyle: {
        "text-align": "center",
        "margin-top": "3px",
        "font-size": "12px",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(cnd.cndiscount_business_name))]), _vm._v(" "), _c('p', [(cnd.cndiscount_discount_price > 0) ? _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(cnd.cndiscount_discount_price)))]) : _vm._e(), _vm._v(" "), (cnd.cndiscount_normal_price > 0) ? _c('span', [_c('del', [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(cnd.cndiscount_normal_price)))])]) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "countdown"
    }, [_c('li', [_vm._v(_vm._s(cnd.cndiscount_countdown_days)), _c('br'), _vm._v("days")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(cnd.cndiscount_countdown_hours)), _c('br'), _vm._v("hours")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(cnd.cndiscount_countdown_minutes)), _c('br'), _vm._v("mins")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(cnd.cndiscount_countdown_seconds)), _c('br'), _vm._v("sec")])])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.page_set.length > 1) ? _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.page_set), function(page) {
    return _c('li', {
      class: {
        active: _vm.isActive(page)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCNdiscounts(page.page_no, page.page_offset, page.page_limit)
        }
      }
    }, [_vm._v(_vm._s(page.page_no))])])
  }))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('horizontal-widget')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_c('b', [_vm._v("Find Hot")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#22baae",
      "font-style": "italic"
    }
  }, [_c('b', [_vm._v("DiscountBazaar Codes and Promos")])])])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header header-transparent"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "src": "/static/assets/img/logo.png",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-bottom"
  }, [_c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/forums"
    }
  }, [_vm._v("Join Forum")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find CNpros")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/discountbazaar"
    }
  }, [_vm._v("DiscountBazaar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/insuremoto"
    }
  }, [_vm._v("InsureMoto")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnsurveys"
    }
  }, [_vm._v("Take CNsurveys")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/businesses"
    }
  }, [_vm._v("Find Businesses")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/how-it-works"
    }
  }, [_vm._v("How CNpro Works")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v("CNpro Plans & Pricing")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.user != null || _vm.user != undefined) ? [_c('li', [(_vm.user != '') ? _c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Hello, " + _vm._s(_vm.user) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("My Account")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Logout")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help-me-find-a-cnpro"
    }
  }, [_vm._v("Help Me Find A CNpro")])], 1)] : _vm._e(), _vm._v(" "), _c('li', [(_vm.user == '') ? _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In / Sign Up")]) : _vm._e()], 1)], 2), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('prompts')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "col-md-4 widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Forums")]), _vm._v(" "), _c('div', _vm._l((_vm.forums), function(forum, index) {
    return _c('ul', {
      key: index,
      staticClass: "list-group"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 6),
        expression: "(index) < 6"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setForum(forum.forum_id)
        }
      }
    }, [_c('li', {
      staticClass: "list-group-item"
    }, [_c('span', {
      staticClass: "badge",
      staticStyle: {
        "background-color": "#22baae"
      }
    }, [_vm._v(_vm._s(forum.forum_comments.length))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#333"
      }
    }, [_vm._v(_vm._s(forum.forum_topic))])])])])
  }))]), _vm._v(" "), (_vm.pageNotSurvey) ? _c('div', {
    staticClass: "col-md-4 widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Live Poll")]), _vm._v(" "), _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": "/cnsurveys"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 1),
        expression: "(index) < 1"
      }],
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_vm._v(_vm._s(survey.cnsurvey_title))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }],
        key: index2
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt, index22) {
        return _c('div', {
          key: index22,
          staticClass: "options"
        }, [_c('div', [_c('div', {
          staticClass: "radio"
        }, [_c('input', {
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-default pull-right",
        on: {
          "click": function($event) {
            _vm.next(index, index2)
          }
        }
      }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])], 2)
    }))])])], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 widget hidden-xs"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Search Listings")]), _vm._v(" "), _c('div', {
    staticClass: "detail-enquire-form background-white p20"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      key: cc.cnpro_parent_category_id,
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.cnpro_category_name,
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.business_category_name,
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n                                         ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {}, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Plumbing'
    }
  }, [_vm._v("Plumbing")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Roofing'
    }
  }, [_vm._v("Roofing")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Tiling'
    }
  }, [_vm._v("Tiling")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Airconditioner'
    }
  }, [_vm._v("Airconditioning")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Food Beverage'
    }
  }, [_vm._v("Food & Beverage")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Hotels'
    }
  }, [_vm._v("Hotels")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Home Services'
    }
  }, [_vm._v("Home Services")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Event Planning'
    }
  }, [_vm._v("Event Planning")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-bottom-left"
  }, [_vm._v("\r\n                    © " + _vm._s(_vm.this_year) + " All rights reserved. cityneeds.\r\n                ")]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "cnpros"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("CNpro CATEGORIES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "businesses"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("BUSINESS CATEGORIES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": "about"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("ABOUT")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "about"
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "how-it-works"
    }
  }, [_vm._v("How CNpro Works")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "pricing"
    }
  }, [_vm._v("CNpro Plans & Pricing")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "insuremoto"
    }
  }, [_vm._v("InsureMoto")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "discountbazaar"
    }
  }, [_vm._v("DiscountBazaar")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "terms"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "policy"
    }
  }, [_vm._v("Privacy & Policy")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": "forums"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("COMMUNITY")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "forums"
    }
  }, [_vm._v("Forum")]), _vm._v("   "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "https://www.blog.cityneeds.ng",
      "target": "_blank"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/cityneedsng"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://web.facebook.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": " https://www.instagram.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://linkedin.com/in/cityneeds-technologies-00b090138"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("    08032258453")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("   Visit Us:"), _c('br'), _vm._v("\r\n                                    P53A, Emirate Lane, Sunnyvale Estate,\r\n                                    Abuja, Nigeria.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom-right"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "about"
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "terms"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "policy"
    }
  }, [_vm._v("Privacy & Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("08032258453")])])])])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "-6em"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mt-200"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "hero-image-inner",
    staticStyle: {
      "background-image": "none"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "home-form-wrapper",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "home-form-inner col-sm-12 col-md-6 col-md-offset-2"
  }, [_c('form', [_c('h4', {
    staticStyle: {
      "color": "#000000",
      "line-height": "1.4"
    }
  }, [_vm._v("Search for Pre-verified Cityneeds Professional Workers (CNpros), or Listed Businesses")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "columns": "#000000"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("This service is only available in Abuja for now")])])])])])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row background-brand-blue",
    staticStyle: {
      "margin": "1em 5px"
    }
  }, [_c('div', {}, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "boxable-cta-right col-md-5 col-sm-12 col-xs-12 pull-right",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "102%"
    }
  }, _vm._l((_vm.cnsurveys), function(survey, index) {
    return _c('div', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": "/cnsurveys"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 1),
        expression: "(index) < 1"
      }],
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_vm._v(_vm._s(survey.cnsurvey_title))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }],
        key: index2
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt, index22) {
        return _c('div', {
          key: index22,
          staticClass: "options"
        }, [_c('div', [_c('div', {
          staticClass: "radio",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('input', {
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-default pull-right"
      }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])], 2)
    }))])])], 1)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "block fullwidth",
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "row regular-section"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12 regular-boxes"
  }, [_c('div', {
    staticClass: "regular-boxes-cta"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Get instant help on any of our services")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000",
      "margin-top": "3em"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Call our Hotline")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "block background-black-light",
    staticStyle: {
      "min-height": "14em",
      "margin-top": "5em",
      "padding-bottom": "2em"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "#fff",
      "margin-top": "-5px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Keep up with updates on all our services")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2 "
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.process_message))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline",
      "white-space": "nowrap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription.email),
      expression: "subscription.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Enter your Email"
    },
    domProps: {
      "value": (_vm.subscription.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subscription.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.subscribe
    }
  }, [_vm._v("Subscribe")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _vm._m(9)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/home-banner-new.jpg')"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "0em",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carousel-home-slider",
      "data-ride": "carousel"
    }
  }, [_c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "item active home-slide"
  }, [_c('div', {
    staticClass: "mobi-off home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/home-banner-cn.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobi-on home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/home-banner-cn-mobile.png')"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item home-slide"
  }, [_c('div', {
    staticClass: "mobi-off home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/insure-moto-slide.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobi-on home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/insure-moto-slide-mobile.png')"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item home-slide"
  }, [_c('div', {
    staticClass: "mobi-off home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/discount-bazaar-slide.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobi-on home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/discount-bazaar-slide-mobile.png')"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-banner-bubble",
    staticStyle: {
      "z-index": "9",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "container intro-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 col-xs-12"
  }, [_c('h1', {
    staticClass: "intro-big"
  }, [_vm._v("\"Earning May Be Stressful, Getting A Great Service Shouldn't Be\" ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("What need would you like us to help you meet? Click below menus to explore Cityneeds.")])]), _vm._v(" "), _c('div', {
    staticClass: "fine-box-list"
  }, [_c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you want to Pay a "), _c('span', {
    staticClass: "catchy-wrap catchy-y"
  }, [_vm._v("Bill")]), _vm._v("? ")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("PAY\r\n                                            DSTV, REMITA, AIRTIME, ELECTRICITY...\r\n                                        ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/discountbazaar"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you want to attract shoppers and boost "), _c('span', {
    staticClass: "catchy-wrap catchy-y"
  }, [_vm._v("sales")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("SETUP DiscountBazaar")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/discountbazaar"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v(" Do you want to save money while "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("shopping")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v("SEARCH DiscountBazaar")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/insuremoto-cornerstoneinsurance"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you want to "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("buy or renew your")]), _vm._v(" vehicle insurance?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("Buy InsureMoto ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.houseaggregator.com",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v("Do you want to "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("share, sell, buy, or rent ")]), _vm._v("a property?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v(" Visit Houseaggregator ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "cnpros"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v("Do you need a skilled "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("worker/artisan")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v("FIND TILER, MASON, ELECTRICIAN... ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "businesses"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you need a Business "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("Directory")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("FIND DENTIST, LAWYER,  BAKER... ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "business-listings"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v("Do you "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("own")]), _vm._v(" a business and want to widen your reach?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v("LIST IT ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "cnpro-accounts"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v(" Do you have a "), _c('span', {
    staticClass: "catchy-wrap catchy-y"
  }, [_vm._v("skill")]), _vm._v(" and want to work?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("LIST IT (subject to approval ) ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxable-cta-left col-md-7 pull-left hidden-sm hidden-xs",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1.5em",
      "text-align": "left",
      "color": "#ffffff",
      "line-height": "1.8",
      "font-size": "16px"
    }
  }, [_c('p', [_vm._v("CNsurveys is all about inclusive ideas that fosters growth and development.")]), _vm._v(" "), _c('p', [_vm._v("The more Nigerians are able to participate in the creation of products, and polices that are designed for them, the greater the utilitarian value derived.")]), _vm._v(" "), _c('p', [_vm._v("CNsurveys enables business owners, and policy makers bounce off ideas on their target audience, use the feedback received as an affirmation of their concept, or a call to rejig, as the case maybe, thereby creating products, and policies that meet the aspiration of the people.")]), _vm._v(" "), _c('p', [_vm._v("We enjoin you to be steadfast in your contribution to the growth and development of Naija, as we look forward to your honest answers on our daily CNsurveys.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "color": "#fff",
      "margin-top": "-5px",
      "font-size": "18px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Take "), _c('span', {
    staticStyle: {
      "color": "#f8d732",
      "font-weight": "bold"
    }
  }, [_vm._v("CNsurveys")]), _vm._v(" - what Naija thinks")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-xs-12 regular-boxes"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#000",
      "margin-bottom": "-4px"
    }
  }, [_vm._v("New or Old in Town?")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "bold"
    }
  }, [_vm._v("We've got you covered")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Search for your proposed job category."), _c('br'), _vm._v("Choose from a pool of listed Service Professionals (CNpros) that match the job\r\n                                    ")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/new-in-city.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "cta_call"
  }, [_c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "color": "#ff0000"
    }
  }), _vm._v(" 080-3225-8453 ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a_cta",
    staticStyle: {
      "padding-top": "1em",
      "margin-top": "2em"
    }
  }, [_c('a', {
    staticClass: "btn a_mail a_mail_lg",
    attrs: {
      "href": "mailto:interact@cityneeds.ng?Subject=Hello%20cityneeds",
      "target": "_top"
    }
  }, [_vm._v("Send us a Mail at interact@cityneeds.ng")]), _vm._v(" "), _c('a', {
    staticClass: "btn a_mail a_mail_xs",
    attrs: {
      "href": "mailto:interact@cityneeds.ng?Subject=Hello%20cityneeds",
      "target": "_top"
    }
  }, [_vm._v("Send us a Mail at"), _c('br'), _vm._v(" interact@cityneeds.ng")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "prompt",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', {
    staticStyle: {
      "color": "#22baae",
      "font-weight": "bold"
    }
  }, [_vm._v("Transact Quicker- Add Cityneeds to Home screen:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "1.8",
      "color": "#000000"
    }
  }, [_vm._v("While on Cityneeds' webpage, tap the menu button ("), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(") at the top right corner of your browser, the menu list will drop down, tap Add to Home screen. Done!")])])])])])
}]}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12 fld"
  }, [_c('div', {
    staticClass: "content"
  }, [(!_vm.process_request_sent) ? _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("File Claim")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#f52323"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_form),
      expression: "cninsurance_data.cninsurance_form"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter the InsureMoto Form Policy ID"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_form)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_form = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_complaint_title),
      expression: "cninsurance_data.cninsurance_complaint_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Title of Complaint"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_complaint_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_complaint_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_complaint),
      expression: "cninsurance_data.cninsurance_complaint"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Complaint Details"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_complaint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_complaint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding": "1em 5px",
      "border": "#f3c0c0 1px dashed"
    }
  }, [(!_vm.remove_files && (Object.keys(_vm.files_info).length > 0)) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em",
      "background-color": "#d84040",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setRemoveFiles
    }
  }, [_vm._v("Remove files")]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', [_vm._v(" Add Media")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "fileElem",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.setOnFileChange($event, _vm.cninsurance)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "background-color": "#e7c619",
      "color": "#000000"
    },
    attrs: {
      "id": "fileSelect"
    }
  }, [_vm._v("Select some files")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "display": "none",
      "margin-top": "2em"
    },
    attrs: {
      "id": "stackFiles"
    }
  }, [(Object.keys(_vm.files_info).length > 0) ? _c('div', [_vm._l((_vm.files_info), function(file_info, index) {
    return _c('p', [_c('span', {
      attrs: {
        "id": 'filsdaw' + index
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-xs",
      staticStyle: {
        "background-color": "#d84040",
        "font-size": "13px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeFileUpload(file_info)
        }
      }
    }, [_vm._v("Tap to Remove")])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em",
      "background-color": "#d84040",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unsetRemoveFiles
    }
  }, [_vm._v("Cancel Remove")])], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#f52323"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitCNInsuranceForm
    }
  }, [_vm._v("Send Claim")])])]) : _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "color": "#22baae",
      "font-weight": "bolder"
    }
  }, [_vm._v("Your Complaint has been sent.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("OK")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Enter your InsureMoto Form Policy ID"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Claim Title"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Claim"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    attrs: {
      "id": "fileList"
    }
  }, [_c('p', [_vm._v("No files selected!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#d84040"
    }
  }, [_vm._v("Maximum number of Photos allowed: "), _c('b', [_vm._v("10")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "border": "solid #22baae 8px",
      "border-radius": "50%",
      "width": "100px",
      "height": "180px",
      "padding": "5.5em 1em 1em 1em"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "text-align": "center",
      "font-size": "7.2em",
      "color": "#22baae"
    }
  })])])
}]}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [(_vm.panelFlag) ? _c('div', {}, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mt-80 mb80"
  }, [_c('div', {
    staticClass: "detail-banner",
    staticStyle: {
      "background-image": "url(../static/assets/img/business-img.jpg)"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "detail-banner-left"
  }, [_c('div', {
    staticClass: "detail-banner-info"
  }, [_c('div', {
    staticClass: "detail-label"
  }, [_vm._v(_vm._s(_vm.business.business_category_name))]), _vm._v(" "), _c('div', {
    staticClass: "detail-verified"
  }, [_vm._v("Verified")])]), _vm._v(" "), _c('h2', {
    staticClass: "detail-title"
  }, [_vm._v("\r\n                                            " + _vm._s(_vm.business.business_name) + "bbb\r\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-banner-address"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v(" " + _vm._s(_vm.business.business_address) + "\r\n                                        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "detail-banner-btn bookmark btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveComponent(_vm.business)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "Bookmarked"
    }
  }, [_vm._v("Save")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row detail-content"
  }, [_c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "detail-gallery",
    staticStyle: {
      "margin-bottom": "10em"
    }
  }, [_c('div', {
    staticClass: "detail-gallery-preview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "src": _vm.img_url + _vm.business.business_image
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "descr p20"
  }, [_c('h2', [_c('span', {
    staticClass: "text-secondary"
  }, [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.business.business_description))])])]), _vm._v(" "), (_vm.business.business_reviews.length != 0) ? _c('h2', {
    attrs: {
      "id": "reviews"
    }
  }, [_vm._v("All Reviews \r\n                                        "), _c('span', {
    staticClass: "pull-right points",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.business.business_rating_average_rate) + " / " + _vm._s(_vm.business.business_rating_total_rating) + " , ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#reviews"
    }
  }, [_vm._v(_vm._s(_vm.business.business_reviews_total_count) + "  reviews")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reviews"
  }, [_vm._l((_vm.business.business_reviews), function(review) {
    return [_c('div', {
      staticClass: "review"
    }, [_c('div', {
      staticClass: "review-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.img_url + review.review_user_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "review-inner"
    }, [_c('div', {
      staticClass: "review-title"
    }, [_c('h2', [_vm._v(_vm._s(review.review_user))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "review-overall-rating"
    }, [_vm._l((review.review_user_rate), function(rate) {
      return _c('i', {
        staticClass: "fa fa-star"
      })
    }), _vm._l(((5 - review.review_user_rate)), function(rate) {
      return _c('i', {
        staticClass: "fa fa-star-o"
      })
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "review-content-wrapper"
    }, [_c('div', {
      staticClass: "review-content"
    }, [_c('div', {
      staticClass: "review-pros"
    }, [_c('p', [_vm._v(_vm._s(review.review_review) + ".")])])])])])])]
  })], 2), _vm._v(" "), (!_vm.has_reviewed) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Submit a Review")]), _vm._v(" "), _c('form', {
    staticClass: "background-white p20 add-review"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Your Review")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.review),
      expression: "review.review"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.review.review)
    },
    on: {
      "change": _vm.trackevent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.review.review = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.has_rated) ? _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("What's your rating")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitReview
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("Submit Review")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "background-white p20 hidded-sm hidden-xs"
  }, [_c('div', {
    staticClass: "detail-overview-rating"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.business.business_rating_average_rate) + " / " + _vm._s(_vm.business.business_rating_total_rating) + " , ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#reviews"
    }
  }, [_vm._v(_vm._s(_vm.business.business_reviews_total_count) + "  reviews")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "detail-vcard"
  }, [_c('div', {
    staticClass: "detail-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_url + _vm.business.business_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact"
  }, [_c('div', {
    staticClass: "detail-contact-email"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.business.business_email))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-phone"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.business.business_phone))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-website"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.business.business_website))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-address"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v("\r\n                                                    " + _vm._s(_vm.business.business_address) + "\r\n                                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-follow"
  }, [_c('h5', [_vm._v("Follow Us:")]), _vm._v(" "), _c('div', {
    staticClass: "follow-wrapper"
  }, [_c('a', {
    staticClass: "follow-btn facebook",
    attrs: {
      "href": _vm.business.business_facebook
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-btn twitter",
    attrs: {
      "href": _vm.business.business_twitter
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-btn instagram",
    attrs: {
      "href": _vm.business.business_instagram
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Working Hours")]), _vm._v(" "), _c('div', {
    staticClass: "p20 background-white"
  }, [(_vm.business.working_hours) ? _c('div', {
    staticClass: "working-hours"
  }, [_c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Mon")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.mon_open) + " - " + _vm._s(_vm.business.working_hours.mon_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Tue")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.tue_open) + " - " + _vm._s(_vm.business.working_hours.tue_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Wed")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.wed_open) + " - " + _vm._s(_vm.business.working_hours.wed_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Thu")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.thu_open) + " - " + _vm._s(_vm.business.working_hours.thu_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Fri")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.fri_open) + " - " + _vm._s(_vm.business.working_hours.fri_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Sat")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.sat_open) + " - " + _vm._s(_vm.business.working_hours.sat_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Sun")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.sun_open) + " - " + _vm._s(_vm.business.working_hours.sun_close))])])]) : _vm._e()])])])])])])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDiv('vcCNdiscount', 'Find Hot Discount Codes and Promos')
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-lg-8"
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "vcCNdiscount"
    }
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.search_result))]), _vm._v(" in Abuja")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.search_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.search_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cards-row"
  }, [_vm._l((_vm.businesses), function(business) {
    return [_c('div', {
      staticClass: "card-row"
    }, [_c('a', {
      staticStyle: {
        "color": "inherit"
      },
      attrs: {
        "href": 'business?context=' + business.business_url_name
      }
    }, [_c('div', {
      staticClass: "card-row-inner"
    }, [_c('div', {
      staticClass: "card-row-image"
    }, [_c('img', {
      staticClass: "full-image img-responsive",
      attrs: {
        "src": _vm.img_url + business.business_image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-row-label"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent(business)
        }
      }
    }, [_vm._v(_vm._s(business.business_category_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-body"
    }, [_c('h2', {
      staticClass: "card-row-title"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent(business)
        }
      }
    }, [_vm._v(_vm._s(business.business_name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-content"
    }, [_c('p', [_vm._v("\r\n                                                    " + _vm._s(business.business_category_name) + "\r\n                                                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-properties points"
    }, [_c('dl', [_c('dd', [_vm._v("Review(s)")]), _c('dt', [_vm._v(_vm._s(business.business_reviews_total_count))]), _vm._v(" "), _c('dd', [_vm._v("Category")]), _c('dt', [_vm._v(_vm._s(business.business_category_name))]), _vm._v(" "), _c('dd', [_vm._v("Location")]), _c('dt', [_vm._v(_vm._s(business.business_address))]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('dd', [_vm._v("Rating")]), _c('dt', [_vm._v(_vm._s(business.business_rating_average_rate) + " "), _c('i', {
      staticClass: "fa fa-star"
    })])])])])])])])]
  })], 2), _vm._v(" "), (_vm.search_mode) ? _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.businesses.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSearchBusinesses(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))]) : _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.businesses.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getAllBusinesses(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])])]), _vm._v(" "), _c('sidebar')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-banner-rating"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "report"
  }, [_c('span', {
    staticClass: "separator"
  }, [_vm._v("•")]), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "title": "Report",
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', [_vm._v("Required fields are marked "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "text-secondary"
  }, [_vm._v("Reach Us")])])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    key: _vm.cnprosKey,
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.search_result))]), _vm._v(" in Abuja")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.search_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.search_message))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.cnpros), function(cp) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3"
    }, [_c('a', {
      staticStyle: {
        "color": "#000",
        "cursor": "pointer"
      },
      attrs: {
        "href": 'cnpro?context=' + cp.cnpro_url_name
      }
    }, [_c('div', {
      staticStyle: {
        "border": "solid 1px rgb(209, 205, 205)",
        "background": "#fff",
        "min-height": "25em",
        "max-height": "25em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "bg_image",
      style: ({
        'background': 'url(' + _vm.img_cp_url + cp.cnpro_bg_image + ')',
        backgroundSize: _vm.backgroundSize
      })
    }, [_c('div', {}, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-left": "auto",
        "margin-right": "auto",
        "border": "1px solid rgba(255, 255, 255, 0.6)",
        "margin": "0 auto",
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.img_url + cp.cnpro_image,
        "width": "100",
        "height": "100"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-tags"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      }
    }, [_vm._v(_vm._s(cp.cnpro_category))]), _vm._v(" |\r\n                                                          "), _c('span', [_vm._v(_vm._s(cp.cnpro_jobs_done) + " Job(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
      staticStyle: {
        "margin-top": "1em",
        "font-size": "1em"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewCnpro(cp)
        }
      }
    }, [_vm._v(_vm._s(cp.cnpro_name))])]), _vm._v(" "), _c('div', {
      staticClass: "descr"
    }, [_c('p', {
      staticClass: "truncate-words"
    }, [_vm._v(_vm._s(cp.cnpro_description))])]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" " + _vm._s(cp.cnpro_rating_average_rate) + " Point(s)\r\n                                                           " + _vm._s(cp.cnpro_reviews_total_count) + " Review(s)\r\n                                                    ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.cnpros_store.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count, 'cnpros')
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.sortCnpros(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "otherwrap"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.other_cnpros), function(cp) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3"
    }, [_c('a', {
      staticStyle: {
        "color": "#000",
        "cursor": "pointer"
      },
      attrs: {
        "href": 'cnpro?context=' + cp.cnpro_url_name
      }
    }, [_c('div', {
      staticStyle: {
        "border": "solid 1px rgb(209, 205, 205)",
        "background": "#fff",
        "min-height": "25em",
        "max-height": "25em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "bg_image",
      style: ({
        'background': 'url(' + _vm.img_cp_url + cp.cnpro_bg_image + ')',
        backgroundSize: _vm.backgroundSize
      })
    }, [_c('div', {}, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-left": "auto",
        "margin-right": "auto",
        "border": "1px solid rgba(255, 255, 255, 0.6)",
        "margin": "0 auto",
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.img_url + cp.cnpro_image,
        "width": "100",
        "height": "100"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-tags"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      }
    }, [_vm._v(_vm._s(cp.cnpro_category))]), _vm._v(" |\r\n                                                          "), _c('span', [_vm._v(_vm._s(cp.cnpro_jobs_done) + " Job(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
      staticStyle: {
        "margin-top": "1em",
        "font-size": "1em"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewCnpro(cp)
        }
      }
    }, [_vm._v(_vm._s(cp.cnpro_name))])]), _vm._v(" "), _c('div', {
      staticClass: "descr"
    }, [_c('p', {
      staticClass: "truncate-words"
    }, [_vm._v(_vm._s(cp.cnpro_description))])]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" " + _vm._s(cp.cnpro_rating_average_rate) + " Point(s)\r\n                                                           " + _vm._s(cp.cnpro_reviews_total_count) + " Review(s)\r\n                                                    ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.other_cnpros_store.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count, 'othercnpros')
      },
      model: {
        value: (_vm.other_cnpros_current_page),
        callback: function($$v) {
          _vm.other_cnpros_current_page = $$v
        },
        expression: "other_cnpros_current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.sortOtherCnpros(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])], 2)])], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v("Other CNpros ")]), _vm._v(" in Abuja")])])
}]}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 "
  }, [_c('h1', [_vm._v("Trending Surveys")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_c('a', {
      attrs: {
        "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
      }
    }, [_vm._v(_vm._s(survey.cnsurvey_title))])])]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
      }
    }, [_c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }]
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt) {
        return _c('div', {
          staticClass: "options"
        }, [(_vm.check_if_user_has_polled(svq.cnsurveys_answers) || svq.polled) ? _c('div', [_c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))]), _vm._v(" "), _c('p', {
          staticClass: "pull-right",
          staticStyle: {
            "margin-top": "-0.7em"
          }
        }, [_vm._v("  " + _vm._s(_vm.get_option_answer(opt.cnsurvey_option_id, svq.cnsurveys_answers)))]), _vm._v(" "), _c('div', {
          staticClass: "progress",
          staticStyle: {
            "height": "0.2em"
          }
        }, [_c('div', {
          staticClass: "progress-bar progress-bar-info",
          style: ({
            width: _vm.get_option_answer(opt.cnsurvey_option_id, svq.cnsurveys_answers) + '%'
          }),
          attrs: {
            "role": "progressbar",
            "aria-valuenow": "60",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]) : _c('div', [_c('div', {
          staticClass: "radio"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.answer),
            expression: "answer"
          }],
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id,
            "checked": _vm._q(_vm.answer, opt.cnsurvey_option_id)
          },
          on: {
            "__c": function($event) {
              _vm.answer = opt.cnsurvey_option_id
            }
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])], 2)
    }))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.surveys.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSurveys(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])])])], 1)])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('create-thread'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "guest-poll",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-offset-2 modal-content",
    staticStyle: {
      "top": "10em",
      "border-radius": "0px",
      "padding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Thank you for making your opinion count! If you would like to partake in future CNsurveys, \r\n                or create your own CNsurvey, and stand the chance of earning random rewards , register now!\r\n                ")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/register",
      "type": "button"
    }
  }, [_vm._v("Sign Up")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-image": "url('https://cityneeds.ng/cnpro.jpg')",
      "height": "8em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-lg-3"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "widget"
  }, [_c('h3', [_vm._v("Service Providers")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-advanced",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.listings), function(sv, index) {
    return (sv.citisave_category == 'CNpro') ? _c('li', {
      class: {
        active: _vm.isActive(++index)
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      attrs: {
        "href": "",
        "aria-controls": "one",
        "role": "tab",
        "data-toggle": "tab",
        "data-target": "one"
      },
      on: {
        "click": function($event) {
          _vm.getSavedListing(sv.citisave_id)
        }
      }
    }, [_vm._v(_vm._s(sv.citisave_cnpro))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "widget"
  }, [_c('h3', [_vm._v("Business Listings")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-advanced",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.listings), function(sv, index) {
    return (sv.citisave_category == 'Business') ? _c('li', {
      class: {
        active: _vm.isActive(++index)
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      attrs: {
        "href": "",
        "aria-controls": "one",
        "role": "tab",
        "data-toggle": "tab",
        "data-target": "one"
      },
      on: {
        "click": function($event) {
          _vm.getSavedListing(sv.citisave_id)
        }
      }
    }, [_vm._v(_vm._s(sv.citisave_business))])]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-lg-9"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "one"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.listing.citisave_category == 'CNpro') ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                            Service Provider: " + _vm._s(_vm.listing.citisave_cnpro) + "\r\n                                                         ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img_url + _vm.listing.citisave_cnpro_image,
      "width": "150",
      "height": "150"
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("saved on:")]), _vm._v(" " + _vm._s(_vm.listing.citisave_save_date))]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.viewCnpro(_vm.listing.citisave_cnpro_data_item)
      }
    }
  }, [_vm._v("View Service Provider")])])])])]) : _vm._e(), _vm._v(" "), (_vm.listing.citisave_category == 'Business') ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                            Business Listing: " + _vm._s(_vm.listing.citisave_business) + "\r\n                                                        ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img_url + _vm.listing.citisave_business_image,
      "width": "250",
      "height": "150"
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("saved on:")]), _vm._v(" " + _vm._s(_vm.listing.citisave_save_date))]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.viewBusiness(_vm.listing.citisave_business_data_item)
      }
    }
  }, [_vm._v("View Listing")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "two"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "three"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "four"
    }
  }, [_vm._v("...")])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Listing  Details")])])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-sm-5 col-sm-offset-4"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "data-vv-rules": "required|alpha_spaces",
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('name')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')) + " " + _vm._s(_vm.error_here.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('address')
    }
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address),
      expression: "user.address"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "address",
      "data-vv-rules": "required",
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.user.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('address')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('phone')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required|numeric",
      "data-vv-delay": "500",
      "name": "phone",
      "type": "number",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('phone')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.error_here.phone))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required|email",
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.error_here.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required",
      "data-vv-delay": "500",
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [(_vm.password_error_match != ' ') ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.password_error_match))]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.cpassword),
      expression: "user.cpassword"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required|confirmed:password",
      "data-vv-delay": "1500",
      "name": "password_confirmation",
      "type": "password",
      "placeholder": "Password, Again",
      "data-vv-as": "password"
    },
    domProps: {
      "value": (_vm.user.cpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.cpassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('password_confirmation')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))]) : _vm._e()]), _vm._v(" "), ((_vm.ref_code != '' && _vm.ref_code != undefined)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Referral Code : " + _vm._s(_vm.ref_code))])]) : _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('address')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Referral Code(enter referral code if you have one)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ref_code),
      expression: "user.ref_code"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "23%"
    },
    attrs: {
      "type": "number",
      "pattern": "/^-?\\d+\\.?\\d*$/",
      "onKeyPress": "if(this.value.length==5) return false;"
    },
    domProps: {
      "value": (_vm.user.ref_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.ref_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms_agree),
      expression: "terms_agree"
    }],
    attrs: {
      "id": "checkbox1",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms_agree) ? _vm._i(_vm.terms_agree, "1") > -1 : (_vm.terms_agree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms_agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms_agree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms_agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms_agree = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox1"
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), (_vm.terms_agree) ? _c('button', {
    staticClass: "btn btn-warning btn-block m-t-xs",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center m-t-xs text-sm"
  }, [_vm._v("Already have an account?")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-block m-t-xs",
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])])])])])])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Register")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#22baae"
    }
  }, [_vm._v("create your cityneeds account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Confirm Password"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_vm._v(" I agree to Cityneeds Technologies Limited "), _c('a', {
    attrs: {
      "href": "terms"
    }
  }, [_vm._v("Terms & Service")])])
}]}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 fld"
  }, [_c('div', {
    staticClass: "content"
  }, [(!_vm.process_request_sent) ? _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("File Complaint")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#f52323"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_form),
      expression: "cninsurance_data.cninsurance_form"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter the InsureMoto Form Policy ID"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_form)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_form = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_complaint_title),
      expression: "cninsurance_data.cninsurance_complaint_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Title of Complaint"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_complaint_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_complaint_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_data.cninsurance_complaint),
      expression: "cninsurance_data.cninsurance_complaint"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Complaint Details"
    },
    domProps: {
      "value": (_vm.cninsurance_data.cninsurance_complaint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_data.cninsurance_complaint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none",
      "padding": "1em 5px",
      "border": "#f3c0c0 1px dashed"
    }
  }, [(!_vm.remove_files && (Object.keys(_vm.files_info).length > 0)) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em",
      "background-color": "#d84040",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setRemoveFiles
    }
  }, [_vm._v("Remove files")]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', [_vm._v(" Add Media")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "fileElem02",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.setOnFileChange($event, _vm.cninsurance)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "background-color": "#e7c619",
      "color": "#000000"
    },
    attrs: {
      "id": "fileSelect"
    }
  }, [_vm._v("Select some files")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "display": "none",
      "margin-top": "2em"
    },
    attrs: {
      "id": "stackFiles02"
    }
  }, [(Object.keys(_vm.files_info).length > 0) ? _c('div', [_vm._l((_vm.files_info), function(file_info, index) {
    return _c('p', [_c('span', {
      attrs: {
        "id": 'filsdaw' + index
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-xs",
      staticStyle: {
        "background-color": "#d84040",
        "font-size": "13px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeFileUpload(file_info)
        }
      }
    }, [_vm._v("Tap to Remove")])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em",
      "background-color": "#d84040",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unsetRemoveFiles
    }
  }, [_vm._v("Cancel Remove")])], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#f52323"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitCNInsuranceForm
    }
  }, [_vm._v("Send Complaint")])])]) : _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "color": "#22baae",
      "font-weight": "bolder"
    }
  }, [_vm._v("Your Complaint has been sent.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("OK")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Enter your InsureMoto Form Policy ID"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Complaint Title"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Complaint"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    attrs: {
      "id": "fileList02"
    }
  }, [_c('p', [_vm._v("No files selected!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#d84040"
    }
  }, [_vm._v("Maximum number of Photos allowed: "), _c('b', [_vm._v("10")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "border": "solid #22baae 8px",
      "border-radius": "50%",
      "width": "100px",
      "height": "180px",
      "padding": "5.5em 1em 1em 1em"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "text-align": "center",
      "font-size": "7.2em",
      "color": "#22baae"
    }
  })])])
}]}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper",
    attrs: {
      "id": "topp03"
    }
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/loader.gif",
      "height": "120"
    }
  })]) : _c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "wn-left-mn"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.printDiv('cCNdiscount', 'Find Hot Discount Codes and Promos')
      }
    }
  }, [_vm._v("Print")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDiv('cCNdiscount', 'Find Hot Discount Codes and Promos')
      }
    }
  }, [_vm._v("Save\r\n                            "), (_vm.downloading) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/assets/img/loader.gif",
      "height": "20"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "background-color": "none !important"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-sm-2 col-lg-2",
    staticStyle: {
      "padding": "0",
      "background-color": "none !important",
      "margin-bottom": "1.8em"
    }
  }, [((Object.keys(_vm.cndiscount_prev) && (Object.keys(_vm.cndiscount_prev).length > 0))) ? _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin": "14.5em 0.5em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setCNdiscount(_vm.cndiscount_prev)
      }
    }
  }, [_c('div', {
    staticClass: "card-row-inner",
    staticStyle: {
      "border": "#f0e8e8 solid",
      "padding": "1em",
      "height": "00px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "35%",
      "margin-right": "35%",
      "margin-top": "-15%"
    }
  }, [((_vm.cndiscount_prev.cndiscount_business_image && ((_vm.cndiscount_prev.cndiscount_business_image != '') && (_vm.cndiscount_prev.cndiscount_business_image != 'business-default.jpg')))) ? _c('img', {
    staticClass: "full-image img-responsive",
    staticStyle: {
      "text-align": "center",
      "border": "2px solid #cccccc",
      "height": "70px",
      "width": "70px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.img_url + _vm.cndiscount_prev.cndiscount_business_image
    }
  }) : _c('img', {
    staticClass: "full-image img-responsive",
    staticStyle: {
      "text-align": "center",
      "border": "2px solid #cccccc",
      "height": "70px",
      "width": "70px",
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/img/logo.jpg"
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "card-row-title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3px",
      "font-size": "16px",
      "color": "#22baae",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.cndiscount_prev.cndiscount_business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-row-content",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_c('p', {
    staticClass: "cnd_caption"
  }, [_vm._v(_vm._s(_vm.cndiscount_prev.cndiscount_caption))]), _vm._v(" "), _vm._m(0)])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-8",
    staticStyle: {
      "padding": "0",
      "background-color": "none !important",
      "margin-bottom": "1.8em"
    }
  }, [_c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin": "0.5em"
    },
    attrs: {
      "id": "cCNdiscount"
    }
  }, [_c('div', {
    staticClass: "card-row-inner",
    staticStyle: {
      "z-index": "500 !important",
      "background-color": "#ffffff",
      "border": "#f0e8e8 solid",
      "padding": "1em",
      "min-height": "600px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5%"
    }
  }, [(_vm.cndiscount.cndiscount_percentage_discount > 0) ? _c('div', {
    staticClass: "rnd_d"
  }, [_c('p', {}, [_vm._v(_vm._s(_vm.cndiscount.cndiscount_percentage_discount) + "%"), _c('br'), _vm._v("off")])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "cnd_caption"
  }, [_vm._v(_vm._s(_vm.cndiscount.cndiscount_caption))]), _vm._v(" "), _c('h6', {
    staticClass: "card-row-title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3px",
      "font-size": "16px",
      "color": "#22baae",
      "font-weight": "bold",
      "padding-top": "3px"
    }
  }, [_vm._v(" " + _vm._s(_vm.cndiscount.cndiscount_business_name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "card-row-content",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._m(1), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "-0.1em",
      "padding": "1em",
      "background-color": "#22baae",
      "color": "#ffffff",
      "display": "inline-block",
      "word-wrap": "break-word"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_code))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "250px",
      "width": "100%"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "src": _vm.set_cndiscount_image(_vm.cndiscount)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin-top": "1.3em"
    }
  }, [(_vm.cndiscount.cndiscount_link && (_vm.cndiscount.cndiscount_link != '' && _vm.cndiscount.cndiscount_link != '#' && _vm.cndiscount.cndiscount_link != ' ')) ? _c('a', {
    staticClass: "btn  btn-xm",
    staticStyle: {
      "cursor": "pointer",
      "border": "#ec313b solid 1px",
      "background-color": "#ec313b",
      "color": "#ffffff",
      "border-radius": "3px",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_url(_vm.cndiscount.cndiscount_link)
      }
    }
  }, [_vm._v("Claim")]) : _vm._e(), _vm._v(" "), _c('p', [(_vm.cndiscount.cndiscount_discount_price > 0) ? _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "28px"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.cndiscount.cndiscount_discount_price)))]) : _vm._e(), _vm._v(" "), (_vm.cndiscount.cndiscount_normal_price > 0) ? _c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_c('del', [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.cndiscount.cndiscount_normal_price)))])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "countdown"
  }, [((_vm.cndiscount.cndiscount_countdown_days >= 0)) ? _c('li', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_countdown_days)), _c('br'), _vm._v("days")]) : _vm._e(), _vm._v(" "), ((_vm.cndiscount.cndiscount_countdown_hours >= 0)) ? _c('li', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_countdown_hours)), _c('br'), _vm._v("hours")]) : _vm._e(), _vm._v(" "), ((_vm.cndiscount.cndiscount_countdown_minutes >= 0)) ? _c('li', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_countdown_minutes)), _c('br'), _vm._v("mins")]) : _vm._e(), _vm._v(" "), ((_vm.cndiscount.cndiscount_countdown_seconds >= 0)) ? _c('li', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_countdown_seconds)), _c('br'), _vm._v("sec")]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "cnd_caption"
  }, [_vm._v(_vm._s(_vm.cndiscount.cndiscount_description))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row-content",
    staticStyle: {
      "text-align": "left !important"
    }
  }, [(((_vm.cndiscount.cndiscount_business_location != ' ') || (_vm.cndiscount.cndiscount_business_address != ' '))) ? _c('h4', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Contact Business")]) : _vm._e(), _vm._v(" "), (_vm.cndiscount.cndiscount_business_address != ' ') ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.cndiscount.cndiscount_business_address))]) : _vm._e(), _vm._v(" "), (_vm.cndiscount.cndiscount_business_location != ' ') ? _c('p', [_c('b', [_vm._v("Location: ")]), _vm._v(_vm._s(_vm.cndiscount.cndiscount_business_location))]) : _vm._e(), _vm._v(" "), (((_vm.cndiscount.cndiscount_business_map_lat != '') && (_vm.cndiscount.cndiscount_business_map_lng != ''))) ? _c('div', {
    staticClass: "mapouter"
  }, [_c('div', {
    staticClass: "gmap_canvas"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "gmap_canvas",
      "src": 'https://maps.google.com/?q=' + _vm.cndiscount.cndiscount_business_map_lat + ',' + _vm.cndiscount.cndiscount_business_map_lng + '&output=embed',
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.siteUrl + _vm.data_share_link + '&text=' + _vm.cndiscount.cndiscount_caption + '&hashtags=cityneeds,cndisconts',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'http://www.facebook.com/sharer.php?u=' + _vm.siteUrl + _vm.data_share_link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("Copy Link")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-lg-3",
    staticStyle: {
      "padding": "0",
      "background-color": "none !important",
      "margin-bottom": "1.8em"
    }
  }, [((Object.keys(_vm.cndiscount_next) && (Object.keys(_vm.cndiscount_next).length > 0))) ? _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin": "14.5em 0.5em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setCNdiscount(_vm.cndiscount_next)
      }
    }
  }, [_c('div', {
    staticClass: "card-row-inner",
    staticStyle: {
      "border": "#f0e8e8 solid",
      "padding": "1em",
      "height": "100px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "35%",
      "margin-right": "35%",
      "margin-top": "-15%"
    }
  }, [((_vm.cndiscount_next.cndiscount_business_image && ((_vm.cndiscount_next.cndiscount_business_image != '') && (_vm.cndiscount_next.cndiscount_business_image != 'business-default.jpg')))) ? _c('img', {
    staticClass: "full-image img-responsive",
    staticStyle: {
      "text-align": "center",
      "border": "2px solid #cccccc",
      "height": "70px",
      "width": "70px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.img_url + _vm.cndiscount_next.cndiscount_business_image
    }
  }) : _c('img', {
    staticClass: "full-image img-responsive",
    staticStyle: {
      "text-align": "center",
      "border": "2px solid #cccccc",
      "height": "70px",
      "width": "70px",
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/img/logo.jpg"
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "card-row-title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3px",
      "font-size": "16px",
      "color": "#22baae",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.cndiscount_next.cndiscount_business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-row-content",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_c('p', {
    staticClass: "cnd_caption"
  }, [_vm._v(_vm._s(_vm.cndiscount_next.cndiscount_caption))]), _vm._v(" "), _vm._m(2)])])])])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('horizontal-widget')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary btn-xm",
    staticStyle: {
      "text-align": "center",
      "background-color": "#ec313b",
      "color": "#ffffff",
      "border-radius": "3px"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "text-align": "center",
      "background-color": "#e7c619",
      "color": "#000000",
      "padding": "3px",
      "border-radius": "2px"
    }
  }, [_vm._v("Open")]), _vm._v(" CNdiscount")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Discount Code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary btn-xm",
    staticStyle: {
      "text-align": "center",
      "background-color": "#ec313b",
      "color": "#ffffff",
      "border-radius": "3px"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "text-align": "center",
      "background-color": "#e7c619",
      "color": "#000000",
      "padding": "3px",
      "border-radius": "2px"
    }
  }, [_vm._v("Open")]), _vm._v(" CNdiscount")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-xm",
    staticStyle: {
      "color": "#ffffff",
      "border-radius": "3px",
      "margin-bottom": "1em"
    },
    attrs: {
      "href": "/discountbazaar",
      "type": "button"
    }
  }, [_vm._v("View DiscountBazaar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-xm",
    staticStyle: {
      "background-color": "#e7c619",
      "color": "#000000",
      "border-radius": "3px",
      "margin-bottom": "1em"
    },
    attrs: {
      "href": "/discountbazaarsetup",
      "type": "button"
    }
  }, [_vm._v("Setup DiscountBazaar")])])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-header",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.set_payment_object.payment_detail_name))])]), _vm._v(" "), (_vm.show_done) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "https://www.prep.cityneeds.ng/pricing"
    }
  }, [_vm._v("Go Back")])]) : _c('div', {
    staticClass: "container"
  }, [(_vm.component_view.paymentDetails) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.payment_details_data).length !== 0)) ? _c('div', [(_vm.payment_details_data.cninsurance_form_policy_amount && (_vm.payment_details_data.cninsurance_form_policy_amount > 0)) ? _c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('h4', [_vm._v("Payment Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h6', [_c('b', [_vm._v("Name")]), _c('br'), _c('br'), _vm._v("\r\n                                                    " + _vm._s(_vm.payment_details_data.customerName) + "\r\n                                                ")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "line-height": "1.8"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), (_vm.payment_details_data.cninsurance_form_policy_amount_with_discount > 0) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('del', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" \r\n                                                            "), _c('span', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount_with_discount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("(" + _vm._s(_vm.payment_details_data.cninsurance_form_policy_discount) + "% off)")])]) : _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_commission))])]), _vm._v(" "), (Number(_vm.payment_details_data.cninsurance_form_policy_stamp_duty) > 0) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_stamp_duty))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦ ")]), _vm._v(_vm._s(_vm.payment_details_data.total_amount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentModeModal(_vm.payment_details_data)
      }
    }
  }, [_vm._v("Proceed")])])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Could not get payment details")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Could not get payment details")])]) : _c('div', [_c('div', {
    staticClass: "cx-loading-sm"
  })]), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('cnpayment-modal', {
    attrs: {
      "payment_data": _vm.set_payment_data,
      "payment_object": _vm.set_payment_object
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Policy Cost:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Processing Fee: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Above Threshold Limit Charge (ATLC):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total Amount: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [_c('p', [_c('b', [_vm._v("WHY YOU HAVE TO SUBSCRIBE BEFORE YOU CAN CONTACT CNpros:")])]), _vm._v(" "), _c('p', [_vm._v("Finding diligent workers is HARD. Ensuring that workers keep transactions within the loop is EVEN HARDER. "), _c('br'), _vm._v("\r\n                             Subscription fees guarantees that insurance is in place, and keeps conflict mediation mechanism active.")])])
}]}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__cov-progress",
    style: (_vm.style)
  })
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "posts post-detail"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.forum.forum_topic))])]), _vm._v(" "), _c('div', {
    staticClass: "post-meta clearfix"
  }, [_c('div', {
    staticClass: "post-meta-author"
  }, [_vm._v("By "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_created_by))])]), _vm._v(" "), _c('div', {
    staticClass: "post-meta-date"
  }, [_vm._v(_vm._s(_vm.forum.forum_reg_date))]), _vm._v(" "), _c('div', {
    staticClass: "post-meta-categories"
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_category))])]), _vm._v(" "), _c('div', {
    staticClass: "post-meta-comments"
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_comments_count) + " comments")])]), _vm._v(" "), (_vm.forum_can_edit) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#edit-forum"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Edit Forum "), _c('i', {
    staticClass: "fa fa-edit"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [_c('p', {
    staticClass: "drop-cap"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setForumDsc(_vm.forum.forum_description))
    }
  }), _vm._v(" "), (_vm.forum.forum_attachment) ? _c('span', {
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "fc-img",
    attrs: {
      "src": _vm.img_url + _vm.forum.forum_attachment
    }
  })]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_vm._v("Share On")]), _vm._v(" "), _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.forum.forum_url + '&text=' + _vm.forum.forum_topic + '&hashtags=cityneeds',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'http://www.facebook.com/sharer.php?u=' + _vm.forum.forum_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("Copy Link")])])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reviews"
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_comments.length) + " Comment(s)")]), _vm._v(" "), _c('div', {
    staticClass: "comments"
  }, [_vm._l((_vm.forum.forum_comments), function(comment) {
    return [_c('div', {
      staticClass: "comment"
    }, [_c('div', {
      staticStyle: {
        "background": "#fff",
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "comment-header"
    }, [_c('div', {
      staticClass: "comment-image"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": _vm.img_url + comment.forum_comment_user_image,
        "alt": "",
        "width": "35",
        "height": "35"
      }
    })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(comment.forum_comment_user))]), _vm._v(" "), _c('span', {
      staticClass: "separator"
    }, [_vm._v("•")]), _vm._v(" "), _c('span', {
      staticClass: "comment-date"
    }, [_vm._v(_vm._s(comment.forum_comment_date))])]), _vm._v(" "), _c('div', {
      staticClass: "comment-content-wrapper"
    }, [_c('div', {
      staticClass: "comment-content",
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setForumDsc(comment.forum_comment_comment))
      }
    }), _vm._v(" "), (comment.forum_comment_attachment) ? _c('span', {
      staticStyle: {
        "margin-top": "1.4em"
      }
    }, [_c('img', {
      staticClass: "fc-img",
      attrs: {
        "src": _vm.img_url + comment.forum_comment_attachment
      }
    })]) : _vm._e()]), _vm._v(" "), (_vm.can_edit_comment(comment.forum_comment_post_ref_no)) ? _c('div', {
      staticClass: "pull-right"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#edit-comment"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('forum_comment', comment)
        }
      }
    }, [_vm._v("Edit Comment"), _c('i', {
      staticClass: "fa fa-edit"
    })])]) : _vm._e()])])])])]
  })], 2), _vm._v(" "), _c('h2', [_vm._v("Join The Discussion")]), _vm._v(" "), _c('form', {
    staticClass: "background-white p20 add-comment"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReg
    }
  }, [_vm._v("\r\n                                    Log In / Create your cityneeds account\r\n                                ")])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What do you think?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.forum_comment_comment),
      expression: "comment.forum_comment_comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.forum_comment_comment)
    },
    on: {
      "change": _vm.trackevent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.forum_comment_comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Add a Photo to your post?")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addComment
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v("Post\r\n                                ")])])])])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('create-thread'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-forum",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "0px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discussion Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forum.forum_topic),
      expression: "forum.forum_topic"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Discussion Title"
    },
    domProps: {
      "value": (_vm.forum.forum_topic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forum.forum_topic = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Category "), _c('b', [_vm._v(_vm._s(_vm.forum.forum_category))])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forum.forum_category_id),
      expression: "forum.forum_category_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.forum.forum_category_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Community")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Short Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forum.forum_description),
      expression: "forum.forum_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "What would you want to discuss?"
    },
    domProps: {
      "value": (_vm.forum.forum_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forum.forum_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.forum.forum_attachment) ? _c('span', [_c('img', {
    staticClass: "fc-img",
    attrs: {
      "src": _vm.img_url + _vm.forum.forum_attachment
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Change Photo?")])]) : _c('span', [_c('label', [_vm._v(" Add a Photo?")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.editForum
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-comment",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "0px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Edit Comment")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.forum_comment_comment),
      expression: "comment.forum_comment_comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.comment.forum_comment_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.forum_comment_comment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.comment.forum_comment_attachment) ? _c('span', [_c('img', {
    staticClass: "fc-img",
    attrs: {
      "src": _vm.img_url + _vm.comment.forum_comment_attachment
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Change Photo?")])]) : _c('span', [_c('label', [_vm._v(" Add a Photo?")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.editComment(_vm.comment)
      }
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "guest-poll",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-offset-2 modal-content",
    staticStyle: {
      "top": "10em",
      "border-radius": "0px",
      "padding": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("If you would like to partake in future CNforum discussions, or even initiate a CNforum discussion, register now!\r\n            ")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/register",
      "type": "button"
    }
  }, [_vm._v("Sign Up")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "/forums"
    }
  }, [_vm._v("Back to Forum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#9c0909",
      "font-size": "18px",
      "line-height": "1.6"
    }
  }, [_vm._v("Oops! You will have to log in to join the discussion.\r\n                                    "), _c('br'), _vm._v("Don't have a Cityneeds account?"), _c('br'), _vm._v(" Create one; It won't take you more than a minute.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Edit This Forum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-image": "url('https://cityneeds.ng/cnpro.jpg')",
      "height": "8em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header header-minimal"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-bottom"
  }, [_c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/forums"
    }
  }, [_vm._v("Join Forum")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find CNpros ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/discountbazaar"
    }
  }, [_vm._v("DiscountBazaar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/insuremoto"
    }
  }, [_vm._v("InsureMoto")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnsurveys"
    }
  }, [_vm._v("Take CNsurveys")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "businesses"
    }
  }, [_vm._v("Find Businesses")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v("CNpro Plans & Pricing")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help-me-find-a-cnpro"
    }
  }, [_vm._v("Help Me Find A CNpro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Logout")])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "header-nav-user"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "id": "dropdownMenu1",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('div', {
    staticClass: "user-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_url + _vm.user.user_image,
      "alt": "User Photo"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "header-nav-user-name"
  }, [_vm._v(_vm._s(_vm.user.user_fullname))])])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-statusbar"
  }, [_c('div', {
    staticClass: "header-statusbar-inner"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "header-statusbar-right"
  }, [_c('div', {
    staticClass: "hidden-xs visible-lg"
  }, [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Dashboard")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "prompt",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_c('h1', {
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_vm._v("Your Referral Code")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "line-height": "1.8",
      "font-size": "18px"
    }
  }, [_vm._v("Refer friends and family with your unique Cityneeds Referral Code and earn N100 when the person you referred signups \r\n                                        and completes three transactions, one of which will include one CNpro service.\r\n                                    ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    attrs: {
      "title": "Copy Link and Share"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#000000",
      "background": "rgb(242, 248, 248)",
      "border": "1px solid #013d3f",
      "padding": "1em",
      "border-radius": "2px",
      "min-height": "3.5em"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.user.user_referral_code))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("copy")])])]), _vm._v(" "), _c('p', [(_vm.copy_succ) ? _c('span', {
    staticStyle: {
      "color": "#000000",
      "background": "#ffff00",
      "font-size": "12px",
      "padding": "3px"
    }
  }, [_vm._v("Referral Link Copied")]) : _vm._e()])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "5em"
    },
    attrs: {
      "src": "static/assets/img/logo.png",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-statusbar-left"
  }, [_c('h1', {
    staticStyle: {
      "margin-left": "1.5em"
    }
  }, [_vm._v(" Dashboard ")])])
}]}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "prompt-forum",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "i-trending"
  }, [(_vm.forums && (Object.keys(_vm.forums).length > 0)) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "line-height": "1.8"
    }
  }, [_c('span', {
    staticClass: "center",
    staticStyle: {
      "background": "#22baae",
      "margin-top": "-1.2em",
      "margin-left": "18vw",
      "text-align": "center",
      "padding": "0.3em",
      "color": "#ffffff"
    }
  }, [_vm._v("Trending")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'forum?topic=' + _vm.forums[0].forum_topic_url
    }
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [(_vm.forums[0].forum_comments.length) ? _c('span', {
    staticClass: "badge",
    staticStyle: {
      "background-color": "#22baae"
    }
  }, [_vm._v(_vm._s(_vm.forums[0].forum_comments.length))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333",
      "font-size": "18px"
    }
  }, [_c('i', [_vm._v("...\"" + _vm._s(_vm.forums[0].forum_topic) + "\"...")])])])])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block m-t-xs",
    attrs: {
      "href": "https://cityneeds.ng/forums"
    }
  }, [_vm._v("Join Discussions")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger btn-block m-t-xs",
    attrs: {
      "href": "https://cityneeds.ng/forums"
    }
  }, [_vm._v("Start a Discussion")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "28px",
      "line-height": "1.4",
      "color": "#000000"
    }
  }, [_vm._v("So many "), _c('span', [_vm._v("discussions")]), _vm._v(" are going on..")])
}]}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-admin-footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "content-admin-footer-inner"
  }, [_vm._v("\r\n                © " + _vm._s(_vm.this_year) + " cityneeds. All rights reserved.\r\n            ")])])])
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {}, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mt-80 mb80"
  }, [_c('div', {
    staticClass: "detail-banner bg_image",
    style: ({
      'background': 'url(' + _vm.img_bz_url + _vm.business.business_category_image + ')',
      backgroundSize: _vm.backgroundSize
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "detail-banner-left"
  }, [_c('div', {
    staticClass: "detail-banner-info"
  }, [_c('div', {
    staticClass: "detail-label"
  }, [_vm._v(_vm._s(_vm.business.business_category_name))]), _vm._v(" "), _c('div', {
    staticClass: "detail-verified"
  }, [_vm._v("Verified")])]), _vm._v(" "), _c('h2', {
    staticClass: "detail-title"
  }, [_vm._v("\r\n                                                        " + _vm._s(_vm.business.business_name) + "\r\n                                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-banner-address"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v(" " + _vm._s(_vm.business.business_address) + "\r\n                                                    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "detail-banner-btn bookmark btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveComponent(_vm.business)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "Bookmarked"
    }
  }, [_vm._v("Save")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row detail-content"
  }, [_c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "detail-gallery",
    staticStyle: {
      "margin-bottom": "10em"
    }
  }, [_c('div', {
    staticClass: "detail-gallery-preview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "src": _vm.img_url + _vm.business.business_image
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "descr p20"
  }, [_c('h2', [_c('span', {
    staticClass: "text-secondary"
  }, [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.business.business_description))])])]), _vm._v(" "), (_vm.business.business_reviews.length != 0) ? _c('h2', {
    attrs: {
      "id": "reviews"
    }
  }, [_vm._v("All Reviews \r\n                                                    "), _c('span', {
    staticClass: "pull-right points",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.business.business_rating_average_rate) + " / " + _vm._s(_vm.business.business_rating_total_rating) + " , ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#reviews"
    }
  }, [_vm._v(_vm._s(_vm.business.business_reviews_total_count) + "  reviews")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reviews"
  }, [_vm._l((_vm.business.business_reviews), function(review) {
    return [_c('div', {
      staticClass: "review"
    }, [_c('div', {
      staticClass: "review-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.img_url + review.review_user_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "review-inner"
    }, [_c('div', {
      staticClass: "review-title"
    }, [_c('h2', [_vm._v(_vm._s(review.review_user))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "review-overall-rating"
    }, [_vm._l((review.review_user_rate), function(rate) {
      return _c('i', {
        staticClass: "fa fa-star"
      })
    }), _vm._l(((5 - review.review_user_rate)), function(rate) {
      return _c('i', {
        staticClass: "fa fa-star-o"
      })
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "review-content-wrapper"
    }, [_c('div', {
      staticClass: "review-content"
    }, [_c('div', {
      staticClass: "review-pros"
    }, [_c('p', [_vm._v(_vm._s(review.review_review) + ".")])])])])])])]
  })], 2), _vm._v(" "), (!_vm.has_reviewed) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Submit a Review")]), _vm._v(" "), _c('form', {
    staticClass: "background-white p20 add-review"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Your Review")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.review),
      expression: "review.review"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.review.review)
    },
    on: {
      "change": _vm.trackevent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.review.review = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.has_rated) ? _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("What's your rating")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitReview
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("Submit Review")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "background-white p20 hidded-sm hidden-xs"
  }, [_c('div', {
    staticClass: "detail-overview-rating"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.business.business_rating_average_rate) + " / " + _vm._s(_vm.business.business_rating_total_rating) + " , ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#reviews"
    }
  }, [_vm._v(_vm._s(_vm.business.business_reviews_total_count) + "  reviews")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "detail-vcard"
  }, [_c('div', {
    staticClass: "detail-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_url + _vm.business.business_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact"
  }, [_c('div', {
    staticClass: "detail-contact-email"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.business.business_email))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-phone"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.business.business_phone))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-website"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.business.business_website))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-address"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v("\r\n                                                                " + _vm._s(_vm.business.business_address) + "\r\n                                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-follow"
  }, [_c('h5', [_vm._v("Follow Us:")]), _vm._v(" "), _c('div', {
    staticClass: "follow-wrapper"
  }, [_c('a', {
    staticClass: "follow-btn facebook",
    attrs: {
      "href": _vm.business.business_facebook
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-btn twitter",
    attrs: {
      "href": _vm.business.business_twitter
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-btn instagram",
    attrs: {
      "href": _vm.business.business_instagram
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Working Hours")]), _vm._v(" "), _c('div', {
    staticClass: "p20 background-white"
  }, [(_vm.business.working_hours) ? _c('div', {
    staticClass: "working-hours"
  }, [_c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Mon")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.mon_open) + " - " + _vm._s(_vm.business.working_hours.mon_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Tue")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.tue_open) + " - " + _vm._s(_vm.business.working_hours.tue_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Wed")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.wed_open) + " - " + _vm._s(_vm.business.working_hours.wed_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Thu")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.thu_open) + " - " + _vm._s(_vm.business.working_hours.thu_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Fri")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.fri_open) + " - " + _vm._s(_vm.business.working_hours.fri_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Sat")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.sat_open) + " - " + _vm._s(_vm.business.working_hours.sat_close))])]), _vm._v(" "), _c('div', {
    staticClass: "day clearfix"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Sun")]), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.business.working_hours.sun_open) + " - " + _vm._s(_vm.business.working_hours.sun_close))])])]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-banner-rating"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "report"
  }, [_c('span', {
    staticClass: "separator"
  }, [_vm._v("•")]), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "title": "Report",
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', [_vm._v("Required fields are marked "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "text-secondary"
  }, [_vm._v("Reach Us")])])
}]}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v("\r\n​\r\n\t"), _vm._m(0), _vm._v("\r\n​\r\n"), _c('main-footer'), _vm._v("\r\n​\r\n")], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {}, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ab-hd",
    staticStyle: {
      "background-image": "linear-gradient(rgba(0, 0, 0, 0.75),rgba(0, 0, 0, 0.75)),url('static/assets/img/scissors.png')"
    }
  }, [_c('div', {
    staticClass: "htg-50"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("ABOUT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "background": "#fff",
      "padding-top": "3em",
      "margin-bottom": "6em"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Cityneeds is the online platform that matches your NEEDS with SERVICE-PROVIDERS. We have taken full advantage of technology to make living convenient and stress-less for you. \r\n\t\t\t\t\t\t\t\t\t\t\tWith Cityneeds, finding a Good Plumber, or a Great Dentist, or even paying your Electricity bill, or topping-up Airtime on your phone, is simpler  than ever, as you can initiate and finish the afore-listed tasks, and many more from the comfort of your computer or smartphone, without leaving home! \r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v(" Our vision is to be your service-solutions repository. Whenever a need arises, we want to be the first and only option that comes to your mind.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("CITYNEEDS’ SERVICES:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("1. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("Pay Utility Bills and Top-up Airtime  ")])]), _vm._v(" - On CNpay, you can pay a host of utility bills in real-time: Electricity, Cable-Tv, Airtime, Remita, Internet Data and so on. Most payments made on CNpay earns you instant cashback rewards, which you can use to make purchases on CNpay. With CNpay, it's win-win for all!\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(" 2. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("Find Diligent Workers")])]), _vm._v("- We provide an online marketplace for pre-verified freelancers whom are known as CNpros: Professionals, Skilled-Workers, and Artisans, who pride themselves on getting solutions delivered for you with excellent finish. Everyday living and comfort solutions : Plumbers; Electricians; Masons; Architects; Building Engineers ; Lawnmowers ; Tilers; Painters; House-Movers; and many more.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("OUR PLEDGE:")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("To shield our customers from fraud, worker-no-show ( job-abandonment), poor- job-quality, and delays-in-job-completion, \r\n\t\t\t\t\t\t\t\t\t\t\t\t\tthat are common with workers picked-off the street.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("OUR MODUS OPERANDI:")]), _c('br'), _vm._v("\r\n​\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tWe escrow payment, and only release payment to our workers when job is completed to customer's satisfaction, \r\n\t\t\t\t\t\t\t\t\t\t\t\t\tand in very rare occasions, swap workers in the event a CNpro fails to deliver to standard, for any reason whatsoever- however, terms and conditions do apply.  \r\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t\tCustomers are also guaranteed insurance cover for the replacement of property unavoidably and accidentally damaged in the course of carrying-out a job.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("3. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("Business Directory")])]), _vm._v(" - You can search and find Listed Businesses- be it a Baker, or a Lawyer, or a Tailor, or a Videographer.  \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tMost listed businesses offer discount vouchers targeted at Cityneeds' community members. You can also get information about new product arrivals or latest service-offerings, or even find a job, as businesses list vacancies. Businesses also publicise their upcoming trainings and conferences on their pages. \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("Listing your business on Cityneeds is free! Come on, expose your hustle to our community and beyond! \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("4. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("Administer Business Surveys")])]), _vm._v(" - Administering a survey before you launch a product provides unbiased feedbacks and vibes from members of our community on product market-fit of your proposed product. \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou may ask industry-peers for suggestions on how to improve on your existing products.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("5. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("Community Forum Discussions")])]), _vm._v(" - Make your voice heard on the state of infrastructure, \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tand quality of service delivery within your immediate community thereby helping to curate healthy socio-economic-cum political discuss that subtly compels political leaders to deliver on good governance, or businesses to improve on their service delivery.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("6. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("Cityneeds Meals")])]), _vm._v(" - If you want to control how much you spend on food at work, \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tthen you have to signup to Cityneeds Meals plan; It will help you to take charge of how much you spend on feeding in a month, while at work! Roll with Cityneeds Meals for a month and you will be amazed to find out that your salary can actually take you beyond the next PAYDAY! Enjoy meals that you love, cooked the way you want, delivered where you are, and at the time you choose. \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("One plan. Scheduled Deliveries. Controlled Spending ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("7. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("Refer and Earn")])]), _vm._v(" - Refer friends and family with your unique Cityneeds Referral Code and earn money when the person you referred signups and completes three transactions, one of which will include one CNpro service.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("8. "), _c('strong', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "text-decoration": "underline",
      "font-style": "italic"
    }
  }, [_vm._v("CNpay Rewards")])]), _vm._v(" - CNpay Rewards are tokens of appreciation for transactions done on Cityneeds. They are for the exclusive purchase of Cityneeds' services, offered on Cityneeds' platform, hence, cannot be transferred out. \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCityneeds reserves the right to cancel and withdraw all rewards earned without notice or recourse to the customer. \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#22baae",
      "font-weight": "bold",
      "font-style": "italic",
      "font-size": "130%"
    }
  }, [_vm._v("Do more with cityneeds!\r\n\t\t\t\t\t\t\t\t\t\t\t")])])])])])])])
}]}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "src": "/static/assets/img/logo.png",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    key: _vm.headerKey,
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_vm._m(0), _vm._v(" "), (_vm.is_logged_in) ? _c('ul', {
    staticClass: "header-nav-secondary nav nav-pills"
  }, [_c('p', [_vm._m(1), _vm._v(": "), _c('b', [_vm._v("\r\n                                    ₦" + _vm._s(_vm.formatCurrency(_vm.user.current_wallet_balance)))])])]) : _c('ul', {
    staticClass: "header-nav-secondary nav nav-pills"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/forums"
    }
  }, [_vm._v("Join Forum")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find CNpros ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/discountbazaar"
    }
  }, [_vm._v("DiscountBazaar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/insuremoto"
    }
  }, [_vm._v("InsureMoto")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnsurveys"
    }
  }, [_vm._v("Take CNsurveys")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/businesses"
    }
  }, [_vm._v("Find Businesses")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/how-it-works"
    }
  }, [_vm._v("How CNpro Works")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v("CNpro Plans & Pricing")])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help-me-find-a-cnpro"
    }
  }, [_vm._v("Help Me Find A CNpro")])], 1), _vm._v(" "), (_vm.user != null && _vm.user != undefined && _vm.user != '') ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Hello, " + _vm._s(_vm.user.user_fullname) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("My Account")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Logout")])], 1)])], 1)] : [_c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In")])], 1), _vm._v(" "), _c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)]], 2), _vm._v(" "), _vm._m(3)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "header-nav-social social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/cityneedsng"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://web.facebook.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": " https://www.instagram.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://linkedin.com/in/cityneeds-technologies-00b090138"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("Rewards ")]), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v("Balance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_vm._m(0), _vm._v(" "), (_vm.can_reset) ? _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-password"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.new_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-password"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirm_password),
      expression: "user.confirm_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirm_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.is_not_valid) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "2em"
    }
  }, [_vm._v("This Link has expired")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Continue")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Reset Password")])])
}]}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "background-white mb80",
    staticStyle: {
      "margin-top": "0.3em !important",
      "border": "#edf7f6 solid"
    }
  }, [_c('div', {}, [_c('img', {
    staticClass: "wn-bbanner mobi-off",
    staticStyle: {
      "height": "350px !important"
    },
    attrs: {
      "src": "/static/assets/img/home-banner-parkwell-insuremoto.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "detail-banner-left"
  }, [_c('h4', {
    staticClass: "detail-title",
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.cninsurance_listing.cninsurance_name))]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.cninsurance_listing.cninsurance_tagline))])]), _vm._v(" "), _c('div', {
    staticClass: "wn-xmenu"
  }, [_c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_get_insurance')
      }
    }
  }, [_vm._v("Get Insurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_claim')
      }
    }
  }, [_vm._v("File Claim")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_complaint')
      }
    }
  }, [_vm._v("File Complaint")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "1em 3em"
    }
  }, [(_vm.set_component_view.set_flie_complaint) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE COMPLAINT")]), _vm._v(" "), _c('p', [_vm._v("With InsureMoto scheme we connect you to our multi-insurance partner Cornerstone Insurance to enable you \r\n                                            enjoy the benefits of their advanced insurance system. ")]), _vm._v(" "), _c('cninsurance-file-complaint')], 1)]) : (_vm.set_component_view.set_flie_claim) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE CLAIM")]), _vm._v(" "), _c('p', [_vm._v("With InsureMoto scheme we connect you to our multi-insurance partner Cornerstone Insurance to enable you \r\n                                            enjoy the benefits of their advanced insurance system. ")]), _vm._v(" "), _c('cninsurance-file-claim')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Buy or Renew your motor insurance on The Go!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), ((Object.keys(_vm.cninsurance_listing).length !== 0)) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-12 fld"
  }, [_c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_listing,
      "cninsurance": _vm.cninsurance_form_entry
    }
  })], 1)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_get_insurance')
      }
    }
  }, [_vm._v("Get Insurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_claim')
      }
    }
  }, [_vm._v("File Claim")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_complaint')
      }
    }
  }, [_vm._v("File Complaint")])])])])])], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "font-size": "4em",
      "font-weight": "bolder"
    }
  }, [_vm._v("C")]), _vm._v("ityneeds Technologies\r\n                                    Limited is an authorized vendor of Cornerstone Insurance Plc's Third-party Motor Insurance product.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "color": "#222223"
    }
  }, [_c('b', [_vm._v("Process your Third-party Motor Insurance")]), _vm._v(" "), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Fill the form below")])])
}]}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [(_vm.activation_error_message) ? _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "1em",
      "border": "#22baae 3px solid"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-email"
    }
  }, [_vm._v("E-mail or Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "id": "login-form-email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "login-form-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "text-left m-t-xs text-sm"
  }, [_vm._v("Don't have an account?")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-block m-t-xs",
    attrs: {
      "to": "register"
    }
  }, [_vm._v("Register")])], 1)])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "13em"
    },
    attrs: {
      "id": "forgot",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "font-weight": "600",
      "color": "#22baae"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Forgot your Password?")])]), _vm._v(" "), (_vm.forgot_processed) ? _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetForgot
    }
  }, [_vm._v("Close")])])]) : _c('div', [_c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Please enter your email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("Submit")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\r\n                                   Sorry!, your account could not be Activated, please "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Request")]), _vm._v(" \r\n                                   for another activation link, to be able to access relevant features.\r\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-right m-t-xs text-sm"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#forgot"
    }
  }, [_vm._v("Forgot Password?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Some instruction have been sent to your email to help you Reset your password. Please check your mail")])])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_vm._m(0), _vm._v(" "), _c('component-footer')], 1)])])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('h3', [_vm._v("Listings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', {
    staticStyle: {
      "text-transform": "inherit"
    }
  }, [_vm._v("CNpros")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "cnpro-accounts"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', [_vm._v("Businesses")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "business-listings"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('h3', [_vm._v("Activities")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', [_vm._v("Contracts")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "contracts"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', {
    staticStyle: {
      "text-transform": "inherit"
    }
  }, [_vm._v("CNsurveys")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "survey-requests"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])])])])])])])])])
}]}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "admin-menu"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "-5.2em"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]) : _c('div', {
    staticClass: "sidebar-secondary-admin"
  }, [_c('div', {
    staticClass: "toggle-btn",
    staticStyle: {
      "margin-top": "-4.7em",
      "position": "absolute"
    }
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('ul', [_c('li', {
    class: {
      active: _vm.isActive('/dashboard')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Reports & Analytics")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/profile')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Profile")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Manage Your Aaccount")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/contracts')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contracts"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Contracts "), (_vm.notifications_contracts != 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.notifications_contracts))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Contracts")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/business-listings')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "business-listings"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-suitcase",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Business Listings")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Business Listings")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/survey-requests')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/survey-requests"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("CNsurveys"), (_vm.notifications_cnsurveys != 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.notifications_cnsurveys))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Surveys Requests")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/cnpro-accounts')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cnpro-accounts"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("CNpro Accounts "), (_vm.notifications_cnpros != 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.notifications_cnpros))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Service Listings")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/saved-listings')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/saved-listings"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-bookmark",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Saved Listings")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("View Them Again")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/mymoney')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/mymoney"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("My Money")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Payouts")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/cnwallet')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cnwallet"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Rewards")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Rewards")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/cnpaytransactions')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cnpaytransactions"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("CNpay Transactions")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Transactions")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/account-cninsurance')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/account-cninsurance"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-table",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("InsureMoto")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Insurance Packages")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/myreferrals')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/myreferrals"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("My Referrals")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("People you referred")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/login')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-power-off",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Log Out")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("sign out from account")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', [(_vm.cnpay_transactions.length != 0) ? _c('div', {
    attrs: {
      "id": "remita-transactions"
    }
  }, [_c('div', {
    staticClass: " p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20 col-md-8 col-md-offset-2",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.cnpay_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.cnpay_txn_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.cnpay_txn_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.cnpay_txn_service))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.cnpay_txn_total_amt_paid)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setTransaction(txn, txn.cnpay_txn_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.cnpay_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.cnpay_txn_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.cnpay_txn_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _vm._v(_vm._s(txn.cnpay_txn_service))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.cnpay_txn_total_amt_paid)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setTransaction(txn, txn.cnpay_txn_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have any CNpay Transactions yet")])])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (!_vm.show_payment_receipt) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Transaction Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.cnpay_transaction_type == 1) ? _c('div', [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("RRR Code: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_rrr))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_rrr_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction Charges: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_rrr_charges)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpay Charges: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_cnpay_charges)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Amount Paid: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_total_paid_amt)))])]) : _vm._e(), _vm._v(" "), (_vm.cnpay_transaction_type == 2) ? _c('div', [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_merchant_service_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_set_transaction_confirmationCode))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_price)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpayCharges: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_commission)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Amount Paid: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_total_paid_amt)))]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_status == 1) ? _c('p', [_c('b', [_vm._v("Transaction Status: ")]), _vm._v("Payment Made, Awaiting Service Delivery")]) : _vm._e(), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_status == 2) ? _c('p', [_c('b', [_vm._v("Transaction Status: ")]), _vm._v("Successful")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_payment_receipt = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" View Receipt")]), _vm._v("\r\n            `   "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show_payment_receipt) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "width": "342px !important"
    },
    attrs: {
      "id": "paymod"
    }
  }, [_c('div', {
    staticClass: "table rctable",
    staticStyle: {
      "border": "none",
      "margin-top": "1em",
      "color": "#000000",
      "font-weight": "bolder",
      "margin-bottom": "0.1em !important"
    }
  }, [_c('table', {
    staticStyle: {
      "border": "none",
      "width": "100%",
      "overflow": "hidden"
    }
  }, [_c('tr', {}, [_vm._m(5), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.1em",
      "margin-left": "0px"
    }
  }, [(_vm.cnpay_transaction.payment_merchant_logo != '') ? _c('span', [_c('img', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "src": _vm.img_url + _vm.cnpay_transaction.payment_merchant_logo
    }
  })]) : _c('span', [_c('p', {
    staticClass: "service-pay-title-logo"
  }, [_vm._v(_vm._s(_vm.cnpay_transaction.payment_merchant_name))])])])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "table rctable",
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_c('table', {}, [_c('tr', [_c('td', [_vm._v("Payment:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_merchant_service_name))])]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_name && (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_name != '')) ? _c('tr', [_c('td', [_vm._v("From:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_name))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Number:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_payercodeAtBiller))])]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_address && (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_address != '')) ? _c('tr', [_c('td', [_vm._v("Address:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_address))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_reg_date))])]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_confirmationCode != 0) ? _c('tr', [_c('td', [_vm._v("Token:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.setFormattedVoucher(_vm.cnpay_transaction.cnpay_paga_transaction_confirmationCode)))])]) : _vm._e(), _vm._v(" "), ((_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units != '') && (_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_unitType != '')) ? _c('tr', [_c('td', [_vm._v("Units:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units) + " " + _vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_unitType))])]) : ((_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units != '')) ? _c('tr', [_c('td', [_vm._v("Units:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Amount:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_price)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CNpay Charges:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_commission)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_total_paid_amt)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Transaction Status:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_status_name))])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.printDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Print")]), _vm._v("   \r\n                    "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Save\r\n                        "), (_vm.downloading) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/assets/img/loader.gif",
      "height": "20"
    }
  })]) : _vm._e()]), _vm._v("   \r\n                    "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("My CNpay Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-5 col-sm-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "-1em",
      "margin-left": "0em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('u', [_vm._v("CNpay Payment Receipt")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "margin-left": "1em",
      "font-size": "11px",
      "text-align": "left"
    }
  }, [_vm._v("Thank you for choosing CNpay."), _c('br'), _vm._v("\r\n                            Cityneeds™ ... meet everyday needs on the go!")])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "background": "#fff",
      "padding": "2em",
      "border-radius": "5px",
      "border": "1px solid #666"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-lg-12 ccol-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Cityneeds Technologies Limited's Terms of Service")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Welcome to Cityneeds Technologies Limited also referred herein as (\"Cityneeds\", \"We\", \"Our\", or \"Us\" ). Our Uniform Resource Locator (URL) is "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng"
    }
  }, [_vm._v("www.cityneeds.ng. ")])]), _vm._v(" "), _c('p', [_vm._v("Our purpose for existence as a business entity includes the following :\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("To provide to the public an online marketplace and platform for the procurement of services offered by carefully Pre-verified Freelancers- Professionals; Skilled-workers; and Artisan \r\n\t\t\t\t\t\t\t\t\t\t(Architects, Building Engineers, Plumbers, Masons, Welders, and Electricians, etc). ")]), _vm._v(" "), _c('li', [_vm._v(" To provide a free platform for listing of businesses. ")]), _vm._v(" "), _c('li', [_vm._v(" To provide interactive services ; Forums, Polls, and Surveys, through which Cityneeds community members can cross-share ideas for the good and progress of the city they live in.\r\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', [_vm._v("The following terms and conditions (these "), _c('strong', [_vm._v("\"Terms of Service\"")]), _vm._v("), govern your access and use of the Cityneeds Technologies Limited website, including any content, functionality and services offered on \r\n\t\t\t\t\t\t\t\t\tor through "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng"
    }
  }, [_vm._v("www.cityneeds.ng ")]), _vm._v("(the "), _c('strong', [_vm._v("\"Site\"")]), _vm._v("), by Cityneeds Technologies Limited.")]), _vm._v(" "), _c('p', [_vm._v(" Please read the Terms of Service carefully before you start to use the Site. "), _c('strong', [_vm._v("By using the Site, opening an account or by clicking to accept or agree to the Terms of Service when this option is made available to you, you accept and agree to be bound and abide by these Terms of Service and our Privacy Policy, as incorporated herein.")]), _vm._v(" If you do not want to agree to these Terms of Service or the Privacy Policy, you must not access or use the Site. \r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("This Site is offered and is available to users who are 13 years of age or older. If you are under 13, you may not use this Site or the Cityneeds services. By using this Site, you represent and warrant that you are of legal age to form a binding contract and meet all of the foregoing eligibility requirements. If you do not meet all of these requirements, you must not access or use the Site.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("Our Customer Support team is available  if you have any questions regarding the Site or Terms of Service. Contacting our Customer Support team can be performed by submitting a request through support@cityneeds.ng\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("Key Terms")]), _vm._v(" "), _c('p', [_vm._v("1. "), _c('strong', [_vm._v("CNservices")]), _vm._v(" are services offered on www.cityneeds.ng.")]), _vm._v(" "), _c('p', [_vm._v("2. "), _c('strong', [_vm._v("CNusers")]), _vm._v(" are customers who use the services available on www.cityneeds.ng")]), _vm._v(" "), _c('p', [_vm._v("3. "), _c('strong', [_vm._v("CNpros")]), _vm._v(" are pre-verified freelance professionals , skilled workers, and artisans who provide services through www.cityneeds.ng")]), _vm._v(" "), _c('p', [_vm._v("4. "), _c('strong', [_vm._v("Dashboard")]), _vm._v(" is where  CNusers and CNpros can find and manage the following: profile; contracts; list a business; create and administer a survey; add a CNpro service; request a payout; and logout.")]), _vm._v(" "), _c('p', [_vm._v("5. "), _c('strong', [_vm._v("ACTIVE REQUEST")]), _vm._v(" is a status that indicates a live interaction or discussion which the receiver should click on it and respond to accordingly. ")]), _vm._v(" "), _c('p', [_vm._v("6. "), _c('strong', [_vm._v("CNorders")]), _vm._v(" are requests made by a CNuser to receive a Quote from CNpro.")]), _vm._v(" "), _c('p', [_vm._v("7.  "), _c('strong', [_vm._v("Confirmed /Accepted Quote")]), _vm._v(" represents a formal agreement between a CNuser and CNpro after a Quotation was sent, received, and agreed upon by both parties.")]), _vm._v(" "), _c('p', [_vm._v("8. "), _c('strong', [_vm._v("CNchat")]), _vm._v(" is where CNusers and CNpros communicate with each other in connection with an order.")]), _c('p'), _c('p', [_vm._v("9. "), _c('strong', [_vm._v("Disputes Resolution is the settlement of")]), _vm._v("  disagreements between CNpro and CNuser that arises in the course of carrying -out a job order. However, this service is only available to Paid Plan Users.")]), _vm._v(" "), _c('p', [_vm._v("10. "), _c('strong', [_vm._v("CNproServiceFees")]), _vm._v(" is the money CNpros charge CNusers as professional fees or LABOUR/WAGES in local parlance . This is different from cost of materials for the job.")]), _vm._v(" "), _c('p', [_vm._v("11. "), _c('strong', [_vm._v("CNcommission")]), _vm._v(" is the administrative charge /money deducted from CNproServiceFees earned by CNpro on completed and fully delivered orders.")]), _vm._v(" "), _c('p', [_vm._v("12. CNquote is the Quotation of working materials prepared by the CNpro and issued to the CNuser after evaluation of the proposed job.")]), _vm._v(" "), _c('p', [_vm._v("13. "), _c('strong', [_vm._v("CNinsured")]), _vm._v(" is an exclusive insurance cover for Paid Plan CNusers. It covers losses sustained through accidental damage of working materials and property of a CNuser in the course of a CNpro carrying-out their job order.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Overview (At a Glance )")]), _vm._v(" "), _c('p', [_vm._v("1. Only registered users may use the services provided by cityneeds. Registration is free.")]), _vm._v(" "), _c('p', [_vm._v("2. There are three plan categories for CNusers: Quarter-Year; Half-Year; Full-Year plans. The longer plan , the cheaper in cost per month. Full-Year plan is recommended.")]), _vm._v(" "), _c('p', [_vm._v(" 3. CNusers are to choose CNpros from a pool of pre-verified professionals, skilled-workers, and artisans. ")]), _vm._v(" "), _c('p', [_vm._v("4.  CNusers are to invite CNpros to their property or place for evaluation of the proposed job, after which the CNpro issues a CNquote.")]), _vm._v(" "), _c('p', [_vm._v("5. CNusers are to negotiate/bargain the CNquote  and the cost of executing their order with CNpros. ")]), _vm._v(" "), _c('p', [_vm._v("6. CNusers are to independently verify , then buy materials as quoted by the CNpro by themselves. Cityneeds Technologies Limited shall not be liable for any loss of money or material.")]), _vm._v(" "), _c('p', [_vm._v("7.  Paid Plan CNusers must pay their CNproServiceFees in advance to Cityneeds Technologies Limited before the commencement of their job otherwise they won't be eligible to enjoy the features of a Paid Plan.")]), _vm._v(" "), _c('p', [_vm._v("8. CNusers have the prerogative to fulfill the Quotation in bits by buying the materials needed bit by bit, or in fewer quantities so as to avoid wastage of materials in the event of over-quotation.")]), _vm._v(" "), _c('p', [_vm._v("9.  Quotes are confirmed through the Accept Quote button found on a Quotation page.  ")]), _vm._v(" "), _c('p', [_vm._v("10.  CNpros must fulfil their orders, and may not cancel orders on a regular basis or without cause. Cancelling orders will affect CNpro's reputation and status.")]), _vm._v(" "), _c('p', [_vm._v("11.  CNpros gains reviews by CNusers based on their performance.")]), _vm._v(" "), _c('p', [_vm._v("12. CNusers are granted all rights for the Completed and Delivered work, except otherwise stated and  agreed upon by CNpro and CNuser.")]), _vm._v(" "), _c('p', [_vm._v("13.  Cityneeds retains the right to use all published delivered works for Cityneeds marketing and promotion purposes.")]), _vm._v(" "), _c('h2', [_vm._v("CNpro Terms of Operations")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("CNpro is pre-verified and then enlisted as a freelance professional, skilled- worker, or artisan on cityneeds platform where CNusers can connect and  access their services.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v(" CNpro may offer a maximum of two services: however , it is recommended that these services should be related e.g.( Air-conditioner repairs and Refrigerator repairs).\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v(" Each order you successfully complete and deliver credits your account with a net income of 80% of CNproServiceFees (Labour Charge) you quoted to the CNuser (customer): in order words, Cityneeds Technologies Limited charges and automatically deducts a commission of 15%, and a Value Added Tax (VAT) of 5% for every job a CNpro successfully completes and delivers. For example, if your Labour Charge for painting a Three Bedroom Flat is N50,000.00, \r\n\t\t\t\t\t\t\t\t\t\t\t\t\tyou are to add 5% of N50,000.00 (which is N2,500.00) to the Labour Charge as Value Added Tax (VAT).\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v(" Cityneeds credits CNpro once an order is completed and delivered to the satisfaction of the CNuser.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v(" If an order is cancelled (for any reason), the funds paid will be used to settle a new CNpro that  will be  chosen by the CNuser to complete the job, however , if the funds paid in advance is deemed to be too small to complete the job, the CNuser will be required to make-up the  amount to the agreed fees.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v(" CNincomes are only credited to CNpros account after safety clearance period of two days, (time within which the CNuser would have tested the job and is satisfied ) after the order is marked as delivered satisfactorily by the CNuser .\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v(" CNpros may promote their completed jobs.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("The CNpro's rating is calculated based on the order reviews posted by CNusers.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("For security concerns, improper behaviour , violation of the trust of CNuser, or any other action deemed to be inappropriate by Cityneeds ,Cityneeds may   temporarily disable or permanently delete the CNpro's Account.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds is all about helping CNpros leverage their skills. We seek to empower top performing CNpros with helpful tools to grow their business. CNpros who invest in skills enhancement programmes may achieve greater customer satisfaction. \r\n\t\t\t\t\t\t\t\t\t\t\tAnd, if they deliver on time and maintain high quality and ratings, Cityneeds may reward them with new statuses, special opportunities, benefits, and tools that come with it.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("CNuser Terms of Service ")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("You must not offer direct payments to CNpros using payment systems outside of the Cityneeds Quotation Settlement system.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds retains the right to use all publicly published delivered works for Cityneeds marketing and promotional purposes.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds only receives professional fees or labour wage (CNproServiceFees) with respect to only transactions of Premium Plan CNusers. But all work materials e.g. for a plumbing work like gum, pipe , taps etc are to be procured by the CNusers.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Purchasing")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("CNusers who choose Paid Plan must pay Cityneeds the stipulated Subscription Fees that enables them to gain access to a pool of pre-verified CNpros  using the Select a Plan button.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Order may be confirmed using one of the following payment methods: Credit Card, Debit Card,or any other payment options on the platform.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Paid Plan Users are charged a fee depending on the plan they choose ( either quarterly-year , half-year or full-year plan) at the time of choosing a plan . These fees cover payment processing and administrative fees.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("To protect against fraud, unauthorised transactions , dubious claims or other liabilities, we do not collect credit/ debit card information; but our payment vendors  collect information for the purpose of collecting payments from CNusers on the Site or transferring payments to CNpros on the Site. We are not exposed to the payment information provided to our payment vendors, and this information is subject to the privacy policy applicable to the payment vendor, "), _c('a', {
    attrs: {
      "href": "https://paystack.com"
    }
  }, [_vm._v(" www.paystack.com ")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Once payment is confirmed, your subscription will be created and given a unique Cityneeds subscription code.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNpros  must deliver completed job and/or proof of work using the Deliver Work button (located on the Order page) according to the service that was quoted , accepted , completed and delivered.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Using the Completed Work button may not be abused by CNpros to circumvent Quote guidelines described in this Terms of Service. Using the \"Completed Work\" button when an order was not fulfilled may result in a cancellation of that order after review, affect the CNpro's rating and result in a query or outright termination of the CNpro's account .\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("A Quote/job order is considered as complete after the Quote is marked as Completed and then rated by the CNuser. An order will be automatically marked as complete and delivered if not rated and no request for modification was submitted within 2 days after the work was marked as completed by the CNpro.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("We encourage our CNusers and CNpros to try and settle conflicts amongst themselves. If for any reason this fails, Paid Plan CNusers can contact Cityneeds Customer Support department for assistance: support@cityneeds.com\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Handling Orders")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("When a CNuser orders a job, the CNpro is notified by email, SMS , as well as notifications on the site while logged into the account.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNpros are required to meet the delivery time they specified when creating their job order. Failing to do so will allow the CNuser to cancel the order when an order is marked as late and may harm the CNpro's status.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNpros must send completed files and/or proof of work using the Completed Work button (located on the Order page) to mark the order as Completed .\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNuser are responsible for scanning all transferred files for viruses and malware. Cityneeds will not be held responsible for any damages which might occur due to site usage, use of content or files transferred.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("A CNpro may cancel an order without the CNuser's knowledge at any given moment (Force Cancellation). However, this might have a negative effect on the CNpro's status.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNusers may use the \"Complaint feature\" located on the Contract Page  while an order is marked as Completed if the completed work/ materials do not match the CNpro's description on their Quotation or they do not match the requirements sent to the CNpro at the beginning of the order process.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Reviews")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("Feedback reviews provided by CNusers while completing an order are an essential part of Cityneeds rating system. Reviews demonstrate the CNuser's overall experience with the CNpro and their service. CNusers are encouraged to communicate to the CNpros any concerns experienced during their active order in regards to the service provided by the CNpro.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Leaving a CNuser feedback is a basic prerogative of a CNuser. Feedback reviews will not be removed unless there are clear violations to our Terms of Service.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("To prevent any misuse of our Feedback system, all feedback reviews must come from legitimate services executed exclusively through the cityneeds.ng platform from users within our Community. Purchases arranged, determined to artificially enhance CNpro's ratings, or to abuse the Cityneeds platform with purchases from additional accounts, will result in a permanent suspension of all related accounts.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Feedback comments given by CNusers are publicly displayed on a CNpro's page. CNusers have the option not to include a comment, but still rate the service. Cancellation of an order does not remove feedback unless mutually agreed.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Withholding the delivery of services, files, or information required to complete a job order or service with the intent to gain favourable reviews or additional services is prohibited.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Responding and posting a review: Once work is Completed, the CNuser has two days to respond and post a review . If no response is provided within the response period, the order will be considered satisfactorily Completed and Delivered .\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNusers are allowed to leave reviews on orders up to 30 days after an order is marked as Completed . No new reviews may be added to an order after 30 days.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNpros are prohibited from soliciting for the removal of feedback reviews from their CNuser through mutual cancellations.\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Disputes and Cancellations for Premium Plan Customer")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("We encourage our CNusers  and CNpros to try and settle conflicts amongst themselves. If for any reason this fails, Cityneeds will intervene using its in-house mechanism to resolve the conflict . If both measures fails, the CNuser will have the option of choosing another CNpro to fulfil their job order under a fresh term and condition( if for any reason the former CNpro inadvertently  under-quoted or undercharged the job ab initio )\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("If a CNuser chooses to cancel their order, CNproServiceFees less CNincome will be credited to the account of the CNuser for future use. \r\n\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Refunds")]), _vm._v(" "), _c('p', [_vm._v("      Cityneeds does not automatically refund payments made for cancelled orders back to your payment provider. Funds from order cancellations are refunded to the buyer's balance as credit and are available for future purchases on cityneed.ng. Funds returned to your balance from cancelled orders will not include Subscription Fees paid.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("User Conduct And Protection")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("Cityneeds enable users  to provide , create, share, sell and purchase nearly any service they need at very competitive  rate/ value. Services offered on Cityneeds reflects the dynamics of an ever changing shared-economy. Members of the cityneeds community communicate and engage through orders, social media, and on Cityneeds Community Forums.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds maintains a friendly, community spirited, and professional environment. Users should keep to that spirit while participating in any activity or extensions of Cityneeds . This section relates to the expected conduct users should adhere to while interacting with each other on Cityneeds .\r\n\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("To report a violation of our Terms of Service, User Misconduct, or inquiries regarding your account, please contact our Customer Support team by sending a mail to report@cityneeds.ng \r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("To protect our users' privacy, user identities are kept anonymous. Requesting or providing Email addresses, Skype/IM usernames, telephone numbers or any other personal contact details to communicate outside of Cityneeds in order to circumvent or abuse the Cityneeds messaging system or Cityneeds platform is not permitted.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Any necessary exchange of personal information required to continue a service may be exchanged within the Contract page.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds does not provide any guarantee of the level of service offered to CNusers. You may use the dispute resolution tools provided to you ONLY IF you are a Paid Plan Customer. \r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds does not provide protection for users who interact outside of the cityneeds platform.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("All information and file exchanges must be performed exclusively on cityneeds platform.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Rude, abusive, improper language, or violent messages sent to users will not be tolerated and may result in an account warning or the suspension/removal of your account.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("The Cityneeds platform  is open to everyone. Discrimination against a community member based on gender, race, age, religious affiliation, sexual preference or otherwise is not acceptable and may result in the suspension/removal of your account.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Orders")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "number"
    }
  }, [_c('li', [_vm._v("Users with the intention to defame competing sellers by ordering from competing services will have their reviews removed or further account status related actions determined by review by our Trust & Safety team.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Users are to refrain from spamming or soliciting previous Buyers or Sellers to pursue removing/modifying reviews or cancelling orders that do not align on Order Cancellation or Feedback policies.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds reviews cases of payment provider chargebacks and disputes on behalf of CNusers. Although results vary per case due to each chargeback reason, we work hard on resolving disputes in the CNuser's favour. \r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Users may report infractions to Customer Support that may be in violation of Cityneeds Terms of Service based on a confirmed replicated similarity to pre-existing services (copycat ).\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds will respond to clear and complete notices of alleged copyright or trademark infringement.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Reporting Violations")]), _vm._v(" "), _c('p', [_vm._v("If you come across any content that may violate our Terms of Service, you should report it to us through the appropriate channels created to handle those issues as outlined in our Terms of Service. All cases are reviewed by our Trust & Safety team. To protect individual privacy, the results of the investigation are not shared. You can review our Privacy Policy for more information.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("Violations")]), _vm._v(" "), _c('p', [_vm._v("Community members (CNusers and CNpros alike)  may receive a warning to their account for violations of our Terms of Service or any user misconduct reported to our Trust and Safety team. A warning will be sent to the member's email address and will be displayed for such member on the Site. Warnings do not limit account activity, but can lead to your account losing community member statuses or becoming permanently disabled based on the severity of the violation.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "100%",
      "font-weight": "strong"
    }
  }, [_vm._v("NON-PERMITTED USAGE")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Adult Services & Pornography ")]), _vm._v("- Cityneeds does not allow any exchange of adult oriented or pornographic materials and services.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Inappropriate Behaviour & Language ")]), _vm._v("- Communication on Cityneeds should be friendly, constructive, and professional. Cityneeds condemns bullying, harassment, and hate speech towards others. We allow members a medium for which messages are exchanged between individuals, a system to rate orders, and to engage on larger platforms such as our Community Forum and Social Media pages.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Phishing and Spam")]), _vm._v(" - Cityneeds takes its members’ security seriously. Any attempts to publish or send malicious content with the intent to compromise another member’s account or computer environment is strictly prohibited. Please respect our members privacy by not contacting them for commercial purposes without their consent.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Privacy & Identity ")]), _vm._v("- You may not publish or post other people's private and confidential information. Any exchange of personal information required for the completion of a service must be provided in the order page. CNpros further confirm that whatever information they receive from the CNuser, which is not public domain, shall not be used for any purpose whatsoever other than for the completion and delivery of the work to the CNuser. Any users who engage and communicate off of Cityneeds platform will not be protected by our Terms of Service.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Intellectual Property Claims")]), _vm._v(" - Cityneeds will respond to clear and complete notices of alleged copyright or trademark infringement, and/or violation of third party’s terms of service. \r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Fraud / Unlawful Use")]), _vm._v(" - You may not use Cityneeds for any unlawful purposes or to conduct illegal activities.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "80%",
      "font-weight": "normal"
    }
  }, [_vm._v("ABUSE AND SPAM")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Multiple Accounts ")]), _vm._v("- To prevent fraud and abuse, CNusers are limited to one active account. Any additional account determined to be created to circumvent guidelines, promote competitive advantages, or mislead the Cityneeds community will be disabled. Mass account creation may result in disabling of all related accounts. Note: any violations to Cityneeds Terms of Service is cause for permanent suspension of all accounts.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Targeted Abuse ")]), _vm._v("- We do not tolerate users who engage in targeted abuse or harassment towards other users on cityneeds . This includes creating new multiple accounts to harass members through our forum, message or ordering system.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Selling Accounts")]), _vm._v(" - You may not transfer , buy or sell Cityneeds accounts.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("General Terms")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "nummber"
    }
  }, [_c('li', [_vm._v("Cityneeds reserves the right to put any account on hold or permanently disable accounts due to breach of these terms of service or due to any illegal or inappropriate use of the Site or services.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Violation of Cityneeds Terms of Service may get your account disabled permanently.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Members with disabled accounts will not be able to access Cityneeds platform.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Members who have violated our Terms of Service and had their account disabled may contact our Customer Support team for more information surrounding the violation and status of the account.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNuser have the option to enable account Security features to protect their  account from any unauthorised usage.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNuser must be able to verify their account ownership through Customer Support by providing materials that prove ownership of that account.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("CNpros  will be able to withdraw their CNincome from disabled accounts after a safety period of 7 days following full verification of ownership of the account in question, from the day of the last cleared payment received in their account and subject to Cityneeds approval.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Disputes should be handled using Cityneeds dispute resolution tools ('Resolution Center) or by contacting Cityneeds Customer Support.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cityneeds may make changes to its Terms of Service from time to time. When these changes are made, Cityneeds will make a new copy of the terms of service available on this page.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("You understand and agree that if you use Cityneeds after the date on which the Terms of Service have changed, Cityneeds will treat your use as acceptance of the updated Terms of Service.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("User Generated Content")]), _vm._v(" "), _c('p', [_vm._v("User Generated Content (\"UGC\") refers to the content added by our community members as opposed to content created by the Site. All content uploaded to Cityneeds by our members (CNusers and CNpros) is User Generated Content. Cityneeds does not check user/member uploaded/created content for appropriateness, violations of copyright, trademarks, other rights or violations. We invite everyone to report violations together with proof of ownership as appropriate. Reported violating content may be removed or disabled.  \r\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("Furthermore, Cityneeds is not responsible for the content, quality or the level of service provided by the CNpros. We provide no warranty with respect to the job order delivery, and any communications between CNusers and CNpros. We encourage CNusers to take advantage of our rating system, our community and common sense in choosing preferred CNpros/ service providers.  \r\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("By offering a service, the CNpro undertakes that he/she has sufficient permissions, rights and/or licenses to provide, sell or resell the service is offered on Cityneeds .CNpros must comply with laws and terms of service of the advertising platform or relevant website used to advertise. Failing to do so may result in removal of the advert and may lead to the suspension of CNpro's account.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("Commercial Use License")]), _vm._v(" "), _c('p', [_vm._v("By purchasing a \"Commercial Use License\" with your order, the CNpro grants you a perpetual, exclusive, non-transferable, worldwide license to use the purchased delivery for Permitted Commercial Purposes. All intellectual property rights of the purchased delivery are hereby assigned to you. \"Permitted Commercial Purposes\" means any business related use, such as (by way of example) advertising, promotion, creating web pages, integration into product, software or other business related tools etc., and strictly excludes any illegal, immoral or defamatory purpose. This License is subject to Cityneeds Terms of Service. There is no warranty, express or implied, with the purchase of this delivery, including with respect to fitness for a particular purpose. Neither the CNpro nor Cityneeds will be liable for any claims, or incidental, consequential or other damages arising out of this license, the delivery or your use of the delivery.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("Disclaimer of Warranties")]), _vm._v(" "), _c('p', [_vm._v("YOUR USE OF THE SITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE IS AT YOUR OWN RISK. THE SITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. NEITHER CITYNEEDS TECHNOLOGIES LIMITED NOR ANY PERSON ASSOCIATED WITH CITYNEEDS TECHNOLOGIES LIMITED MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE WEBSITE. THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("Automatic Translation")]), _vm._v(" "), _c('p', [_vm._v("THIS SERVICE MAY CONTAIN TRANSLATIONS POWERED BY GOOGLE. GOOGLE DISCLAIMS ALL WARRANTIES RELATED TO THE TRANSLATIONS, EXPRESS OR IMPLIED, INCLUDING ANY WARRANTIES OF ACCURACY, RELIABILITY, AND ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("The Site maybe translated for your convenience using translation software powered by Google Translate. Reasonable efforts have been made to provide an accurate translation, however, no automated translation is perfect nor is it intended to replace human translators. Translations are provided as a service to users of the website, and are provided \"as is\". No warranty of any kind, either expressed or implied, is made as to the accuracy, reliability, or correctness of any translations made from English into any other language. Some content (such as images, videos, Flash, etc.) may not be accurately translated due to the limitations of the translation software.\r\n\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("The official text is the English version of the website. Any discrepancies or differences created in the translation are not binding and have no legal effect for compliance or enforcement purposes. If any questions arise related to the accuracy of the information contained in the translated website, please refer to the English version of the website which is the official version.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', [_vm._v("Limitation on Liability")]), _vm._v(" "), _c('p', [_vm._v("IN NO EVENT WILL CITYNEEDS , ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH OTHER WEBSITES OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE OR SUCH OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE.\r\n\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.\r\n\t\t\t\t\t\t\t\t\t\t\t")])])])])])])])])
}]}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [(_vm.panelFlag) ? _c('div', {}) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('sidebar')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.premium_message) ? _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "1em",
      "border": "#22baae 3px solid"
    }
  }, [_c('p', [_vm._v("Your Free Trial is Over. To Access CNpros, Please Upgrade; See Plans Below.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h1', [_vm._v("CNpro Plans & Pricing")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.plan_type) ? _c('div', {
    staticClass: "plan-header"
  }, [_vm._m(2)]) : _c('div', [(_vm.user.user_free_plan_option == 1) ? _c('div', {
    staticClass: "plan-header"
  }, [_c('p', [_vm._v("Your "), _c('b', [_vm._v("1 Month Free Plan")]), _vm._v(" ends on " + _vm._s(_vm.user.user_premuim_plan_expiry_date))])]) : (_vm.user.user_premuim_plan_id == 1) ? _c('div', {
    staticClass: "plan-header"
  }, [_c('p', [_vm._v("Your "), _c('b', [_vm._v("Plan expired on " + _vm._s(_vm.user.user_premuim_plan_expiry_date))]), _vm._v(" please subscribe to another plan ")])]) : _c('div', {
    staticClass: "plan-header"
  }, [_c('p', [_vm._v("You are on a "), _c('b', [_vm._v(_vm._s(_vm.user.user_premuim_plan) + " Plan")]), _vm._v(" ending on " + _vm._s(_vm.user.user_premuim_plan_expiry_date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "pricings hidden-sm hidden-xs"
  }, [_c('table', {
    staticClass: "comparison-table"
  }, [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("Quarterly"), _c('br'), _vm._v("(3 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[0].plan_amount))])]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("Half Year"), _c('br'), _vm._v("(6 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[1].plan_amount))])]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("Full Year"), _c('br'), _vm._v("(12 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[2].plan_amount))])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.plans), function(plan) {
    return _c('td', {
      staticClass: "plans"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      style: ({
        display: _vm.check_free_plan(plan)
      }),
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.presetPaymentPlan(plan)
        }
      }
    }, [_vm._v("Select Plan")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pricings hidden-lg hidden-md"
  }, [_c('div', {
    staticClass: "col-md-12 pricing-tab",
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "font-size": "12px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-head"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("Quarterly"), _c('br'), _vm._v("(3 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[0].plan_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("Half Year"), _c('br'), _vm._v("(6 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[1].plan_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("Full Year"), _c('br'), _vm._v("(12 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[2].plan_amount))])])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-head"
  }, _vm._l((_vm.plans), function(plan) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        display: _vm.check_free_plan(plan)
      }),
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.presetPaymentPlan(plan)
        }
      }
    }, [_vm._v("Select Plan")])])
  }))])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.selected_plan.plan_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance > _vm.selected_plan.plan_amount) ? _c('div', [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _vm._e()]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process Payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("WHY YOU HAVE TO SUBSCRIBE BEFORE YOU CAN CONTACT CNpros:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Finding diligent workers is HARD. Ensuring that workers keep transactions within the loop is EVEN HARDER. "), _c('br'), _vm._v("\r\n                             Subscription fees guarantees that insurance is in place, and keeps conflict mediation mechanism active.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("You are entitled to a 1 Month Free Introductory Plan"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Get Started")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Number of CNpros to Choose From")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("unlimited")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("unlimited")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("unlimited")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Insurance Cover on Accidental Damage of Property by CNpro")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Withholding (Escrow) of CNpro’s Service Fees/Labour Wage until Satisfactory Completion of Job ")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Access to User Support and Conflict Mediation")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Transfer of Unfinished Job to Another CNpro")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Newsletter")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✘")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Do-It-Yourself Tips")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✘")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✘")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Number of CNpros to Choose From")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("unlimited")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("unlimited")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("unlimited")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Insurance Cover on Accidental Damage of Property by CNpro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-x"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Withholding (Escrow) of CNpro’s Service Fees/Labour Wage until Satisfactory Completion of Job ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Access to User Support and Conflict Mediation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-x"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Transfer of Unfinished Job to Another CNpro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Newsletter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-x"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✘")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Do-It-Yourself Tips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✘")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✘")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "img-responsive col-md-4 col-sm-12 col-xs-12 img-rounded",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-8"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "btn btn-primary btn-share",
    on: {
      "click": function($event) {
        _vm.saveComponent(_vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bookmark"
  }), _vm._v(" Save CNpro\r\n                                    \r\n                                ")])]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "text-secondary"
  }, [_vm._v(_vm._s(_vm.cnpro.cnpro_name))])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "detail-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.cnpro.cnpro_description) + ".")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user.user_premuim_plan_id != 1) ? _c('div', [_c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_vm._v("Social Handles: ")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.cnpro.cnpro_twitter
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.cnpro.cnpro_facebook
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.cnpro.cnpro_instagram
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])]), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user.user_premuim_plan_id != 1) ? _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "detail-vcard"
  }, [_c('div', {
    staticClass: "detail-contact row"
  }, [_c('div', {
    staticClass: "detail-contact-address col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_address))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact-email col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_email))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "detail-vcard"
  }, [_c('div', {
    staticClass: "detail-contact row"
  }, [_c('div', {
    staticClass: "detail-contact-phone col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone"
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_phone))])]), _vm._v(" "), _vm._m(0)])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row detail-content"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [(_vm.cnpro.cnpro_rating_average_rate) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.cnpro.cnpro_rating_average_rate) + " ")]), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "goldenrod"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("(" + _vm._s(_vm.cnpro.cnpro_rating_total_rating) + ") ")]), _vm._v(", \r\n                                    ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('a', [_vm._v(_vm._s(_vm.cnpro.cnpro_reviews_total_count) + " reviews")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reviews"
    }
  }, [_vm._v("All Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "reviews"
  }, [(_vm.cnpro.cnpro_reviews.length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No reviews yet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cnpro.cnpro_reviews), function(review) {
    return [_c('div', {
      staticClass: "review"
    }, [_c('div', {
      staticClass: "review-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.img_url + review.review_user_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "review-inner"
    }, [_c('div', {
      staticClass: "review-title"
    }, [_c('h2', [_vm._v(_vm._s(review.review_user))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "review-overall-rating"
    }, [_c('span', {
      staticClass: "overall-rating-title"
    }, [_vm._v("Total Score:")]), _vm._v(" "), _vm._l((review.review_user_rate), function(rate) {
      return [_c('i', {
        staticClass: "fa fa-star"
      })]
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "review-content-wrapper"
    }, [_c('div', {
      staticClass: "review-content"
    }, [_c('div', {
      staticClass: "review-pros"
    }, [_c('p', [_vm._v(_vm._s(review.review_review) + ".")])])])])])])]
  })], 2)]), _vm._v(" "), (_vm.user.user_premuim_plan_id == 1) ? _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger btn-block col-sm-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.moveToPlans
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("Chat with CNpro")])]) : _c('div', {
    staticClass: "col-sm-5"
  }, [_c('h2', [_vm._v("How May I Help You?")]), _vm._v(" "), _c('div', {
    staticClass: "detail-enquire-form background-white p20"
  }, [(_vm.activeRequest) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active discussion with this CNpro")]), _vm._v(" "), _vm._m(2)]) : _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.details),
      expression: "request.details"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "placeholder": "Start Typing...",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.request.details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.requestQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("Send")])])])])])])])])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-contact-website col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "report"
  }, [_c('span', {
    staticClass: "separator"
  }, [_vm._v("•")]), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "title": "Report",
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "contracts",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("View Discussion")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Let's Chat "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "background": "#fff",
      "padding": "2em",
      "border-radius": "5px",
      "border": "1px solid #999"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-lg-12 ccol-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h2', [_vm._v("Privacy Policy of Cityneeds Technologies Limited, operating online through its registered URL, "), _c('span', [_c('a', {
    staticStyle: {
      "color": "#22baae"
    },
    attrs: {
      "href": "https://www.cityneeds.ng",
      "target": "_blank"
    }
  }, [_vm._v("https://cityneeds.ng ")])])])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Welcome to ‪http://cityneeds.ng (our "), _c('em', [_vm._v("\"Website\"")]), _vm._v("), an interactive online platform   (\""), _c('em', [_vm._v("us")]), _vm._v("\", \""), _c('em', [_vm._v("we")]), _vm._v("\" or \""), _c('em', [_vm._v("our")]), _vm._v("\"). Please read the following to learn more about our Privacy Policy.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("We respect your privacy and are committed to protecting personally identifiable information you may provide us through our Website (however accessed and/or used, whether via personal computers, mobile devices or otherwise). We have adopted this Privacy Policy (this \""), _c('em', [_vm._v("Privacy Policy")]), _vm._v("\") to explain what information may be collected on our Website, how we use this information, and under what circumstances we may disclose the information to third parties. This Privacy Policy applies only to information we collect through our Website and does not apply to our collection of information from other sources.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy, together with the "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_c('em', [_vm._v("Terms of Use")])]), _vm._v(" posted on our Website, sets forth the general rules and policies governing your use of our Website. Depending on your activities when visiting our Website, you may be required to agree to additional terms and conditions.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("We generally keep this Privacy Policy posted on our Website and you should review it frequently, as it may change from time to time without notice. Any changes will be effective immediately upon the posting of the revised Privacy Policy. WHEN YOU ACCESS OUR WEBSITE, YOU AGREE TO THIS PRIVACY POLICY. IF YOU DO NOT AGREE TO THIS PRIVACY POLICY, OR TO ANY CHANGES WE MAY SUBSEQUENTLY MAKE, IMMEDIATELY STOP ACCESSING OUR WEBSITE. If, at any point, we decide to use your personally identifiable information in a manner materially different than what was stated at the time it was collected, we will notify users of this change by email to the last email address provided to us. Users will have a choice (by means of an opt-out opportunity) as to whether or not we use their information in this different manner. We will use information in accordance with the privacy policy under which the information was collected if you opt-out of the new policy.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("A. INFORMATION WE COLLECT\r\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("Our Website typically collects two kinds of information about you: (a) information that you provide that personally identifies you; and (b) information that does not personally identify you that we automatically collect when you visit our Website or that you provide to us.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "120%",
      "font-weight": "bold"
    }
  }, [_vm._v("1. Personally Identifiable Information:")]), _vm._v(" "), _c('br'), _vm._v("\r\n\t\t\t\t\t\t\t\t\tOur definition of personally identifiable information includes any information that may be used to specifically identify or contact you, such as your name, mail address, phone number, etc. As a general policy, \r\n\t\t\t\t\t\t\t\t\twe do not automatically collect your personally identifiable information when you visit our Website. In certain circumstances, we may request, allow or otherwise provide you with an opportunity to submit your personally identifiable information in connection with a feature, program, promotion or some other aspect of our Website. For instance, you may: (a) provide your name, mail/shipping address, e-mail address, credit card number and phone number when registering with our Website, using our online store, or in connection with a contest entry; (b) provide certain demographic information about you (e.g., age, gender, purchase preference, usage frequency, etc.) when participating in a survey, poll or joining a club; or (c) post a product rating and recommendation on our Website. \r\n\t\t\t\t\t\t\t\t\tCertain information may not be personally identifiable when standing alone (e.g., your age), but may become so when combined with other information (e.g., your age and name). Whether or not you provide this information is your choice; however, in many instances this type of information is required to participate in the particular activity, realise a benefit we may offer, or gain access to certain content on our Website.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "120%",
      "font-weight": "bold"
    }
  }, [_vm._v("2. Non-Personal Information:")]), _vm._v(" "), _c('br'), _vm._v("Our definition of non-personal information is any information that does not personally identify you. Non-personal information can include certain personally identifiable information that has been de-identified; that is, information that has been rendered anonymous. We and/or our third party service providers obtain non-personal information about you from information that you provide us, either separately or together with your personally identifiable information. We also automatically collect certain non-personal information from you when you access our Website. This information can include, among other things, IP addresses (or some other unique identifier for the particular device you use to access the Internet), the type of browser you are using, the third party website from which your visit originated, the operating system you are using, the domain name of your Internet service provider, the search terms you use on our Website, the specific web pages you visit and the duration of your visits.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("B. HOW WE USE & SHARE THE INFORMATION COLLECTED\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "120%",
      "font-weight": "bold"
    }
  }, [_vm._v("1. Personally Identifiable Information:")]), _vm._v(" "), _c('br'), _vm._v("The personally identifiable information you submit to us is generally used to carry out your requests, respond to your inquiries or in other ways naturally associated with the circumstances in which you provide the information. We may also use this information to later contact you for a variety of reasons, such as customer service, providing you with promotional information for our products or those of our subsidiaries or other affiliated companies (\""), _c('em', [_vm._v("affiliated companies")]), _vm._v("\"), or to communicate with you about content or other information you have posted or shared with us via our Website. You may opt-out from receiving future promotional information from us or our affiliated companies, or direct that we not share your information with any affiliated companies, as set forth below.\r\n\t\t\t\t\t\t\t\t\tIn certain instances we may also share your personally identifiable information with our third party vendors performing functions on our behalf (or on behalf of our affiliated companies) — e.g., vendors that process credit card orders, deliver merchandise, administer our promotions, provide us with marketing or promotional assistance, analyse our data, assist us with customer service, etc. Our vendors agree to use this information, and we share information with them, only to carry out our requests. In addition, we may share your personally identifiable information with participating sponsors to a program or promotion you enter via our Website, and with third parties who assist us in using the content or other information you have posted or shared with us via our Website (e.g., production companies we may use). Further, we may share your personally identifiable information with third parties such as our co-promotional partners and others with whom we have marketing or other relationships. Except as provided in this Privacy Policy, "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_c('em', [_vm._v("our Terms of Use")])]), _vm._v(", or as set forth when you submit the information, your personally identifiable information will not be shared or sold to any third parties without your prior approval.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "120%",
      "font-weight": "bold"
    }
  }, [_vm._v("2. Non-Personal Information:")]), _vm._v(" "), _c('br'), _vm._v("In addition to any personally identifiable information or other information that you choose to provide to us on our Website, we and our third-party service providers may use a variety of technologies, now and hereafter devised, that automatically collect certain non-personal information whenever you visit or interact with our Website. We collect IP addresses for purposes of system administration, to report non-personal aggregate information to others, and to track the use of our Website. It is not our practice to link IP addresses to anything personally identifiable; that is, the visitor's session will be logged, but the visitor remains anonymous to us. \r\n\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("However, we reserve the right to use IP addresses to identify a visitor when we feel it is necessary to enforce compliance with our Website rules or to: (a) fulfil a government request; (b) conform with the requirements of the law or legal process; (c) protect or defend our legal rights or property, our Website, or other users; or (d) in an emergency to protect the health and safety of our Website's users or the general public.\r\n\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("We use non-personal information in a variety of ways, including to help analyse site traffic, understand customer needs and trends, carry out targeted promotional activities and to improve our services. We may use your non-personal information by itself or aggregate it with information we have obtained from others. We may share your non-personal information with our affiliated companies and third parties to achieve these objectives and others, but remember that aggregate information is anonymous information that does not personally identify you. Website usage information may be collected using various methods, such as the following:\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(a) Cookies, etc.:")]), _vm._v(" "), _c('br'), _vm._v("\"Cookies\" are small text files from a website that are stored on your hard drive. These text files make using our Website more convenient by, among other things, saving your passwords and preferences for you. Cookies themselves do not typically contain any personally identifiable information. We may analyze the information derived from these cookies and other technological tools we employ (such as clear gifs/web beacons) and match this information with data provided by you or another party. We may provide our analysis and certain non-personal information to third parties (who may in turn use this information to provide advertisements tailored to your interests), but this will not involve disclosing any of your personally identifiable information. Please note that advertisers that serve advertisements on our Website may also use their own cookies and other technological tools which are subject to the advertiser's privacy policies, not this Privacy Policy. If you are concerned about the storage and use of cookies, you may be able to direct your internet browser to notify you and seek approval whenever a cookie is being sent to your hard drive. You may also delete a cookie manually from your hard drive through your internet browser or other programs. Please note, however, that some parts of our Website will not function properly or be available to you if you refuse to accept a cookie or choose to disable the acceptance of cookies.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(b) Web Beacons:")]), _vm._v(" "), _c('br'), _vm._v("Small graphic images or other web programming code called web beacons (also known as “1x1 GIFs” or “clear GIFs”) may be included in our web pages and e-mail messages. Web beacons may be invisible to you, but any electronic image or other web programming code inserted into a web page or e-mail can act as a web beacon. Web beacons or similar technologies may be used for a number of purposes, including to count visitors to our Website, to monitor how users navigate our Website, to count how many e-mails that were sent were actually opened or to count how many particular articles or links were actually viewed.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(c) Mobile Device Identifiers:")]), _vm._v(" "), _c('br'), _vm._v("Certain mobile service providers uniquely identify mobile devices and we or our third-party service providers may receive such device information if you access the Website through mobile devices. Certain features of the Website may require collection of mobile phone numbers, and we may associate that phone number to mobile device identification information. Additionally, some mobile phone service providers operate systems that pinpoint the physical location of devices that use their service. Depending on the provider, we or our third-party service providers may receive this information.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(d) Embedded Scripts:")]), _vm._v(" "), _c('br'), _vm._v("An embedded script is programming code that is designed to collect information about your interactions with our Website, such as the links you click on. The code is temporarily downloaded onto your computer from our web server or a third-party service provider, is active only while you are connected to our Website, and is deactivated or deleted thereafter.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("C. OTHER USES")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1. E-mail Communications:")]), _vm._v(" "), _c('br'), _vm._v("If you send us an e-mail with questions or comments, we may use your personally identifiable information to respond to your questions or comments, and we may save your questions or comments for future reference. For security reasons, we do not recommend that you send non-public personal information, such as passwords, social security numbers, or bank account information, to us by e-mail. However, aside from our reply to such an e-mail, it is not our standard practice to send you e-mail unless you request a particular service or sign up for a feature that involves e-mail communications, it relates to purchases you have made with us (e.g., product updates, comments, customer support, etc.), we are sending you information about our other products and services, or you consented to being contacted by e-mail for a particular purpose. In certain instances, we may provide you with the option to set your preferences for receiving e-mail communications from us; that is, agree to some communications but not others. You may \"opt-out\" of receiving future commercial e-mail communications from us by clicking the \"unsubscribe\" link included at the bottom of most e-mails we send, or as provided below; provided, however, we reserve the right to send you transactional e-mails such as customer service communications.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2. Transfer of Assets:")]), _vm._v(" "), _c('br'), _vm._v("As we continue to develop our business, we may sell or purchase assets. If another entity acquires our company or all (or substantially all) of our assets, the personally identifiable information and non-personal information we have about you will be transferred to and used by this acquiring entity, though we will take reasonable steps to ensure that your preferences are followed. Also, if any bankruptcy or reorganisation proceeding is brought by or against us, all such information may be considered an asset of ours and as such may be sold or transferred to third parties.\r\n\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t")]), _c('p', [_c('strong', [_vm._v("3. Other:")]), _vm._v(" "), _c('br'), _vm._v("Notwithstanding anything herein to the contrary, we reserve the right to disclose any personally identifiable or non-personal information about you if we are required to do so by law, with respect to notices and counter notices pursuant to extant laws of the operating country or Nigeria as the case maybe  and takedown policy and procedures and/or if we believe that such action is necessary to: (a) fulfil a government request; (b) conform with the requirements of the law or legal process; (c) protect or defend our legal rights or property, our Website, or other users; or (d) in an emergency to protect the health and safety of our Website's users or the general public.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4. Contests and Promotions:")]), _vm._v(" "), _c('br'), _vm._v("We may offer contests and other promotions through the Website that may require registration. By entering any contest or promotion, you are agreeing to the official rules that govern that contest or promotion, which may contain specific requirements of you, including, except where prohibited by law, allowing the sponsor(s) of the contest or promotion to use your name, voice and/or likeness in advertising or marketing associated with the contest or promotion. If you choose to enter a contest or promotion, personally identifiable information may be disclosed to third parties or the public in connection with the administration of such contest or promotion, including, without limitation, in connection with winner selection, prize fulfilment and as required by law or permitted by the promotion’s official rules, such as on a winners list.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("5. Third-Party Email Promotions")]), _vm._v(" "), _c('br'), _vm._v("Occasionally we'll send you an advertorial email from one of our advertisers. These advertorial features are clearly marked as such by the emails \"From\" line and the title at the top of the article itself. The content is paid for by our sponsors, and does not reflect the opinions of the our editorial staff. When you sign up for our emails, you are agreeing not only to get our content delivered to you for free, but these occasional advertorial emails from our partners. If you would prefer not to receive these emails, you can unsubscribe by and we will not send you any additional content or advertorial emails.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("6. Third Party Ad Server Networks:")]), _vm._v(" "), _c('br'), _vm._v("Our Website may use third parties such as network advertisers to serve advertisements on our Website and may use traffic measurement services to analyze traffic on our Website. Network advertisers are third parties that display advertisements based on your visits to our Website and other websites you have visited. Third-party ad serving enables us to target advertisements to you for products and services in which you might be interested. Our Website’s third party ad network providers, the advertisers, the sponsors and/or traffic measurement services may themselves set and access their own cookies and other technologies on your computer and track certain behavioural information regarding users of your computer via an IP address or other device identifier. These third party cookies and other technologies are set to, among other things: (a) help deliver advertisements to you that you might be interested in; (b) prevent you from seeing the same advertisements too many times; and (c) understand the usefulness to you of the advertisements that have been delivered to you. Note that any images (or any other parts of a web page) served by third parties in association with third party cookies may serve as web beacons, which enable third parties to carry out the previously described activities. Third party cookies, web beacons and other third party technologies are governed by each third party’s specific privacy policy, not this one.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("D. PUBLIC FORUMS")]), _vm._v(" "), _c('p', [_vm._v("We may offer chat rooms, message boards, bulletin boards or similar public forums where you and other users of our Website can communicate. The protections described in this Privacy Policy do not apply when you provide information (including personal information) in connection with your use of these public forums. We may use personally identifiable and non-personal information about you to identify you with a posting in a public forum. Any information you share in a public forum is public information and may be seen or collected by anyone, including third parties that do not adhere to our Privacy Policy. We are not responsible for events arising from the distribution of any information you choose to publicly post or share through our Website.\r\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("E. CHILDREN")]), _vm._v(" "), _c('p', [_vm._v("The features, programs, promotions and other aspects of our Website requiring the submission of personally identifiable information are not intended for children. We do not knowingly collect personally identifiable information from children under the age of 13. If you are a parent or guardian of a child under the age of 13 and believe he or she has disclosed personally identifiable information to us, please contact us at "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("‪interact@cityneeds.ng ")]), _vm._v(". A parent or guardian of a child under the age of 13 may review and request deletion of such child's personally identifiable information as well as prohibit the use thereof.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("F. KEEPING YOUR INFORMATION SECURE")]), _vm._v(" "), _c('p', [_vm._v("We have implemented security measures we consider reasonable and appropriate to protect against the loss, misuse and alteration of the information under our control. Please be advised, however, that while we strive to protect your personally identifiable information and privacy, we cannot guarantee or warrant the security of any information you disclose or transmit to us online and are not responsible for the theft, destruction, or inadvertent disclosure of your personally identifiable information. In the unfortunate event that your \"personally identifiable information\" (as the term or similar terms are defined by any applicable law requiring notice upon a security breach) is compromised, we may notify you by e-mail (at our sole and absolute discretion) to the last e-mail address you have provided us in the most expedient time reasonable under the circumstances; provided, however, delays in notification may occur while we take necessary measures to determine the scope of the breach and restore reasonable integrity to the system as well as for the legitimate needs of law enforcement if notification would impede a criminal investigation. From time to time we evaluate new technology for protecting information, and when appropriate, we upgrade our information security systems.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("G. OTHER SITES / LINKS")]), _vm._v(" "), _c('p', [_vm._v("Our Website may link to or contain links to other third party websites that we do not control or maintain, such as in connection with purchasing products referenced on our Website and banner advertisements. We are not responsible for the privacy practices employed by any third party website. We encourage you to note when you leave our Website and to read the privacy statements of all third party websites before submitting any personally identifiable information.\r\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("H. CONTACT & OPT-OUT INFORMATION")]), _vm._v(" "), _c('p', [_vm._v("You may contact us as at "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("‪interact@cityneeds.ng ")]), _vm._v("if: (a) you have questions or comments about our Privacy Policy; (b) wish to make corrections to any personally identifiable information you have provided; (c) want to opt-out from receiving future commercial correspondence, including e-mails, from us or our affiliated companies; or (d) wish to withdraw your consent to sharing your personally identifiable information with others.\r\n\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("We will respond to your request and, if applicable and appropriate, make the requested change in our active databases as soon as reasonably practicable. Please note that we may not be able to fulfill certain requests while allowing you access to certain benefits and features of our Website.\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("I. SOLE STATEMENT")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy as posted on our Website is the sole statement of our privacy policy with respect to our Website, and no summary, modification, restatement or other version thereof, or other privacy statement or policy, in any form, is valid unless we post a new or revised policy on our Website.\r\n\t\t\t\t\t\t\t\t\t\t")])])])])])])])])
}]}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "pull-right col-md-3 col-xs-12 wallet-background p20 mb30"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("Your Referral Code")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#f2f2f2"
    }
  }, [_vm._v(_vm._s(_vm.referral_code))]), _vm._v(" "), _c('div', {
    staticClass: "ref-links"
  }, [_c('p', [_vm._v("Share Your Referral Code")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "22px",
      "margin-left": "-1em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": 'http://www.facebook.com/sharer.php?u=' + _vm.site_url,
      "target": "_blank",
      "title": "Share on Facebook"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.site_url + '&hashtags=cityneeds,paybills,buyairtime,surveys,discussions,findworkers,',
      "target": "_blank",
      "title": "Share on Twitter"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": 'whatsapp://send?text=' + _vm.site_url,
      "data-action": _vm.site_url,
      "target": "_blank",
      "title": "Share on Whatsapp"
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "title": "Copy Link and Share"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link",
    attrs: {
      "id": "copiied"
    }
  })])]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.copy_succ) ? _c('span', {
    staticStyle: {
      "color": "#000000",
      "background": "#ffff00",
      "font-size": "12px",
      "padding": "3px"
    }
  }, [_vm._v("Copied")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.referrals.length != 0) ? _c('div', {
    attrs: {
      "id": "refferals"
    }
  }, [_c('div', {
    staticClass: " col-md-8 p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('td', [_c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Your Referral has completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed for you to earn reward'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_status))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Referred: ")]), _vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward Progress: ")]), _c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Your Referral has completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed for you to earn reward'
      }
    })]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(ref.referral_status))])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not made any Referrals yet")])])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Referrals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-5 col-sm-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Your Referrals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("Referred")]), _vm._v(" "), _c('th', [_vm._v("Reward Progress")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Your Referrals")])])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.search_result))]), _vm._v(" in Abuja")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.search_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.search_message))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.cnpros), function(cp) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3"
    }, [_c('a', {
      staticStyle: {
        "color": "#000",
        "cursor": "pointer"
      },
      attrs: {
        "href": 'cnpro?context=' + cp.cnpro_url_name
      }
    }, [_c('div', {
      staticStyle: {
        "border": "solid 1px rgb(209, 205, 205)",
        "background": "#fff",
        "min-height": "25em",
        "max-height": "25em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "bg_image",
      style: ({
        'background': 'url(' + _vm.img_cp_url + cp.cnpro_bg_image + ')',
        backgroundSize: _vm.backgroundSize
      })
    }, [_c('div', {}, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-left": "auto",
        "margin-right": "auto",
        "border": "1px solid rgba(255, 255, 255, 0.6)",
        "margin": "0 auto",
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.img_url + cp.cnpro_image,
        "width": "100",
        "height": "100"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-tags"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(cp.cnpro_category))]), _vm._v(" |\r\n                                                  "), _c('span', [_vm._v(_vm._s(cp.cnpro_jobs_done) + " Job(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
      staticStyle: {
        "margin-top": "1em",
        "font-size": "1em"
      },
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(cp.cnpro_name))]), _vm._v(" "), _c('div', {
      staticClass: "descr"
    }, [_c('p', {
      staticClass: "truncate-words"
    }, [_vm._v(_vm._s(cp.cnpro_description))])]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" " + _vm._s(cp.cnpro_rating_average_rate) + " Point(s)\r\n                                                   " + _vm._s(cp.cnpro_reviews_total_count) + " Review(s)\r\n                                            ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.cnpros.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getAllCnpros(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])], 2)]), _vm._v(" "), _c('horizontal-widget')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid fld"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.panelFlag) ? _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12 col-lg-12 fld"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Contract Details")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back to Contracts")])]), _vm._v(" "), (_vm.viewContractPanel) ? _c('div', [_c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title hidden-md hidden-lg"
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Service Provider: " + _vm._s(_vm.contract.contract_cnpro)), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Contract Status:")]), _vm._v(" "), _c('span', {
    staticClass: "status-flag",
    style: ({
      background: _vm.contract.contract_status_color_code,
      color: '#fff',
      padding: '0.4em'
    })
  }, [_vm._v(_vm._s(_vm.contract.contract_status))])])]), _vm._v(" "), _c('h3', {
    staticClass: "page-title hidden-xs hidden-sm"
  }, [_vm._v("\r\n                                                                    Service Provider: " + _vm._s(_vm.contract.contract_cnpro) + "\r\n                                                                    "), _c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Contract Status:")]), _vm._v(" "), _c('span', {
    staticClass: "status-flag",
    style: ({
      background: _vm.contract.contract_status_color_code,
      color: '#fff',
      padding: '0.4em'
    })
  }, [_vm._v(_vm._s(_vm.contract.contract_status))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left hidden-lg hidden-md"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenuActions
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v("View Actions")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu-actions"
  }, [(_vm.contract.contract_status_id != 3) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewQuote(_vm.contract.contract_cnpro)
      }
    }
  }, [_vm._v("View Quote")]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-thread', '')
      }
    }
  }, [_vm._v("View Discussion")]), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id != 3 && _vm.contract.contract_status_id != 6 && _vm.contract.contract_status_id != 7 && _vm.contract.contract_status_id != 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#complaint"
    }
  }, [_vm._v("Make A Complaint")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id == 3 || _vm.contract.contract_status_id == 6) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeContract
    }
  }, [_vm._v("End / Close Contract Request")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8 || _vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#contract_pictures"
    }
  }, [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v(" View Uploaded Work Pictures")]) : _vm._e(), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-thread', '')
      }
    }
  }, [_vm._v("View Discussion")]), _vm._v(" "), (_vm.contract.contract_status_id != 3) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewQuote(_vm.contract.contract_cnpro)
      }
    }
  }, [_vm._v("View Quote")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id != 3 && _vm.contract.contract_status_id != 6 && _vm.contract.contract_status_id != 7 && _vm.contract.contract_status_id != 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#complaint"
    }
  }, [_vm._v("Make A Complaint")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 3 || _vm.contract.contract_status_id == 6) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeContract
    }
  }, [_vm._v("End / Close Contract Request")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8 || _vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#contract_pictures"
    }
  }, [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v(" View Uploaded Work Pictures")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_status_id == 5) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), (_vm.contract.contract_status_id == 5) ? _c('p', [_vm._v("You have Confirmed that this Work has been carrried out "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Notice!: ")]), _vm._v("Your 48hrs time frame to report any issue regarding this works ends on "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.contract.contract_expiry_date))])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 4) ? _c('div', [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), _c('p', [_vm._v("Work should be in progress, if work is completed, confirm by clicking the button below")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmQuote(_vm.contract.contract_id)
      }
    }
  }, [_vm._v("Confirm / Approve Work")])]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8) ? _c('div', [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), _c('p', [_vm._v("Work has been confirmed by CNpro, if work is completed, confirm by clicking the button below")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmQuote(_vm.contract.contract_id)
      }
    }
  }, [_vm._v("Confirm / Approve Work")])]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_contract_complaints && _vm.contract.contract_contract_complaints == 16) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), _c('p', [_vm._v("Please resolve all pending disputes (see below). If resolved, please hold on while Admin verifies CNuser job satisfaction. Thank you")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Complaints Made ")]), _vm._v(" "), _vm._l((_vm.contract.contract_contract_complaints), function(complaint, index) {
    return _c('div', [_c('p', [_vm._v(" " + _vm._s(++index) + ") " + _vm._s(complaint.contract_complaint) + " \r\n                                                                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(complaint.contract_complaint_date) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), (complaint.contract_complaint_status == 15) ? _c('span', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v("RESOLVED")]) : _c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.resolveComplaint(complaint, complaint.contract_complaint_id)
        }
      }
    }, [_vm._v("Resolve Complaint")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.contract.contract_ratings.length == 0 && _vm.contract.contract_reviews.length != 0) ? _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("Rate Service Provider")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_reviews.length == 0) ? _c('div', [(_vm.contract.contract_reviews.length == 0) ? _c('form', {
    staticClass: "background-white p20 add-review"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Review CNpro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Your Review")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.review),
      expression: "review.review"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.review.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.review.review = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.canRate) ? _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("What's your rating?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitReview(_vm.contract.contract_cnpro_id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("Submit Review")])])])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.contract.contract_reviews), function(review) {
    return _c('p', [_vm._v("\r\n                                                                                       " + _vm._s(review.contract_review_review) + "\r\n                                                                                   ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, _vm._l((_vm.contract.contract_ratings), function(rate) {
    return _c('p', [_c('b', [_vm._v("You Rated:  \r\n                                                                                         "), _vm._l((rate.contract_rating_rate), function(r) {
      return _c('i', {
        staticClass: "fa fa-star",
        staticStyle: {
          "color": "goldenrod"
        }
      })
    }), _vm._l(((5 - rate.contract_rating_rate)), function(r) {
      return _c('i', {
        staticClass: "fa fa-star-o",
        staticStyle: {
          "color": "goldenrod"
        }
      })
    })], 2)])
  }))])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.viewContractThread) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Discussion\r\n                                                            "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), _vm._l((_vm.contract.contract_contract_threads), function(thread) {
    return [_c('p', [_c('b', [_vm._v(_vm._s(thread.contract_thread_user_name) + ":")]), _vm._v(" " + _vm._s(thread.contract_thread_thread) + " ")])]
  }), _vm._v(" "), (_vm.contract.contract_status_id != 5) ? _c('form', [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.message),
      expression: "contract.message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Message",
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.replyContract(_vm.contract.contract_id, _vm.user.user_id)
      }
    }
  }, [_vm._v("Send")])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.viewQuote) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Quote Details\r\n                                                                        "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details/Description:")]), _vm._v(" " + _vm._s(_vm.contract.contract_quote_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Material Detail:")]), _vm._v(" " + _vm._s(_vm.contract.contract_material_details))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Labour Cost:")]), _vm._v(" ₦" + _vm._s(_vm.contract.contract_labour_cost))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Work Duration:")]), _vm._v(" " + _vm._s(_vm.contract.contract_work_duration) + " Days")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id == 6) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.preAcceptQuote(_vm.contract)
      }
    }
  }, [_vm._v("Accept Quote")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.rejectQuote(_vm.contract.contract_id)
      }
    }
  }, [_vm._v("Reject Quote")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()]) : _vm._e()])])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-md-offset-3",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), ((_vm.contracts.length == null)) ? _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Contracts Request Yet")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contracts), function(co, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-12 col-xs-12",
      staticStyle: {
        "padding": "1em",
        "border-bottom": "solid 1px rgb(230, 225, 225)"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('viewContract', co.contract_id)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-10 col-sm-10 col-xs-8",
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h4', [_vm._v(_vm._s(co.contract_cnpro))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(co.contract_ref))]), _vm._v(" "), _c('span', {
      style: ({
        background: co.contract_status_color_code,
        color: '#fff',
        padding: '0.2em'
      })
    }, [_vm._v(_vm._s(co.contract_status))]), _vm._v(" "), (co.contract_status_id == 12) ? _c('span', [_vm._v(" - " + _vm._s(co.contract_job_status))]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        background: co.contract_complaint_status_color_code,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(co.contract_complaint_status_name))])])])])
  })], 2)])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "complaint",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "height": "300px"
    }
  }, [_vm._m(3), _c('br'), _vm._v(" "), _c('div', {}, [_c('h3', [_vm._v("Make a complaint on the Job carried out")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.complaint),
      expression: "contract.complaint"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Message",
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.complaint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.complaint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: " btn btn-primary btn-xl",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.makeComplaint(_vm.contract.contract_id, _vm.user.user_id)
      }
    }
  }, [_vm._v("Send")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "contract_pictures",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h3', [_vm._v("Uploaded Work Pictures")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_1
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_2
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(6), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_3
    }
  })])]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "reviewModal",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('form', {
    staticClass: "background-white p20 add-review"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Review CNpro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Your Review")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.review),
      expression: "review.review"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.review.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.review.review = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.canRate) ? _c('div', {
    staticClass: "form-group input-rating col-sm-12"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("What's your rating?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitReview(_vm.contract.contract_cnpro_id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("Submit Review")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.selected_contract.contract_labour_cost))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance > _vm.selected_contract.contract_labour_cost) ? _c('div', [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.acceptQuote('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process Payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.acceptQuote('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Your Review")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_vm._v("Contracts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4"
  }, [_c('i', {
    staticClass: "fa fa-file-o",
    staticStyle: {
      "padding": "0.1em",
      "font-size": "4.6em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "2em",
      "color": "#000"
    }
  }, [_c('b', [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 1 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 2 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 3 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-top": "-3em",
      "background": "#fff",
      "padding": "2em",
      "border-radius": "3px",
      "border": "1px solid rgb(211, 208, 208)"
    }
  }, [(_vm.data_server_ready) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-8 col-lg-offset-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {}, [_vm._m(1), _vm._v(" "), _c('div', [(!_vm.view_info) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.view_info = true;
        _vm.toggleComponent('info01');
      }
    }
  }, [_vm._v("\r\n                                                Ok, Noted, Collapse this info "), _c('i', {
    staticClass: "fa fa-angle-up",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]) : _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.view_info = false;
        _vm.toggleComponent('info01');
      }
    }
  }, [_vm._v("\r\n                                                View Info "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('cndiscount-form', {
    attrs: {
      "cndiscount": _vm.cndiscount,
      "cndiscount_set_view": '',
      "payment_details_data": _vm.cndiscount_payment_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('horizontal-widget')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h2', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#22baae",
      "text-align": "center"
    }
  }, [_vm._v("How To Setup a DiscountBazaar Code or Promo ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "info01"
    }
  }, [_c('p', [_vm._v("DiscountBazaar is a platform where businesses display \r\n                                                discounted goods and services for accelerated clearance sales.\r\n                                                When business is slow and  and you want to create a marketing buzz,\r\n                                                 or you have goods that are tying down money, setup DiscountBazaar and free your business capital.\r\n                                            ")]), _vm._v(" "), _c('h6', [_vm._v("HOW TO SETUP DiscountBazaar")]), _vm._v(" "), _c('p', [_vm._v("Click \"Setup DiscountBazaar\" A form will drop down. \r\n                                                The instructions with examples as numbered and listed below are a guide on how to fill the form.\r\n                                            ")]), _vm._v(" "), _c('p', [_vm._v("1). Add/register your business on Cityneeds, if you haven't . It is  free!")]), _vm._v(" "), _c('p', [_vm._v("2). Select the registered business you want to setup DiscountBazaar for.")]), _vm._v(" "), _c('p', [_vm._v("3). Add a Caption-e.g. Buy One Get One Free")]), _vm._v(" "), _c('p', [_vm._v("4). Add a Discount Code- e.g. BOGOF")]), _vm._v(" "), _c('p', [_vm._v("5). Describe the Offer- e.g. Visit our shop, or go to our website, enter BOGOF at checkout, to get 40% discount on select items, while stock lasts.")]), _vm._v(" "), _c('p', [_vm._v("6). Add Discount Claim Link- e.g. If you have a website or a social media account where customers can purchase your product, enter the link.. For example- https://quickstew.com")]), _vm._v(" "), _c('p', [_vm._v("7). Add Normal Price- This is the original market price of the product - e.g. 50000")]), _vm._v(" "), _c('p', [_vm._v("8). Add Discount Price- This is the reduced price you are offering to sell your product  for- e.g. 20000")]), _vm._v(" "), _c('p', [_vm._v("9). Add Media- Photo or Image  of the product on offer.")]), _vm._v(" "), _c('p', [_vm._v("10). Add the location where customers can find you- e.g. 10 Usuma street, Maitama.")])])
}]}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "xloader"
  })])])])])])
}]}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin fld"
  }, [_c('div', {
    staticClass: "content-admin-wrapper fld"
  }, [_c('div', {
    staticClass: "content-admin-main fld"
  }, [_c('div', {
    staticClass: "content-admin-main-inner fld"
  }, [_c('div', {
    staticClass: "container-fluid fld"
  }, [_c('div', {
    staticClass: "row fld"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12 col-lg-3 fld"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "widget fld"
  }, [_c('ul', {
    staticClass: "menu-advanced",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.businesses), function(bz, index) {
    return _c('li', {
      class: {
        active: _vm.isActive(++index)
      },
      staticStyle: {
        "padding-left": "0"
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      attrs: {
        "href": "",
        "aria-controls": "one",
        "role": "tab",
        "data-toggle": "tab",
        "data-target": "one"
      },
      on: {
        "click": function($event) {
          _vm.getBusiness(bz.business_id)
        }
      }
    }, [_vm._v(_vm._s(bz.business_name))])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.businesses.length < 2) ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('add', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Business")]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br')])])]), _vm._v(" "), (_vm.panelFlag) ? _c('div', {
    staticClass: "col-sm-12  col-xs-12 col-lg-12 fld xfld"
  }, [(_vm.addFlag) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Business Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.category),
      expression: "business.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Business Category")]), _vm._v(" "), _vm._l((_vm.businessCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_id
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.name),
      expression: "business.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.business.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.description),
      expression: "business.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Your Service Description",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.business.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Contact Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.address),
      expression: "business.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.business.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.phone),
      expression: "business.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone "
    },
    domProps: {
      "value": (_vm.business.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.email),
      expression: "business.email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "E-mail",
      "data-vv-rules": "required|email"
    },
    domProps: {
      "value": (_vm.business.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.website),
      expression: "business.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Website"
    },
    domProps: {
      "value": (_vm.business.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.website = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Social Media Handles")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.facebook),
      expression: "business.facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://web.facebook.com/MyName/"
    },
    domProps: {
      "value": (_vm.business.facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.twitter),
      expression: "business.twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://twitter.com/MyName"
    },
    domProps: {
      "value": (_vm.business.twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.instagram),
      expression: "business.instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://www.instagram.com/MyName"
    },
    domProps: {
      "value": (_vm.business.instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.instagram = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Google Map")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_map),
      expression: "business.business_map"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "please paste your google map embed code here"
    },
    domProps: {
      "value": (_vm.business.business_map)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_map = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addBusiness
    }
  }, [_vm._v("Submit Listing")])])]) : _vm._e(), _vm._v(" "), (_vm.editFlag) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Business Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.businessCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_id
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_description),
      expression: "business.business_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Your Service Description",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.business.business_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Contact Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_address),
      expression: "business.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.business.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_phone),
      expression: "business.business_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone "
    },
    domProps: {
      "value": (_vm.business.business_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(26), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_email),
      expression: "business.business_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "E-mail "
    },
    domProps: {
      "value": (_vm.business.business_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_website),
      expression: "business.business_website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Website"
    },
    domProps: {
      "value": (_vm.business.business_website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_website = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Social Media Handles")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(28), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_facebook),
      expression: "business.business_facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://web.facebook.com/MyName/"
    },
    domProps: {
      "value": (_vm.business.business_facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_twitter),
      expression: "business.business_twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://twitter.com/MyName"
    },
    domProps: {
      "value": (_vm.business.business_twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(30), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_instagram),
      expression: "business.business_instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://www.instagram.com/MyName"
    },
    domProps: {
      "value": (_vm.business.business_instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_instagram = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Google Map")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(31), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_map),
      expression: "business.business_map"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "please paste your google map embed code here"
    },
    domProps: {
      "value": (_vm.business.business_map)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_map = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editBusiness
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editFlag = false;
        _vm.panelFlag = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.deleteFlag) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Delete Business Listing")]), _vm._v(" "), _vm._m(32), (_vm.business.business_delete_request != '') ? _c('p', [_c('b', [_vm._v("Remove Account Status: ")]), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.business.business_delete_request))])]) : _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you wish to Continue?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "center"
  }, [(_vm.business.business_delete_request == '') ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeBusiness
    }
  }, [_vm._v("Yes Continue")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.cnsurveysPanel) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-12 fld xfld"
  }, [(_vm.noBusinessSet) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_vm._m(35), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('add', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Business")])]), _vm._v(" "), _c('p')])]) : _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                            Service: " + _vm._s(_vm.business.business_category_name) + "\r\n                                                             "), _c('a', {
    staticClass: " btn btn-primary fld-pull",
    on: {
      "click": function($event) {
        _vm.setPanel('edit', _vm.business)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Edit")]), _vm._v("\r\n                                                                   \r\n                                                            "), _vm._m(36), _vm._v("\r\n                                                               \r\n                                                            "), _c('a', {
    staticClass: " btn btn-primary fld-pull",
    on: {
      "click": function($event) {
        _vm.setPanel('delete', _vm.business)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Remove")])]), _vm._v(" "), _c('p', [_vm._v("Name: " + _vm._s(_vm.business.business_name))]), _vm._v(" "), _c('p', [_vm._v("City: "), (_vm.business.business_city_name == 'error') ? _c('span') : _c('span', [_vm._v(_vm._s(_vm.business.business_city_name))])]), _vm._v(" "), _c('p', [_vm._v("State:  "), (_vm.business.business_city_name == 'error') ? _c('span') : _c('span', [_vm._v(_vm._s(_vm.business.business_state_name))])]), _vm._v(" "), _c('p', [_vm._v("Address: " + _vm._s(_vm.business.business_address))]), _vm._v(" "), _c('p', [_vm._v("Email: " + _vm._s(_vm.business.business_email))]), _vm._v(" "), _c('p', [_vm._v("Phone: " + _vm._s(_vm.business.business_phone))]), _vm._v(" "), _c('p', [_vm._v("Website: " + _vm._s(_vm.business.business_website))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.business.business_description))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Social Media")]), _vm._v(" "), _c('p', [_vm._v("Facebook: " + _vm._s(_vm.business.business_facebook))]), _vm._v(" "), _c('p', [_vm._v("Twitter: " + _vm._s(_vm.business.business_twitter))]), _vm._v(" "), _c('p', [_vm._v("Instagram: " + _vm._s(_vm.business.business_instagram))]), _vm._v(" "), _c('h3', [_vm._v("Google Map")]), _vm._v(" "), _c('div', [(_vm.business.business_map == '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Map Set")]) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.business.business_map)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 fld"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Profile Image")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.business.business_image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.business.business_id)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 fld",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                        Business Working Hours\r\n                                                        ")]), _vm._v(" "), (_vm.business.working_hours) ? _c('div', {
    staticClass: "col-xs-12 fld"
  }, [_c('div', {
    staticClass: "form-group col-sm-12 col-xs-12"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.mon_open),
      expression: "business.working_hours.mon_open"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.mon_open = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.mon_open
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.mon_open))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.mon_close),
      expression: "business.working_hours.mon_close"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.mon_close = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.mon_close
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.mon_close))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 col-xs-12"
  }, [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.tue_open),
      expression: "business.working_hours.tue_open"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.tue_open = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.tue_open
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.tue_open))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.tue_close),
      expression: "business.working_hours.tue_close"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.tue_close = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.tue_close
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.tue_close))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 col-xs-12"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.wed_open),
      expression: "business.working_hours.wed_open"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.wed_open = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.wed_open
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.wed_open))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.wed_close),
      expression: "business.working_hours.wed_close"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.wed_close = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.wed_close
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.wed_close))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 col-xs-12"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.thu_open),
      expression: "business.working_hours.thu_open"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.thu_open = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.thu_open
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.thu_open))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.thu_close),
      expression: "business.working_hours.thu_close"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.thu_close = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.thu_close
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.thu_close))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 col-xs-12"
  }, [_vm._m(41), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.fri_open),
      expression: "business.working_hours.fri_open"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.fri_open = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.fri_open
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.fri_open))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.fri_close),
      expression: "business.working_hours.fri_close"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.fri_close = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.fri_close
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.fri_close))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 col-xs-12"
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.sat_open),
      expression: "business.working_hours.sat_open"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.sat_open = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.sat_open
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.sat_open))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.sat_close),
      expression: "business.working_hours.sat_close"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.sat_close = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.sat_close
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.sat_close))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 col-xs-12"
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.sun_open),
      expression: "business.working_hours.sun_open"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.sun_open = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.sun_open
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.sun_open))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.working_hours.sun_close),
      expression: "business.working_hours.sun_close"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.working_hours.sun_close = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.business.working_hours.sun_close
    }
  }, [_vm._v(_vm._s(_vm.business.working_hours.sun_close))]), _vm._v(" "), _vm._l((_vm.working_hours), function(hr) {
    return _c('option', [_vm._v(_vm._s(hr))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.setWorkingHours
    }
  }, [_vm._v("Set Working Hours")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30",
    staticStyle: {
      "margin-top": "5em",
      "height": "auto",
      "margin-right": "4em"
    },
    attrs: {
      "id": "discountbazaar"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_c('b', [_vm._v("DiscountBazaar")]), _vm._v(" for " + _vm._s(_vm.business.business_name) + "\r\n                                                            "), _c('a', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right",
      "background-color": "#22baae",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/cndiscountsetup"
    }
  }, [_vm._v("Set up DiscountBazaar")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.component_view.set_update_cndiscount) ? _c('div', {
    staticClass: "p30"
  }, [_c('cndiscount-form', {
    attrs: {
      "cndiscount": _vm.set_cndiscount,
      "cndiscount_set_view": 'form_view',
      "payment_details_data": _vm.cndiscount.payment_data
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.component_view.set_pay_cndiscount) ? _c('div', {
    staticClass: "p30",
    attrs: {
      "id": "setPayCndiscount"
    }
  }, [_c('cndiscount-form', {
    attrs: {
      "cndiscount": _vm.set_cndiscount,
      "cndiscount_set_view": 'payment_view',
      "payment_details_data": _vm.cndiscount.payment_data
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.component_view.set_view_cndiscount) ? _c('div', {
    staticClass: "p30"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('', 'discountbazaar')
      }
    }
  }, [_vm._v("Back to DiscountBazaar")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Caption")]), _c('br'), _c('br'), _vm._v("\r\n                                                                             " + _vm._s(_vm.cndiscount.cndiscount_caption) + "\r\n                                                                         ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Code")]), _c('br'), _c('br'), _vm._v("\r\n                                                                             " + _vm._s(_vm.cndiscount.cndiscount_code) + "\r\n                                                                         ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Description")]), _c('br'), _c('br'), _vm._v("\r\n                                                                             " + _vm._s(_vm.cndiscount.cndiscount_description) + "\r\n                                                                         ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Claim Link")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.set_url(_vm.cndiscount.cndiscount_link)
      }
    }
  }, [_vm._v(_vm._s(_vm.cndiscount.cndiscount_link))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Start Date")]), _c('br'), _c('br'), _vm._v("\r\n                                                                             " + _vm._s(_vm.cndiscount.cndiscount_start_date) + "\r\n                                                                         ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Expiry Date")]), _c('br'), _c('br'), _vm._v("\r\n                                                                             " + _vm._s(_vm.cndiscount.cndiscount_expiry_date) + "\r\n                                                                         ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [(_vm.cndiscount.cndiscount_media && (_vm.cndiscount.cndiscount_media != '')) ? _c('div', {
    staticStyle: {
      "height": "250px",
      "width": "250px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "inherit",
      "width": "100%"
    },
    attrs: {
      "src": _vm.img_url + _vm.cndiscount.cndiscount_media
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Normal Price")]), _c('br'), _c('br'), _vm._v("\r\n                                                                            ₦" + _vm._s(_vm.formatCurrency_2(_vm.cndiscount.cndiscount_normal_price)) + "\r\n                                                                        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Price")]), _c('br'), _c('br'), _vm._v("\r\n                                                                            ₦" + _vm._s(_vm.formatCurrency_2(_vm.cndiscount.cndiscount_discount_price)) + "\r\n                                                                        ")])])]), _vm._v(" "), (_vm.cndiscount.cndiscount_payment_status == 0) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_vm._m(44), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "left",
      "background-color": "#ff0000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_pay_cndiscount', 'discountbazaar')
      }
    }
  }, [_vm._v("Make Payment")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_update_cndiscount', 'discountbazaar')
      }
    }
  }, [_vm._v("Update DiscountBazaar")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('br'), _c('br')])]) : _c('div', {
    staticClass: "col-md-12 col-xs-12 fld"
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "-2em",
      "padding-left": "1em",
      "padding-top": "1em",
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Available Discounts")]), _vm._v(" "), _vm._l((_vm.business.business_cndiscounts), function(cnd, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "border-bottom": "#22baae solid 1px"
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('h6', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('b', [_vm._v(" Code")]), _c('br'), _c('br'), _vm._v("\r\n                                                                                " + _vm._s(cnd.cndiscount_code) + "\r\n                                                                            ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cndiscount = cnd;
          _vm.set_cndiscount = cnd;
          _vm.setComponentView('set_view_cndiscount', 'discountbazaar');
        }
      }
    }, [_vm._v("view")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h6', [_c('b', [_vm._v("Details")]), _c('br'), _c('br'), _vm._v("\r\n                                                                                " + _vm._s(cnd.cndiscount_caption)), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Start-Date: ")]), _vm._v(_vm._s(cnd.cndiscount_start_date)), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Expiry-Date: ")]), _vm._v(_vm._s(cnd.cndiscount_expiry_date)), _c('br'), _vm._v(" "), (cnd.cndiscount_payment_status == 0) ? _c('span', [_c('b', [_vm._v("Payment status: ")]), _vm._v("Not Active")]) : _c('span', [_c('b', [_vm._v("Payment status: ")]), _vm._v("Active")])])])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "two"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "three"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "four"
    }
  }, [_vm._v("...")])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Add a Business")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe Your Businesses"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Phone Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Email "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(You will receive messages and notifications with this email)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Edit Business")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe your Business"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Phone"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(" You have requested to remove this Business Account,\r\n                                                    This account would be checked for any pending or unresovled Information,\r\n                                                    the process would take a minimum of 48hrs.\r\n                                                    "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("CNSurveys Requests")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Business Listings ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not added any Business  "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: " btn btn-primary fld-pull",
    attrs: {
      "href": "#discountbazaar"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" DiscountBazaar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Monday")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Tuesday")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Wednessday")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Thursday")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Friday")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Saturday")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Sunday")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Payment has not been made. "), _c('br'), _vm._v(" Make payment to activate DiscountBazaar")])
}]}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', [_vm._m(2), _vm._v(" "), _vm._l((_vm.monies), function(money) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(money.contract_money_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.contract_money_ref))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "cnpro-accounts"
      }
    }, [_vm._v(_vm._s(money.contract_money_contract_cnpro_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.contract_money_contract_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.contract_money_pay_out_amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "uppercase"
      },
      style: ({
        color: money.contract_money_status_color,
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(money.contract_money_status))]), _vm._v(" "), (money.contract_money_status_id == 1) ? _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "type": "submit",
        "data-toggle": "modal",
        "data-target": "#banking"
      },
      on: {
        "click": function($event) {
          _vm.setPayment(money)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bell-o"
    }), _vm._v(" Pay Me")])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, _vm._l((_vm.monies), function(money) {
    return _c('div', [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(" " + _vm._s(money.contract_money_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(" " + _vm._s(money.contract_money_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpro: ")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "cnpro-accounts"
      }
    }, [_vm._v(_vm._s(money.contract_money_contract_cnpro_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Contract ID: ")]), _vm._v(" " + _vm._s(money.contract_money_contract_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Contract Amount: ")]), _vm._v(" ₦" + _vm._s(money.contract_money_pay_out_amount))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-transform": "uppercase"
      },
      style: ({
        color: money.contract_money_status_color,
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(money.contract_money_status))])]), _vm._v(" "), (money.contract_money_status_id == 1) ? _c('p', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "type": "submit",
        "data-toggle": "modal",
        "data-target": "#banking"
      },
      on: {
        "click": function($event) {
          _vm.setPayment(money)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bell-o"
    }), _vm._v(" Pay Me")])]) : _vm._e(), _vm._v(" "), _c('hr')])
  }))])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "banking",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h3', [_vm._v("Bank details")]), _vm._v(" "), (_vm.bank_set) ? _c('div', [_c('h5', [_vm._v("Bank Name: " + _vm._s(_vm.bank.bank_name))]), _vm._v(" "), _c('h5', [_vm._v("Account Name: " + _vm._s(_vm.bank.account_name))]), _vm._v(" "), _c('h5', [_vm._v("Account Number: " + _vm._s(_vm.bank.account_number))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editBank
    }
  }, [_vm._v("Edit Setting")]), _vm._v(" "), (_vm.payment_request) ? _c('div', [_c('h2', [_vm._v("Request Payment")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Contract: "), _c('b', [_vm._v(_vm._s(_vm.money.contract_money_contract_ref))])]), _vm._v(" "), _c('h6', [_vm._v("Labour Cost: "), _c('b', [_vm._v("₦" + _vm._s(_vm.money.contract_money_labour_cost))])]), _vm._v(" "), _c('h6', [_vm._v("Service Charge(incl. of VAT): "), _c('b', [_vm._v(_vm._s(_vm.money.contract_money_set_service_charge) + "%")])]), _vm._v(" "), _c('h6', [_vm._v("---------")]), _vm._v(" "), _c('h6', [_vm._v("Total Money after VAT and Service Charge deductions: "), _c('b', [_c('span', {
    staticStyle: {
      "font-size": "2em"
    }
  }, [_vm._v("₦" + _vm._s(_vm.money.contract_money_pay_out_amount))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.processPayment
    }
  }, [_vm._v("Receive Payment")])]) : _vm._e()]) : _c('div', [(_vm.bank.length == null || _vm.editBankFlag) ? _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bank Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank.bank_name),
      expression: "bank.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Bank Name"
    },
    domProps: {
      "value": (_vm.bank.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Account Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank.account_name),
      expression: "bank.account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Account Name"
    },
    domProps: {
      "value": (_vm.bank.account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank.account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Account Numbr")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank.account_number),
      expression: "bank.account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Account Number"
    },
    domProps: {
      "value": (_vm.bank.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank.account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.editBankFlag) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateBankSetting
    }
  }, [_vm._v("Save")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setBanking
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Your Information is safe. You can always edit these details later")])])]), _vm._v(" "), _vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Money Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p20 mb30"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#banking"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Set Up Bank Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~")]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("CNpro")]), _vm._v(" "), _c('th', [_vm._v("Contract ID")]), _vm._v(" "), _c('th', [_vm._v("Contract Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[118]);


// WEBPACK FOOTER //
// static/js/app.e76c92fa99059efa3056.js